(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e0b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e0b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gkYm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $be4d54dbcddc16f8$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-this-alias */ /* eslint-disable no-new, no-prototype-builtins, import/no-amd */ /* global $ */ parcelRequire("6CyE5");
var $iRjKv = parcelRequire("iRjKv");
var $2uJqM = parcelRequire("2uJqM");
var $cQ6wP = parcelRequire("cQ6wP");
const $be4d54dbcddc16f8$var$nullishValues = new Set([
    null,
    undefined
]);
function $be4d54dbcddc16f8$var$setTextColorWithBackground(color) {
    const { r: r } = color;
    const { g: g } = color;
    const { b: b } = color;
    const colorValue = Math.round((parseInt(r, 10) * 299 + parseInt(g, 10) * 587 + parseInt(b, 10) * 114) / 1000);
    return colorValue > 125 ? '#000' : '#fff';
}
function $be4d54dbcddc16f8$var$MakeTable(opts) {
    function Table(tableOpts) {
        this.highlightColor = $cQ6wP.default();
        this.highlightRanking = $cQ6wP.default().range([
            '#ff7777',
            '#ffffff'
        ]).domain([
            1,
            20
        ]);
        // Sets global tableOpts variables
        this.initOpts(tableOpts);
        // Initiliazes table and draws it
        this.initTable();
    }
    Table.prototype.initTable = function initTable() {
        // this.tableHeader = '<table><thead>';
        this.secondaryHeaderHTML = '';
        this.primaryHeaderHTML = '';
        if (this.secondaryHeaders) this.secondaryHeaderHTML = this.secondaryHeader(this.secondaryHeaders);
        this.primaryHeaderHTML = this.primaryHeader(this.headers, 'th');
        this.tableFooter = '';
        // this.tableHeader += '</thead><tbody>'
        this.tableClose = '</tbody></table>';
        this.showFooterLinks = false;
        this.currentSortColumn = [];
        // If dynamically highlighted columns exist, identify it/them
        // First if check filters out "League" tables that don't get highlighted
        if (this.data.length > 1) {
            this.dynamicHighlightHeaders = this.headers.filter((d)=>d.highlightDynamic).map((h)=>h.field);
            if (this.dynamicHighlightHeaders.length) {
                this.hasDynamicHighlights = true;
                this.dynamicHighlightDomains = $be4d54dbcddc16f8$var$getDynamicDomains(this.dynamicHighlightHeaders, this.data);
            }
        }
        // If defaultSort column passed in and it exists sort by that column initially
        if (this.defaultSort) {
            this.currentSortColumn = this.defaultSort;
            this.sortColumns();
        }
        if (this.data) this.populateRow(this.data);
    };
    // Sort by (potentially) multiple columns
    Table.prototype.sortColumns = function sortColumns() {
        const reversedSorts = this.currentSortColumn.slice().reverse();
        reversedSorts.forEach(({ field: field, state: state })=>{
            const header = this.headers.find((d)=>field === d.customSortField || field === d.field);
            if (header) {
                header.state = state;
                this.handlePreSort(header);
                this.sortColumn(header);
            }
        });
    };
    // Set opts variables
    Table.prototype.initOpts = function initOptsFn(initOpts) {
        if (initOpts.id) {
            this.id = initOpts.id;
            this.sel = $(`#${initOpts.id}`);
        }
        if (initOpts.data) this.data = initOpts.data;
        if (initOpts.headers) this.headers = initOpts.headers;
        if (initOpts.secondaryHeaders) this.secondaryHeaders = initOpts.secondaryHeaders;
        if (initOpts.defaultSort) {
            if (typeof initOpts.defaultSort === 'string') {
                const header = this.headers.find((d)=>initOpts.defaultSort === d.customSortField || initOpts.defaultSort === d.field);
                // This is done to match the way it currently works, I think.
                const state = initOpts.initialSortDirection || initOpts.defaultSortDirection || header.defaultSortDir || 'desc';
                // eslint-disable-next-line no-param-reassign
                initOpts.defaultSort = [
                    {
                        field: initOpts.defaultSort,
                        state: state
                    }
                ];
            }
            this.defaultSort = initOpts.defaultSort;
            this.currentSortColumn = initOpts.defaultSort;
        }
        if (initOpts.defaultSortDirection) this.defaultSortDirection = initOpts.defaultSortDirection;
        else this.defaultSortDirection = 'desc';
        if (initOpts.initialSortDirection) this.initialSortDirection = initOpts.initialSortDirection;
        if (initOpts.subDataId) this.subDataId = initOpts.subDataId;
        if (initOpts.drawerAvailable) this.drawerAvailable = initOpts.drawerAvailable;
        if (initOpts.uniqueId) this.uniqueId = initOpts.uniqueId;
        if (initOpts.showRank) this.showRank = initOpts.showRank;
        if (initOpts.repeatHeader) this.repeatHeader = initOpts.repeatHeader;
        this.hasPinned = Boolean(initOpts.hasPinned);
        if (initOpts.isSticky) this.isSticky = initOpts.isSticky;
        if (initOpts.filter) this.filter = initOpts.filter;
        if (initOpts.footer) this.footer = initOpts.footer;
        if (initOpts.sortClass) this.sortClass = initOpts.sortClass;
        if (opts.footerClass) this.footerClass = opts.footerClass;
        if (initOpts.sortCallback) this.sortCallback = initOpts.sortCallback;
        if (initOpts.rowClass) this.rowClass = initOpts.rowClass;
        this.highlightValFn = initOpts.highlightValFn || ((val)=>val);
        // default is true, make true unless explicit
        this.highlightFalsy = initOpts.highlightFalsy !== false;
        this.highlightNullish = initOpts.highlightNullish !== false;
        this.existsLinkedSort = this.headers.filter((header)=>header.isLinkedSort).length > 0;
    };
    // Draw table and attach event listeners
    Table.prototype.drawTable = function drawTable() {
        this.sel.html('');
        if (this.footer) this.populateRow(this.footer, true);
        this.sel.html(`<table><thead>${this.secondaryHeaderHTML}${this.primaryHeaderHTML}</thead><tbody>${this.tableRows}${this.tableFooter}${this.tableClose}`);
        this.addListeners();
    };
    // Add event listeners for sorting
    Table.prototype.addListeners = function addListeners() {
        const This = this;
        try {
            for(let x = 0; x < this.headers.length; x++){
                /* document.getElementById(This.id + "_th-" + x).addEventListener("mouseover", function () {
                        console.log('over');
                        var id = this.id.split('-')[1];
                        document.getElementById('tooltip-' + This.id + "_th-" + id).style.display = 'block';

                    });
                    document.getElementById(This.id + "_th-" + x).addEventListener("mouseleave", function () {
                        console.log('leave');
                        var id = this.id.split('-')[1];
                        document.getElementById('tooltip-' + This.id + "_th-" + id).style.display = 'none';
                    }); */ const th = document.getElementById(`${This.id}_th-${x}`);
                // This prevents the browser default to select text when holding the shift key.
                th.addEventListener('mousedown', (e)=>e.shiftKey && e.preventDefault());
                th.addEventListener('click', function clickHandler(e) {
                    e.preventDefault();
                    const isSecondary = e.shiftKey;
                    const id = this.id.split('-')[1];
                    const header = This.headers[id];
                    // Make sure it's explicitly set to false
                    if (header.sortable === false) return;
                    const lastIdx = This.currentSortColumn.length - 1;
                    const relevantSort = This.currentSortColumn[isSecondary ? lastIdx : 0];
                    const sortColumn = header.customSortField || header.field;
                    const isFlip = Boolean(relevantSort) && (sortColumn === relevantSort.field || sortColumn === relevantSort.customSortField);
                    // If it's already set, flip it
                    if (isFlip) This.headers[id].state = header.state === 'asc' ? 'desc' : 'asc';
                    else This.headers[id].state = header.defaultSortDir || This.defaultSortDirection;
                    const newSort = {
                        field: sortColumn,
                        state: This.headers[id].state
                    };
                    if (isSecondary) // tack on the end
                    This.currentSortColumn = [
                        ...This.currentSortColumn.filter((d)=>d.field !== newSort.field),
                        newSort
                    ];
                    else This.currentSortColumn = [
                        newSort
                    ];
                    This.sortColumns();
                    // This.tableHeader = '';
                    This.primaryHeaderHTML = This.primaryHeader(This.headers, 'th');
                    This.populateRow(This.data);
                    if (This.sortCallback) This.sortCallback(This.currentSortColumn[0].field, id, This.headers[id], This.data, This);
                });
            }
        } catch (ex) {
            console.log('Error: Maybe mismatched opts.id???') // eslint-disable-line
            ;
            console.error(ex) // eslint-disable-line
            ;
            throw ex;
        }
    };
    // headers closest to start of TR
    Table.prototype.primaryHeader = function primaryHeader(headers, type) {
        const This = this;
        let html = '<tr class="tr-component-row">';
        if (this.showRank) html += `<${type} class="th-component-rank th-component-header align-left th-vertical-bottom">Rk.${this.isSticky ? '<div>Rk.</div>' : ''}</${type}>`;
        for(let x = 0; x < headers.length; x++){
            const header = headers[x];
            let cssClass = '';
            if (header.headerClass) {
                cssClass = ` class="${header.headerClass} ${header.toolTip ? 'tooltip-hover' : ''}`;
                if (header.sortable === false) cssClass += ` th-component-header-no-sort `;
            }
            if (this.sortClass && (this.currentSortColumn[0].field === header.field || this.currentSortColumn[0].field === header.customSortField)) {
                if (cssClass.indexOf('class=') > -1) cssClass += ` ${this.sortClass}`;
                else cssClass = ` class="${this.sortClass} ${header.toolTip ? 'tooltip-hover' : ''}`;
            }
            if (cssClass) cssClass += '"';
            let toolTip = '';
            if (header.toolTip) toolTip = `<div class="${header.toolTipClass || 'th-tooltip'}">${header.toolTip}</div>`;
            html += `<${type} id="${This.id}_th-${x}" ${cssClass}>${header.name}${this.isSticky ? `<div>${header.name}</div>` : ''}${toolTip}</${type}>`;
        }
        html += '</tr>';
        return html;
    };
    // Very Top Headers
    Table.prototype.secondaryHeader = function secondaryHeader(headers) {
        let html = '<tr>';
        for(let x = 0; x < headers.length; x++){
            const header = headers[x];
            let cssClass = '';
            if (header.headerClass) cssClass = ` class="${header.headerClass}" `;
            let colspan = 1;
            if (header.colspan) colspan = header.colspan;
            html += `<th colspan="${colspan}" ${cssClass}>${header.name}</th>`;
        }
        html += '</tr>';
        return html;
    };
    Table.prototype.populateRow = function populateRow(data, isFooter) {
        const This = this;
        let tableHTML = '';
        let pinnedRows = 0;
        for(let x = 0; x < data.length; x++){
            if (this.repeatHeader && x % this.repeatHeader === 0 && x > 0) tableHTML += this.primaryHeader(this.headers, 'th');
            if (data[x]) {
                const pinnedRow = this.hasPinned && data[x].pinned;
                if (pinnedRow) pinnedRows += 1;
                let rowId = x;
                let rowStyle = '';
                // Used for AJAX Calls
                if (this.subDataId) {
                    rowId = data[x][this.subDataId];
                    if (!this.drawerAvailable || this.drawerAvailable(data[x])) rowStyle = ' style="cursor: pointer;" ';
                } else if (this.uniqueId && data[x]) rowId = data[x][this.uniqueId];
                // Append custom class per row if specified in the data set
                let customClass = '';
                if (data[x].customClass) customClass = data[x].customClass;
                // Append Footer Class if specified
                let footerClass = '';
                if (isFooter && this.footerClass) footerClass = this.footerClass;
                let rowClass = this.rowClass || '';
                rowClass = pinnedRow ? rowClass += ' savant-table-pinned-row' : rowClass;
                tableHTML += `<tr id="${This.id}-tr_${rowId}" class="default-table-row ${rowClass} ${footerClass} ${customClass}" ${rowStyle} data-id="${rowId}">`;
                if (this.showRank) {
                    const rank = pinnedRow ? '' : x + 1 - pinnedRows;
                    tableHTML += `<td>${rank}</td>`;
                }
                for(let y = 0; y < this.headers.length; y++){
                    const header = this.headers[y];
                    let cssClass = '';
                    if (header.fieldClass) cssClass = ` class="${header.fieldClass} `;
                    if (this.sortClass && (this.currentSortColumn[0].field === header.field || this.currentSortColumn[0].field === header.customSortField) && !isFooter) {
                        if (cssClass.indexOf('class=') > -1) cssClass += ` ${this.sortClass}`;
                        else cssClass = ` class="${this.sortClass} `;
                    }
                    if (header.footerClass && isFooter) {
                        if (cssClass.indexOf('class=') > -1) cssClass += ` ${header.footerClass}`;
                        else cssClass = ` class="${this.sortClass} `;
                    }
                    if (cssClass) cssClass += '"';
                    let id = '';
                    // Only allow id to be used on td if it has a uniqueId defined
                    if (header.id && this.uniqueId) id = ` id="td_${data[x][this.uniqueId]}_${header.id}" `;
                    let fieldData = '';
                    if (data[x].hasOwnProperty(header.field)) fieldData = data[x][header.field];
                    if (fieldData == null || header.photoOnly === true) fieldData = '';
                    if (header.fieldAlt && typeof header.fieldAlt === 'string') cssClass += ` title="${header.fieldAlt}" `;
                    else if (header.fieldAlt && typeof header.fieldAlt === 'function') {
                        const title = header.fieldAlt(fieldData, data[x], header);
                        cssClass += ` title="${title}" `;
                    }
                    let rankingData = '';
                    if (data[x].hasOwnProperty(header.ranking)) rankingData = data[x][header.ranking];
                    let photo = '';
                    if (header.photo) photo = header.photo.split('{1}').join(data[x][header.photoId]);
                    let background = '';
                    let backgroundColor = '';
                    if (header.highlightDynamic || header.highlight && header.highlight.length > 0) {
                        if (header.highlight && header.highlight.length === 5) this.highlightColor = $cQ6wP.default().clamp(true).range(header.highlightColors || [
                            '#3661AD',
                            '#3661AD',
                            '#ffffff',
                            '#D82129',
                            '#D82129'
                        ]);
                        else if (header.highlightDynamic && !this.hasDynamicHighlights) // Specific case to handle the "league" default gray highlight for a one-row table
                        this.highlightColor = $cQ6wP.default().clamp(true).range([
                            '#DCDCDC',
                            '#DCDCDC',
                            '#DCDCDC'
                        ]);
                        else this.highlightColor = $cQ6wP.default().clamp(true).range(header.highlightColors || [
                            '#3661AD',
                            '#ffffff',
                            '#D82129'
                        ]);
                        if (header.highlightDynamic && this.hasDynamicHighlights) {
                            const highlightDomain = this.dynamicHighlightDomains.find((d)=>d.field === header.field).domain;
                            this.highlightColor.domain(highlightDomain);
                        } else if (header.highlight) this.highlightColor.domain(header.highlight);
                        let rankColumn = fieldData;
                        if (data[x].hasOwnProperty(header.rankColumn)) rankColumn = data[x][header.rankColumn];
                        if (this.highlightNullish === false && !$be4d54dbcddc16f8$var$nullishValues.has(rankColumn)) {
                            const val = this.highlightValFn(rankColumn, data[x], data);
                            backgroundColor = this.highlightColor(val);
                            background = `style="background-color: ${backgroundColor}" `;
                        } else if (this.highlightFalsy === false && rankColumn || this.highlightFalsy !== false && this.highlightNullish !== false) {
                            const val = this.highlightValFn(rankColumn, data[x], data);
                            backgroundColor = this.highlightColor(val);
                            background = `style="background-color: ${backgroundColor}" `;
                        }
                    }
                    const spanFieldData = this.getSpan(header, data[x], rankingData, fieldData, isFooter, backgroundColor);
                    tableHTML += `<td ${id} ${cssClass} ${background}>${photo} ${spanFieldData}</td>`;
                }
                tableHTML += '</tr>';
                if (this.subDataId) {
                    tableHTML += `<tr class="tr-sub-data" id="${This.id}-trSub_${rowId}" style="background-color: #ffffff; display: none;"><td id="${This.id}-tdSub_${rowId}" colspan="${this.headers.length + (This.showRank ? 1 : 0)}" ></td></tr>`;
                    // To keep stripe add another row
                    tableHTML += '<tr style="display: none;"></tr>';
                }
            }
        }
        if (!isFooter) {
            this.tableRows = tableHTML;
            this.drawTable();
        } else this.tableFooter = tableHTML;
    };
    // Returns table span
    Table.prototype.getSpan = function getSpan(header, data, rankingData, fieldData, isFooter, backgroundColor) {
        let spanStart = '<span';
        const spanEnd = '</span>';
        if (header.spanClass) {
            if (data.playerId && data.season) spanStart += ` id="${Array.isArray(header.spanClass) ? header.spanClass.map((d)=>d.className).join(' ') : header.spanClass}_${data.playerId}_${data.season}" `;
            if (header.spanClass.length && header.spanClass.length > 0 && Array.isArray(header.spanClass)) {
                spanStart += ' class="';
                for(let x = 0; x < header.spanClass.length; x++){
                    const c = header.spanClass[x];
                    if (c.className && c.exception && !isFooter) {
                        if (c.exception === 'gte' && data[c.field] >= c.parameter) {
                            this.showFooterLinks = true;
                            spanStart += ` ${c.className}`;
                        } else if (c.exception === 'gt' && data[c.field] > c.parameter) {
                            this.showFooterLinks = true;
                            spanStart += ` ${c.className}`;
                        } else if (c.exception === 'lte' && data[c.field] <= c.parameter) {
                            this.showFooterLinks = true;
                            spanStart += ` ${c.className}`;
                        } else if (c.exception === 'lt' && data[c.field] < c.parameter) {
                            this.showFooterLinks = true;
                            spanStart += ` ${c.className}`;
                        } else if (c.exception === 'eq' && data[c.field] === c.parameter) {
                            this.showFooterLinks = true;
                            spanStart += ` ${c.className}`;
                        }
                    } else if (isFooter && c.includeFooter && this.showFooterLinks) spanStart += ` ${c.className}`;
                    else if (c.className && !c.exception) spanStart += ` ${c.className}`;
                }
                spanStart += '"';
            } else spanStart += ` class="${header.spanClass}" `;
        }
        if (header.ranking && rankingData) spanStart += ` ${spanStart} style="padding: 0px 5px 0px 5px; background-color: ${this.highlightRanking(rankingData)};" `;
        else if (backgroundColor) spanStart += ` ` + ` style="color: ${$be4d54dbcddc16f8$var$setTextColorWithBackground($iRjKv.default(backgroundColor))};" `;
        spanStart += '>';
        const value = header.displayFn ? header.displayFn(fieldData, data, header, isFooter) : fieldData;
        return spanStart + value + spanEnd;
    };
    Table.prototype.handlePreSort = function handlePreSort(header) {
        if (header.hasLinkedSort && this.existsLinkedSort) {
            const linkedHeader = this.headers.find((h)=>h.field === header.linkedSort);
            if (!linkedHeader) throw new Error(`no linked header: ${header.linkedSort} found.`);
            // Assume we want the same direction for sanity for now
            linkedHeader.state = header.state;
            this.sortColumn(linkedHeader);
        }
    };
    // Sort by a single column
    Table.prototype.sortColumn = function sortColumn(header) {
        const { type: type, state: state, customSortField: customSortField, field: field } = header;
        const col = customSortField || field;
        const isDesc = state === 'desc';
        this.data = this.data.sort((a, b)=>{
            let aVal = $be4d54dbcddc16f8$var$sortFunction(type, a, col, this.hasPinned, isDesc);
            let bVal = $be4d54dbcddc16f8$var$sortFunction(type, b, col, this.hasPinned, isDesc);
            // `sortFunction` will return a maximum/minimum value for pinned rows, to place them at the top.
            // Without the following code those rows will all be tied and won't change order when sorted.
            // Below we check whether we are dealing with two pinned rows and if so set `false` for the `hasPinned` parameter.
            // This will allow the two pinned rows to be compared via the normal `sortFunction` value.
            if (a.pinned && b.pinned && this.hasPinned) {
                aVal = $be4d54dbcddc16f8$var$sortFunction(type, a, col, false, isDesc);
                bVal = $be4d54dbcddc16f8$var$sortFunction(type, b, col, false, isDesc);
            }
            if (aVal === bVal) return 0;
            if (isDesc) return aVal > bVal ? -1 : 1;
            return aVal > bVal ? 1 : -1;
        });
    };
    Table.prototype.getHeader = function getHeader(headerName) {
        const header = this.headers.find((d)=>headerName === d.customSortField || headerName === d.field);
        return header;
    };
    // Assume we have sorted already,
    Table.prototype.refreshTable = function refreshTable() {
        this.sortColumns();
        this.primaryHeaderHTML = this.primaryHeader(this.headers, 'th');
        this.populateRow(this.data);
    };
    return new Table(opts);
}
// Need to be lowercase for comparison sake...I think.
const $be4d54dbcddc16f8$var$almostMaxString = 'zzzzzzzzzzzzzzzzzzzzzzzzzzzz';
const $be4d54dbcddc16f8$var$maxestString = `${$be4d54dbcddc16f8$var$almostMaxString}z`;
function $be4d54dbcddc16f8$var$sortFunction(type, row, sortColumn, hasPinned, isDesc = false) {
    let value;
    if (row) {
        if (hasPinned && row.pinned && type === 'number') return isDesc ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
        if (hasPinned && row.pinned) return isDesc ? $be4d54dbcddc16f8$var$maxestString : '';
        if (type === 'number') {
            value = row[sortColumn];
            // sort nulls last, picked random large number
            if (value === null || value === undefined) value = isDesc ? Number.MIN_SAFE_INTEGER + 1 : Number.MAX_SAFE_INTEGER - 1;
            return Number(String(value).replace('%', '').replace(',', ''));
        }
        if (!row[sortColumn]) // Lowest unicode character vs. a slightly smaller string
        return isDesc ? '\u0000' : $be4d54dbcddc16f8$var$almostMaxString;
        return String(row[sortColumn]).toLowerCase();
    }
    return isDesc ? Number.MAX_SAFE_INTEGER - 1 : Number.MIN_SAFE_INTEGER + 1;
}
function $be4d54dbcddc16f8$var$getDynamicDomains(headers, data) {
    return headers.map((h)=>{
        const [min, max] = $2uJqM.default(data, (d)=>Number(d[h]));
        let valRange = [];
        // A somewhat rough way to handle this, but we'll see how it looks
        if (min * max > 0) {
            const mid = (min + max) / 2;
            const diff = 0.8 * (mid - min);
            valRange = [
                mid - diff,
                mid,
                mid + diff
            ];
        } else {
            const extreme = Math.abs(min) > Math.abs(max) ? Math.abs(min) : Math.abs(max);
            valRange = [
                -0.8 * extreme,
                0,
                0.8 * extreme
            ];
        }
        return {
            field: h,
            domain: valRange
        };
    });
}
var $be4d54dbcddc16f8$export$2e2bcd8739ae039 = $be4d54dbcddc16f8$var$MakeTable;

});
parcelRegister("6CyE5", function(module, exports) {
$parcel$export(module.exports, "extent", () => (parcelRequire("2uJqM")).default);
$parcel$export(module.exports, "color", () => (parcelRequire("iRjKv")).default);
$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("cQ6wP")).default);

var $6gxHc = parcelRequire("6gxHc");
parcelRequire("3Hd9L");
parcelRequire("1ANGL");
parcelRequire("jxkNS");
parcelRequire("3Joxq");
parcelRequire("1CdYK");
parcelRequire("3RLhB");
parcelRequire("cS2K3");
parcelRequire("kkt77");
parcelRequire("8wWlh");
parcelRequire("jumO7");
parcelRequire("gOnHS");
parcelRequire("hyf3w");
parcelRequire("6iMXx");
parcelRequire("8nWhQ");
parcelRequire("jzbvG");
parcelRequire("4AYSz");
parcelRequire("2dfim");
parcelRequire("dtSPP");
parcelRequire("iqCIa");
parcelRequire("h44gN");
parcelRequire("fDxci");
parcelRequire("ePEak");
parcelRequire("bGdDD");
parcelRequire("4dA5O");
parcelRequire("fMuq7");
parcelRequire("7q3aS");
parcelRequire("3pidO");
parcelRequire("8BkNz");
parcelRequire("7Jt2T");
parcelRequire("fMdIC");

});
parcelRegister("6gxHc", function(module, exports) {
var $48fe5ff629faf77a$export$a8ff84c12d48cfa6 = "d3";
var $48fe5ff629faf77a$export$83d89fbfd8236492 = "4.13.0";
var $48fe5ff629faf77a$export$6d59db4903f20f7d = "Data-Driven Documents";
var $48fe5ff629faf77a$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $48fe5ff629faf77a$export$4cec2234a9c7ce6d = "https://d3js.org";
var $48fe5ff629faf77a$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $48fe5ff629faf77a$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $48fe5ff629faf77a$export$f22da7240b7add18 = "build/d3.node.js";
var $48fe5ff629faf77a$export$101358e655b23e68 = "build/d3.min.js";
var $48fe5ff629faf77a$export$a2877c4988dda7ec = "build/d3.min.js";
var $48fe5ff629faf77a$export$130be424786e852f = "index";
var $48fe5ff629faf77a$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $48fe5ff629faf77a$export$e0fef70db1fd3806 = {
    "pretest": "rimraf build && mkdir build && json2module package.json > build/package.js && node rollup.node",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "npm run test && rollup -c --banner \"$(preamble)\" && uglifyjs -b beautify=false,preamble=\"'$(preamble)'\" build/d3.js -c negate_iife=false -m -o build/d3.min.js",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/build/d3.js d3.v4.js && cp ../d3/build/d3.min.js d3.v4.min.js && git add d3.v4.js d3.v4.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/build/d3.js ../d3/build/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j build/d3.zip -- LICENSE README.md API.md CHANGES.md build/d3.js build/d3.min.js"
};
var $48fe5ff629faf77a$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "package-preamble": "0.1",
    "rimraf": "2",
    "rollup": "0.53",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "3",
    "tape": "4",
    "uglify-js": "3.2"
};
var $48fe5ff629faf77a$export$b74ff737e0e298b5 = {
    "d3-array": "1.2.1",
    "d3-axis": "1.0.8",
    "d3-brush": "1.0.4",
    "d3-chord": "1.0.4",
    "d3-collection": "1.0.4",
    "d3-color": "1.0.3",
    "d3-dispatch": "1.0.3",
    "d3-drag": "1.2.1",
    "d3-dsv": "1.0.8",
    "d3-ease": "1.0.3",
    "d3-force": "1.1.0",
    "d3-format": "1.2.2",
    "d3-geo": "1.9.1",
    "d3-hierarchy": "1.1.5",
    "d3-interpolate": "1.1.6",
    "d3-path": "1.0.5",
    "d3-polygon": "1.0.3",
    "d3-quadtree": "1.0.3",
    "d3-queue": "3.0.7",
    "d3-random": "1.1.0",
    "d3-request": "1.0.6",
    "d3-scale": "1.0.7",
    "d3-selection": "1.3.0",
    "d3-shape": "1.2.0",
    "d3-time": "1.0.8",
    "d3-time-format": "2.1.1",
    "d3-timer": "1.0.7",
    "d3-transition": "1.1.1",
    "d3-voronoi": "1.1.2",
    "d3-zoom": "1.7.1"
};

});

parcelRegister("3Hd9L", function(module, exports) {

$parcel$export(module.exports, "extent", () => (parcelRequire("2uJqM")).default);

var $5Tp4D = parcelRequire("5Tp4D");

var $cROxg = parcelRequire("cROxg");

var $ilxnX = parcelRequire("ilxnX");

var $cfrgq = parcelRequire("cfrgq");

var $eLXUA = parcelRequire("eLXUA");

var $jNWQS = parcelRequire("jNWQS");

var $2uJqM = parcelRequire("2uJqM");

var $7oQHZ = parcelRequire("7oQHZ");

var $koBGU = parcelRequire("koBGU");

var $a2EBg = parcelRequire("a2EBg");

var $5Jo4a = parcelRequire("5Jo4a");

var $2Xfp9 = parcelRequire("2Xfp9");

var $4daJa = parcelRequire("4daJa");

var $e95in = parcelRequire("e95in");

var $5wXeK = parcelRequire("5wXeK");

var $8MwqZ = parcelRequire("8MwqZ");

var $lJyD8 = parcelRequire("lJyD8");

var $43obe = parcelRequire("43obe");

var $aisTv = parcelRequire("aisTv");

var $hqGoq = parcelRequire("hqGoq");

var $9szg1 = parcelRequire("9szg1");

var $jTZ9M = parcelRequire("jTZ9M");

var $dcrVL = parcelRequire("dcrVL");

var $aA277 = parcelRequire("aA277");

var $53Qz5 = parcelRequire("53Qz5");

var $bPYBp = parcelRequire("bPYBp");

var $9KKqW = parcelRequire("9KKqW");

});
parcelRegister("5Tp4D", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a589e9a749e544$export$2e2bcd8739ae039);

var $cROxg = parcelRequire("cROxg");

var $ilxnX = parcelRequire("ilxnX");
var $44a589e9a749e544$var$ascendingBisect = (0, $ilxnX.default)((0, $cROxg.default));
var $44a589e9a749e544$export$4d945ad3ad5751b0 = $44a589e9a749e544$var$ascendingBisect.right;
var $44a589e9a749e544$export$df7d25c84ebd12a5 = $44a589e9a749e544$var$ascendingBisect.left;
var $44a589e9a749e544$export$2e2bcd8739ae039 = $44a589e9a749e544$export$4d945ad3ad5751b0;

});
parcelRegister("cROxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e1a28f22c79a56$export$2e2bcd8739ae039);
function $95e1a28f22c79a56$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("ilxnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5b415ca998e51b3$export$2e2bcd8739ae039);

var $cROxg = parcelRequire("cROxg");
function $d5b415ca998e51b3$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $d5b415ca998e51b3$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $d5b415ca998e51b3$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $cROxg.default)(f(d), x);
    };
}

});


parcelRegister("cfrgq", function(module, exports) {

var $lJyD8 = parcelRequire("lJyD8");
function $8eac08c92029ff99$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $lJyD8.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("lJyD8", function(module, exports) {

$parcel$export(module.exports, "pair", () => $fd28a9c4a820d7d8$export$a04cb3fe8b81dd);
function $fd28a9c4a820d7d8$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $fd28a9c4a820d7d8$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $fd28a9c4a820d7d8$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("eLXUA", function(module, exports) {
function $ac13edb2b84b46bd$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("jNWQS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b03ea72f666da9$export$2e2bcd8739ae039);

var $bPYBp = parcelRequire("bPYBp");
function $e6b03ea72f666da9$export$2e2bcd8739ae039(array, f) {
    var v = (0, $bPYBp.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("bPYBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $89e3777cd0a635a9$export$2e2bcd8739ae039);

var $isuBq = parcelRequire("isuBq");
function $89e3777cd0a635a9$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $isuBq.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $isuBq.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("isuBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70294961632745d$export$2e2bcd8739ae039);
function $d70294961632745d$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("2uJqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d119fba6f265274$export$2e2bcd8739ae039);
function $1d119fba6f265274$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("7oQHZ", function(module, exports) {

var $j0TCQ = parcelRequire("j0TCQ");

var $5Tp4D = parcelRequire("5Tp4D");

var $ib2XA = parcelRequire("ib2XA");

var $2uJqM = parcelRequire("2uJqM");

var $dHXf7 = parcelRequire("dHXf7");

var $hqGoq = parcelRequire("hqGoq");

var $aA277 = parcelRequire("aA277");

var $5Jo4a = parcelRequire("5Jo4a");
function $5633a9182533f856$export$2e2bcd8739ae039() {
    var value = (0, $dHXf7.default), domain = (0, $2uJqM.default), threshold = (0, $5Jo4a.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $aA277.tickStep)(x0, x1, tz);
            tz = (0, $hqGoq.default)(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $5Tp4D.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $ib2XA.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $ib2XA.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $ib2XA.default)((0, $j0TCQ.slice).call(_)) : (0, $ib2XA.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("j0TCQ", function(module, exports) {

$parcel$export(module.exports, "slice", () => $dd792a77fe59ed55$export$58adb3bec8346d0f);
$parcel$export(module.exports, "map", () => $dd792a77fe59ed55$export$871de8747c9eaa88);
var $dd792a77fe59ed55$var$array = Array.prototype;
var $dd792a77fe59ed55$export$58adb3bec8346d0f = $dd792a77fe59ed55$var$array.slice;
var $dd792a77fe59ed55$export$871de8747c9eaa88 = $dd792a77fe59ed55$var$array.map;

});

parcelRegister("ib2XA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3bb8cdca0a53273$export$2e2bcd8739ae039);
function $d3bb8cdca0a53273$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("dHXf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fad3ee7d16d6e9a$export$2e2bcd8739ae039);
function $9fad3ee7d16d6e9a$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("hqGoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb05bfb66b418b00$export$2e2bcd8739ae039);
function $cb05bfb66b418b00$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("aA277", function(module, exports) {

$parcel$export(module.exports, "tickStep", () => $7b3ee7e94ae0d191$export$81087d9b915d4ede);
var $7b3ee7e94ae0d191$var$e10 = Math.sqrt(50), $7b3ee7e94ae0d191$var$e5 = Math.sqrt(10), $7b3ee7e94ae0d191$var$e2 = Math.sqrt(2);
function $7b3ee7e94ae0d191$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $7b3ee7e94ae0d191$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $7b3ee7e94ae0d191$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $7b3ee7e94ae0d191$var$e10 ? 10 : error >= $7b3ee7e94ae0d191$var$e5 ? 5 : error >= $7b3ee7e94ae0d191$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $7b3ee7e94ae0d191$var$e10 ? 10 : error >= $7b3ee7e94ae0d191$var$e5 ? 5 : error >= $7b3ee7e94ae0d191$var$e2 ? 2 : 1);
}
function $7b3ee7e94ae0d191$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $7b3ee7e94ae0d191$var$e10) step1 *= 10;
    else if (error >= $7b3ee7e94ae0d191$var$e5) step1 *= 5;
    else if (error >= $7b3ee7e94ae0d191$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("5Jo4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c3d2bf616965ee$export$2e2bcd8739ae039);
function $42c3d2bf616965ee$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("koBGU", function(module, exports) {

var $j0TCQ = parcelRequire("j0TCQ");

var $cROxg = parcelRequire("cROxg");

var $isuBq = parcelRequire("isuBq");

var $aisTv = parcelRequire("aisTv");
function $ed934931fd404d64$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $j0TCQ.map).call(values, (0, $isuBq.default)).sort((0, $cROxg.default));
    return Math.ceil((max - min) / (2 * ((0, $aisTv.default)(values, 0.75) - (0, $aisTv.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("aisTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $77f1ff9f896f04aa$export$2e2bcd8739ae039);

var $isuBq = parcelRequire("isuBq");
function $77f1ff9f896f04aa$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $isuBq.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("a2EBg", function(module, exports) {

var $jNWQS = parcelRequire("jNWQS");
function $74f9959dff3a4f6e$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $jNWQS.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("2Xfp9", function(module, exports) {
function $226d0a7e8cca1609$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("4daJa", function(module, exports) {

var $isuBq = parcelRequire("isuBq");
function $3110b28f194407e0$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $isuBq.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $isuBq.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("e95in", function(module, exports) {

var $cROxg = parcelRequire("cROxg");

var $isuBq = parcelRequire("isuBq");

var $aisTv = parcelRequire("aisTv");
function $a4c60380ac0944d6$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $isuBq.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $isuBq.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $aisTv.default)(numbers.sort((0, $cROxg.default)), 0.5);
}

});

parcelRegister("5wXeK", function(module, exports) {
function $406de417ea19ffa6$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("8MwqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $664bf730e17559d0$export$2e2bcd8739ae039);
function $664bf730e17559d0$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("43obe", function(module, exports) {
function $2f3a32e9256382ad$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("9szg1", function(module, exports) {

var $cROxg = parcelRequire("cROxg");
function $6e3213fa40e70e4e$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $cROxg.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("jTZ9M", function(module, exports) {
function $e7d297d33cce63c9$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("dcrVL", function(module, exports) {
function $99c20fccc4bb95a3$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("53Qz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af601e1f34386f2$export$2e2bcd8739ae039);

var $8MwqZ = parcelRequire("8MwqZ");
function $3af601e1f34386f2$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $8MwqZ.default)(matrix, $3af601e1f34386f2$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $3af601e1f34386f2$var$length(d) {
    return d.length;
}

});

parcelRegister("9KKqW", function(module, exports) {

var $53Qz5 = parcelRequire("53Qz5");
function $719c6da8a3a37496$export$2e2bcd8739ae039() {
    return (0, $53Qz5.default)(arguments);
}

});


parcelRegister("1ANGL", function(module, exports) {

var $iWAIl = parcelRequire("iWAIl");

});
parcelRegister("iWAIl", function(module, exports) {

var $1CHTh = parcelRequire("1CHTh");

var $53K4d = parcelRequire("53K4d");
var $dcaa1f724a8b789d$var$top = 1, $dcaa1f724a8b789d$var$right = 2, $dcaa1f724a8b789d$var$bottom = 3, $dcaa1f724a8b789d$var$left = 4, $dcaa1f724a8b789d$var$epsilon = 1e-6;
function $dcaa1f724a8b789d$var$translateX(x) {
    return "translate(" + (x + 0.5) + ",0)";
}
function $dcaa1f724a8b789d$var$translateY(y) {
    return "translate(0," + (y + 0.5) + ")";
}
function $dcaa1f724a8b789d$var$number(scale) {
    return function(d) {
        return +scale(d);
    };
}
function $dcaa1f724a8b789d$var$center(scale) {
    var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        return +scale(d) + offset;
    };
}
function $dcaa1f724a8b789d$var$entering() {
    return !this.__axis;
}
function $dcaa1f724a8b789d$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, k = orient === $dcaa1f724a8b789d$var$top || orient === $dcaa1f724a8b789d$var$left ? -1 : 1, x = orient === $dcaa1f724a8b789d$var$left || orient === $dcaa1f724a8b789d$var$right ? "x" : "y", transform = orient === $dcaa1f724a8b789d$var$top || orient === $dcaa1f724a8b789d$var$bottom ? $dcaa1f724a8b789d$var$translateX : $dcaa1f724a8b789d$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $53K4d.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + 0.5, range1 = +range[range.length - 1] + 0.5, position = (scale.bandwidth ? $dcaa1f724a8b789d$var$center : $dcaa1f724a8b789d$var$number)(scale.copy()), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "#000"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "#000").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "#000").attr(x, k * spacing).attr("dy", orient === $dcaa1f724a8b789d$var$top ? "0em" : orient === $dcaa1f724a8b789d$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $dcaa1f724a8b789d$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $dcaa1f724a8b789d$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform(p && isFinite(p = p(d)) ? p : position(d));
            });
        }
        tickExit.remove();
        path.attr("d", orient === $dcaa1f724a8b789d$var$left || orient == $dcaa1f724a8b789d$var$right ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d));
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($dcaa1f724a8b789d$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $dcaa1f724a8b789d$var$right ? "start" : orient === $dcaa1f724a8b789d$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, $1CHTh.slice).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, $1CHTh.slice).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, $1CHTh.slice).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    return axis;
}
function $dcaa1f724a8b789d$export$59b8cfab074bdeb1(scale) {
    return $dcaa1f724a8b789d$var$axis($dcaa1f724a8b789d$var$top, scale);
}
function $dcaa1f724a8b789d$export$b0d2e24dc4f898f0(scale) {
    return $dcaa1f724a8b789d$var$axis($dcaa1f724a8b789d$var$right, scale);
}
function $dcaa1f724a8b789d$export$e5cb22533a15e72e(scale) {
    return $dcaa1f724a8b789d$var$axis($dcaa1f724a8b789d$var$bottom, scale);
}
function $dcaa1f724a8b789d$export$2749afb169a520d2(scale) {
    return $dcaa1f724a8b789d$var$axis($dcaa1f724a8b789d$var$left, scale);
}

});
parcelRegister("1CHTh", function(module, exports) {

$parcel$export(module.exports, "slice", () => $12eb62d1a6ede078$export$58adb3bec8346d0f);
var $12eb62d1a6ede078$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("53K4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af0f782b67bea63$export$2e2bcd8739ae039);
function $3af0f782b67bea63$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("jxkNS", function(module, exports) {

var $layzb = parcelRequire("layzb");

});
parcelRegister("layzb", function(module, exports) {

var $jZKv4 = parcelRequire("jZKv4");

var $5HdkF = parcelRequire("5HdkF");

var $jrAlt = parcelRequire("jrAlt");

var $khWJJ = parcelRequire("khWJJ");
var $2oMVM = parcelRequire("2oMVM");
var $9CP6e = parcelRequire("9CP6e");
parcelRequire("eAwOD");
var $eYMOM = parcelRequire("eYMOM");

var $kLt7R = parcelRequire("kLt7R");

var $kVoZk = parcelRequire("kVoZk");

var $3Kjca = parcelRequire("3Kjca");
var $f695584e4687b0d2$var$MODE_DRAG = {
    name: "drag"
}, $f695584e4687b0d2$var$MODE_SPACE = {
    name: "space"
}, $f695584e4687b0d2$var$MODE_HANDLE = {
    name: "handle"
}, $f695584e4687b0d2$var$MODE_CENTER = {
    name: "center"
};
var $f695584e4687b0d2$var$X = {
    name: "x",
    handles: [
        "e",
        "w"
    ].map($f695584e4687b0d2$var$type),
    input: function(x, e) {
        return x && [
            [
                x[0],
                e[0][1]
            ],
            [
                x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $f695584e4687b0d2$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($f695584e4687b0d2$var$type),
    input: function(y, e) {
        return y && [
            [
                e[0][0],
                y[0]
            ],
            [
                e[1][0],
                y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $f695584e4687b0d2$var$XY = {
    name: "xy",
    handles: [
        "n",
        "e",
        "s",
        "w",
        "nw",
        "ne",
        "se",
        "sw"
    ].map($f695584e4687b0d2$var$type),
    input: function(xy) {
        return xy;
    },
    output: function(xy) {
        return xy;
    }
};
var $f695584e4687b0d2$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $f695584e4687b0d2$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $f695584e4687b0d2$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $f695584e4687b0d2$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $f695584e4687b0d2$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $f695584e4687b0d2$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $f695584e4687b0d2$var$defaultFilter() {
    return !(0, $khWJJ.event).button;
}
function $f695584e4687b0d2$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $f695584e4687b0d2$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $f695584e4687b0d2$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $f695584e4687b0d2$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $f695584e4687b0d2$export$979ace6c88860aa8() {
    return $f695584e4687b0d2$var$brush($f695584e4687b0d2$var$X);
}
function $f695584e4687b0d2$export$468748b530991c54() {
    return $f695584e4687b0d2$var$brush($f695584e4687b0d2$var$Y);
}
function $f695584e4687b0d2$export$2e2bcd8739ae039() {
    return $f695584e4687b0d2$var$brush($f695584e4687b0d2$var$XY);
}
function $f695584e4687b0d2$var$brush(dim) {
    var extent = $f695584e4687b0d2$var$defaultExtent, filter = $f695584e4687b0d2$var$defaultFilter, listeners = (0, $jZKv4.default)(brush, "start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $f695584e4687b0d2$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $f695584e4687b0d2$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $f695584e4687b0d2$var$local(this).extent;
            (0, $9CP6e.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $f695584e4687b0d2$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $f695584e4687b0d2$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $f695584e4687b0d2$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush touchstart.brush", started);
    }
    brush.move = function(group, selection) {
        if (group.selection) group.on("start.brush", function() {
            emitter(this, arguments).beforestart().start();
        }).on("interrupt.brush end.brush", function() {
            emitter(this, arguments).end();
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $jrAlt.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && $f695584e4687b0d2$var$empty(selection1) ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 && selection1 ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $eYMOM.default)(that);
            state.selection = selection1 == null || $f695584e4687b0d2$var$empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    function redraw() {
        var group = (0, $9CP6e.default)(this), selection = $f695584e4687b0d2$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args) {
        return that.__brush.emitter || new Emitter(that, args);
    }
    function Emitter(that, args) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function() {
            if (this.starting) this.starting = false, this.emit("start");
            return this;
        },
        brush: function() {
            this.emit("brush");
            return this;
        },
        end: function() {
            if (--this.active === 0) delete this.state.emitter, this.emit("end");
            return this;
        },
        emit: function(type) {
            (0, $khWJJ.customEvent)(new (0, $kVoZk.default)(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function started() {
        if ((0, $khWJJ.event).touches) {
            if ((0, $khWJJ.event).changedTouches.length < (0, $khWJJ.event).touches.length) return (0, $3Kjca.default)();
        } else if (touchending) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = (0, $khWJJ.event).target.__data__.type, mode = ((0, $khWJJ.event).metaKey ? type = "overlay" : type) === "selection" ? $f695584e4687b0d2$var$MODE_DRAG : (0, $khWJJ.event).altKey ? $f695584e4687b0d2$var$MODE_CENTER : $f695584e4687b0d2$var$MODE_HANDLE, signX = dim === $f695584e4687b0d2$var$Y ? null : $f695584e4687b0d2$var$signsX[type], signY = dim === $f695584e4687b0d2$var$X ? null : $f695584e4687b0d2$var$signsY[type], state = $f695584e4687b0d2$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx, dy, moving, shifting = signX && signY && (0, $khWJJ.event).shiftKey, lockX, lockY, point0 = (0, $2oMVM.default)(that), point = point0, emit = emitter(that, arguments).beforestart();
        if (type === "overlay") state.selection = selection = [
            [
                w0 = dim === $f695584e4687b0d2$var$Y ? W : point0[0],
                n0 = dim === $f695584e4687b0d2$var$X ? N : point0[1]
            ],
            [
                e0 = dim === $f695584e4687b0d2$var$Y ? E : w0,
                s0 = dim === $f695584e4687b0d2$var$X ? S : n0
            ]
        ];
        else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $9CP6e.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $f695584e4687b0d2$var$cursors[type]);
        if ((0, $khWJJ.event).touches) group.on("touchmove.brush", moved, true).on("touchend.brush touchcancel.brush", ended, true);
        else {
            var view = (0, $9CP6e.default)((0, $khWJJ.event).view).on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            (0, $5HdkF.default)((0, $khWJJ.event).view);
        }
        (0, $3Kjca.nopropagation)();
        (0, $eYMOM.default)(that);
        redraw.call(that);
        emit.start();
        function moved() {
            var point1 = (0, $2oMVM.default)(that);
            if (shifting && !lockX && !lockY) {
                if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
                else lockX = true;
            }
            point = point1;
            moving = true;
            (0, $3Kjca.default)();
            move();
        }
        function move() {
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $f695584e4687b0d2$var$MODE_SPACE:
                case $f695584e4687b0d2$var$MODE_DRAG:
                    if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $f695584e4687b0d2$var$MODE_HANDLE:
                    if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                    else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                    if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                    else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    break;
                case $f695584e4687b0d2$var$MODE_CENTER:
                    if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
                    if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $f695584e4687b0d2$var$flipX) overlay.attr("cursor", $f695584e4687b0d2$var$cursors[type = $f695584e4687b0d2$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $f695584e4687b0d2$var$flipY) overlay.attr("cursor", $f695584e4687b0d2$var$cursors[type = $f695584e4687b0d2$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush();
            }
        }
        function ended() {
            (0, $3Kjca.nopropagation)();
            if ((0, $khWJJ.event).touches) {
                if ((0, $khWJJ.event).touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
                group.on("touchmove.brush touchend.brush touchcancel.brush", null);
            } else {
                (0, $5HdkF.yesdrag)((0, $khWJJ.event).view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $f695584e4687b0d2$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($f695584e4687b0d2$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end();
        }
        function keydowned() {
            switch((0, $khWJJ.event).keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $f695584e4687b0d2$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $f695584e4687b0d2$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $f695584e4687b0d2$var$MODE_HANDLE || mode === $f695584e4687b0d2$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $f695584e4687b0d2$var$MODE_SPACE;
                        overlay.attr("cursor", $f695584e4687b0d2$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $3Kjca.default)();
        }
        function keyupped() {
            switch((0, $khWJJ.event).keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $f695584e4687b0d2$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $f695584e4687b0d2$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $f695584e4687b0d2$var$MODE_SPACE) {
                        if ((0, $khWJJ.event).altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $f695584e4687b0d2$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $f695584e4687b0d2$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $f695584e4687b0d2$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $3Kjca.default)();
        }
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = extent.apply(this, arguments);
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $kLt7R.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $kLt7R.default)(!!_), brush) : filter;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("jZKv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8e7c8c52815b810$export$2e2bcd8739ae039);
var $e8e7c8c52815b810$var$noop = {
    value: function() {}
};
function $e8e7c8c52815b810$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $e8e7c8c52815b810$var$Dispatch(_);
}
function $e8e7c8c52815b810$var$Dispatch(_) {
    this._ = _;
}
function $e8e7c8c52815b810$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$e8e7c8c52815b810$var$Dispatch.prototype = $e8e7c8c52815b810$var$dispatch.prototype = {
    constructor: $e8e7c8c52815b810$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $e8e7c8c52815b810$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $e8e7c8c52815b810$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $e8e7c8c52815b810$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $e8e7c8c52815b810$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $e8e7c8c52815b810$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $e8e7c8c52815b810$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $e8e7c8c52815b810$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $e8e7c8c52815b810$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $e8e7c8c52815b810$export$2e2bcd8739ae039 = $e8e7c8c52815b810$var$dispatch;

});

parcelRegister("5HdkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $425b4f68cb13fbf1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $425b4f68cb13fbf1$export$833237748009e1e1);

var $9CP6e = parcelRequire("9CP6e");

var $d7CZE = parcelRequire("d7CZE");
function $425b4f68cb13fbf1$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $9CP6e.default)(view).on("dragstart.drag", (0, $d7CZE.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $d7CZE.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $425b4f68cb13fbf1$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $9CP6e.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $d7CZE.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("9CP6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $701f4cf194387cf9$export$2e2bcd8739ae039);

var $8wGsp = parcelRequire("8wGsp");
function $701f4cf194387cf9$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $8wGsp.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $8wGsp.Selection)([
        [
            selector
        ]
    ], (0, $8wGsp.root));
}

});
parcelRegister("8wGsp", function(module, exports) {

$parcel$export(module.exports, "root", () => $63523f0423c6104a$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $63523f0423c6104a$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $63523f0423c6104a$export$2e2bcd8739ae039);

var $fqae5 = parcelRequire("fqae5");

var $iWu28 = parcelRequire("iWu28");

var $4Qmmi = parcelRequire("4Qmmi");

var $6Cguy = parcelRequire("6Cguy");

var $5vrMF = parcelRequire("5vrMF");

var $9fVaq = parcelRequire("9fVaq");

var $ceZte = parcelRequire("ceZte");

var $huO5N = parcelRequire("huO5N");

var $zMUtQ = parcelRequire("zMUtQ");

var $53j5M = parcelRequire("53j5M");

var $8KClT = parcelRequire("8KClT");

var $b9KS1 = parcelRequire("b9KS1");

var $5XZHG = parcelRequire("5XZHG");

var $4EYIh = parcelRequire("4EYIh");

var $gS4wV = parcelRequire("gS4wV");

var $htJl9 = parcelRequire("htJl9");

var $8ftqX = parcelRequire("8ftqX");

var $cz1ec = parcelRequire("cz1ec");

var $45bMn = parcelRequire("45bMn");

var $2RVnA = parcelRequire("2RVnA");

var $4GXDu = parcelRequire("4GXDu");

var $2j8Zv = parcelRequire("2j8Zv");

var $3hFcH = parcelRequire("3hFcH");

var $55r9V = parcelRequire("55r9V");

var $dRVvd = parcelRequire("dRVvd");

var $2CqsG = parcelRequire("2CqsG");

var $fCoVd = parcelRequire("fCoVd");

var $gTxFF = parcelRequire("gTxFF");

var $ahx8A = parcelRequire("ahx8A");

var $khWJJ = parcelRequire("khWJJ");

var $7tuaf = parcelRequire("7tuaf");
var $63523f0423c6104a$export$e8e78c978b129247 = [
    null
];
function $63523f0423c6104a$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $63523f0423c6104a$var$selection() {
    return new $63523f0423c6104a$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $63523f0423c6104a$export$e8e78c978b129247);
}
$63523f0423c6104a$export$52baac22726c72bf.prototype = $63523f0423c6104a$var$selection.prototype = {
    constructor: $63523f0423c6104a$export$52baac22726c72bf,
    select: (0, $fqae5.default),
    selectAll: (0, $iWu28.default),
    filter: (0, $4Qmmi.default),
    data: (0, $6Cguy.default),
    enter: (0, $5vrMF.default),
    exit: (0, $9fVaq.default),
    join: (0, $ceZte.default),
    merge: (0, $huO5N.default),
    order: (0, $zMUtQ.default),
    sort: (0, $53j5M.default),
    call: (0, $8KClT.default),
    nodes: (0, $b9KS1.default),
    node: (0, $5XZHG.default),
    size: (0, $4EYIh.default),
    empty: (0, $gS4wV.default),
    each: (0, $htJl9.default),
    attr: (0, $8ftqX.default),
    style: (0, $cz1ec.default),
    property: (0, $45bMn.default),
    classed: (0, $2RVnA.default),
    text: (0, $4GXDu.default),
    html: (0, $2j8Zv.default),
    raise: (0, $3hFcH.default),
    lower: (0, $55r9V.default),
    append: (0, $dRVvd.default),
    insert: (0, $2CqsG.default),
    remove: (0, $fCoVd.default),
    clone: (0, $gTxFF.default),
    datum: (0, $ahx8A.default),
    on: (0, $khWJJ.default),
    dispatch: (0, $7tuaf.default)
};
var $63523f0423c6104a$export$2e2bcd8739ae039 = $63523f0423c6104a$var$selection;

});
parcelRegister("fqae5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3a137715b7adc98$export$2e2bcd8739ae039);

var $8wGsp = parcelRequire("8wGsp");

var $ksKiQ = parcelRequire("ksKiQ");
function $b3a137715b7adc98$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $ksKiQ.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $8wGsp.Selection)(subgroups, this._parents);
}

});
parcelRegister("ksKiQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee5a56f90753935a$export$2e2bcd8739ae039);
function $ee5a56f90753935a$var$none() {}
function $ee5a56f90753935a$export$2e2bcd8739ae039(selector) {
    return selector == null ? $ee5a56f90753935a$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("iWu28", function(module, exports) {

$parcel$export(module.exports, "default", () => $dca4f0cb7dc968a2$export$2e2bcd8739ae039);

var $8wGsp = parcelRequire("8wGsp");

var $hkKjE = parcelRequire("hkKjE");
function $dca4f0cb7dc968a2$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $hkKjE.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $8wGsp.Selection)(subgroups, parents);
}

});
parcelRegister("hkKjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e83b4a76a8a3dd$export$2e2bcd8739ae039);
function $c9e83b4a76a8a3dd$var$empty() {
    return [];
}
function $c9e83b4a76a8a3dd$export$2e2bcd8739ae039(selector) {
    return selector == null ? $c9e83b4a76a8a3dd$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("4Qmmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $386d5cb449aff4c6$export$2e2bcd8739ae039);

var $8wGsp = parcelRequire("8wGsp");

var $hh078 = parcelRequire("hh078");
function $386d5cb449aff4c6$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $hh078.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $8wGsp.Selection)(subgroups, this._parents);
}

});
parcelRegister("hh078", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9341cd90a85b369$export$2e2bcd8739ae039);
function $c9341cd90a85b369$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("6Cguy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d13159ed513833c$export$2e2bcd8739ae039);

var $8wGsp = parcelRequire("8wGsp");

var $5vrMF = parcelRequire("5vrMF");

var $5EPy5 = parcelRequire("5EPy5");
var $4d13159ed513833c$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $4d13159ed513833c$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $5vrMF.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $4d13159ed513833c$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $4d13159ed513833c$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $4d13159ed513833c$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $5vrMF.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $4d13159ed513833c$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $4d13159ed513833c$var$bindKey : $4d13159ed513833c$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $5EPy5.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $8wGsp.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("5vrMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $402566541f5250e6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $402566541f5250e6$export$67b01759a14cf6a4);

var $9rOSm = parcelRequire("9rOSm");

var $8wGsp = parcelRequire("8wGsp");
function $402566541f5250e6$export$2e2bcd8739ae039() {
    return new (0, $8wGsp.Selection)(this._enter || this._groups.map((0, $9rOSm.default)), this._parents);
}
function $402566541f5250e6$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$402566541f5250e6$export$67b01759a14cf6a4.prototype = {
    constructor: $402566541f5250e6$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("9rOSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0e198516090924$export$2e2bcd8739ae039);
function $6e0e198516090924$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("5EPy5", function(module, exports) {

$parcel$export(module.exports, "default", () => $41e8acb67122c9fa$export$2e2bcd8739ae039);
function $41e8acb67122c9fa$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("9fVaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bd1dbfb8c4373e8$export$2e2bcd8739ae039);

var $9rOSm = parcelRequire("9rOSm");

var $8wGsp = parcelRequire("8wGsp");
function $6bd1dbfb8c4373e8$export$2e2bcd8739ae039() {
    return new (0, $8wGsp.Selection)(this._exit || this._groups.map((0, $9rOSm.default)), this._parents);
}

});

parcelRegister("ceZte", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e96799adde0e028$export$2e2bcd8739ae039);
function $8e96799adde0e028$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("huO5N", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbcc18579eb7afb7$export$2e2bcd8739ae039);

var $8wGsp = parcelRequire("8wGsp");
function $cbcc18579eb7afb7$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $8wGsp.Selection)(merges, this._parents);
}

});

parcelRegister("zMUtQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b9358041c5f9e8$export$2e2bcd8739ae039);
function $06b9358041c5f9e8$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("53j5M", function(module, exports) {

$parcel$export(module.exports, "default", () => $3adc0ae0f16d45f8$export$2e2bcd8739ae039);

var $8wGsp = parcelRequire("8wGsp");
function $3adc0ae0f16d45f8$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $3adc0ae0f16d45f8$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $8wGsp.Selection)(sortgroups, this._parents).order();
}
function $3adc0ae0f16d45f8$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("8KClT", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f05e8546a2188d$export$2e2bcd8739ae039);
function $65f05e8546a2188d$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("b9KS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $81f4e4736933cdff$export$2e2bcd8739ae039);
function $81f4e4736933cdff$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("5XZHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $458253804b353bd7$export$2e2bcd8739ae039);
function $458253804b353bd7$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("4EYIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3649fe370e97d972$export$2e2bcd8739ae039);
function $3649fe370e97d972$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("gS4wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c485340c41b27d6b$export$2e2bcd8739ae039);
function $c485340c41b27d6b$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("htJl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb9850bbd3cf5bc2$export$2e2bcd8739ae039);
function $cb9850bbd3cf5bc2$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("8ftqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $60168e607bb1c884$export$2e2bcd8739ae039);

var $h50AC = parcelRequire("h50AC");
function $60168e607bb1c884$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $60168e607bb1c884$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $60168e607bb1c884$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $60168e607bb1c884$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $60168e607bb1c884$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $60168e607bb1c884$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $60168e607bb1c884$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $h50AC.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $60168e607bb1c884$var$attrRemoveNS : $60168e607bb1c884$var$attrRemove : typeof value === "function" ? fullname.local ? $60168e607bb1c884$var$attrFunctionNS : $60168e607bb1c884$var$attrFunction : fullname.local ? $60168e607bb1c884$var$attrConstantNS : $60168e607bb1c884$var$attrConstant)(fullname, value));
}

});
parcelRegister("h50AC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f35c66170a4d37$export$2e2bcd8739ae039);

var $ipApi = parcelRequire("ipApi");
function $c6f35c66170a4d37$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $ipApi.default).hasOwnProperty(prefix) ? {
        space: (0, $ipApi.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("ipApi", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $d676cd73e2cdea5e$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $d676cd73e2cdea5e$export$2e2bcd8739ae039);
var $d676cd73e2cdea5e$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $d676cd73e2cdea5e$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $d676cd73e2cdea5e$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("cz1ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $9259b4c26a320784$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $9259b4c26a320784$export$5e3cec964f0b5efd);

var $8g2Wc = parcelRequire("8g2Wc");
function $9259b4c26a320784$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $9259b4c26a320784$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $9259b4c26a320784$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $9259b4c26a320784$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $9259b4c26a320784$var$styleRemove : typeof value === "function" ? $9259b4c26a320784$var$styleFunction : $9259b4c26a320784$var$styleConstant)(name, value, priority == null ? "" : priority)) : $9259b4c26a320784$export$5e3cec964f0b5efd(this.node(), name);
}
function $9259b4c26a320784$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $8g2Wc.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("8g2Wc", function(module, exports) {

$parcel$export(module.exports, "default", () => $603218b709b87bea$export$2e2bcd8739ae039);
function $603218b709b87bea$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("45bMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f90c42ae68a8f3c$export$2e2bcd8739ae039);
function $2f90c42ae68a8f3c$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2f90c42ae68a8f3c$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2f90c42ae68a8f3c$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2f90c42ae68a8f3c$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2f90c42ae68a8f3c$var$propertyRemove : typeof value === "function" ? $2f90c42ae68a8f3c$var$propertyFunction : $2f90c42ae68a8f3c$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("2RVnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $216d0a5dbc842221$export$2e2bcd8739ae039);
function $216d0a5dbc842221$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $216d0a5dbc842221$var$classList(node) {
    return node.classList || new $216d0a5dbc842221$var$ClassList(node);
}
function $216d0a5dbc842221$var$ClassList(node) {
    this._node = node;
    this._names = $216d0a5dbc842221$var$classArray(node.getAttribute("class") || "");
}
$216d0a5dbc842221$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $216d0a5dbc842221$var$classedAdd(node, names) {
    var list = $216d0a5dbc842221$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $216d0a5dbc842221$var$classedRemove(node, names) {
    var list = $216d0a5dbc842221$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $216d0a5dbc842221$var$classedTrue(names) {
    return function() {
        $216d0a5dbc842221$var$classedAdd(this, names);
    };
}
function $216d0a5dbc842221$var$classedFalse(names) {
    return function() {
        $216d0a5dbc842221$var$classedRemove(this, names);
    };
}
function $216d0a5dbc842221$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $216d0a5dbc842221$var$classedAdd : $216d0a5dbc842221$var$classedRemove)(this, names);
    };
}
function $216d0a5dbc842221$export$2e2bcd8739ae039(name, value) {
    var names = $216d0a5dbc842221$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $216d0a5dbc842221$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $216d0a5dbc842221$var$classedFunction : value ? $216d0a5dbc842221$var$classedTrue : $216d0a5dbc842221$var$classedFalse)(names, value));
}

});

parcelRegister("4GXDu", function(module, exports) {

$parcel$export(module.exports, "default", () => $36a95823562fa98e$export$2e2bcd8739ae039);
function $36a95823562fa98e$var$textRemove() {
    this.textContent = "";
}
function $36a95823562fa98e$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $36a95823562fa98e$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $36a95823562fa98e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $36a95823562fa98e$var$textRemove : (typeof value === "function" ? $36a95823562fa98e$var$textFunction : $36a95823562fa98e$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("2j8Zv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ae4548f10be1f73$export$2e2bcd8739ae039);
function $1ae4548f10be1f73$var$htmlRemove() {
    this.innerHTML = "";
}
function $1ae4548f10be1f73$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $1ae4548f10be1f73$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $1ae4548f10be1f73$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $1ae4548f10be1f73$var$htmlRemove : (typeof value === "function" ? $1ae4548f10be1f73$var$htmlFunction : $1ae4548f10be1f73$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("3hFcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2642ebdf02e64e3f$export$2e2bcd8739ae039);
function $2642ebdf02e64e3f$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $2642ebdf02e64e3f$export$2e2bcd8739ae039() {
    return this.each($2642ebdf02e64e3f$var$raise);
}

});

parcelRegister("55r9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b427ca1d7f858c0$export$2e2bcd8739ae039);
function $3b427ca1d7f858c0$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $3b427ca1d7f858c0$export$2e2bcd8739ae039() {
    return this.each($3b427ca1d7f858c0$var$lower);
}

});

parcelRegister("dRVvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a18cd45f01a7469e$export$2e2bcd8739ae039);

var $76xIv = parcelRequire("76xIv");
function $a18cd45f01a7469e$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $76xIv.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("76xIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $52c33f6a7b057087$export$2e2bcd8739ae039);

var $h50AC = parcelRequire("h50AC");

var $ipApi = parcelRequire("ipApi");
function $52c33f6a7b057087$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $ipApi.xhtml) && document.documentElement.namespaceURI === (0, $ipApi.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $52c33f6a7b057087$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $52c33f6a7b057087$export$2e2bcd8739ae039(name) {
    var fullname = (0, $h50AC.default)(name);
    return (fullname.local ? $52c33f6a7b057087$var$creatorFixed : $52c33f6a7b057087$var$creatorInherit)(fullname);
}

});


parcelRegister("2CqsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e83a81860d9a3d3$export$2e2bcd8739ae039);

var $76xIv = parcelRequire("76xIv");

var $ksKiQ = parcelRequire("ksKiQ");
function $1e83a81860d9a3d3$var$constantNull() {
    return null;
}
function $1e83a81860d9a3d3$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $76xIv.default)(name), select = before == null ? $1e83a81860d9a3d3$var$constantNull : typeof before === "function" ? before : (0, $ksKiQ.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("fCoVd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5edbc92835c39c4$export$2e2bcd8739ae039);
function $b5edbc92835c39c4$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $b5edbc92835c39c4$export$2e2bcd8739ae039() {
    return this.each($b5edbc92835c39c4$var$remove);
}

});

parcelRegister("gTxFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4cbe6c542d7a1e6$export$2e2bcd8739ae039);
function $c4cbe6c542d7a1e6$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $c4cbe6c542d7a1e6$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $c4cbe6c542d7a1e6$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $c4cbe6c542d7a1e6$var$selection_cloneDeep : $c4cbe6c542d7a1e6$var$selection_cloneShallow);
}

});

parcelRegister("ahx8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $77c5325b0bcaec31$export$2e2bcd8739ae039);
function $77c5325b0bcaec31$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("khWJJ", function(module, exports) {

$parcel$export(module.exports, "event", () => $ec52f50e00aaac10$export$6cd530ed55e06764);
$parcel$export(module.exports, "default", () => $ec52f50e00aaac10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "customEvent", () => $ec52f50e00aaac10$export$4c724631b4750aef);
var $ec52f50e00aaac10$var$filterEvents = {};
var $ec52f50e00aaac10$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $ec52f50e00aaac10$var$element = document.documentElement;
    if (!("onmouseenter" in $ec52f50e00aaac10$var$element)) $ec52f50e00aaac10$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $ec52f50e00aaac10$var$filterContextListener(listener, index, group) {
    listener = $ec52f50e00aaac10$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $ec52f50e00aaac10$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $ec52f50e00aaac10$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $ec52f50e00aaac10$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $ec52f50e00aaac10$export$6cd530ed55e06764 = event0;
        }
    };
}
function $ec52f50e00aaac10$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $ec52f50e00aaac10$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $ec52f50e00aaac10$var$onAdd(typename, value, capture) {
    var wrap = $ec52f50e00aaac10$var$filterEvents.hasOwnProperty(typename.type) ? $ec52f50e00aaac10$var$filterContextListener : $ec52f50e00aaac10$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $ec52f50e00aaac10$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $ec52f50e00aaac10$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $ec52f50e00aaac10$var$onAdd : $ec52f50e00aaac10$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $ec52f50e00aaac10$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $ec52f50e00aaac10$export$6cd530ed55e06764;
    event1.sourceEvent = $ec52f50e00aaac10$export$6cd530ed55e06764;
    $ec52f50e00aaac10$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $ec52f50e00aaac10$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("7tuaf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5712a3d87dbf62ea$export$2e2bcd8739ae039);

var $8g2Wc = parcelRequire("8g2Wc");
function $5712a3d87dbf62ea$var$dispatchEvent(node, type, params) {
    var window = (0, $8g2Wc.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $5712a3d87dbf62ea$var$dispatchConstant(type, params) {
    return function() {
        return $5712a3d87dbf62ea$var$dispatchEvent(this, type, params);
    };
}
function $5712a3d87dbf62ea$var$dispatchFunction(type, params) {
    return function() {
        return $5712a3d87dbf62ea$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $5712a3d87dbf62ea$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $5712a3d87dbf62ea$var$dispatchFunction : $5712a3d87dbf62ea$var$dispatchConstant)(type, params));
}

});



parcelRegister("d7CZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $98da2d12c7d54f74$export$2e2bcd8739ae039);

var $khWJJ = parcelRequire("khWJJ");
function $98da2d12c7d54f74$export$2e2561858db9bf47() {
    (0, $khWJJ.event).stopImmediatePropagation();
}
function $98da2d12c7d54f74$export$2e2bcd8739ae039() {
    (0, $khWJJ.event).preventDefault();
    (0, $khWJJ.event).stopImmediatePropagation();
}

});


parcelRegister("jrAlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e27cbb5769cb216a$export$2e2bcd8739ae039);

var $dMCtN = parcelRequire("dMCtN");

var $9EvF5 = parcelRequire("9EvF5");

var $iPAFm = parcelRequire("iPAFm");

var $1j2QQ = parcelRequire("1j2QQ");

var $fEAwl = parcelRequire("fEAwl");

var $i477R = parcelRequire("i477R");

var $hlVfj = parcelRequire("hlVfj");

var $haWw4 = parcelRequire("haWw4");

var $dv83M = parcelRequire("dv83M");
function $e27cbb5769cb216a$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $haWw4.default)(b) : (t === "number" ? (0, $fEAwl.default) : t === "string" ? (c = (0, $dMCtN.default)(b)) ? (b = c, $9EvF5.default) : (0, $hlVfj.default) : b instanceof (0, $dMCtN.default) ? (0, $9EvF5.default) : b instanceof Date ? (0, $1j2QQ.default) : (0, $dv83M.isNumberArray)(b) ? (0, $dv83M.default) : Array.isArray(b) ? (0, $iPAFm.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $i477R.default) : (0, $fEAwl.default))(a, b);
}

});
parcelRegister("dMCtN", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $12nzI = parcelRequire("12nzI");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $12nzI.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $12nzI.default)(Rgb, rgb, (0, $12nzI.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $12nzI.default)(Hsl, hsl, (0, $12nzI.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("12nzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c1843e395d004df$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $0c1843e395d004df$export$8b58be045bf06082);
function $0c1843e395d004df$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $0c1843e395d004df$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("9EvF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $707068d6228a139a$export$2e2bcd8739ae039);

var $dMCtN = parcelRequire("dMCtN");

var $dmQd1 = parcelRequire("dmQd1");

var $crZOc = parcelRequire("crZOc");

var $lVJ0t = parcelRequire("lVJ0t");
var $707068d6228a139a$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $lVJ0t.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $dMCtN.rgb)(start)).r, (end = (0, $dMCtN.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $lVJ0t.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $707068d6228a139a$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $dMCtN.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $707068d6228a139a$export$2c0e28f2e2852d3f = $707068d6228a139a$var$rgbSpline((0, $dmQd1.default));
var $707068d6228a139a$export$53d5214f625ccd4c = $707068d6228a139a$var$rgbSpline((0, $crZOc.default));

});
parcelRegister("dmQd1", function(module, exports) {

$parcel$export(module.exports, "basis", () => $9bb5d414ff92d029$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $9bb5d414ff92d029$export$2e2bcd8739ae039);
function $9bb5d414ff92d029$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $9bb5d414ff92d029$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $9bb5d414ff92d029$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("crZOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9107f3905bb1550d$export$2e2bcd8739ae039);

var $dmQd1 = parcelRequire("dmQd1");
function $9107f3905bb1550d$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dmQd1.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("lVJ0t", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $ff71d53be2fea425$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $ff71d53be2fea425$export$2e2bcd8739ae039);

var $haWw4 = parcelRequire("haWw4");
function $ff71d53be2fea425$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $ff71d53be2fea425$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $ff71d53be2fea425$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $ff71d53be2fea425$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $haWw4.default)(isNaN(a) ? b : a);
}
function $ff71d53be2fea425$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $ff71d53be2fea425$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $ff71d53be2fea425$var$exponential(a, b, y) : (0, $haWw4.default)(isNaN(a) ? b : a);
    };
}
function $ff71d53be2fea425$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $ff71d53be2fea425$var$linear(a, d) : (0, $haWw4.default)(isNaN(a) ? b : a);
}

});
parcelRegister("haWw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c810c2f749b80fd8$export$2e2bcd8739ae039);
function $c810c2f749b80fd8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("iPAFm", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $db596e8821c401fd$export$15d09067c6a5ee49);

var $jrAlt = parcelRequire("jrAlt");

var $dv83M = parcelRequire("dv83M");
function $db596e8821c401fd$export$2e2bcd8739ae039(a, b) {
    return ((0, $dv83M.isNumberArray)(b) ? (0, $dv83M.default) : $db596e8821c401fd$export$15d09067c6a5ee49)(a, b);
}
function $db596e8821c401fd$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $jrAlt.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("dv83M", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d446c2881b1022e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $9d446c2881b1022e$export$5cd576d1827d40c8);
function $9d446c2881b1022e$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $9d446c2881b1022e$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("1j2QQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f39c6fdca5b471c$export$2e2bcd8739ae039);
function $0f39c6fdca5b471c$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("fEAwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b656ebabb5b4a540$export$2e2bcd8739ae039);
function $b656ebabb5b4a540$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("i477R", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26e20bcbdf4b2de$export$2e2bcd8739ae039);

var $jrAlt = parcelRequire("jrAlt");
function $d26e20bcbdf4b2de$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $jrAlt.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("hlVfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca20cdb5679aab09$export$2e2bcd8739ae039);

var $fEAwl = parcelRequire("fEAwl");
var $ca20cdb5679aab09$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $ca20cdb5679aab09$var$reB = new RegExp($ca20cdb5679aab09$var$reA.source, "g");
function $ca20cdb5679aab09$var$zero(b) {
    return function() {
        return b;
    };
}
function $ca20cdb5679aab09$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $ca20cdb5679aab09$export$2e2bcd8739ae039(a, b) {
    var bi = $ca20cdb5679aab09$var$reA.lastIndex = $ca20cdb5679aab09$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $ca20cdb5679aab09$var$reA.exec(a)) && (bm = $ca20cdb5679aab09$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $fEAwl.default)(am, bm)
            });
        }
        bi = $ca20cdb5679aab09$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $ca20cdb5679aab09$var$one(q[0].x) : $ca20cdb5679aab09$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("2oMVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf3c7565749804d$export$2e2bcd8739ae039);

var $72mjV = parcelRequire("72mjV");

var $5zrpv = parcelRequire("5zrpv");
function $1bf3c7565749804d$export$2e2bcd8739ae039(node) {
    var event = (0, $72mjV.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $5zrpv.default)(node, event);
}

});
parcelRegister("72mjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $51fa08a8fd91c2a7$export$2e2bcd8739ae039);

var $khWJJ = parcelRequire("khWJJ");
function $51fa08a8fd91c2a7$export$2e2bcd8739ae039() {
    var current = (0, $khWJJ.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("5zrpv", function(module, exports) {

$parcel$export(module.exports, "default", () => $40e57bc28db43542$export$2e2bcd8739ae039);
function $40e57bc28db43542$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("eAwOD", function(module, exports) {

$parcel$export(module.exports, "interrupt", () => (parcelRequire("eYMOM")).default);
parcelRequire("iVaBR");

var $cEyaY = parcelRequire("cEyaY");

var $d5CxE = parcelRequire("d5CxE");

var $eYMOM = parcelRequire("eYMOM");

});
parcelRegister("iVaBR", function(module, exports) {

var $8wGsp = parcelRequire("8wGsp");

var $a6VAY = parcelRequire("a6VAY");

var $8pss9 = parcelRequire("8pss9");
(0, $8wGsp.default).prototype.interrupt = (0, $a6VAY.default);
(0, $8wGsp.default).prototype.transition = (0, $8pss9.default);

});
parcelRegister("a6VAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $75c7242b7b0b071d$export$2e2bcd8739ae039);

var $eYMOM = parcelRequire("eYMOM");
function $75c7242b7b0b071d$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $eYMOM.default)(this, name);
    });
}

});
parcelRegister("eYMOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae7c898ab92c0ae2$export$2e2bcd8739ae039);

var $aU19E = parcelRequire("aU19E");
function $ae7c898ab92c0ae2$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $aU19E.STARTING) && schedule.state < (0, $aU19E.ENDING);
        schedule.state = (0, $aU19E.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("aU19E", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", () => $7f00079dd6cd86bd$export$584530fe98d14a84);
$parcel$export(module.exports, "STARTING", () => $7f00079dd6cd86bd$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $7f00079dd6cd86bd$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $7f00079dd6cd86bd$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $7f00079dd6cd86bd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $7f00079dd6cd86bd$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $7f00079dd6cd86bd$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $7f00079dd6cd86bd$export$adaa4cf7ef1b65be);

var $jZKv4 = parcelRequire("jZKv4");

var $9WH2m = parcelRequire("9WH2m");
var $3XTeV = parcelRequire("3XTeV");
var $7f00079dd6cd86bd$var$emptyOn = (0, $jZKv4.default)("start", "end", "cancel", "interrupt");
var $7f00079dd6cd86bd$var$emptyTween = [];
var $7f00079dd6cd86bd$export$ff39ebd4bb12b718 = 0;
var $7f00079dd6cd86bd$export$584530fe98d14a84 = 1;
var $7f00079dd6cd86bd$export$a5d151aee16efd42 = 2;
var $7f00079dd6cd86bd$export$fb935ab5849a0db9 = 3;
var $7f00079dd6cd86bd$export$1573e22b087389af = 4;
var $7f00079dd6cd86bd$export$a2e792214ded83b2 = 5;
var $7f00079dd6cd86bd$export$9d38167254403955 = 6;
function $7f00079dd6cd86bd$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $7f00079dd6cd86bd$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $7f00079dd6cd86bd$var$emptyOn,
        tween: $7f00079dd6cd86bd$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $7f00079dd6cd86bd$export$ff39ebd4bb12b718
    });
}
function $7f00079dd6cd86bd$export$2cd8252107eb640b(node, id) {
    var schedule = $7f00079dd6cd86bd$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $7f00079dd6cd86bd$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $7f00079dd6cd86bd$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $7f00079dd6cd86bd$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $7f00079dd6cd86bd$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $7f00079dd6cd86bd$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $7f00079dd6cd86bd$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $3XTeV.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $7f00079dd6cd86bd$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $7f00079dd6cd86bd$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $7f00079dd6cd86bd$export$fb935ab5849a0db9) return (0, $9WH2m.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $7f00079dd6cd86bd$export$1573e22b087389af) {
                o.state = $7f00079dd6cd86bd$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $7f00079dd6cd86bd$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $9WH2m.default)(function() {
            if (self.state === $7f00079dd6cd86bd$export$fb935ab5849a0db9) {
                self.state = $7f00079dd6cd86bd$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $7f00079dd6cd86bd$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $7f00079dd6cd86bd$export$a5d151aee16efd42) return; // interrupted
        self.state = $7f00079dd6cd86bd$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $7f00079dd6cd86bd$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $7f00079dd6cd86bd$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $7f00079dd6cd86bd$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("9WH2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $73daea1ddda8210f$export$2e2bcd8739ae039);

var $3XTeV = parcelRequire("3XTeV");
function $73daea1ddda8210f$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $3XTeV.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("3XTeV", function(module, exports) {

$parcel$export(module.exports, "now", () => $2e31bb43a29f6264$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $2e31bb43a29f6264$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $2e31bb43a29f6264$export$9dc4ecf953986f04);
var $2e31bb43a29f6264$var$frame = 0, $2e31bb43a29f6264$var$timeout = 0, $2e31bb43a29f6264$var$interval = 0, $2e31bb43a29f6264$var$pokeDelay = 1000, $2e31bb43a29f6264$var$taskHead, $2e31bb43a29f6264$var$taskTail, $2e31bb43a29f6264$var$clockLast = 0, $2e31bb43a29f6264$var$clockNow = 0, $2e31bb43a29f6264$var$clockSkew = 0, $2e31bb43a29f6264$var$clock = typeof performance === "object" && performance.now ? performance : Date, $2e31bb43a29f6264$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $2e31bb43a29f6264$export$461939dd4422153() {
    return $2e31bb43a29f6264$var$clockNow || ($2e31bb43a29f6264$var$setFrame($2e31bb43a29f6264$var$clearNow), $2e31bb43a29f6264$var$clockNow = $2e31bb43a29f6264$var$clock.now() + $2e31bb43a29f6264$var$clockSkew);
}
function $2e31bb43a29f6264$var$clearNow() {
    $2e31bb43a29f6264$var$clockNow = 0;
}
function $2e31bb43a29f6264$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$2e31bb43a29f6264$export$c57e9b2d8b9e4de.prototype = $2e31bb43a29f6264$export$9dc4ecf953986f04.prototype = {
    constructor: $2e31bb43a29f6264$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $2e31bb43a29f6264$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $2e31bb43a29f6264$var$taskTail !== this) {
            if ($2e31bb43a29f6264$var$taskTail) $2e31bb43a29f6264$var$taskTail._next = this;
            else $2e31bb43a29f6264$var$taskHead = this;
            $2e31bb43a29f6264$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $2e31bb43a29f6264$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $2e31bb43a29f6264$var$sleep();
        }
    }
};
function $2e31bb43a29f6264$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $2e31bb43a29f6264$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $2e31bb43a29f6264$export$d60154c1d7f3990e() {
    $2e31bb43a29f6264$export$461939dd4422153(); // Get the current time, if not already set.
    ++$2e31bb43a29f6264$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $2e31bb43a29f6264$var$taskHead, e;
    while(t){
        if ((e = $2e31bb43a29f6264$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$2e31bb43a29f6264$var$frame;
}
function $2e31bb43a29f6264$var$wake() {
    $2e31bb43a29f6264$var$clockNow = ($2e31bb43a29f6264$var$clockLast = $2e31bb43a29f6264$var$clock.now()) + $2e31bb43a29f6264$var$clockSkew;
    $2e31bb43a29f6264$var$frame = $2e31bb43a29f6264$var$timeout = 0;
    try {
        $2e31bb43a29f6264$export$d60154c1d7f3990e();
    } finally{
        $2e31bb43a29f6264$var$frame = 0;
        $2e31bb43a29f6264$var$nap();
        $2e31bb43a29f6264$var$clockNow = 0;
    }
}
function $2e31bb43a29f6264$var$poke() {
    var now = $2e31bb43a29f6264$var$clock.now(), delay = now - $2e31bb43a29f6264$var$clockLast;
    if (delay > $2e31bb43a29f6264$var$pokeDelay) $2e31bb43a29f6264$var$clockSkew -= delay, $2e31bb43a29f6264$var$clockLast = now;
}
function $2e31bb43a29f6264$var$nap() {
    var t0, t1 = $2e31bb43a29f6264$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $2e31bb43a29f6264$var$taskHead = t2;
    }
    $2e31bb43a29f6264$var$taskTail = t0;
    $2e31bb43a29f6264$var$sleep(time);
}
function $2e31bb43a29f6264$var$sleep(time) {
    if ($2e31bb43a29f6264$var$frame) return; // Soonest alarm already set, or will be.
    if ($2e31bb43a29f6264$var$timeout) $2e31bb43a29f6264$var$timeout = clearTimeout($2e31bb43a29f6264$var$timeout);
    var delay = time - $2e31bb43a29f6264$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $2e31bb43a29f6264$var$timeout = setTimeout($2e31bb43a29f6264$var$wake, time - $2e31bb43a29f6264$var$clock.now() - $2e31bb43a29f6264$var$clockSkew);
        if ($2e31bb43a29f6264$var$interval) $2e31bb43a29f6264$var$interval = clearInterval($2e31bb43a29f6264$var$interval);
    } else {
        if (!$2e31bb43a29f6264$var$interval) $2e31bb43a29f6264$var$clockLast = $2e31bb43a29f6264$var$clock.now(), $2e31bb43a29f6264$var$interval = setInterval($2e31bb43a29f6264$var$poke, $2e31bb43a29f6264$var$pokeDelay);
        $2e31bb43a29f6264$var$frame = 1, $2e31bb43a29f6264$var$setFrame($2e31bb43a29f6264$var$wake);
    }
}

});





parcelRegister("8pss9", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f6bab2f0a4daff$export$2e2bcd8739ae039);

var $cEyaY = parcelRequire("cEyaY");

var $aU19E = parcelRequire("aU19E");

var $847R9 = parcelRequire("847R9");

var $3XTeV = parcelRequire("3XTeV");
var $61f6bab2f0a4daff$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $847R9.cubicInOut)
};
function $61f6bab2f0a4daff$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $61f6bab2f0a4daff$var$defaultTiming.time = (0, $3XTeV.now)(), $61f6bab2f0a4daff$var$defaultTiming;
    }
    return timing;
}
function $61f6bab2f0a4daff$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $cEyaY.Transition)) id = name._id, name = name._name;
    else id = (0, $cEyaY.newId)(), (timing = $61f6bab2f0a4daff$var$defaultTiming).time = (0, $3XTeV.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $aU19E.default)(node, name, id, i, group, timing || $61f6bab2f0a4daff$var$inherit(node, id));
    }
    return new (0, $cEyaY.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("cEyaY", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $9363bb15af8bb8fe$export$be58926105124dd4);
$parcel$export(module.exports, "newId", () => $9363bb15af8bb8fe$export$9ffd10a3fbdc175b);

var $8wGsp = parcelRequire("8wGsp");

var $8TwjN = parcelRequire("8TwjN");

var $1tY2H = parcelRequire("1tY2H");

var $467Ez = parcelRequire("467Ez");

var $dykUg = parcelRequire("dykUg");

var $5iDvO = parcelRequire("5iDvO");

var $cG8Sv = parcelRequire("cG8Sv");

var $8lV48 = parcelRequire("8lV48");

var $dB0AX = parcelRequire("dB0AX");

var $drsLZ = parcelRequire("drsLZ");

var $QFHcX = parcelRequire("QFHcX");

var $5Z89w = parcelRequire("5Z89w");

var $3wXGh = parcelRequire("3wXGh");

var $itnsL = parcelRequire("itnsL");

var $bjSBE = parcelRequire("bjSBE");

var $klX1e = parcelRequire("klX1e");

var $ibily = parcelRequire("ibily");

var $k7R0B = parcelRequire("k7R0B");

var $iyRE1 = parcelRequire("iyRE1");

var $gM6QM = parcelRequire("gM6QM");
var $9363bb15af8bb8fe$var$id = 0;
function $9363bb15af8bb8fe$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $9363bb15af8bb8fe$export$2e2bcd8739ae039(name) {
    return (0, $8wGsp.default)().transition(name);
}
function $9363bb15af8bb8fe$export$9ffd10a3fbdc175b() {
    return ++$9363bb15af8bb8fe$var$id;
}
var $9363bb15af8bb8fe$var$selection_prototype = (0, $8wGsp.default).prototype;
$9363bb15af8bb8fe$export$be58926105124dd4.prototype = $9363bb15af8bb8fe$export$2e2bcd8739ae039.prototype = {
    constructor: $9363bb15af8bb8fe$export$be58926105124dd4,
    select: (0, $QFHcX.default),
    selectAll: (0, $5Z89w.default),
    filter: (0, $cG8Sv.default),
    merge: (0, $8lV48.default),
    selection: (0, $3wXGh.default),
    transition: (0, $k7R0B.default),
    call: $9363bb15af8bb8fe$var$selection_prototype.call,
    nodes: $9363bb15af8bb8fe$var$selection_prototype.nodes,
    node: $9363bb15af8bb8fe$var$selection_prototype.node,
    size: $9363bb15af8bb8fe$var$selection_prototype.size,
    empty: $9363bb15af8bb8fe$var$selection_prototype.empty,
    each: $9363bb15af8bb8fe$var$selection_prototype.each,
    on: (0, $dB0AX.default),
    attr: (0, $8TwjN.default),
    attrTween: (0, $1tY2H.default),
    style: (0, $itnsL.default),
    styleTween: (0, $bjSBE.default),
    text: (0, $klX1e.default),
    textTween: (0, $ibily.default),
    remove: (0, $drsLZ.default),
    tween: (0, $iyRE1.default),
    delay: (0, $467Ez.default),
    duration: (0, $dykUg.default),
    ease: (0, $5iDvO.default),
    end: (0, $gM6QM.default)
};

});
parcelRegister("8TwjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $679c8786847579d2$export$2e2bcd8739ae039);

var $rbkVS = parcelRequire("rbkVS");

var $h50AC = parcelRequire("h50AC");

var $iyRE1 = parcelRequire("iyRE1");

var $dtBAq = parcelRequire("dtBAq");
function $679c8786847579d2$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $679c8786847579d2$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $679c8786847579d2$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $679c8786847579d2$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $679c8786847579d2$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $679c8786847579d2$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $679c8786847579d2$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $h50AC.default)(name), i = fullname === "transform" ? (0, $rbkVS.interpolateTransformSvg) : (0, $dtBAq.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $679c8786847579d2$var$attrFunctionNS : $679c8786847579d2$var$attrFunction)(fullname, i, (0, $iyRE1.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $679c8786847579d2$var$attrRemoveNS : $679c8786847579d2$var$attrRemove)(fullname) : (fullname.local ? $679c8786847579d2$var$attrConstantNS : $679c8786847579d2$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("rbkVS", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $051b50f2987bf5a5$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $051b50f2987bf5a5$export$da8cba906d64c082);

var $fEAwl = parcelRequire("fEAwl");

var $hZfMO = parcelRequire("hZfMO");
function $051b50f2987bf5a5$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $fEAwl.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $fEAwl.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $fEAwl.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $fEAwl.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $fEAwl.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $fEAwl.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $051b50f2987bf5a5$export$56bec7123bb3589a = $051b50f2987bf5a5$var$interpolateTransform((0, $hZfMO.parseCss), "px, ", "px)", "deg)");
var $051b50f2987bf5a5$export$da8cba906d64c082 = $051b50f2987bf5a5$var$interpolateTransform((0, $hZfMO.parseSvg), ", ", ")", ")");

});
parcelRegister("hZfMO", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $d18461004b338e65$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $d18461004b338e65$export$f9ef43f9a1d89a18);

var $17x2R = parcelRequire("17x2R");
var $d18461004b338e65$var$cssNode, $d18461004b338e65$var$cssRoot, $d18461004b338e65$var$cssView, $d18461004b338e65$var$svgNode;
function $d18461004b338e65$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $17x2R.identity;
    if (!$d18461004b338e65$var$cssNode) $d18461004b338e65$var$cssNode = document.createElement("DIV"), $d18461004b338e65$var$cssRoot = document.documentElement, $d18461004b338e65$var$cssView = document.defaultView;
    $d18461004b338e65$var$cssNode.style.transform = value;
    value = $d18461004b338e65$var$cssView.getComputedStyle($d18461004b338e65$var$cssRoot.appendChild($d18461004b338e65$var$cssNode), null).getPropertyValue("transform");
    $d18461004b338e65$var$cssRoot.removeChild($d18461004b338e65$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $17x2R.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $d18461004b338e65$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $17x2R.identity;
    if (!$d18461004b338e65$var$svgNode) $d18461004b338e65$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $d18461004b338e65$var$svgNode.setAttribute("transform", value);
    if (!(value = $d18461004b338e65$var$svgNode.transform.baseVal.consolidate())) return 0, $17x2R.identity;
    value = value.matrix;
    return (0, $17x2R.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("17x2R", function(module, exports) {

$parcel$export(module.exports, "identity", () => $0d1013f484ecca8d$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $0d1013f484ecca8d$export$2e2bcd8739ae039);
var $0d1013f484ecca8d$var$degrees = 180 / Math.PI;
var $0d1013f484ecca8d$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $0d1013f484ecca8d$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $0d1013f484ecca8d$var$degrees,
        skewX: Math.atan(skewX) * $0d1013f484ecca8d$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("iyRE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d83503a13f74b481$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $d83503a13f74b481$export$f78ce6ab10405d82);

var $aU19E = parcelRequire("aU19E");
function $d83503a13f74b481$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $aU19E.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $d83503a13f74b481$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $aU19E.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $d83503a13f74b481$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $aU19E.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $d83503a13f74b481$var$tweenRemove : $d83503a13f74b481$var$tweenFunction)(id, name, value));
}
function $d83503a13f74b481$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $aU19E.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $aU19E.get)(node, id).value[name];
    };
}

});

parcelRegister("dtBAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cfb23b4cf7e7a20$export$2e2bcd8739ae039);

var $dMCtN = parcelRequire("dMCtN");

var $fEAwl = parcelRequire("fEAwl");
var $9EvF5 = parcelRequire("9EvF5");
var $hlVfj = parcelRequire("hlVfj");
function $9cfb23b4cf7e7a20$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $fEAwl.default) : b instanceof (0, $dMCtN.default) ? (0, $9EvF5.default) : (c = (0, $dMCtN.default)(b)) ? (b = c, $9EvF5.default) : (0, $hlVfj.default))(a, b);
}

});


parcelRegister("1tY2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $1147131672eca409$export$2e2bcd8739ae039);

var $h50AC = parcelRequire("h50AC");
function $1147131672eca409$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $1147131672eca409$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $1147131672eca409$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $1147131672eca409$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $1147131672eca409$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $1147131672eca409$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $1147131672eca409$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $h50AC.default)(name);
    return this.tween(key, (fullname.local ? $1147131672eca409$var$attrTweenNS : $1147131672eca409$var$attrTween)(fullname, value));
}

});

parcelRegister("467Ez", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbda8c376524eff$export$2e2bcd8739ae039);

var $aU19E = parcelRequire("aU19E");
function $2fbda8c376524eff$var$delayFunction(id, value) {
    return function() {
        (0, $aU19E.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $2fbda8c376524eff$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $aU19E.init)(this, id).delay = value;
    };
}
function $2fbda8c376524eff$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $2fbda8c376524eff$var$delayFunction : $2fbda8c376524eff$var$delayConstant)(id, value)) : (0, $aU19E.get)(this.node(), id).delay;
}

});

parcelRegister("dykUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ddeaaeb86aa5179$export$2e2bcd8739ae039);

var $aU19E = parcelRequire("aU19E");
function $9ddeaaeb86aa5179$var$durationFunction(id, value) {
    return function() {
        (0, $aU19E.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9ddeaaeb86aa5179$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $aU19E.set)(this, id).duration = value;
    };
}
function $9ddeaaeb86aa5179$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9ddeaaeb86aa5179$var$durationFunction : $9ddeaaeb86aa5179$var$durationConstant)(id, value)) : (0, $aU19E.get)(this.node(), id).duration;
}

});

parcelRegister("5iDvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dbd487357ddf718$export$2e2bcd8739ae039);

var $aU19E = parcelRequire("aU19E");
function $3dbd487357ddf718$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $aU19E.set)(this, id).ease = value;
    };
}
function $3dbd487357ddf718$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($3dbd487357ddf718$var$easeConstant(id, value)) : (0, $aU19E.get)(this.node(), id).ease;
}

});

parcelRegister("cG8Sv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0261cfaa7bf9b428$export$2e2bcd8739ae039);

var $hh078 = parcelRequire("hh078");

var $cEyaY = parcelRequire("cEyaY");
function $0261cfaa7bf9b428$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $hh078.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $cEyaY.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("8lV48", function(module, exports) {

$parcel$export(module.exports, "default", () => $614c8cf9b23a6f14$export$2e2bcd8739ae039);

var $cEyaY = parcelRequire("cEyaY");
function $614c8cf9b23a6f14$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $cEyaY.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("dB0AX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e5f313ebbbfb7fd$export$2e2bcd8739ae039);

var $aU19E = parcelRequire("aU19E");
function $9e5f313ebbbfb7fd$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $9e5f313ebbbfb7fd$var$onFunction(id, name, listener) {
    var on0, on1, sit = $9e5f313ebbbfb7fd$var$start(name) ? (0, $aU19E.init) : (0, $aU19E.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $9e5f313ebbbfb7fd$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $aU19E.get)(this.node(), id).on.on(name) : this.each($9e5f313ebbbfb7fd$var$onFunction(id, name, listener));
}

});

parcelRegister("drsLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c941db6581002e9$export$2e2bcd8739ae039);
function $9c941db6581002e9$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $9c941db6581002e9$export$2e2bcd8739ae039() {
    return this.on("end.remove", $9c941db6581002e9$var$removeFunction(this._id));
}

});

parcelRegister("QFHcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $09e5336182c53a93$export$2e2bcd8739ae039);

var $ksKiQ = parcelRequire("ksKiQ");

var $cEyaY = parcelRequire("cEyaY");

var $aU19E = parcelRequire("aU19E");
function $09e5336182c53a93$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $ksKiQ.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $aU19E.default)(subgroup[i], name, id, i, subgroup, (0, $aU19E.get)(node, id));
        }
    }
    return new (0, $cEyaY.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("5Z89w", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b8f92af56d27cc$export$2e2bcd8739ae039);

var $hkKjE = parcelRequire("hkKjE");

var $cEyaY = parcelRequire("cEyaY");

var $aU19E = parcelRequire("aU19E");
function $45b8f92af56d27cc$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $hkKjE.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $aU19E.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $aU19E.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $cEyaY.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("3wXGh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2922a7a3254dab57$export$2e2bcd8739ae039);

var $8wGsp = parcelRequire("8wGsp");
var $2922a7a3254dab57$var$Selection = (0, $8wGsp.default).prototype.constructor;
function $2922a7a3254dab57$export$2e2bcd8739ae039() {
    return new $2922a7a3254dab57$var$Selection(this._groups, this._parents);
}

});

parcelRegister("itnsL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72d22b072bb5d91$export$2e2bcd8739ae039);

var $rbkVS = parcelRequire("rbkVS");

var $cz1ec = parcelRequire("cz1ec");

var $aU19E = parcelRequire("aU19E");

var $iyRE1 = parcelRequire("iyRE1");

var $dtBAq = parcelRequire("dtBAq");
function $d72d22b072bb5d91$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $cz1ec.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $cz1ec.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d72d22b072bb5d91$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d72d22b072bb5d91$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $cz1ec.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d72d22b072bb5d91$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $cz1ec.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $cz1ec.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d72d22b072bb5d91$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $aU19E.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d72d22b072bb5d91$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d72d22b072bb5d91$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $rbkVS.interpolateTransformCss) : (0, $dtBAq.default);
    return value == null ? this.styleTween(name, $d72d22b072bb5d91$var$styleNull(name, i)).on("end.style." + name, $d72d22b072bb5d91$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d72d22b072bb5d91$var$styleFunction(name, i, (0, $iyRE1.tweenValue)(this, "style." + name, value))).each($d72d22b072bb5d91$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d72d22b072bb5d91$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("bjSBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $83dbd3c04bcad383$export$2e2bcd8739ae039);
function $83dbd3c04bcad383$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83dbd3c04bcad383$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83dbd3c04bcad383$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83dbd3c04bcad383$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83dbd3c04bcad383$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("klX1e", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed138cb87550de05$export$2e2bcd8739ae039);

var $iyRE1 = parcelRequire("iyRE1");
function $ed138cb87550de05$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $ed138cb87550de05$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $ed138cb87550de05$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $ed138cb87550de05$var$textFunction((0, $iyRE1.tweenValue)(this, "text", value)) : $ed138cb87550de05$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("ibily", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c77c514ba4ca58$export$2e2bcd8739ae039);
function $d3c77c514ba4ca58$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $d3c77c514ba4ca58$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $d3c77c514ba4ca58$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $d3c77c514ba4ca58$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $d3c77c514ba4ca58$var$textTween(value));
}

});

parcelRegister("k7R0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea6d9489718f0f0f$export$2e2bcd8739ae039);

var $cEyaY = parcelRequire("cEyaY");

var $aU19E = parcelRequire("aU19E");
function $ea6d9489718f0f0f$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $cEyaY.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $aU19E.get)(node, id0);
            (0, $aU19E.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $cEyaY.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("gM6QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c366715e2002336d$export$2e2bcd8739ae039);

var $aU19E = parcelRequire("aU19E");
function $c366715e2002336d$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $aU19E.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
    });
}

});


parcelRegister("847R9", function(module, exports) {

$parcel$export(module.exports, "cubicInOut", () => $5df4ca8927a4767e$export$89238d3bc79d3ada);
function $5df4ca8927a4767e$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5df4ca8927a4767e$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5df4ca8927a4767e$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("d5CxE", function(module, exports) {

var $cEyaY = parcelRequire("cEyaY");

var $aU19E = parcelRequire("aU19E");
var $9879a39b0ac3584d$var$root = [
    null
];
function $9879a39b0ac3584d$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $aU19E.SCHEDULED) && schedule.name === name) return new (0, $cEyaY.Transition)([
                [
                    node
                ]
            ], $9879a39b0ac3584d$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("kLt7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1deca3b7ba4bd6f$export$2e2bcd8739ae039);
function $f1deca3b7ba4bd6f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("kVoZk", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ee65384d49a13d$export$2e2bcd8739ae039);
function $03ee65384d49a13d$export$2e2bcd8739ae039(target, type, selection) {
    this.target = target;
    this.type = type;
    this.selection = selection;
}

});

parcelRegister("3Kjca", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $2ba48ebbb80e2a36$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $2ba48ebbb80e2a36$export$2e2bcd8739ae039);

var $khWJJ = parcelRequire("khWJJ");
function $2ba48ebbb80e2a36$export$2e2561858db9bf47() {
    (0, $khWJJ.event).stopImmediatePropagation();
}
function $2ba48ebbb80e2a36$export$2e2bcd8739ae039() {
    (0, $khWJJ.event).preventDefault();
    (0, $khWJJ.event).stopImmediatePropagation();
}

});



parcelRegister("3Joxq", function(module, exports) {

var $1PtmF = parcelRequire("1PtmF");

var $eHgnk = parcelRequire("eHgnk");

});
parcelRegister("1PtmF", function(module, exports) {
parcelRequire("8qmD5");
var $g4YVZ = parcelRequire("g4YVZ");

var $k7SDm = parcelRequire("k7SDm");
function $155155140021f612$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $155155140021f612$export$2e2bcd8739ae039() {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = [], groupIndex = (0, $g4YVZ.default)(n), subgroupIndex = [], chords = [], groups = chords.groups = new Array(n), subgroups = new Array(n * n), k, x, x0, dx, i, j;
        // Compute the sum.
        k = 0, i = -1;
        while(++i < n){
            x = 0, j = -1;
            while(++j < n)x += matrix[i][j];
            groupSums.push(x);
            subgroupIndex.push((0, $g4YVZ.default)(n));
            k += x;
        }
        // Sort groups…
        if (sortGroups) groupIndex.sort(function(a, b) {
            return sortGroups(groupSums[a], groupSums[b]);
        });
        // Sort subgroups…
        if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
            d.sort(function(a, b) {
                return sortSubgroups(matrix[i][a], matrix[i][b]);
            });
        });
        // Convert the sum to scaling factor for [0, 2pi].
        // TODO Allow start and end angle to be specified?
        // TODO Allow padding to be specified as percentage?
        k = (0, $k7SDm.max)(0, (0, $k7SDm.tau) - padAngle * n) / k;
        dx = k ? padAngle : (0, $k7SDm.tau) / n;
        // Compute the start and end angle for each group and subgroup.
        // Note: Opera has a bug reordering object literal properties!
        x = 0, i = -1;
        while(++i < n){
            x0 = x, j = -1;
            while(++j < n){
                var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
                subgroups[dj * n + di] = {
                    index: di,
                    subindex: dj,
                    startAngle: a0,
                    endAngle: a1,
                    value: v
                };
            }
            groups[di] = {
                index: di,
                startAngle: x0,
                endAngle: x,
                value: groupSums[di]
            };
            x += dx;
        }
        // Generate chords for each (non-empty) subgroup-subgroup link.
        i = -1;
        while(++i < n){
            j = i - 1;
            while(++j < n){
                var source = subgroups[j * n + i], target = subgroups[i * n + j];
                if (source.value || target.value) chords.push(source.value < target.value ? {
                    source: target,
                    target: source
                } : {
                    source: source,
                    target: target
                });
            }
        }
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $k7SDm.max)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $155155140021f612$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}

});
parcelRegister("8qmD5", function(module, exports) {

$parcel$export(module.exports, "bisect", () => (parcelRequire("cwZCH")).default);
$parcel$export(module.exports, "bisectRight", () => (parcelRequire("cwZCH")).bisectRight);
$parcel$export(module.exports, "bisectLeft", () => (parcelRequire("cwZCH")).bisectLeft);
$parcel$export(module.exports, "ascending", () => (parcelRequire("ikXK9")).default);
$parcel$export(module.exports, "bisector", () => (parcelRequire("1hA0I")).default);
$parcel$export(module.exports, "cross", () => (parcelRequire("2FKxn")).default);
$parcel$export(module.exports, "descending", () => (parcelRequire("h7Ue2")).default);
$parcel$export(module.exports, "deviation", () => (parcelRequire("2uDpI")).default);
$parcel$export(module.exports, "extent", () => (parcelRequire("7vAcD")).default);
$parcel$export(module.exports, "histogram", () => (parcelRequire("9EYaC")).default);
$parcel$export(module.exports, "thresholdFreedmanDiaconis", () => (parcelRequire("4577G")).default);
$parcel$export(module.exports, "thresholdScott", () => (parcelRequire("6YZeN")).default);
$parcel$export(module.exports, "thresholdSturges", () => (parcelRequire("aHgyR")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("KpPuy")).default);
$parcel$export(module.exports, "mean", () => (parcelRequire("4yfeG")).default);
$parcel$export(module.exports, "median", () => (parcelRequire("l1gm2")).default);
$parcel$export(module.exports, "merge", () => (parcelRequire("aXvHU")).default);
$parcel$export(module.exports, "min", () => (parcelRequire("kAZFv")).default);
$parcel$export(module.exports, "pairs", () => (parcelRequire("EjaQz")).default);
$parcel$export(module.exports, "permute", () => (parcelRequire("j7ztS")).default);
$parcel$export(module.exports, "quantile", () => (parcelRequire("dAnXI")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("g4YVZ")).default);
$parcel$export(module.exports, "scan", () => (parcelRequire("fgOxt")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("lNlBs")).default);
$parcel$export(module.exports, "sum", () => (parcelRequire("7FxEL")).default);
$parcel$export(module.exports, "ticks", () => (parcelRequire("jmphu")).default);
$parcel$export(module.exports, "tickIncrement", () => (parcelRequire("jmphu")).tickIncrement);
$parcel$export(module.exports, "tickStep", () => (parcelRequire("jmphu")).tickStep);
$parcel$export(module.exports, "transpose", () => (parcelRequire("iow2t")).default);
$parcel$export(module.exports, "variance", () => (parcelRequire("iCJvK")).default);
$parcel$export(module.exports, "zip", () => (parcelRequire("i1MSl")).default);

var $cwZCH = parcelRequire("cwZCH");

var $ikXK9 = parcelRequire("ikXK9");

var $1hA0I = parcelRequire("1hA0I");

var $2FKxn = parcelRequire("2FKxn");

var $h7Ue2 = parcelRequire("h7Ue2");

var $2uDpI = parcelRequire("2uDpI");

var $7vAcD = parcelRequire("7vAcD");

var $9EYaC = parcelRequire("9EYaC");

var $4577G = parcelRequire("4577G");

var $6YZeN = parcelRequire("6YZeN");

var $aHgyR = parcelRequire("aHgyR");

var $KpPuy = parcelRequire("KpPuy");

var $4yfeG = parcelRequire("4yfeG");

var $l1gm2 = parcelRequire("l1gm2");

var $aXvHU = parcelRequire("aXvHU");

var $kAZFv = parcelRequire("kAZFv");

var $EjaQz = parcelRequire("EjaQz");

var $j7ztS = parcelRequire("j7ztS");

var $dAnXI = parcelRequire("dAnXI");

var $g4YVZ = parcelRequire("g4YVZ");

var $fgOxt = parcelRequire("fgOxt");

var $lNlBs = parcelRequire("lNlBs");

var $7FxEL = parcelRequire("7FxEL");

var $jmphu = parcelRequire("jmphu");

var $iow2t = parcelRequire("iow2t");

var $iCJvK = parcelRequire("iCJvK");

var $i1MSl = parcelRequire("i1MSl");

});
parcelRegister("cwZCH", function(module, exports) {

$parcel$export(module.exports, "bisectRight", () => $91f8464a3528c5ce$export$4d945ad3ad5751b0);
$parcel$export(module.exports, "bisectLeft", () => $91f8464a3528c5ce$export$df7d25c84ebd12a5);
$parcel$export(module.exports, "default", () => $91f8464a3528c5ce$export$2e2bcd8739ae039);

var $ikXK9 = parcelRequire("ikXK9");

var $1hA0I = parcelRequire("1hA0I");
var $91f8464a3528c5ce$var$ascendingBisect = (0, $1hA0I.default)((0, $ikXK9.default));
var $91f8464a3528c5ce$export$4d945ad3ad5751b0 = $91f8464a3528c5ce$var$ascendingBisect.right;
var $91f8464a3528c5ce$export$df7d25c84ebd12a5 = $91f8464a3528c5ce$var$ascendingBisect.left;
var $91f8464a3528c5ce$export$2e2bcd8739ae039 = $91f8464a3528c5ce$export$4d945ad3ad5751b0;

});
parcelRegister("ikXK9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d598700e36b5a148$export$2e2bcd8739ae039);
function $d598700e36b5a148$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1hA0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ef34ff1b66340ea$export$2e2bcd8739ae039);

var $ikXK9 = parcelRequire("ikXK9");
function $0ef34ff1b66340ea$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $0ef34ff1b66340ea$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $0ef34ff1b66340ea$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $ikXK9.default)(f(d), x);
    };
}

});


parcelRegister("2FKxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f23826fb05aba34$export$2e2bcd8739ae039);

var $EjaQz = parcelRequire("EjaQz");
function $1f23826fb05aba34$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $EjaQz.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("EjaQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $07929c169d633b68$export$2e2bcd8739ae039);
$parcel$export(module.exports, "pair", () => $07929c169d633b68$export$a04cb3fe8b81dd);
function $07929c169d633b68$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $07929c169d633b68$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $07929c169d633b68$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("h7Ue2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c77eb44d730cfaa4$export$2e2bcd8739ae039);
function $c77eb44d730cfaa4$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("2uDpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d0cf4d82ba929b5$export$2e2bcd8739ae039);

var $iCJvK = parcelRequire("iCJvK");
function $1d0cf4d82ba929b5$export$2e2bcd8739ae039(array, f) {
    var v = (0, $iCJvK.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("iCJvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ef142b429b71f1$export$2e2bcd8739ae039);

var $lqKDf = parcelRequire("lqKDf");
function $d8ef142b429b71f1$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("lqKDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9a032d23365899f$export$2e2bcd8739ae039);
function $f9a032d23365899f$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("7vAcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $577782c99ff74bed$export$2e2bcd8739ae039);
function $577782c99ff74bed$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("9EYaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7086860614c67edf$export$2e2bcd8739ae039);

var $3TF7W = parcelRequire("3TF7W");

var $cwZCH = parcelRequire("cwZCH");

var $3i4QB = parcelRequire("3i4QB");

var $7vAcD = parcelRequire("7vAcD");

var $89GLX = parcelRequire("89GLX");

var $g4YVZ = parcelRequire("g4YVZ");

var $jmphu = parcelRequire("jmphu");

var $aHgyR = parcelRequire("aHgyR");
function $7086860614c67edf$export$2e2bcd8739ae039() {
    var value = (0, $89GLX.default), domain = (0, $7vAcD.default), threshold = (0, $aHgyR.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $jmphu.tickStep)(x0, x1, tz);
            tz = (0, $g4YVZ.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $cwZCH.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $3i4QB.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $3i4QB.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $3i4QB.default)((0, $3TF7W.slice).call(_)) : (0, $3i4QB.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("3TF7W", function(module, exports) {

$parcel$export(module.exports, "slice", () => $2d66691cfe8394ae$export$58adb3bec8346d0f);
$parcel$export(module.exports, "map", () => $2d66691cfe8394ae$export$871de8747c9eaa88);
var $2d66691cfe8394ae$var$array = Array.prototype;
var $2d66691cfe8394ae$export$58adb3bec8346d0f = $2d66691cfe8394ae$var$array.slice;
var $2d66691cfe8394ae$export$871de8747c9eaa88 = $2d66691cfe8394ae$var$array.map;

});

parcelRegister("3i4QB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2656d0219b83d594$export$2e2bcd8739ae039);
function $2656d0219b83d594$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("89GLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0057b51f7fe5bb$export$2e2bcd8739ae039);
function $5f0057b51f7fe5bb$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("g4YVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb4c495b508b89d6$export$2e2bcd8739ae039);
function $bb4c495b508b89d6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("jmphu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e183aeb81cd707dd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $e183aeb81cd707dd$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $e183aeb81cd707dd$export$81087d9b915d4ede);
var $e183aeb81cd707dd$var$e10 = Math.sqrt(50), $e183aeb81cd707dd$var$e5 = Math.sqrt(10), $e183aeb81cd707dd$var$e2 = Math.sqrt(2);
function $e183aeb81cd707dd$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $e183aeb81cd707dd$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $e183aeb81cd707dd$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $e183aeb81cd707dd$var$e10 ? 10 : error >= $e183aeb81cd707dd$var$e5 ? 5 : error >= $e183aeb81cd707dd$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $e183aeb81cd707dd$var$e10 ? 10 : error >= $e183aeb81cd707dd$var$e5 ? 5 : error >= $e183aeb81cd707dd$var$e2 ? 2 : 1);
}
function $e183aeb81cd707dd$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $e183aeb81cd707dd$var$e10) step1 *= 10;
    else if (error >= $e183aeb81cd707dd$var$e5) step1 *= 5;
    else if (error >= $e183aeb81cd707dd$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("aHgyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9ac43f0750ec32$export$2e2bcd8739ae039);
function $7c9ac43f0750ec32$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("4577G", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f8d278a267c0aea$export$2e2bcd8739ae039);

var $3TF7W = parcelRequire("3TF7W");

var $ikXK9 = parcelRequire("ikXK9");

var $lqKDf = parcelRequire("lqKDf");

var $dAnXI = parcelRequire("dAnXI");
function $2f8d278a267c0aea$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $3TF7W.map).call(values, (0, $lqKDf.default)).sort((0, $ikXK9.default));
    return Math.ceil((max - min) / (2 * ((0, $dAnXI.default)(values, 0.75) - (0, $dAnXI.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("dAnXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e41398df751047a$export$2e2bcd8739ae039);

var $lqKDf = parcelRequire("lqKDf");
function $9e41398df751047a$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $lqKDf.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("6YZeN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5157d92b80fddd2c$export$2e2bcd8739ae039);

var $2uDpI = parcelRequire("2uDpI");
function $5157d92b80fddd2c$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $2uDpI.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("KpPuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $08b8553225be4ad3$export$2e2bcd8739ae039);
function $08b8553225be4ad3$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("4yfeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $350627edb0fd1355$export$2e2bcd8739ae039);

var $lqKDf = parcelRequire("lqKDf");
function $350627edb0fd1355$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("l1gm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4d660a154239ee6$export$2e2bcd8739ae039);

var $ikXK9 = parcelRequire("ikXK9");

var $lqKDf = parcelRequire("lqKDf");

var $dAnXI = parcelRequire("dAnXI");
function $f4d660a154239ee6$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $lqKDf.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $dAnXI.default)(numbers.sort((0, $ikXK9.default)), 0.5);
}

});

parcelRegister("aXvHU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa80274138b92c0$export$2e2bcd8739ae039);
function $7fa80274138b92c0$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("kAZFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe701885a1d3da6$export$2e2bcd8739ae039);
function $efe701885a1d3da6$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("j7ztS", function(module, exports) {

$parcel$export(module.exports, "default", () => $deba318444812356$export$2e2bcd8739ae039);
function $deba318444812356$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("fgOxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1df8d99ffd1b619$export$2e2bcd8739ae039);

var $ikXK9 = parcelRequire("ikXK9");
function $b1df8d99ffd1b619$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $ikXK9.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("lNlBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $fddeee7d9dab40a6$export$2e2bcd8739ae039);
function $fddeee7d9dab40a6$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("7FxEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $595678317647702e$export$2e2bcd8739ae039);
function $595678317647702e$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("iow2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6435228b354c3fc$export$2e2bcd8739ae039);

var $kAZFv = parcelRequire("kAZFv");
function $d6435228b354c3fc$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $kAZFv.default)(matrix, $d6435228b354c3fc$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $d6435228b354c3fc$var$length(d) {
    return d.length;
}

});

parcelRegister("i1MSl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1fe3ba6484d9b47$export$2e2bcd8739ae039);

var $iow2t = parcelRequire("iow2t");
function $d1fe3ba6484d9b47$export$2e2bcd8739ae039() {
    return (0, $iow2t.default)(arguments);
}

});


parcelRegister("k7SDm", function(module, exports) {

$parcel$export(module.exports, "cos", () => $ea6ed74049022910$export$50d414a77b60d802);
$parcel$export(module.exports, "sin", () => $ea6ed74049022910$export$5de3937cb4b592ed);
$parcel$export(module.exports, "halfPi", () => $ea6ed74049022910$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $ea6ed74049022910$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "max", () => $ea6ed74049022910$export$8960430cfd85939f);
var $ea6ed74049022910$export$50d414a77b60d802 = Math.cos;
var $ea6ed74049022910$export$5de3937cb4b592ed = Math.sin;
var $ea6ed74049022910$export$18c7bea995a110f = Math.PI;
var $ea6ed74049022910$export$e51408a300e8929a = $ea6ed74049022910$export$18c7bea995a110f / 2;
var $ea6ed74049022910$export$a4b4b4d4d776fe92 = $ea6ed74049022910$export$18c7bea995a110f * 2;
var $ea6ed74049022910$export$8960430cfd85939f = Math.max;

});


parcelRegister("eHgnk", function(module, exports) {

var $aPoQM = parcelRequire("aPoQM");

var $eIjcs = parcelRequire("eIjcs");

var $k7SDm = parcelRequire("k7SDm");

var $176ah = parcelRequire("176ah");
function $ab31c8a59691f4ad$var$defaultSource(d) {
    return d.source;
}
function $ab31c8a59691f4ad$var$defaultTarget(d) {
    return d.target;
}
function $ab31c8a59691f4ad$var$defaultRadius(d) {
    return d.radius;
}
function $ab31c8a59691f4ad$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $ab31c8a59691f4ad$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $ab31c8a59691f4ad$export$2e2bcd8739ae039() {
    var source = $ab31c8a59691f4ad$var$defaultSource, target = $ab31c8a59691f4ad$var$defaultTarget, radius = $ab31c8a59691f4ad$var$defaultRadius, startAngle = $ab31c8a59691f4ad$var$defaultStartAngle, endAngle = $ab31c8a59691f4ad$var$defaultEndAngle, context = null;
    function ribbon() {
        var buffer, argv = (0, $aPoQM.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv), sr = +radius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $k7SDm.halfPi), sa1 = endAngle.apply(this, argv) - (0, $k7SDm.halfPi), sx0 = sr * (0, $k7SDm.cos)(sa0), sy0 = sr * (0, $k7SDm.sin)(sa0), tr = +radius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $k7SDm.halfPi), ta1 = endAngle.apply(this, argv) - (0, $k7SDm.halfPi);
        if (!context) context = buffer = (0, $176ah.default)();
        context.moveTo(sx0, sy0);
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            context.quadraticCurveTo(0, 0, tr * (0, $k7SDm.cos)(ta0), tr * (0, $k7SDm.sin)(ta0));
            context.arc(0, 0, tr, ta0, ta1);
        }
        context.quadraticCurveTo(0, 0, sx0, sy0);
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    ribbon.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $eIjcs.default)(+_), ribbon) : radius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $eIjcs.default)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $eIjcs.default)(+_), ribbon) : endAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}

});
parcelRegister("aPoQM", function(module, exports) {

$parcel$export(module.exports, "slice", () => $7e21f18816e6c205$export$58adb3bec8346d0f);
var $7e21f18816e6c205$export$58adb3bec8346d0f = Array.prototype.slice;

});

parcelRegister("eIjcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab641176d2af9dfa$export$2e2bcd8739ae039);
function $ab641176d2af9dfa$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("176ah", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cfb3a1425ae275c$export$2e2bcd8739ae039);
var $0cfb3a1425ae275c$var$pi = Math.PI, $0cfb3a1425ae275c$var$tau = 2 * $0cfb3a1425ae275c$var$pi, $0cfb3a1425ae275c$var$epsilon = 1e-6, $0cfb3a1425ae275c$var$tauEpsilon = $0cfb3a1425ae275c$var$tau - $0cfb3a1425ae275c$var$epsilon;
function $0cfb3a1425ae275c$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $0cfb3a1425ae275c$var$path() {
    return new $0cfb3a1425ae275c$var$Path;
}
$0cfb3a1425ae275c$var$Path.prototype = $0cfb3a1425ae275c$var$path.prototype = {
    constructor: $0cfb3a1425ae275c$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $0cfb3a1425ae275c$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $0cfb3a1425ae275c$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($0cfb3a1425ae275c$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $0cfb3a1425ae275c$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $0cfb3a1425ae275c$var$epsilon || Math.abs(this._y1 - y0) > $0cfb3a1425ae275c$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $0cfb3a1425ae275c$var$tau + $0cfb3a1425ae275c$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $0cfb3a1425ae275c$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $0cfb3a1425ae275c$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $0cfb3a1425ae275c$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $0cfb3a1425ae275c$export$2e2bcd8739ae039 = $0cfb3a1425ae275c$var$path;

});



parcelRegister("1CdYK", function(module, exports) {

var $99q4L = parcelRequire("99q4L");

var $itVSX = parcelRequire("itVSX");

var $cxmF0 = parcelRequire("cxmF0");

var $c2sla = parcelRequire("c2sla");

var $7oTnd = parcelRequire("7oTnd");

var $9zT12 = parcelRequire("9zT12");

});
parcelRegister("99q4L", function(module, exports) {

var $cxmF0 = parcelRequire("cxmF0");
function $6a992e6f807fff04$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $cxmF0.default)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $6a992e6f807fff04$var$createObject, $6a992e6f807fff04$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $6a992e6f807fff04$var$createMap, $6a992e6f807fff04$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $6a992e6f807fff04$var$createMap, $6a992e6f807fff04$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $6a992e6f807fff04$var$createObject() {
    return {};
}
function $6a992e6f807fff04$var$setObject(object, key, value) {
    object[key] = value;
}
function $6a992e6f807fff04$var$createMap() {
    return (0, $cxmF0.default)();
}
function $6a992e6f807fff04$var$setMap(map, key, value) {
    map.set(key, value);
}

});
parcelRegister("cxmF0", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $920a24f993a2b9aa$export$82e9f45cca5ba907);
$parcel$export(module.exports, "default", () => $920a24f993a2b9aa$export$2e2bcd8739ae039);
var $920a24f993a2b9aa$export$82e9f45cca5ba907 = "$";
function $920a24f993a2b9aa$var$Map() {}
$920a24f993a2b9aa$var$Map.prototype = $920a24f993a2b9aa$var$map.prototype = {
    constructor: $920a24f993a2b9aa$var$Map,
    has: function(key) {
        return $920a24f993a2b9aa$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$920a24f993a2b9aa$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$920a24f993a2b9aa$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $920a24f993a2b9aa$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $920a24f993a2b9aa$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $920a24f993a2b9aa$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $920a24f993a2b9aa$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $920a24f993a2b9aa$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $920a24f993a2b9aa$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $920a24f993a2b9aa$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $920a24f993a2b9aa$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $920a24f993a2b9aa$var$map(object, f) {
    var map = new $920a24f993a2b9aa$var$Map;
    // Copy constructor.
    if (object instanceof $920a24f993a2b9aa$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $920a24f993a2b9aa$export$2e2bcd8739ae039 = $920a24f993a2b9aa$var$map;

});


parcelRegister("itVSX", function(module, exports) {

var $cxmF0 = parcelRequire("cxmF0");
function $d747d646aa3c5d28$var$Set() {}
var $d747d646aa3c5d28$var$proto = (0, $cxmF0.default).prototype;
$d747d646aa3c5d28$var$Set.prototype = $d747d646aa3c5d28$var$set.prototype = {
    constructor: $d747d646aa3c5d28$var$Set,
    has: $d747d646aa3c5d28$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $cxmF0.prefix) + value] = value;
        return this;
    },
    remove: $d747d646aa3c5d28$var$proto.remove,
    clear: $d747d646aa3c5d28$var$proto.clear,
    values: $d747d646aa3c5d28$var$proto.keys,
    size: $d747d646aa3c5d28$var$proto.size,
    empty: $d747d646aa3c5d28$var$proto.empty,
    each: $d747d646aa3c5d28$var$proto.each
};
function $d747d646aa3c5d28$var$set(object, f) {
    var set = new $d747d646aa3c5d28$var$Set;
    // Copy constructor.
    if (object instanceof $d747d646aa3c5d28$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $d747d646aa3c5d28$export$2e2bcd8739ae039 = $d747d646aa3c5d28$var$set;

});

parcelRegister("c2sla", function(module, exports) {
function $8c3ba7bc447d7fc4$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}

});

parcelRegister("7oTnd", function(module, exports) {
function $5635ba4dcc35f9f3$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}

});

parcelRegister("9zT12", function(module, exports) {
function $6f920eedeaf0c920$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}

});


parcelRegister("3RLhB", function(module, exports) {

$parcel$export(module.exports, "color", () => (parcelRequire("iRjKv")).default);

var $iRjKv = parcelRequire("iRjKv");

var $ameJb = parcelRequire("ameJb");

var $j9Om5 = parcelRequire("j9Om5");

});
parcelRegister("iRjKv", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "hsl", () => hsl);

var $bzcRZ = parcelRequire("bzcRZ");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex3 = /^#([0-9a-f]{3})$/, reHex6 = /^#([0-9a-f]{6})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bzcRZ.default)(Color, color, {
    displayable: function() {
        return this.rgb().displayable();
    },
    toString: function() {
        return this.rgb() + "";
    }
});
function color(format) {
    var m;
    format = (format + "").trim().toLowerCase();
    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb(m >> 8 & 0xf | m >> 4 & 0x0f0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
    ) : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
     : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bzcRZ.default)(Rgb, rgb, (0, $bzcRZ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
    },
    toString: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
    }
}));
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bzcRZ.default)(Hsl, hsl, (0, $bzcRZ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bzcRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86bcf240eeead5ed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $86bcf240eeead5ed$export$8b58be045bf06082);
function $86bcf240eeead5ed$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $86bcf240eeead5ed$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("ameJb", function(module, exports) {

var $bzcRZ = parcelRequire("bzcRZ");

var $iRjKv = parcelRequire("iRjKv");

var $c4H2R = parcelRequire("c4H2R");
var $78a7621679432e61$var$Kn = 18, $78a7621679432e61$var$Xn = 0.950470, $78a7621679432e61$var$Yn = 1, $78a7621679432e61$var$Zn = 1.088830, $78a7621679432e61$var$t0 = 4 / 29, $78a7621679432e61$var$t1 = 6 / 29, $78a7621679432e61$var$t2 = 3 * $78a7621679432e61$var$t1 * $78a7621679432e61$var$t1, $78a7621679432e61$var$t3 = $78a7621679432e61$var$t1 * $78a7621679432e61$var$t1 * $78a7621679432e61$var$t1;
function $78a7621679432e61$var$labConvert(o) {
    if (o instanceof $78a7621679432e61$export$f2722c70a60257f7) return new $78a7621679432e61$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $78a7621679432e61$export$d9397e094a5fbb9a) {
        var h = o.h * (0, $c4H2R.deg2rad);
        return new $78a7621679432e61$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
    }
    if (!(o instanceof (0, $iRjKv.Rgb))) o = (0, $iRjKv.rgbConvert)(o);
    var b = $78a7621679432e61$var$rgb2xyz(o.r), a = $78a7621679432e61$var$rgb2xyz(o.g), l = $78a7621679432e61$var$rgb2xyz(o.b), x = $78a7621679432e61$var$xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / $78a7621679432e61$var$Xn), y = $78a7621679432e61$var$xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / $78a7621679432e61$var$Yn), z = $78a7621679432e61$var$xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / $78a7621679432e61$var$Zn);
    return new $78a7621679432e61$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $78a7621679432e61$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $78a7621679432e61$var$labConvert(l) : new $78a7621679432e61$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $78a7621679432e61$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bzcRZ.default)($78a7621679432e61$export$f2722c70a60257f7, $78a7621679432e61$export$2e2bcd8739ae039, (0, $bzcRZ.extend)((0, $iRjKv.Color), {
    brighter: function(k) {
        return new $78a7621679432e61$export$f2722c70a60257f7(this.l + $78a7621679432e61$var$Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $78a7621679432e61$export$f2722c70a60257f7(this.l - $78a7621679432e61$var$Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        y = $78a7621679432e61$var$Yn * $78a7621679432e61$var$lab2xyz(y);
        x = $78a7621679432e61$var$Xn * $78a7621679432e61$var$lab2xyz(x);
        z = $78a7621679432e61$var$Zn * $78a7621679432e61$var$lab2xyz(z);
        return new (0, $iRjKv.Rgb)($78a7621679432e61$var$xyz2rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), $78a7621679432e61$var$xyz2rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z), $78a7621679432e61$var$xyz2rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), this.opacity);
    }
}));
function $78a7621679432e61$var$xyz2lab(t) {
    return t > $78a7621679432e61$var$t3 ? Math.pow(t, 1 / 3) : t / $78a7621679432e61$var$t2 + $78a7621679432e61$var$t0;
}
function $78a7621679432e61$var$lab2xyz(t) {
    return t > $78a7621679432e61$var$t1 ? t * t * t : $78a7621679432e61$var$t2 * (t - $78a7621679432e61$var$t0);
}
function $78a7621679432e61$var$xyz2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $78a7621679432e61$var$rgb2xyz(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $78a7621679432e61$var$hclConvert(o) {
    if (o instanceof $78a7621679432e61$export$d9397e094a5fbb9a) return new $78a7621679432e61$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $78a7621679432e61$export$f2722c70a60257f7)) o = $78a7621679432e61$var$labConvert(o);
    var h = Math.atan2(o.b, o.a) * (0, $c4H2R.rad2deg);
    return new $78a7621679432e61$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $78a7621679432e61$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $78a7621679432e61$var$hclConvert(h) : new $78a7621679432e61$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $78a7621679432e61$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bzcRZ.default)($78a7621679432e61$export$d9397e094a5fbb9a, $78a7621679432e61$export$d0e870ba50062ff1, (0, $bzcRZ.extend)((0, $iRjKv.Color), {
    brighter: function(k) {
        return new $78a7621679432e61$export$d9397e094a5fbb9a(this.h, this.c, this.l + $78a7621679432e61$var$Kn * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $78a7621679432e61$export$d9397e094a5fbb9a(this.h, this.c, this.l - $78a7621679432e61$var$Kn * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $78a7621679432e61$var$labConvert(this).rgb();
    }
}));

});
parcelRegister("c4H2R", function(module, exports) {

$parcel$export(module.exports, "deg2rad", () => $8ca73fa55ffa4a78$export$b1b275608b2b1b8);
$parcel$export(module.exports, "rad2deg", () => $8ca73fa55ffa4a78$export$b2ba2578f2c43d74);
var $8ca73fa55ffa4a78$export$b1b275608b2b1b8 = Math.PI / 180;
var $8ca73fa55ffa4a78$export$b2ba2578f2c43d74 = 180 / Math.PI;

});


parcelRegister("j9Om5", function(module, exports) {

var $bzcRZ = parcelRequire("bzcRZ");

var $iRjKv = parcelRequire("iRjKv");

var $c4H2R = parcelRequire("c4H2R");
var $df25eb101935b0a0$var$A = -0.14861, $df25eb101935b0a0$var$B = 1.78277, $df25eb101935b0a0$var$C = -0.29227, $df25eb101935b0a0$var$D = -0.90649, $df25eb101935b0a0$var$E = 1.97294, $df25eb101935b0a0$var$ED = $df25eb101935b0a0$var$E * $df25eb101935b0a0$var$D, $df25eb101935b0a0$var$EB = $df25eb101935b0a0$var$E * $df25eb101935b0a0$var$B, $df25eb101935b0a0$var$BC_DA = $df25eb101935b0a0$var$B * $df25eb101935b0a0$var$C - $df25eb101935b0a0$var$D * $df25eb101935b0a0$var$A;
function $df25eb101935b0a0$var$cubehelixConvert(o) {
    if (o instanceof $df25eb101935b0a0$export$57ed4bde61a1e2f2) return new $df25eb101935b0a0$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $iRjKv.Rgb))) o = (0, $iRjKv.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($df25eb101935b0a0$var$BC_DA * b + $df25eb101935b0a0$var$ED * r - $df25eb101935b0a0$var$EB * g) / ($df25eb101935b0a0$var$BC_DA + $df25eb101935b0a0$var$ED - $df25eb101935b0a0$var$EB), bl = b - l, k = ($df25eb101935b0a0$var$E * (g - l) - $df25eb101935b0a0$var$C * bl) / $df25eb101935b0a0$var$D, s = Math.sqrt(k * k + bl * bl) / ($df25eb101935b0a0$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $c4H2R.rad2deg) - 120 : NaN;
    return new $df25eb101935b0a0$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $df25eb101935b0a0$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $df25eb101935b0a0$var$cubehelixConvert(h) : new $df25eb101935b0a0$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $df25eb101935b0a0$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bzcRZ.default)($df25eb101935b0a0$export$57ed4bde61a1e2f2, $df25eb101935b0a0$export$2e2bcd8739ae039, (0, $bzcRZ.extend)((0, $iRjKv.Color), {
    brighter: function(k) {
        k = k == null ? (0, $iRjKv.brighter) : Math.pow((0, $iRjKv.brighter), k);
        return new $df25eb101935b0a0$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $iRjKv.darker) : Math.pow((0, $iRjKv.darker), k);
        return new $df25eb101935b0a0$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $c4H2R.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $iRjKv.Rgb)(255 * (l + a * ($df25eb101935b0a0$var$A * cosh + $df25eb101935b0a0$var$B * sinh)), 255 * (l + a * ($df25eb101935b0a0$var$C * cosh + $df25eb101935b0a0$var$D * sinh)), 255 * (l + a * ($df25eb101935b0a0$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("cS2K3", function(module, exports) {

var $eCGTw = parcelRequire("eCGTw");

});
parcelRegister("eCGTw", function(module, exports) {
var $aa55e33c1fbe9501$var$noop = {
    value: function() {}
};
function $aa55e33c1fbe9501$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $aa55e33c1fbe9501$var$Dispatch(_);
}
function $aa55e33c1fbe9501$var$Dispatch(_) {
    this._ = _;
}
function $aa55e33c1fbe9501$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$aa55e33c1fbe9501$var$Dispatch.prototype = $aa55e33c1fbe9501$var$dispatch.prototype = {
    constructor: $aa55e33c1fbe9501$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $aa55e33c1fbe9501$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $aa55e33c1fbe9501$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $aa55e33c1fbe9501$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $aa55e33c1fbe9501$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $aa55e33c1fbe9501$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $aa55e33c1fbe9501$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $aa55e33c1fbe9501$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $aa55e33c1fbe9501$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $aa55e33c1fbe9501$export$2e2bcd8739ae039 = $aa55e33c1fbe9501$var$dispatch;

});


parcelRegister("kkt77", function(module, exports) {

var $35qap = parcelRequire("35qap");

var $3Qcfc = parcelRequire("3Qcfc");

});
parcelRegister("35qap", function(module, exports) {

var $5hLeq = parcelRequire("5hLeq");

var $feCaU = parcelRequire("feCaU");
var $g1IyN = parcelRequire("g1IyN");
var $25dMC = parcelRequire("25dMC");
var $8xm28 = parcelRequire("8xm28");

var $3Qcfc = parcelRequire("3Qcfc");

var $iJQ79 = parcelRequire("iJQ79");

var $8w5P9 = parcelRequire("8w5P9");

var $9JhvD = parcelRequire("9JhvD");
// Ignore right-click, since that should open the context menu.
function $23f622ecca00b094$var$defaultFilter() {
    return !(0, $feCaU.event).button;
}
function $23f622ecca00b094$var$defaultContainer() {
    return this.parentNode;
}
function $23f622ecca00b094$var$defaultSubject(d) {
    return d == null ? {
        x: (0, $feCaU.event).x,
        y: (0, $feCaU.event).y
    } : d;
}
function $23f622ecca00b094$var$defaultTouchable() {
    return "ontouchstart" in this;
}
function $23f622ecca00b094$export$2e2bcd8739ae039() {
    var filter = $23f622ecca00b094$var$defaultFilter, container = $23f622ecca00b094$var$defaultContainer, subject = $23f622ecca00b094$var$defaultSubject, touchable = $23f622ecca00b094$var$defaultTouchable, gestures = {}, listeners = (0, $5hLeq.default)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var gesture = beforestart("mouse", container.apply(this, arguments), (0, $g1IyN.default), this, arguments);
        if (!gesture) return;
        (0, $25dMC.default)((0, $feCaU.event).view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
        (0, $3Qcfc.default)((0, $feCaU.event).view);
        (0, $iJQ79.nopropagation)();
        mousemoving = false;
        mousedownx = (0, $feCaU.event).clientX;
        mousedowny = (0, $feCaU.event).clientY;
        gesture("start");
    }
    function mousemoved() {
        (0, $iJQ79.default)();
        if (!mousemoving) {
            var dx = (0, $feCaU.event).clientX - mousedownx, dy = (0, $feCaU.event).clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag");
    }
    function mouseupped() {
        (0, $25dMC.default)((0, $feCaU.event).view).on("mousemove.drag mouseup.drag", null);
        (0, $3Qcfc.yesdrag)((0, $feCaU.event).view, mousemoving);
        (0, $iJQ79.default)();
        gestures.mouse("end");
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $feCaU.event).changedTouches, c = container.apply(this, arguments), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(touches[i].identifier, c, (0, $8xm28.default), this, arguments)) {
            (0, $iJQ79.nopropagation)();
            gesture("start");
        }
    }
    function touchmoved() {
        var touches = (0, $feCaU.event).changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $iJQ79.default)();
            gesture("drag");
        }
    }
    function touchended() {
        var touches = (0, $feCaU.event).changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $iJQ79.nopropagation)();
            gesture("end");
        }
    }
    function beforestart(id, container, point, that, args) {
        var p = point(container, id), s, dx, dy, sublisteners = listeners.copy();
        if (!(0, $feCaU.customEvent)(new (0, $9JhvD.default)(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
            if (((0, $feCaU.event).subject = s = subject.apply(that, args)) == null) return false;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return true;
        })) return;
        return function gesture(type) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[id] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[id], --active; // nobreak
                case "drag":
                    p = point(container, id), n = active;
                    break;
            }
            (0, $feCaU.customEvent)(new (0, $9JhvD.default)(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [
                type,
                that,
                args
            ]);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $8w5P9.default)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $8w5P9.default)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $8w5P9.default)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $8w5P9.default)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}

});
parcelRegister("5hLeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d932d85aae29107$export$2e2bcd8739ae039);
var $3d932d85aae29107$var$noop = {
    value: function() {}
};
function $3d932d85aae29107$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $3d932d85aae29107$var$Dispatch(_);
}
function $3d932d85aae29107$var$Dispatch(_) {
    this._ = _;
}
function $3d932d85aae29107$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$3d932d85aae29107$var$Dispatch.prototype = $3d932d85aae29107$var$dispatch.prototype = {
    constructor: $3d932d85aae29107$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $3d932d85aae29107$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $3d932d85aae29107$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $3d932d85aae29107$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $3d932d85aae29107$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $3d932d85aae29107$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $3d932d85aae29107$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $3d932d85aae29107$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $3d932d85aae29107$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $3d932d85aae29107$export$2e2bcd8739ae039 = $3d932d85aae29107$var$dispatch;

});

parcelRegister("feCaU", function(module, exports) {

$parcel$export(module.exports, "event", () => $b175c69059577c13$export$6cd530ed55e06764);
$parcel$export(module.exports, "default", () => $b175c69059577c13$export$2e2bcd8739ae039);
$parcel$export(module.exports, "customEvent", () => $b175c69059577c13$export$4c724631b4750aef);
var $b175c69059577c13$var$filterEvents = {};
var $b175c69059577c13$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $b175c69059577c13$var$element = document.documentElement;
    if (!("onmouseenter" in $b175c69059577c13$var$element)) $b175c69059577c13$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $b175c69059577c13$var$filterContextListener(listener, index, group) {
    listener = $b175c69059577c13$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $b175c69059577c13$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $b175c69059577c13$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $b175c69059577c13$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $b175c69059577c13$export$6cd530ed55e06764 = event0;
        }
    };
}
function $b175c69059577c13$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $b175c69059577c13$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $b175c69059577c13$var$onAdd(typename, value, capture) {
    var wrap = $b175c69059577c13$var$filterEvents.hasOwnProperty(typename.type) ? $b175c69059577c13$var$filterContextListener : $b175c69059577c13$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $b175c69059577c13$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $b175c69059577c13$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $b175c69059577c13$var$onAdd : $b175c69059577c13$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $b175c69059577c13$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $b175c69059577c13$export$6cd530ed55e06764;
    event1.sourceEvent = $b175c69059577c13$export$6cd530ed55e06764;
    $b175c69059577c13$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $b175c69059577c13$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("g1IyN", function(module, exports) {

$parcel$export(module.exports, "default", () => $baaf4e114495f5b5$export$2e2bcd8739ae039);

var $4w4Jn = parcelRequire("4w4Jn");

var $800jP = parcelRequire("800jP");
function $baaf4e114495f5b5$export$2e2bcd8739ae039(node) {
    var event = (0, $4w4Jn.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $800jP.default)(node, event);
}

});
parcelRegister("4w4Jn", function(module, exports) {

$parcel$export(module.exports, "default", () => $349dd20a70529baa$export$2e2bcd8739ae039);

var $feCaU = parcelRequire("feCaU");
function $349dd20a70529baa$export$2e2bcd8739ae039() {
    var current = (0, $feCaU.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("800jP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2e921cd0a28e69$export$2e2bcd8739ae039);
function $5d2e921cd0a28e69$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("25dMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1846bd6fcd8013c9$export$2e2bcd8739ae039);

var $hMAZl = parcelRequire("hMAZl");
function $1846bd6fcd8013c9$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $hMAZl.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $hMAZl.Selection)([
        [
            selector
        ]
    ], (0, $hMAZl.root));
}

});
parcelRegister("hMAZl", function(module, exports) {

$parcel$export(module.exports, "root", () => $cf239c7b35dbb3c0$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $cf239c7b35dbb3c0$export$52baac22726c72bf);

var $5KJ5j = parcelRequire("5KJ5j");

var $h330s = parcelRequire("h330s");

var $9zqRS = parcelRequire("9zqRS");

var $4cBuK = parcelRequire("4cBuK");

var $9IL4Y = parcelRequire("9IL4Y");

var $h7ska = parcelRequire("h7ska");

var $5dg1o = parcelRequire("5dg1o");

var $9JSUm = parcelRequire("9JSUm");

var $kjUur = parcelRequire("kjUur");

var $fnmhe = parcelRequire("fnmhe");

var $65TbV = parcelRequire("65TbV");

var $9z3rR = parcelRequire("9z3rR");

var $fGt36 = parcelRequire("fGt36");

var $7ugka = parcelRequire("7ugka");

var $k7PQ7 = parcelRequire("k7PQ7");

var $afIoj = parcelRequire("afIoj");

var $fpNMF = parcelRequire("fpNMF");

var $jsT6Q = parcelRequire("jsT6Q");

var $5vvHJ = parcelRequire("5vvHJ");

var $6Aniq = parcelRequire("6Aniq");

var $kmvip = parcelRequire("kmvip");

var $hV7Tm = parcelRequire("hV7Tm");

var $bTQR6 = parcelRequire("bTQR6");

var $cFS8c = parcelRequire("cFS8c");

var $zGqLL = parcelRequire("zGqLL");

var $9xY5j = parcelRequire("9xY5j");

var $cpwZP = parcelRequire("cpwZP");

var $jzZuD = parcelRequire("jzZuD");

var $hgk9S = parcelRequire("hgk9S");

var $feCaU = parcelRequire("feCaU");

var $b3Ocr = parcelRequire("b3Ocr");
var $cf239c7b35dbb3c0$export$e8e78c978b129247 = [
    null
];
function $cf239c7b35dbb3c0$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $cf239c7b35dbb3c0$var$selection() {
    return new $cf239c7b35dbb3c0$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $cf239c7b35dbb3c0$export$e8e78c978b129247);
}
$cf239c7b35dbb3c0$export$52baac22726c72bf.prototype = $cf239c7b35dbb3c0$var$selection.prototype = {
    constructor: $cf239c7b35dbb3c0$export$52baac22726c72bf,
    select: (0, $5KJ5j.default),
    selectAll: (0, $h330s.default),
    filter: (0, $9zqRS.default),
    data: (0, $4cBuK.default),
    enter: (0, $9IL4Y.default),
    exit: (0, $h7ska.default),
    join: (0, $5dg1o.default),
    merge: (0, $9JSUm.default),
    order: (0, $kjUur.default),
    sort: (0, $fnmhe.default),
    call: (0, $65TbV.default),
    nodes: (0, $9z3rR.default),
    node: (0, $fGt36.default),
    size: (0, $7ugka.default),
    empty: (0, $k7PQ7.default),
    each: (0, $afIoj.default),
    attr: (0, $fpNMF.default),
    style: (0, $jsT6Q.default),
    property: (0, $5vvHJ.default),
    classed: (0, $6Aniq.default),
    text: (0, $kmvip.default),
    html: (0, $hV7Tm.default),
    raise: (0, $bTQR6.default),
    lower: (0, $cFS8c.default),
    append: (0, $zGqLL.default),
    insert: (0, $9xY5j.default),
    remove: (0, $cpwZP.default),
    clone: (0, $jzZuD.default),
    datum: (0, $hgk9S.default),
    on: (0, $feCaU.default),
    dispatch: (0, $b3Ocr.default)
};
var $cf239c7b35dbb3c0$export$2e2bcd8739ae039 = $cf239c7b35dbb3c0$var$selection;

});
parcelRegister("5KJ5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $43043887aca60cfb$export$2e2bcd8739ae039);

var $hMAZl = parcelRequire("hMAZl");

var $4JjYU = parcelRequire("4JjYU");
function $43043887aca60cfb$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $4JjYU.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $hMAZl.Selection)(subgroups, this._parents);
}

});
parcelRegister("4JjYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $371add4eb4a9ffb0$export$2e2bcd8739ae039);
function $371add4eb4a9ffb0$var$none() {}
function $371add4eb4a9ffb0$export$2e2bcd8739ae039(selector) {
    return selector == null ? $371add4eb4a9ffb0$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("h330s", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6950c765a268eca$export$2e2bcd8739ae039);

var $hMAZl = parcelRequire("hMAZl");

var $esAkq = parcelRequire("esAkq");
function $c6950c765a268eca$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $esAkq.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $hMAZl.Selection)(subgroups, parents);
}

});
parcelRegister("esAkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a86fdc49c946a7f2$export$2e2bcd8739ae039);
function $a86fdc49c946a7f2$var$empty() {
    return [];
}
function $a86fdc49c946a7f2$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a86fdc49c946a7f2$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("9zqRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7c3962978e148d$export$2e2bcd8739ae039);

var $hMAZl = parcelRequire("hMAZl");

var $3WMMt = parcelRequire("3WMMt");
function $6f7c3962978e148d$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $3WMMt.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $hMAZl.Selection)(subgroups, this._parents);
}

});
parcelRegister("3WMMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dfca0c1cf6103b6$export$2e2bcd8739ae039);
function $2dfca0c1cf6103b6$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("4cBuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $30f55e235a53232a$export$2e2bcd8739ae039);

var $hMAZl = parcelRequire("hMAZl");

var $9IL4Y = parcelRequire("9IL4Y");

var $eqQB7 = parcelRequire("eqQB7");
var $30f55e235a53232a$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $30f55e235a53232a$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $9IL4Y.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $30f55e235a53232a$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $30f55e235a53232a$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $30f55e235a53232a$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $9IL4Y.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $30f55e235a53232a$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $30f55e235a53232a$var$bindKey : $30f55e235a53232a$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $eqQB7.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $hMAZl.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("9IL4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $713cbe147ba4ddcd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $713cbe147ba4ddcd$export$67b01759a14cf6a4);

var $RJOHA = parcelRequire("RJOHA");

var $hMAZl = parcelRequire("hMAZl");
function $713cbe147ba4ddcd$export$2e2bcd8739ae039() {
    return new (0, $hMAZl.Selection)(this._enter || this._groups.map((0, $RJOHA.default)), this._parents);
}
function $713cbe147ba4ddcd$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$713cbe147ba4ddcd$export$67b01759a14cf6a4.prototype = {
    constructor: $713cbe147ba4ddcd$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("RJOHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a187d9beaaa0e06$export$2e2bcd8739ae039);
function $0a187d9beaaa0e06$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("eqQB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a81c4b36493ed0c0$export$2e2bcd8739ae039);
function $a81c4b36493ed0c0$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("h7ska", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7690fb75e4e4c0f$export$2e2bcd8739ae039);

var $RJOHA = parcelRequire("RJOHA");

var $hMAZl = parcelRequire("hMAZl");
function $c7690fb75e4e4c0f$export$2e2bcd8739ae039() {
    return new (0, $hMAZl.Selection)(this._exit || this._groups.map((0, $RJOHA.default)), this._parents);
}

});

parcelRegister("5dg1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cba98297e9609d4$export$2e2bcd8739ae039);
function $3cba98297e9609d4$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("9JSUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7172e8a44f1ce1b8$export$2e2bcd8739ae039);

var $hMAZl = parcelRequire("hMAZl");
function $7172e8a44f1ce1b8$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $hMAZl.Selection)(merges, this._parents);
}

});

parcelRegister("kjUur", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb166bc8f6ad133$export$2e2bcd8739ae039);
function $ecb166bc8f6ad133$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("fnmhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31a48bf7f8eb2c8$export$2e2bcd8739ae039);

var $hMAZl = parcelRequire("hMAZl");
function $b31a48bf7f8eb2c8$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $b31a48bf7f8eb2c8$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $hMAZl.Selection)(sortgroups, this._parents).order();
}
function $b31a48bf7f8eb2c8$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("65TbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $46fe058df02c05aa$export$2e2bcd8739ae039);
function $46fe058df02c05aa$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("9z3rR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6a0ebd01a2b4ed$export$2e2bcd8739ae039);
function $6f6a0ebd01a2b4ed$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("fGt36", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6b14fce68e3efc4$export$2e2bcd8739ae039);
function $b6b14fce68e3efc4$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("7ugka", function(module, exports) {

$parcel$export(module.exports, "default", () => $5737ff6a521c3180$export$2e2bcd8739ae039);
function $5737ff6a521c3180$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("k7PQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea6cac62996f9031$export$2e2bcd8739ae039);
function $ea6cac62996f9031$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("afIoj", function(module, exports) {

$parcel$export(module.exports, "default", () => $776dbd3fa98eaa2d$export$2e2bcd8739ae039);
function $776dbd3fa98eaa2d$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("fpNMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b38fceddaba53ff2$export$2e2bcd8739ae039);

var $6OH6Y = parcelRequire("6OH6Y");
function $b38fceddaba53ff2$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $b38fceddaba53ff2$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $b38fceddaba53ff2$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $b38fceddaba53ff2$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $b38fceddaba53ff2$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $b38fceddaba53ff2$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $b38fceddaba53ff2$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $6OH6Y.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $b38fceddaba53ff2$var$attrRemoveNS : $b38fceddaba53ff2$var$attrRemove : typeof value === "function" ? fullname.local ? $b38fceddaba53ff2$var$attrFunctionNS : $b38fceddaba53ff2$var$attrFunction : fullname.local ? $b38fceddaba53ff2$var$attrConstantNS : $b38fceddaba53ff2$var$attrConstant)(fullname, value));
}

});
parcelRegister("6OH6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f68da9c08febb06$export$2e2bcd8739ae039);

var $jYS7N = parcelRequire("jYS7N");
function $4f68da9c08febb06$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $jYS7N.default).hasOwnProperty(prefix) ? {
        space: (0, $jYS7N.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("jYS7N", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $e8bd9af4cac37d64$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $e8bd9af4cac37d64$export$2e2bcd8739ae039);
var $e8bd9af4cac37d64$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $e8bd9af4cac37d64$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $e8bd9af4cac37d64$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("jsT6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2bb616d71eccf7c$export$2e2bcd8739ae039);

var $5Ze4e = parcelRequire("5Ze4e");
function $e2bb616d71eccf7c$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $e2bb616d71eccf7c$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $e2bb616d71eccf7c$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $e2bb616d71eccf7c$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $e2bb616d71eccf7c$var$styleRemove : typeof value === "function" ? $e2bb616d71eccf7c$var$styleFunction : $e2bb616d71eccf7c$var$styleConstant)(name, value, priority == null ? "" : priority)) : $e2bb616d71eccf7c$export$5e3cec964f0b5efd(this.node(), name);
}
function $e2bb616d71eccf7c$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $5Ze4e.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("5Ze4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $45bd8fb55e41565f$export$2e2bcd8739ae039);
function $45bd8fb55e41565f$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("5vvHJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $402870d021ce7289$export$2e2bcd8739ae039);
function $402870d021ce7289$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $402870d021ce7289$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $402870d021ce7289$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $402870d021ce7289$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $402870d021ce7289$var$propertyRemove : typeof value === "function" ? $402870d021ce7289$var$propertyFunction : $402870d021ce7289$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("6Aniq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb82d05d49c3b65$export$2e2bcd8739ae039);
function $4cb82d05d49c3b65$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $4cb82d05d49c3b65$var$classList(node) {
    return node.classList || new $4cb82d05d49c3b65$var$ClassList(node);
}
function $4cb82d05d49c3b65$var$ClassList(node) {
    this._node = node;
    this._names = $4cb82d05d49c3b65$var$classArray(node.getAttribute("class") || "");
}
$4cb82d05d49c3b65$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $4cb82d05d49c3b65$var$classedAdd(node, names) {
    var list = $4cb82d05d49c3b65$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $4cb82d05d49c3b65$var$classedRemove(node, names) {
    var list = $4cb82d05d49c3b65$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $4cb82d05d49c3b65$var$classedTrue(names) {
    return function() {
        $4cb82d05d49c3b65$var$classedAdd(this, names);
    };
}
function $4cb82d05d49c3b65$var$classedFalse(names) {
    return function() {
        $4cb82d05d49c3b65$var$classedRemove(this, names);
    };
}
function $4cb82d05d49c3b65$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $4cb82d05d49c3b65$var$classedAdd : $4cb82d05d49c3b65$var$classedRemove)(this, names);
    };
}
function $4cb82d05d49c3b65$export$2e2bcd8739ae039(name, value) {
    var names = $4cb82d05d49c3b65$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $4cb82d05d49c3b65$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $4cb82d05d49c3b65$var$classedFunction : value ? $4cb82d05d49c3b65$var$classedTrue : $4cb82d05d49c3b65$var$classedFalse)(names, value));
}

});

parcelRegister("kmvip", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed2e2371ff132917$export$2e2bcd8739ae039);
function $ed2e2371ff132917$var$textRemove() {
    this.textContent = "";
}
function $ed2e2371ff132917$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $ed2e2371ff132917$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $ed2e2371ff132917$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $ed2e2371ff132917$var$textRemove : (typeof value === "function" ? $ed2e2371ff132917$var$textFunction : $ed2e2371ff132917$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("hV7Tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0bde1b94fdf8f6a$export$2e2bcd8739ae039);
function $d0bde1b94fdf8f6a$var$htmlRemove() {
    this.innerHTML = "";
}
function $d0bde1b94fdf8f6a$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d0bde1b94fdf8f6a$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d0bde1b94fdf8f6a$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d0bde1b94fdf8f6a$var$htmlRemove : (typeof value === "function" ? $d0bde1b94fdf8f6a$var$htmlFunction : $d0bde1b94fdf8f6a$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("bTQR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a9dd4c07695286b$export$2e2bcd8739ae039);
function $8a9dd4c07695286b$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $8a9dd4c07695286b$export$2e2bcd8739ae039() {
    return this.each($8a9dd4c07695286b$var$raise);
}

});

parcelRegister("cFS8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a34db4aa51aa7a$export$2e2bcd8739ae039);
function $93a34db4aa51aa7a$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $93a34db4aa51aa7a$export$2e2bcd8739ae039() {
    return this.each($93a34db4aa51aa7a$var$lower);
}

});

parcelRegister("zGqLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b42edd7b986677$export$2e2bcd8739ae039);

var $f4gM5 = parcelRequire("f4gM5");
function $06b42edd7b986677$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $f4gM5.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("f4gM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $af843dcbd054dd79$export$2e2bcd8739ae039);

var $6OH6Y = parcelRequire("6OH6Y");

var $jYS7N = parcelRequire("jYS7N");
function $af843dcbd054dd79$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $jYS7N.xhtml) && document.documentElement.namespaceURI === (0, $jYS7N.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $af843dcbd054dd79$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $af843dcbd054dd79$export$2e2bcd8739ae039(name) {
    var fullname = (0, $6OH6Y.default)(name);
    return (fullname.local ? $af843dcbd054dd79$var$creatorFixed : $af843dcbd054dd79$var$creatorInherit)(fullname);
}

});


parcelRegister("9xY5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f35cdaa9e2ad1fd$export$2e2bcd8739ae039);

var $f4gM5 = parcelRequire("f4gM5");

var $4JjYU = parcelRequire("4JjYU");
function $6f35cdaa9e2ad1fd$var$constantNull() {
    return null;
}
function $6f35cdaa9e2ad1fd$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $f4gM5.default)(name), select = before == null ? $6f35cdaa9e2ad1fd$var$constantNull : typeof before === "function" ? before : (0, $4JjYU.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("cpwZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $90916a383977493b$export$2e2bcd8739ae039);
function $90916a383977493b$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $90916a383977493b$export$2e2bcd8739ae039() {
    return this.each($90916a383977493b$var$remove);
}

});

parcelRegister("jzZuD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e410fc70a64e6fd8$export$2e2bcd8739ae039);
function $e410fc70a64e6fd8$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $e410fc70a64e6fd8$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $e410fc70a64e6fd8$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $e410fc70a64e6fd8$var$selection_cloneDeep : $e410fc70a64e6fd8$var$selection_cloneShallow);
}

});

parcelRegister("hgk9S", function(module, exports) {

$parcel$export(module.exports, "default", () => $c913915601be24d9$export$2e2bcd8739ae039);
function $c913915601be24d9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("b3Ocr", function(module, exports) {

$parcel$export(module.exports, "default", () => $80d6ea2128cf6b0e$export$2e2bcd8739ae039);

var $5Ze4e = parcelRequire("5Ze4e");
function $80d6ea2128cf6b0e$var$dispatchEvent(node, type, params) {
    var window = (0, $5Ze4e.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $80d6ea2128cf6b0e$var$dispatchConstant(type, params) {
    return function() {
        return $80d6ea2128cf6b0e$var$dispatchEvent(this, type, params);
    };
}
function $80d6ea2128cf6b0e$var$dispatchFunction(type, params) {
    return function() {
        return $80d6ea2128cf6b0e$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $80d6ea2128cf6b0e$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $80d6ea2128cf6b0e$var$dispatchFunction : $80d6ea2128cf6b0e$var$dispatchConstant)(type, params));
}

});



parcelRegister("8xm28", function(module, exports) {

$parcel$export(module.exports, "default", () => $019a9ef472c149ed$export$2e2bcd8739ae039);

var $4w4Jn = parcelRequire("4w4Jn");

var $800jP = parcelRequire("800jP");
function $019a9ef472c149ed$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $4w4Jn.default)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $800jP.default)(node, touch);
    }
    return null;
}

});

parcelRegister("3Qcfc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbfb9e17452dd60$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $2cbfb9e17452dd60$export$833237748009e1e1);

var $25dMC = parcelRequire("25dMC");

var $iJQ79 = parcelRequire("iJQ79");
function $2cbfb9e17452dd60$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $25dMC.default)(view).on("dragstart.drag", (0, $iJQ79.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $iJQ79.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $2cbfb9e17452dd60$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $25dMC.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $iJQ79.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("iJQ79", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $da44dac8d6275892$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $da44dac8d6275892$export$2e2bcd8739ae039);

var $feCaU = parcelRequire("feCaU");
function $da44dac8d6275892$export$2e2561858db9bf47() {
    (0, $feCaU.event).stopImmediatePropagation();
}
function $da44dac8d6275892$export$2e2bcd8739ae039() {
    (0, $feCaU.event).preventDefault();
    (0, $feCaU.event).stopImmediatePropagation();
}

});


parcelRegister("8w5P9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6335d467d1c2b23f$export$2e2bcd8739ae039);
function $6335d467d1c2b23f$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("9JhvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7155e5ffa4782db3$export$2e2bcd8739ae039);
function $7155e5ffa4782db3$export$2e2bcd8739ae039(target, type, subject, id, active, x, y, dx, dy, dispatch) {
    this.target = target;
    this.type = type;
    this.subject = subject;
    this.identifier = id;
    this.active = active;
    this.x = x;
    this.y = y;
    this.dx = dx;
    this.dy = dy;
    this._ = dispatch;
}
$7155e5ffa4782db3$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

});



parcelRegister("8wWlh", function(module, exports) {

var $7IBTP = parcelRequire("7IBTP");

var $6wpxV = parcelRequire("6wpxV");

var $eb2QE = parcelRequire("eb2QE");

});
parcelRegister("7IBTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ea0a7b7f1b95d6$export$2e2bcd8739ae039);
var $59ea0a7b7f1b95d6$var$EOL = {}, $59ea0a7b7f1b95d6$var$EOF = {}, $59ea0a7b7f1b95d6$var$QUOTE = 34, $59ea0a7b7f1b95d6$var$NEWLINE = 10, $59ea0a7b7f1b95d6$var$RETURN = 13;
function $59ea0a7b7f1b95d6$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "]";
    }).join(",") + "}");
}
function $59ea0a7b7f1b95d6$var$customConverter(columns, f) {
    var object = $59ea0a7b7f1b95d6$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $59ea0a7b7f1b95d6$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $59ea0a7b7f1b95d6$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $59ea0a7b7f1b95d6$var$customConverter(row, f) : $59ea0a7b7f1b95d6$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $59ea0a7b7f1b95d6$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $59ea0a7b7f1b95d6$var$RETURN) --N;
        function token() {
            if (eof) return $59ea0a7b7f1b95d6$var$EOF;
            if (eol) return eol = false, $59ea0a7b7f1b95d6$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $59ea0a7b7f1b95d6$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $59ea0a7b7f1b95d6$var$QUOTE || text.charCodeAt(++I) === $59ea0a7b7f1b95d6$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $59ea0a7b7f1b95d6$var$NEWLINE) eol = true;
                else if (c === $59ea0a7b7f1b95d6$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $59ea0a7b7f1b95d6$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, "\"");
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $59ea0a7b7f1b95d6$var$NEWLINE) eol = true;
                else if (c === $59ea0a7b7f1b95d6$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $59ea0a7b7f1b95d6$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $59ea0a7b7f1b95d6$var$EOF){
            var row = [];
            while(t !== $59ea0a7b7f1b95d6$var$EOL && t !== $59ea0a7b7f1b95d6$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function format(rows, columns) {
        if (columns == null) columns = $59ea0a7b7f1b95d6$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        })).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
        return text == null ? "" : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\"" : text;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatRows: formatRows
    };
}

});

parcelRegister("6wpxV", function(module, exports) {

var $7IBTP = parcelRequire("7IBTP");
var $0139b3cf37ba9323$var$csv = (0, $7IBTP.default)(",");
var $0139b3cf37ba9323$export$289d25497b0f4c16 = $0139b3cf37ba9323$var$csv.parse;
var $0139b3cf37ba9323$export$c82550ca942d869 = $0139b3cf37ba9323$var$csv.parseRows;
var $0139b3cf37ba9323$export$afe767551074aa08 = $0139b3cf37ba9323$var$csv.format;
var $0139b3cf37ba9323$export$3f42a65843fbd1d9 = $0139b3cf37ba9323$var$csv.formatRows;

});

parcelRegister("eb2QE", function(module, exports) {

var $7IBTP = parcelRequire("7IBTP");
var $a5244d589f984f1d$var$tsv = (0, $7IBTP.default)("\t");
var $a5244d589f984f1d$export$f913251db2f734ee = $a5244d589f984f1d$var$tsv.parse;
var $a5244d589f984f1d$export$8de3b5abc40a067f = $a5244d589f984f1d$var$tsv.parseRows;
var $a5244d589f984f1d$export$77e754c4f8504293 = $a5244d589f984f1d$var$tsv.format;
var $a5244d589f984f1d$export$ae461973f6adc981 = $a5244d589f984f1d$var$tsv.formatRows;

});


parcelRegister("jumO7", function(module, exports) {

var $7DWE6 = parcelRequire("7DWE6");

var $a2dXT = parcelRequire("a2dXT");

var $3iou2 = parcelRequire("3iou2");

var $kGpYw = parcelRequire("kGpYw");

var $7desl = parcelRequire("7desl");

var $cCYOk = parcelRequire("cCYOk");

var $2t21d = parcelRequire("2t21d");

var $c6VOU = parcelRequire("c6VOU");

var $55NsJ = parcelRequire("55NsJ");

var $5VC37 = parcelRequire("5VC37");

});
parcelRegister("7DWE6", function(module, exports) {
function $5909aabcbb019c17$export$45db2fc2f15997e7(t) {
    return +t;
}

});

parcelRegister("a2dXT", function(module, exports) {
function $74e4ec76b49ca5b1$export$5118fc7a1e64441b(t) {
    return t * t;
}
function $74e4ec76b49ca5b1$export$5be5f5e804d0b60c(t) {
    return t * (2 - t);
}
function $74e4ec76b49ca5b1$export$d6ded66933892ed3(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

});

parcelRegister("3iou2", function(module, exports) {
function $26660b739b42872c$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $26660b739b42872c$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $26660b739b42872c$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});

parcelRegister("kGpYw", function(module, exports) {
var $f0ebe109b659fe50$var$exponent = 3;
var $f0ebe109b659fe50$export$aa0b5c3ce2df9d7d = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($f0ebe109b659fe50$var$exponent);
var $f0ebe109b659fe50$export$e3d987a417dc6640 = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($f0ebe109b659fe50$var$exponent);
var $f0ebe109b659fe50$export$ae94c6a40058b429 = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($f0ebe109b659fe50$var$exponent);

});

parcelRegister("7desl", function(module, exports) {
var $5404f600c4a9f08a$var$pi = Math.PI, $5404f600c4a9f08a$var$halfPi = $5404f600c4a9f08a$var$pi / 2;
function $5404f600c4a9f08a$export$a83a280f8d31ba8d(t) {
    return 1 - Math.cos(t * $5404f600c4a9f08a$var$halfPi);
}
function $5404f600c4a9f08a$export$62ec6410ca53f2a7(t) {
    return Math.sin(t * $5404f600c4a9f08a$var$halfPi);
}
function $5404f600c4a9f08a$export$ff58b604d3ba15ba(t) {
    return (1 - Math.cos($5404f600c4a9f08a$var$pi * t)) / 2;
}

});

parcelRegister("cCYOk", function(module, exports) {
function $931834673bf78a83$export$fc3e95f15e1ef38e(t) {
    return Math.pow(2, 10 * t - 10);
}
function $931834673bf78a83$export$f3c9b2f85fbcf0ab(t) {
    return 1 - Math.pow(2, -10 * t);
}
function $931834673bf78a83$export$ae4d4e77fab188ff(t) {
    return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}

});

parcelRegister("2t21d", function(module, exports) {
function $1cbfdb0e500d1404$export$9f82a71b0377c018(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $1cbfdb0e500d1404$export$27989e665abef2c8(t) {
    return Math.sqrt(1 - --t * t);
}
function $1cbfdb0e500d1404$export$2d757ff9ad09038f(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

});

parcelRegister("c6VOU", function(module, exports) {
var $8d12e5710e2746dc$var$b1 = 4 / 11, $8d12e5710e2746dc$var$b2 = 6 / 11, $8d12e5710e2746dc$var$b3 = 8 / 11, $8d12e5710e2746dc$var$b4 = 3 / 4, $8d12e5710e2746dc$var$b5 = 9 / 11, $8d12e5710e2746dc$var$b6 = 10 / 11, $8d12e5710e2746dc$var$b7 = 15 / 16, $8d12e5710e2746dc$var$b8 = 21 / 22, $8d12e5710e2746dc$var$b9 = 63 / 64, $8d12e5710e2746dc$var$b0 = 1 / $8d12e5710e2746dc$var$b1 / $8d12e5710e2746dc$var$b1;
function $8d12e5710e2746dc$export$fccebd7948554554(t) {
    return 1 - $8d12e5710e2746dc$export$cccc9e04465dce11(1 - t);
}
function $8d12e5710e2746dc$export$cccc9e04465dce11(t) {
    return (t = +t) < $8d12e5710e2746dc$var$b1 ? $8d12e5710e2746dc$var$b0 * t * t : t < $8d12e5710e2746dc$var$b3 ? $8d12e5710e2746dc$var$b0 * (t -= $8d12e5710e2746dc$var$b2) * t + $8d12e5710e2746dc$var$b4 : t < $8d12e5710e2746dc$var$b6 ? $8d12e5710e2746dc$var$b0 * (t -= $8d12e5710e2746dc$var$b5) * t + $8d12e5710e2746dc$var$b7 : $8d12e5710e2746dc$var$b0 * (t -= $8d12e5710e2746dc$var$b8) * t + $8d12e5710e2746dc$var$b9;
}
function $8d12e5710e2746dc$export$41ad9e9849a703ce(t) {
    return ((t *= 2) <= 1 ? 1 - $8d12e5710e2746dc$export$cccc9e04465dce11(1 - t) : $8d12e5710e2746dc$export$cccc9e04465dce11(t - 1) + 1) / 2;
}

});

parcelRegister("55NsJ", function(module, exports) {
var $3b53c9975d46ea79$var$overshoot = 1.70158;
var $3b53c9975d46ea79$export$b01116c84cdfe1a2 = function custom(s) {
    s = +s;
    function backIn(t) {
        return t * t * ((s + 1) * t - s);
    }
    backIn.overshoot = custom;
    return backIn;
}($3b53c9975d46ea79$var$overshoot);
var $3b53c9975d46ea79$export$77edfce482316a60 = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((s + 1) * t + s) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($3b53c9975d46ea79$var$overshoot);
var $3b53c9975d46ea79$export$ddc5fd596f6c71b2 = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($3b53c9975d46ea79$var$overshoot);

});

parcelRegister("5VC37", function(module, exports) {
var $450fca6f82cc0f3c$var$tau = 2 * Math.PI, $450fca6f82cc0f3c$var$amplitude = 1, $450fca6f82cc0f3c$var$period = 0.3;
var $450fca6f82cc0f3c$export$41f42134872a5fa0 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $450fca6f82cc0f3c$var$tau);
    function elasticIn(t) {
        return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $450fca6f82cc0f3c$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($450fca6f82cc0f3c$var$amplitude, $450fca6f82cc0f3c$var$period);
var $450fca6f82cc0f3c$export$ed1782b99e69bbc8 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $450fca6f82cc0f3c$var$tau);
    function elasticOut(t) {
        return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $450fca6f82cc0f3c$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($450fca6f82cc0f3c$var$amplitude, $450fca6f82cc0f3c$var$period);
var $450fca6f82cc0f3c$export$309de4f35f218bfd = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $450fca6f82cc0f3c$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p) : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $450fca6f82cc0f3c$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($450fca6f82cc0f3c$var$amplitude, $450fca6f82cc0f3c$var$period);

});


parcelRegister("gOnHS", function(module, exports) {

var $cG15U = parcelRequire("cG15U");

var $hyad2 = parcelRequire("hyad2");

var $6olNk = parcelRequire("6olNk");

var $3gGhi = parcelRequire("3gGhi");

var $46mV1 = parcelRequire("46mV1");

var $4XXBP = parcelRequire("4XXBP");

var $gLOu6 = parcelRequire("gLOu6");

var $8Tq6S = parcelRequire("8Tq6S");

});
parcelRegister("cG15U", function(module, exports) {
function $93aa4192722389c7$export$2e2bcd8739ae039(x, y) {
    var nodes;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("hyad2", function(module, exports) {

var $bzC5C = parcelRequire("bzC5C");

var $4MjmR = parcelRequire("4MjmR");

var $8H00M = parcelRequire("8H00M");
function $cc6d87fcbc3b81c1$var$x(d) {
    return d.x + d.vx;
}
function $cc6d87fcbc3b81c1$var$y(d) {
    return d.y + d.vy;
}
function $cc6d87fcbc3b81c1$export$2e2bcd8739ae039(radius) {
    var nodes, radii, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $bzC5C.default)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $8H00M.default)(nodes, $cc6d87fcbc3b81c1$var$x, $cc6d87fcbc3b81c1$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $4MjmR.default)(), l += x * x;
                        if (y === 0) y = (0, $4MjmR.default)(), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initialize(), force) : radius;
    };
    return force;
}

});
parcelRegister("bzC5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d0826bbc8d3df0$export$2e2bcd8739ae039);
function $86d0826bbc8d3df0$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("4MjmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $37aaab27fbafc10c$export$2e2bcd8739ae039);
function $37aaab27fbafc10c$export$2e2bcd8739ae039() {
    return (Math.random() - 0.5) * 1e-6;
}

});

parcelRegister("8H00M", function(module, exports) {

$parcel$export(module.exports, "default", () => $6542592f68a846af$export$2e2bcd8739ae039);

var $7Fr6t = parcelRequire("7Fr6t");

var $8T1oc = parcelRequire("8T1oc");

var $6c1Nb = parcelRequire("6c1Nb");

var $giVKT = parcelRequire("giVKT");

var $f9i8t = parcelRequire("f9i8t");

var $6CDA9 = parcelRequire("6CDA9");

var $6jQej = parcelRequire("6jQej");

var $iA9MU = parcelRequire("iA9MU");

var $3ANgU = parcelRequire("3ANgU");

var $4fNl3 = parcelRequire("4fNl3");

var $hwlWB = parcelRequire("hwlWB");

var $dCv0y = parcelRequire("dCv0y");
function $6542592f68a846af$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $6542592f68a846af$var$Quadtree(x == null ? (0, $hwlWB.defaultX) : x, y == null ? (0, $dCv0y.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $6542592f68a846af$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $6542592f68a846af$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $6542592f68a846af$var$treeProto = $6542592f68a846af$export$2e2bcd8739ae039.prototype = $6542592f68a846af$var$Quadtree.prototype;
$6542592f68a846af$var$treeProto.copy = function() {
    var copy = new $6542592f68a846af$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $6542592f68a846af$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $6542592f68a846af$var$leaf_copy(child);
        }
    }
    return copy;
};
$6542592f68a846af$var$treeProto.add = (0, $7Fr6t.default);
$6542592f68a846af$var$treeProto.addAll = (0, $7Fr6t.addAll);
$6542592f68a846af$var$treeProto.cover = (0, $8T1oc.default);
$6542592f68a846af$var$treeProto.data = (0, $6c1Nb.default);
$6542592f68a846af$var$treeProto.extent = (0, $giVKT.default);
$6542592f68a846af$var$treeProto.find = (0, $f9i8t.default);
$6542592f68a846af$var$treeProto.remove = (0, $6CDA9.default);
$6542592f68a846af$var$treeProto.removeAll = (0, $6CDA9.removeAll);
$6542592f68a846af$var$treeProto.root = (0, $6jQej.default);
$6542592f68a846af$var$treeProto.size = (0, $iA9MU.default);
$6542592f68a846af$var$treeProto.visit = (0, $3ANgU.default);
$6542592f68a846af$var$treeProto.visitAfter = (0, $4fNl3.default);
$6542592f68a846af$var$treeProto.x = (0, $hwlWB.default);
$6542592f68a846af$var$treeProto.y = (0, $dCv0y.default);

});
parcelRegister("7Fr6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $595162eaa5955e0c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addAll", () => $595162eaa5955e0c$export$32ed0561867ec8a1);
function $595162eaa5955e0c$export$2e2bcd8739ae039(d) {
    var x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $595162eaa5955e0c$var$add(this.cover(x, y), x, y, d);
}
function $595162eaa5955e0c$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $595162eaa5955e0c$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$595162eaa5955e0c$var$add(this, xz[i], yz[i], data[i]);
    return this;
}

});

parcelRegister("8T1oc", function(module, exports) {

$parcel$export(module.exports, "default", () => $678489adabafad3e$export$2e2bcd8739ae039);
function $678489adabafad3e$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}

});

parcelRegister("6c1Nb", function(module, exports) {

$parcel$export(module.exports, "default", () => $482540f40461db04$export$2e2bcd8739ae039);
function $482540f40461db04$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}

});

parcelRegister("giVKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdeb20c746c4bb0d$export$2e2bcd8739ae039);
function $bdeb20c746c4bb0d$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}

});

parcelRegister("f9i8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b075c3a9c3dc65a3$export$2e2bcd8739ae039);

var $WGeW1 = parcelRequire("WGeW1");
function $b075c3a9c3dc65a3$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $WGeW1.default)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $WGeW1.default)(node[3], xm, ym, x2, y2), new (0, $WGeW1.default)(node[2], x1, ym, xm, y2), new (0, $WGeW1.default)(node[1], xm, y1, x2, ym), new (0, $WGeW1.default)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}

});
parcelRegister("WGeW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b062edb07fb906a$export$2e2bcd8739ae039);
function $0b062edb07fb906a$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}

});


parcelRegister("6CDA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d24fed8e0d56ecc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "removeAll", () => $4d24fed8e0d56ecc$export$1cfc7aad5cb1833b);
function $4d24fed8e0d56ecc$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $4d24fed8e0d56ecc$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

});

parcelRegister("6jQej", function(module, exports) {

$parcel$export(module.exports, "default", () => $499d082dee1a532a$export$2e2bcd8739ae039);
function $499d082dee1a532a$export$2e2bcd8739ae039() {
    return this._root;
}

});

parcelRegister("iA9MU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8732e734012c35d$export$2e2bcd8739ae039);
function $d8732e734012c35d$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}

});

parcelRegister("3ANgU", function(module, exports) {

$parcel$export(module.exports, "default", () => $29daf43ae6cd393b$export$2e2bcd8739ae039);

var $WGeW1 = parcelRequire("WGeW1");
function $29daf43ae6cd393b$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $WGeW1.default)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $WGeW1.default)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $WGeW1.default)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $WGeW1.default)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $WGeW1.default)(child, x0, y0, xm, ym));
    }
    return this;
}

});

parcelRegister("4fNl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $318ed5c4d617b5ec$export$2e2bcd8739ae039);

var $WGeW1 = parcelRequire("WGeW1");
function $318ed5c4d617b5ec$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $WGeW1.default)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $WGeW1.default)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $WGeW1.default)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $WGeW1.default)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $WGeW1.default)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}

});

parcelRegister("hwlWB", function(module, exports) {

$parcel$export(module.exports, "defaultX", () => $cc167280ddcb56ad$export$e6fafc98131d2a44);
$parcel$export(module.exports, "default", () => $cc167280ddcb56ad$export$2e2bcd8739ae039);
function $cc167280ddcb56ad$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $cc167280ddcb56ad$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}

});

parcelRegister("dCv0y", function(module, exports) {

$parcel$export(module.exports, "defaultY", () => $9ea6e0837101e005$export$6f0a21aeb844a64c);
$parcel$export(module.exports, "default", () => $9ea6e0837101e005$export$2e2bcd8739ae039);
function $9ea6e0837101e005$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $9ea6e0837101e005$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}

});



parcelRegister("6olNk", function(module, exports) {

var $bzC5C = parcelRequire("bzC5C");

var $4MjmR = parcelRequire("4MjmR");
parcelRequire("gz1Te");
var $5Mltl = parcelRequire("5Mltl");
function $4a75e3eb0cb3c835$var$index(d) {
    return d.index;
}
function $4a75e3eb0cb3c835$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("missing: " + nodeId);
    return node;
}
function $4a75e3eb0cb3c835$export$2e2bcd8739ae039(links) {
    var id = $4a75e3eb0cb3c835$var$index, strength = defaultStrength, strengths, distance = (0, $bzC5C.default)(30), distances, nodes, count, bias, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $4MjmR.default)();
            y = target.y + target.vy - source.y - source.vy || (0, $4MjmR.default)();
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = (0, $5Mltl.default)(nodes, id), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $4a75e3eb0cb3c835$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $4a75e3eb0cb3c835$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initializeDistance(), force) : distance;
    };
    return force;
}

});
parcelRegister("gz1Te", function(module, exports) {

$parcel$export(module.exports, "nest", () => (parcelRequire("glRO0")).default);
$parcel$export(module.exports, "set", () => (parcelRequire("27fQJ")).default);
$parcel$export(module.exports, "map", () => (parcelRequire("5Mltl")).default);
$parcel$export(module.exports, "keys", () => (parcelRequire("3EC4g")).default);
$parcel$export(module.exports, "values", () => (parcelRequire("iI00m")).default);
$parcel$export(module.exports, "entries", () => (parcelRequire("5XG0I")).default);

var $glRO0 = parcelRequire("glRO0");

var $27fQJ = parcelRequire("27fQJ");

var $5Mltl = parcelRequire("5Mltl");

var $3EC4g = parcelRequire("3EC4g");

var $iI00m = parcelRequire("iI00m");

var $5XG0I = parcelRequire("5XG0I");

});
parcelRegister("glRO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $be78582de6c6a367$export$2e2bcd8739ae039);

var $5Mltl = parcelRequire("5Mltl");
function $be78582de6c6a367$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $5Mltl.default)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $be78582de6c6a367$var$createObject, $be78582de6c6a367$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $be78582de6c6a367$var$createMap, $be78582de6c6a367$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $be78582de6c6a367$var$createMap, $be78582de6c6a367$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $be78582de6c6a367$var$createObject() {
    return {};
}
function $be78582de6c6a367$var$setObject(object, key, value) {
    object[key] = value;
}
function $be78582de6c6a367$var$createMap() {
    return (0, $5Mltl.default)();
}
function $be78582de6c6a367$var$setMap(map, key, value) {
    map.set(key, value);
}

});
parcelRegister("5Mltl", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $43521769693521bb$export$82e9f45cca5ba907);
$parcel$export(module.exports, "default", () => $43521769693521bb$export$2e2bcd8739ae039);
var $43521769693521bb$export$82e9f45cca5ba907 = "$";
function $43521769693521bb$var$Map() {}
$43521769693521bb$var$Map.prototype = $43521769693521bb$var$map.prototype = {
    constructor: $43521769693521bb$var$Map,
    has: function(key) {
        return $43521769693521bb$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$43521769693521bb$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$43521769693521bb$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $43521769693521bb$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $43521769693521bb$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $43521769693521bb$var$map(object, f) {
    var map = new $43521769693521bb$var$Map;
    // Copy constructor.
    if (object instanceof $43521769693521bb$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $43521769693521bb$export$2e2bcd8739ae039 = $43521769693521bb$var$map;

});


parcelRegister("27fQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $18a8879a950ce9b8$export$2e2bcd8739ae039);

var $5Mltl = parcelRequire("5Mltl");
function $18a8879a950ce9b8$var$Set() {}
var $18a8879a950ce9b8$var$proto = (0, $5Mltl.default).prototype;
$18a8879a950ce9b8$var$Set.prototype = $18a8879a950ce9b8$var$set.prototype = {
    constructor: $18a8879a950ce9b8$var$Set,
    has: $18a8879a950ce9b8$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $5Mltl.prefix) + value] = value;
        return this;
    },
    remove: $18a8879a950ce9b8$var$proto.remove,
    clear: $18a8879a950ce9b8$var$proto.clear,
    values: $18a8879a950ce9b8$var$proto.keys,
    size: $18a8879a950ce9b8$var$proto.size,
    empty: $18a8879a950ce9b8$var$proto.empty,
    each: $18a8879a950ce9b8$var$proto.each
};
function $18a8879a950ce9b8$var$set(object, f) {
    var set = new $18a8879a950ce9b8$var$Set;
    // Copy constructor.
    if (object instanceof $18a8879a950ce9b8$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $18a8879a950ce9b8$export$2e2bcd8739ae039 = $18a8879a950ce9b8$var$set;

});

parcelRegister("3EC4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a92a2fea54d6c89$export$2e2bcd8739ae039);
function $2a92a2fea54d6c89$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}

});

parcelRegister("iI00m", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9ec57042712cf33$export$2e2bcd8739ae039);
function $d9ec57042712cf33$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}

});

parcelRegister("5XG0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $45730cddb299af25$export$2e2bcd8739ae039);
function $45730cddb299af25$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}

});



parcelRegister("3gGhi", function(module, exports) {

var $bzC5C = parcelRequire("bzC5C");

var $4MjmR = parcelRequire("4MjmR");

var $8H00M = parcelRequire("8H00M");

var $4XXBP = parcelRequire("4XXBP");
function $2613a9403a4ea12f$export$2e2bcd8739ae039() {
    var nodes, node, alpha, strength = (0, $bzC5C.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $8H00M.default)(nodes, (0, $4XXBP.x), (0, $4XXBP.y)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $4MjmR.default)(), l += x * x;
                if (y === 0) y = (0, $4MjmR.default)(), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $4MjmR.default)(), l += x * x;
            if (y === 0) y = (0, $4MjmR.default)(), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}

});
parcelRegister("4XXBP", function(module, exports) {

$parcel$export(module.exports, "x", () => $39dae93bcfd8550e$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $39dae93bcfd8550e$export$4a5767248b18ef41);

var $4h5V5 = parcelRequire("4h5V5");
parcelRequire("gz1Te");
var $5Mltl = parcelRequire("5Mltl");

var $5hwOF = parcelRequire("5hwOF");
function $39dae93bcfd8550e$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $39dae93bcfd8550e$export$4a5767248b18ef41(d) {
    return d.y;
}
var $39dae93bcfd8550e$var$initialRadius = 10, $39dae93bcfd8550e$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $39dae93bcfd8550e$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = (0, $5Mltl.default)(), stepper = (0, $5hwOF.timer)(step), event = (0, $4h5V5.default)("tick", "end");
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick() {
        var i, n = nodes.length, node;
        alpha += (alphaTarget - alpha) * alphaDecay;
        forces.each(function(force) {
            force(alpha);
        });
        for(i = 0; i < n; ++i){
            node = nodes[i];
            if (node.fx == null) node.x += node.vx *= velocityDecay;
            else node.x = node.fx, node.vx = 0;
            if (node.fy == null) node.y += node.vy *= velocityDecay;
            else node.y = node.fy, node.vy = 0;
        }
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $39dae93bcfd8550e$var$initialRadius * Math.sqrt(i), angle = i * $39dae93bcfd8550e$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.remove(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}

});
parcelRegister("4h5V5", function(module, exports) {

$parcel$export(module.exports, "default", () => $31cd57835620496c$export$2e2bcd8739ae039);
var $31cd57835620496c$var$noop = {
    value: function() {}
};
function $31cd57835620496c$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $31cd57835620496c$var$Dispatch(_);
}
function $31cd57835620496c$var$Dispatch(_) {
    this._ = _;
}
function $31cd57835620496c$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$31cd57835620496c$var$Dispatch.prototype = $31cd57835620496c$var$dispatch.prototype = {
    constructor: $31cd57835620496c$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $31cd57835620496c$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $31cd57835620496c$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $31cd57835620496c$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $31cd57835620496c$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $31cd57835620496c$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $31cd57835620496c$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $31cd57835620496c$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $31cd57835620496c$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $31cd57835620496c$export$2e2bcd8739ae039 = $31cd57835620496c$var$dispatch;

});

parcelRegister("5hwOF", function(module, exports) {

$parcel$export(module.exports, "now", () => $3d87fee47766823b$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $3d87fee47766823b$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $3d87fee47766823b$export$9dc4ecf953986f04);
$parcel$export(module.exports, "timerFlush", () => $3d87fee47766823b$export$d60154c1d7f3990e);
var $3d87fee47766823b$var$frame = 0, $3d87fee47766823b$var$timeout = 0, $3d87fee47766823b$var$interval = 0, $3d87fee47766823b$var$pokeDelay = 1000, $3d87fee47766823b$var$taskHead, $3d87fee47766823b$var$taskTail, $3d87fee47766823b$var$clockLast = 0, $3d87fee47766823b$var$clockNow = 0, $3d87fee47766823b$var$clockSkew = 0, $3d87fee47766823b$var$clock = typeof performance === "object" && performance.now ? performance : Date, $3d87fee47766823b$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $3d87fee47766823b$export$461939dd4422153() {
    return $3d87fee47766823b$var$clockNow || ($3d87fee47766823b$var$setFrame($3d87fee47766823b$var$clearNow), $3d87fee47766823b$var$clockNow = $3d87fee47766823b$var$clock.now() + $3d87fee47766823b$var$clockSkew);
}
function $3d87fee47766823b$var$clearNow() {
    $3d87fee47766823b$var$clockNow = 0;
}
function $3d87fee47766823b$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$3d87fee47766823b$export$c57e9b2d8b9e4de.prototype = $3d87fee47766823b$export$9dc4ecf953986f04.prototype = {
    constructor: $3d87fee47766823b$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $3d87fee47766823b$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $3d87fee47766823b$var$taskTail !== this) {
            if ($3d87fee47766823b$var$taskTail) $3d87fee47766823b$var$taskTail._next = this;
            else $3d87fee47766823b$var$taskHead = this;
            $3d87fee47766823b$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $3d87fee47766823b$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $3d87fee47766823b$var$sleep();
        }
    }
};
function $3d87fee47766823b$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $3d87fee47766823b$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $3d87fee47766823b$export$d60154c1d7f3990e() {
    $3d87fee47766823b$export$461939dd4422153(); // Get the current time, if not already set.
    ++$3d87fee47766823b$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $3d87fee47766823b$var$taskHead, e;
    while(t){
        if ((e = $3d87fee47766823b$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$3d87fee47766823b$var$frame;
}
function $3d87fee47766823b$var$wake() {
    $3d87fee47766823b$var$clockNow = ($3d87fee47766823b$var$clockLast = $3d87fee47766823b$var$clock.now()) + $3d87fee47766823b$var$clockSkew;
    $3d87fee47766823b$var$frame = $3d87fee47766823b$var$timeout = 0;
    try {
        $3d87fee47766823b$export$d60154c1d7f3990e();
    } finally{
        $3d87fee47766823b$var$frame = 0;
        $3d87fee47766823b$var$nap();
        $3d87fee47766823b$var$clockNow = 0;
    }
}
function $3d87fee47766823b$var$poke() {
    var now = $3d87fee47766823b$var$clock.now(), delay = now - $3d87fee47766823b$var$clockLast;
    if (delay > $3d87fee47766823b$var$pokeDelay) $3d87fee47766823b$var$clockSkew -= delay, $3d87fee47766823b$var$clockLast = now;
}
function $3d87fee47766823b$var$nap() {
    var t0, t1 = $3d87fee47766823b$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $3d87fee47766823b$var$taskHead = t2;
    }
    $3d87fee47766823b$var$taskTail = t0;
    $3d87fee47766823b$var$sleep(time);
}
function $3d87fee47766823b$var$sleep(time) {
    if ($3d87fee47766823b$var$frame) return; // Soonest alarm already set, or will be.
    if ($3d87fee47766823b$var$timeout) $3d87fee47766823b$var$timeout = clearTimeout($3d87fee47766823b$var$timeout);
    var delay = time - $3d87fee47766823b$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $3d87fee47766823b$var$timeout = setTimeout($3d87fee47766823b$var$wake, time - $3d87fee47766823b$var$clock.now() - $3d87fee47766823b$var$clockSkew);
        if ($3d87fee47766823b$var$interval) $3d87fee47766823b$var$interval = clearInterval($3d87fee47766823b$var$interval);
    } else {
        if (!$3d87fee47766823b$var$interval) $3d87fee47766823b$var$clockLast = $3d87fee47766823b$var$clock.now(), $3d87fee47766823b$var$interval = setInterval($3d87fee47766823b$var$poke, $3d87fee47766823b$var$pokeDelay);
        $3d87fee47766823b$var$frame = 1, $3d87fee47766823b$var$setFrame($3d87fee47766823b$var$wake);
    }
}

});



parcelRegister("46mV1", function(module, exports) {

var $bzC5C = parcelRequire("bzC5C");
function $2fc9802843146465$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $bzC5C.default)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $bzC5C.default)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("gLOu6", function(module, exports) {

var $bzC5C = parcelRequire("bzC5C");
function $c358325126615517$export$2e2bcd8739ae039(x) {
    var strength = (0, $bzC5C.default)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $bzC5C.default)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initialize(), force) : x;
    };
    return force;
}

});

parcelRegister("8Tq6S", function(module, exports) {

var $bzC5C = parcelRequire("bzC5C");
function $6797b6b0e6df5232$export$2e2bcd8739ae039(y) {
    var strength = (0, $bzC5C.default)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $bzC5C.default)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $bzC5C.default)(+_), initialize(), force) : y;
    };
    return force;
}

});


parcelRegister("hyf3w", function(module, exports) {

var $7D56o = parcelRequire("7D56o");

var $4xN3G = parcelRequire("4xN3G");

var $8sPLs = parcelRequire("8sPLs");

var $7j3o3 = parcelRequire("7j3o3");

var $2gSGm = parcelRequire("2gSGm");

var $cfztN = parcelRequire("cfztN");

});
parcelRegister("7D56o", function(module, exports) {

var $4xN3G = parcelRequire("4xN3G");
var $58e022179f529f7a$var$locale;
var $58e022179f529f7a$export$d9468344d3651243;
var $58e022179f529f7a$export$8d85692a469dde6f;
$58e022179f529f7a$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $58e022179f529f7a$export$2e2bcd8739ae039(definition) {
    $58e022179f529f7a$var$locale = (0, $4xN3G.default)(definition);
    $58e022179f529f7a$export$d9468344d3651243 = $58e022179f529f7a$var$locale.format;
    $58e022179f529f7a$export$8d85692a469dde6f = $58e022179f529f7a$var$locale.formatPrefix;
    return $58e022179f529f7a$var$locale;
}

});
parcelRegister("4xN3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $34f04c78f7b4f11a$export$2e2bcd8739ae039);

var $gEq6y = parcelRequire("gEq6y");

var $ffuM6 = parcelRequire("ffuM6");

var $iXcea = parcelRequire("iXcea");

var $8sPLs = parcelRequire("8sPLs");

var $iGosi = parcelRequire("iGosi");

var $6zBVV = parcelRequire("6zBVV");

var $gpssj = parcelRequire("gpssj");
var $34f04c78f7b4f11a$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $34f04c78f7b4f11a$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping && locale.thousands ? (0, $ffuM6.default)(locale.grouping, locale.thousands) : (0, $gpssj.default), currency = locale.currency, decimal = locale.decimal, numerals = locale.numerals ? (0, $iXcea.default)(locale.numerals) : (0, $gpssj.default), percent = locale.percent || "%";
    function newFormat(specifier) {
        specifier = (0, $8sPLs.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, type = specifier.type;
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $iGosi.default)[type], maybeSuffix = !type || /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision == null ? type ? 6 : 12 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Perform the initial formatting.
                var valueNegative = value < 0;
                value = formatType(Math.abs(value), precision);
                // If a negative value rounds to zero during formatting, treat as positive.
                if (valueNegative && +value === 0) valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : "-" : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $34f04c78f7b4f11a$var$prefixes[8 + (0, $6zBVV.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $8sPLs.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $gEq6y.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $34f04c78f7b4f11a$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("gEq6y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f4a19ccde770e4$export$2e2bcd8739ae039);

var $khxe4 = parcelRequire("khxe4");
function $c1f4a19ccde770e4$export$2e2bcd8739ae039(x) {
    return x = (0, $khxe4.default)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("khxe4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3f2b278f26b9a9$export$2e2bcd8739ae039);
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
function $ec3f2b278f26b9a9$export$2e2bcd8739ae039(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("ffuM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1a020fa23e2caae$export$2e2bcd8739ae039);
function $b1a020fa23e2caae$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("iXcea", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcc738d431f7cb47$export$2e2bcd8739ae039);
function $dcc738d431f7cb47$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("8sPLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6299179db4e4b4a4$export$2e2bcd8739ae039);

var $iGosi = parcelRequire("iGosi");
// [[fill]align][sign][symbol][0][width][,][.precision][type]
var $6299179db4e4b4a4$var$re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
function $6299179db4e4b4a4$export$2e2bcd8739ae039(specifier) {
    return new $6299179db4e4b4a4$var$FormatSpecifier(specifier);
}
$6299179db4e4b4a4$export$2e2bcd8739ae039.prototype = $6299179db4e4b4a4$var$FormatSpecifier.prototype; // instanceof
function $6299179db4e4b4a4$var$FormatSpecifier(specifier) {
    if (!(match = $6299179db4e4b4a4$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match, fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zero = !!match[5], width = match[6] && +match[6], comma = !!match[7], precision = match[8] && +match[8].slice(1), type = match[9] || "";
    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";
    else if (!(0, $iGosi.default)[type]) type = "";
    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
    this.fill = fill;
    this.align = align;
    this.sign = sign;
    this.symbol = symbol;
    this.zero = zero;
    this.width = width;
    this.comma = comma;
    this.precision = precision;
    this.type = type;
}
$6299179db4e4b4a4$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + this.type;
};

});
parcelRegister("iGosi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d99f1e8f76c9d95f$export$2e2bcd8739ae039);

var $3rEdV = parcelRequire("3rEdV");

var $6zBVV = parcelRequire("6zBVV");

var $jL4Bs = parcelRequire("jL4Bs");
var $d99f1e8f76c9d95f$export$2e2bcd8739ae039 = {
    "": (0, $3rEdV.default),
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": function(x) {
        return Math.round(x).toString(10);
    },
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $jL4Bs.default)(x * 100, p);
    },
    "r": (0, $jL4Bs.default),
    "s": (0, $6zBVV.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

});
parcelRegister("3rEdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $28231849aa88cb8f$export$2e2bcd8739ae039);
function $28231849aa88cb8f$export$2e2bcd8739ae039(x, p) {
    x = x.toPrecision(p);
    out: for(var n = x.length, i = 1, i0 = -1, i1; i < n; ++i)switch(x[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        case "e":
            break out;
        default:
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
}

});

parcelRegister("6zBVV", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $4c936fb91f8201a6$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $4c936fb91f8201a6$export$2e2bcd8739ae039);

var $khxe4 = parcelRequire("khxe4");
var $4c936fb91f8201a6$export$6863724d9a42263;
function $4c936fb91f8201a6$export$2e2bcd8739ae039(x, p) {
    var d = (0, $khxe4.default)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($4c936fb91f8201a6$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $khxe4.default)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("jL4Bs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e625fa334e602c01$export$2e2bcd8739ae039);

var $khxe4 = parcelRequire("khxe4");
function $e625fa334e602c01$export$2e2bcd8739ae039(x, p) {
    var d = (0, $khxe4.default)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});



parcelRegister("gpssj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf250dd320155cbe$export$2e2bcd8739ae039);
function $bf250dd320155cbe$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("7j3o3", function(module, exports) {

var $gEq6y = parcelRequire("gEq6y");
function $551cef5399b07c87$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $gEq6y.default)(Math.abs(step)));
}

});

parcelRegister("2gSGm", function(module, exports) {

var $gEq6y = parcelRequire("gEq6y");
function $1a777e289dc483de$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $gEq6y.default)(value) / 3))) * 3 - (0, $gEq6y.default)(Math.abs(step)));
}

});

parcelRegister("cfztN", function(module, exports) {

var $gEq6y = parcelRequire("gEq6y");
function $8eb26844fe794908$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $gEq6y.default)(max) - (0, $gEq6y.default)(step)) + 1;
}

});


parcelRegister("6iMXx", function(module, exports) {

var $jguXh = parcelRequire("jguXh");

var $6jHoV = parcelRequire("6jHoV");

var $77YGd = parcelRequire("77YGd");

var $kl3aS = parcelRequire("kl3aS");

var $j4qqr = parcelRequire("j4qqr");

var $dg7hJ = parcelRequire("dg7hJ");

var $9vIcm = parcelRequire("9vIcm");

var $ixcRH = parcelRequire("ixcRH");

var $fXdNB = parcelRequire("fXdNB");

var $kOSYA = parcelRequire("kOSYA");

var $4E2vH = parcelRequire("4E2vH");

var $11WCK = parcelRequire("11WCK");

var $gY8Oe = parcelRequire("gY8Oe");

var $igkLz = parcelRequire("igkLz");

var $4Izw5 = parcelRequire("4Izw5");

var $8qywC = parcelRequire("8qywC");

var $2hrzz = parcelRequire("2hrzz");

var $2r1O0 = parcelRequire("2r1O0");

var $6jeWn = parcelRequire("6jeWn");

var $kRZy5 = parcelRequire("kRZy5");

var $32vMa = parcelRequire("32vMa");

var $cQbjj = parcelRequire("cQbjj");

var $kuA5r = parcelRequire("kuA5r");

var $4go3B = parcelRequire("4go3B");

var $aaHGl = parcelRequire("aaHGl");

var $6B3gM = parcelRequire("6B3gM");

var $e7x84 = parcelRequire("e7x84");

var $2Sjve = parcelRequire("2Sjve");

var $cJ2JL = parcelRequire("cJ2JL");

var $7DhQ2 = parcelRequire("7DhQ2");

var $eftTt = parcelRequire("eftTt");

var $3oRPQ = parcelRequire("3oRPQ");

var $ibZDC = parcelRequire("ibZDC");

});
parcelRegister("jguXh", function(module, exports) {

$parcel$export(module.exports, "areaRingSum", () => $e06785fd60a9812a$export$bf8f994332070c7f);
$parcel$export(module.exports, "areaStream", () => $e06785fd60a9812a$export$cb67cfa750ae69dc);

var $2P1Jm = parcelRequire("2P1Jm");

var $ikW5Q = parcelRequire("ikW5Q");

var $a3voy = parcelRequire("a3voy");

var $3oRPQ = parcelRequire("3oRPQ");
var $e06785fd60a9812a$export$bf8f994332070c7f = (0, $2P1Jm.default)();
var $e06785fd60a9812a$var$areaSum = (0, $2P1Jm.default)(), $e06785fd60a9812a$var$lambda00, $e06785fd60a9812a$var$phi00, $e06785fd60a9812a$var$lambda0, $e06785fd60a9812a$var$cosPhi0, $e06785fd60a9812a$var$sinPhi0;
var $e06785fd60a9812a$export$cb67cfa750ae69dc = {
    point: (0, $a3voy.default),
    lineStart: (0, $a3voy.default),
    lineEnd: (0, $a3voy.default),
    polygonStart: function() {
        $e06785fd60a9812a$export$bf8f994332070c7f.reset();
        $e06785fd60a9812a$export$cb67cfa750ae69dc.lineStart = $e06785fd60a9812a$var$areaRingStart;
        $e06785fd60a9812a$export$cb67cfa750ae69dc.lineEnd = $e06785fd60a9812a$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$e06785fd60a9812a$export$bf8f994332070c7f;
        $e06785fd60a9812a$var$areaSum.add(areaRing < 0 ? (0, $ikW5Q.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $a3voy.default);
    },
    sphere: function() {
        $e06785fd60a9812a$var$areaSum.add((0, $ikW5Q.tau));
    }
};
function $e06785fd60a9812a$var$areaRingStart() {
    $e06785fd60a9812a$export$cb67cfa750ae69dc.point = $e06785fd60a9812a$var$areaPointFirst;
}
function $e06785fd60a9812a$var$areaRingEnd() {
    $e06785fd60a9812a$var$areaPoint($e06785fd60a9812a$var$lambda00, $e06785fd60a9812a$var$phi00);
}
function $e06785fd60a9812a$var$areaPointFirst(lambda, phi) {
    $e06785fd60a9812a$export$cb67cfa750ae69dc.point = $e06785fd60a9812a$var$areaPoint;
    $e06785fd60a9812a$var$lambda00 = lambda, $e06785fd60a9812a$var$phi00 = phi;
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    $e06785fd60a9812a$var$lambda0 = lambda, $e06785fd60a9812a$var$cosPhi0 = (0, $ikW5Q.cos)(phi = phi / 2 + (0, $ikW5Q.quarterPi)), $e06785fd60a9812a$var$sinPhi0 = (0, $ikW5Q.sin)(phi);
}
function $e06785fd60a9812a$var$areaPoint(lambda, phi) {
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    phi = phi / 2 + (0, $ikW5Q.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $e06785fd60a9812a$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $ikW5Q.cos)(phi), sinPhi = (0, $ikW5Q.sin)(phi), k = $e06785fd60a9812a$var$sinPhi0 * sinPhi, u = $e06785fd60a9812a$var$cosPhi0 * cosPhi + k * (0, $ikW5Q.cos)(adLambda), v = k * sdLambda * (0, $ikW5Q.sin)(adLambda);
    $e06785fd60a9812a$export$bf8f994332070c7f.add((0, $ikW5Q.atan2)(v, u));
    // Advance the previous points.
    $e06785fd60a9812a$var$lambda0 = lambda, $e06785fd60a9812a$var$cosPhi0 = cosPhi, $e06785fd60a9812a$var$sinPhi0 = sinPhi;
}
function $e06785fd60a9812a$export$2e2bcd8739ae039(object) {
    $e06785fd60a9812a$var$areaSum.reset();
    (0, $3oRPQ.default)(object, $e06785fd60a9812a$export$cb67cfa750ae69dc);
    return $e06785fd60a9812a$var$areaSum * 2;
}

});
parcelRegister("2P1Jm", function(module, exports) {

$parcel$export(module.exports, "default", () => $20e1afd5bfe9e69d$export$2e2bcd8739ae039);
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/
function $20e1afd5bfe9e69d$export$2e2bcd8739ae039() {
    return new $20e1afd5bfe9e69d$var$Adder;
}
function $20e1afd5bfe9e69d$var$Adder() {
    this.reset();
}
$20e1afd5bfe9e69d$var$Adder.prototype = {
    constructor: $20e1afd5bfe9e69d$var$Adder,
    reset: function() {
        this.s = this.t = 0; // exact error
    },
    add: function(y) {
        $20e1afd5bfe9e69d$var$add($20e1afd5bfe9e69d$var$temp, y, this.t);
        $20e1afd5bfe9e69d$var$add(this, $20e1afd5bfe9e69d$var$temp.s, this.s);
        if (this.s) this.t += $20e1afd5bfe9e69d$var$temp.t;
        else this.s = $20e1afd5bfe9e69d$var$temp.t;
    },
    valueOf: function() {
        return this.s;
    }
};
var $20e1afd5bfe9e69d$var$temp = new $20e1afd5bfe9e69d$var$Adder;
function $20e1afd5bfe9e69d$var$add(adder, a, b) {
    var x = adder.s = a + b, bv = x - a, av = x - bv;
    adder.t = a - av + (b - bv);
}

});

parcelRegister("ikW5Q", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => $d597285d5ed7aa53$export$6c421550c66a327d);
$parcel$export(module.exports, "epsilon2", () => $d597285d5ed7aa53$export$92c06fba281fe81b);
$parcel$export(module.exports, "pi", () => $d597285d5ed7aa53$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $d597285d5ed7aa53$export$e51408a300e8929a);
$parcel$export(module.exports, "quarterPi", () => $d597285d5ed7aa53$export$c39a5cba78ea0fc2);
$parcel$export(module.exports, "tau", () => $d597285d5ed7aa53$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "degrees", () => $d597285d5ed7aa53$export$41fc368e1a942b97);
$parcel$export(module.exports, "radians", () => $d597285d5ed7aa53$export$8449e153fbd325fc);
$parcel$export(module.exports, "abs", () => $d597285d5ed7aa53$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan", () => $d597285d5ed7aa53$export$628dc4eed22b0fbd);
$parcel$export(module.exports, "atan2", () => $d597285d5ed7aa53$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $d597285d5ed7aa53$export$50d414a77b60d802);
$parcel$export(module.exports, "ceil", () => $d597285d5ed7aa53$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "exp", () => $d597285d5ed7aa53$export$b310ec824aaee37f);
$parcel$export(module.exports, "log", () => $d597285d5ed7aa53$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "pow", () => $d597285d5ed7aa53$export$9c297f60e22e3389);
$parcel$export(module.exports, "sin", () => $d597285d5ed7aa53$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sign", () => $d597285d5ed7aa53$export$c5552dfdbc7cec71);
$parcel$export(module.exports, "sqrt", () => $d597285d5ed7aa53$export$eba8049fb5020b81);
$parcel$export(module.exports, "tan", () => $d597285d5ed7aa53$export$fcdd3b0b3246a325);
$parcel$export(module.exports, "acos", () => $d597285d5ed7aa53$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $d597285d5ed7aa53$export$41726bdb1fc63f);
$parcel$export(module.exports, "haversin", () => $d597285d5ed7aa53$export$e808712c2966e662);
var $d597285d5ed7aa53$export$6c421550c66a327d = 1e-6;
var $d597285d5ed7aa53$export$92c06fba281fe81b = 1e-12;
var $d597285d5ed7aa53$export$18c7bea995a110f = Math.PI;
var $d597285d5ed7aa53$export$e51408a300e8929a = $d597285d5ed7aa53$export$18c7bea995a110f / 2;
var $d597285d5ed7aa53$export$c39a5cba78ea0fc2 = $d597285d5ed7aa53$export$18c7bea995a110f / 4;
var $d597285d5ed7aa53$export$a4b4b4d4d776fe92 = $d597285d5ed7aa53$export$18c7bea995a110f * 2;
var $d597285d5ed7aa53$export$41fc368e1a942b97 = 180 / $d597285d5ed7aa53$export$18c7bea995a110f;
var $d597285d5ed7aa53$export$8449e153fbd325fc = $d597285d5ed7aa53$export$18c7bea995a110f / 180;
var $d597285d5ed7aa53$export$2335f513bbd82c6d = Math.abs;
var $d597285d5ed7aa53$export$628dc4eed22b0fbd = Math.atan;
var $d597285d5ed7aa53$export$b8b770ee6a0d9760 = Math.atan2;
var $d597285d5ed7aa53$export$50d414a77b60d802 = Math.cos;
var $d597285d5ed7aa53$export$803ce6b71a0a94b2 = Math.ceil;
var $d597285d5ed7aa53$export$b310ec824aaee37f = Math.exp;
var $d597285d5ed7aa53$export$a3fe094919f356fd = Math.floor;
var $d597285d5ed7aa53$export$bef1f36f5486a6a3 = Math.log;
var $d597285d5ed7aa53$export$9c297f60e22e3389 = Math.pow;
var $d597285d5ed7aa53$export$5de3937cb4b592ed = Math.sin;
var $d597285d5ed7aa53$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $d597285d5ed7aa53$export$eba8049fb5020b81 = Math.sqrt;
var $d597285d5ed7aa53$export$fcdd3b0b3246a325 = Math.tan;
function $d597285d5ed7aa53$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $d597285d5ed7aa53$export$18c7bea995a110f : Math.acos(x);
}
function $d597285d5ed7aa53$export$41726bdb1fc63f(x) {
    return x > 1 ? $d597285d5ed7aa53$export$e51408a300e8929a : x < -1 ? -$d597285d5ed7aa53$export$e51408a300e8929a : Math.asin(x);
}
function $d597285d5ed7aa53$export$e808712c2966e662(x) {
    return (x = $d597285d5ed7aa53$export$5de3937cb4b592ed(x / 2)) * x;
}

});

parcelRegister("a3voy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7522899eb095413b$export$2e2bcd8739ae039);
function $7522899eb095413b$export$2e2bcd8739ae039() {}

});

parcelRegister("3oRPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $279d5f8ed456c2d7$export$2e2bcd8739ae039);
function $279d5f8ed456c2d7$var$streamGeometry(geometry, stream) {
    if (geometry && $279d5f8ed456c2d7$var$streamGeometryType.hasOwnProperty(geometry.type)) $279d5f8ed456c2d7$var$streamGeometryType[geometry.type](geometry, stream);
}
var $279d5f8ed456c2d7$var$streamObjectType = {
    Feature: function(object, stream) {
        $279d5f8ed456c2d7$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$279d5f8ed456c2d7$var$streamGeometry(features[i].geometry, stream);
    }
};
var $279d5f8ed456c2d7$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $279d5f8ed456c2d7$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$279d5f8ed456c2d7$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $279d5f8ed456c2d7$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$279d5f8ed456c2d7$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$279d5f8ed456c2d7$var$streamGeometry(geometries[i], stream);
    }
};
function $279d5f8ed456c2d7$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $279d5f8ed456c2d7$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$279d5f8ed456c2d7$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $279d5f8ed456c2d7$export$2e2bcd8739ae039(object, stream) {
    if (object && $279d5f8ed456c2d7$var$streamObjectType.hasOwnProperty(object.type)) $279d5f8ed456c2d7$var$streamObjectType[object.type](object, stream);
    else $279d5f8ed456c2d7$var$streamGeometry(object, stream);
}

});


parcelRegister("6jHoV", function(module, exports) {

var $2P1Jm = parcelRequire("2P1Jm");

var $jguXh = parcelRequire("jguXh");

var $6m6m0 = parcelRequire("6m6m0");

var $ikW5Q = parcelRequire("ikW5Q");

var $3oRPQ = parcelRequire("3oRPQ");
var $49962ef16bfea777$var$lambda0, $49962ef16bfea777$var$phi0, $49962ef16bfea777$var$lambda1, $49962ef16bfea777$var$phi1, $49962ef16bfea777$var$lambda2, $49962ef16bfea777$var$lambda00, $49962ef16bfea777$var$phi00, $49962ef16bfea777$var$p0, $49962ef16bfea777$var$deltaSum = (0, $2P1Jm.default)(), $49962ef16bfea777$var$ranges, $49962ef16bfea777$var$range;
var $49962ef16bfea777$var$boundsStream = {
    point: $49962ef16bfea777$var$boundsPoint,
    lineStart: $49962ef16bfea777$var$boundsLineStart,
    lineEnd: $49962ef16bfea777$var$boundsLineEnd,
    polygonStart: function() {
        $49962ef16bfea777$var$boundsStream.point = $49962ef16bfea777$var$boundsRingPoint;
        $49962ef16bfea777$var$boundsStream.lineStart = $49962ef16bfea777$var$boundsRingStart;
        $49962ef16bfea777$var$boundsStream.lineEnd = $49962ef16bfea777$var$boundsRingEnd;
        $49962ef16bfea777$var$deltaSum.reset();
        (0, $jguXh.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, $jguXh.areaStream).polygonEnd();
        $49962ef16bfea777$var$boundsStream.point = $49962ef16bfea777$var$boundsPoint;
        $49962ef16bfea777$var$boundsStream.lineStart = $49962ef16bfea777$var$boundsLineStart;
        $49962ef16bfea777$var$boundsStream.lineEnd = $49962ef16bfea777$var$boundsLineEnd;
        if ((0, $jguXh.areaRingSum) < 0) $49962ef16bfea777$var$lambda0 = -($49962ef16bfea777$var$lambda1 = 180), $49962ef16bfea777$var$phi0 = -($49962ef16bfea777$var$phi1 = 90);
        else if ($49962ef16bfea777$var$deltaSum > (0, $ikW5Q.epsilon)) $49962ef16bfea777$var$phi1 = 90;
        else if ($49962ef16bfea777$var$deltaSum < -(0, $ikW5Q.epsilon)) $49962ef16bfea777$var$phi0 = -90;
        $49962ef16bfea777$var$range[0] = $49962ef16bfea777$var$lambda0, $49962ef16bfea777$var$range[1] = $49962ef16bfea777$var$lambda1;
    }
};
function $49962ef16bfea777$var$boundsPoint(lambda, phi) {
    $49962ef16bfea777$var$ranges.push($49962ef16bfea777$var$range = [
        $49962ef16bfea777$var$lambda0 = lambda,
        $49962ef16bfea777$var$lambda1 = lambda
    ]);
    if (phi < $49962ef16bfea777$var$phi0) $49962ef16bfea777$var$phi0 = phi;
    if (phi > $49962ef16bfea777$var$phi1) $49962ef16bfea777$var$phi1 = phi;
}
function $49962ef16bfea777$var$linePoint(lambda, phi) {
    var p = (0, $6m6m0.cartesian)([
        lambda * (0, $ikW5Q.radians),
        phi * (0, $ikW5Q.radians)
    ]);
    if ($49962ef16bfea777$var$p0) {
        var normal = (0, $6m6m0.cartesianCross)($49962ef16bfea777$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $6m6m0.cartesianCross)(equatorial, normal);
        (0, $6m6m0.cartesianNormalizeInPlace)(inflection);
        inflection = (0, $6m6m0.spherical)(inflection);
        var delta = lambda - $49962ef16bfea777$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $ikW5Q.degrees) * sign, phii, antimeridian = (0, $ikW5Q.abs)(delta) > 180;
        if (antimeridian ^ (sign * $49962ef16bfea777$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $ikW5Q.degrees);
            if (phii > $49962ef16bfea777$var$phi1) $49962ef16bfea777$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $49962ef16bfea777$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $ikW5Q.degrees);
            if (phii < $49962ef16bfea777$var$phi0) $49962ef16bfea777$var$phi0 = phii;
        } else {
            if (phi < $49962ef16bfea777$var$phi0) $49962ef16bfea777$var$phi0 = phi;
            if (phi > $49962ef16bfea777$var$phi1) $49962ef16bfea777$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $49962ef16bfea777$var$lambda2) {
                if ($49962ef16bfea777$var$angle($49962ef16bfea777$var$lambda0, lambda) > $49962ef16bfea777$var$angle($49962ef16bfea777$var$lambda0, $49962ef16bfea777$var$lambda1)) $49962ef16bfea777$var$lambda1 = lambda;
            } else if ($49962ef16bfea777$var$angle(lambda, $49962ef16bfea777$var$lambda1) > $49962ef16bfea777$var$angle($49962ef16bfea777$var$lambda0, $49962ef16bfea777$var$lambda1)) $49962ef16bfea777$var$lambda0 = lambda;
        } else if ($49962ef16bfea777$var$lambda1 >= $49962ef16bfea777$var$lambda0) {
            if (lambda < $49962ef16bfea777$var$lambda0) $49962ef16bfea777$var$lambda0 = lambda;
            if (lambda > $49962ef16bfea777$var$lambda1) $49962ef16bfea777$var$lambda1 = lambda;
        } else {
            if (lambda > $49962ef16bfea777$var$lambda2) {
                if ($49962ef16bfea777$var$angle($49962ef16bfea777$var$lambda0, lambda) > $49962ef16bfea777$var$angle($49962ef16bfea777$var$lambda0, $49962ef16bfea777$var$lambda1)) $49962ef16bfea777$var$lambda1 = lambda;
            } else if ($49962ef16bfea777$var$angle(lambda, $49962ef16bfea777$var$lambda1) > $49962ef16bfea777$var$angle($49962ef16bfea777$var$lambda0, $49962ef16bfea777$var$lambda1)) $49962ef16bfea777$var$lambda0 = lambda;
        }
    } else $49962ef16bfea777$var$ranges.push($49962ef16bfea777$var$range = [
        $49962ef16bfea777$var$lambda0 = lambda,
        $49962ef16bfea777$var$lambda1 = lambda
    ]);
    if (phi < $49962ef16bfea777$var$phi0) $49962ef16bfea777$var$phi0 = phi;
    if (phi > $49962ef16bfea777$var$phi1) $49962ef16bfea777$var$phi1 = phi;
    $49962ef16bfea777$var$p0 = p, $49962ef16bfea777$var$lambda2 = lambda;
}
function $49962ef16bfea777$var$boundsLineStart() {
    $49962ef16bfea777$var$boundsStream.point = $49962ef16bfea777$var$linePoint;
}
function $49962ef16bfea777$var$boundsLineEnd() {
    $49962ef16bfea777$var$range[0] = $49962ef16bfea777$var$lambda0, $49962ef16bfea777$var$range[1] = $49962ef16bfea777$var$lambda1;
    $49962ef16bfea777$var$boundsStream.point = $49962ef16bfea777$var$boundsPoint;
    $49962ef16bfea777$var$p0 = null;
}
function $49962ef16bfea777$var$boundsRingPoint(lambda, phi) {
    if ($49962ef16bfea777$var$p0) {
        var delta = lambda - $49962ef16bfea777$var$lambda2;
        $49962ef16bfea777$var$deltaSum.add((0, $ikW5Q.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $49962ef16bfea777$var$lambda00 = lambda, $49962ef16bfea777$var$phi00 = phi;
    (0, $jguXh.areaStream).point(lambda, phi);
    $49962ef16bfea777$var$linePoint(lambda, phi);
}
function $49962ef16bfea777$var$boundsRingStart() {
    (0, $jguXh.areaStream).lineStart();
}
function $49962ef16bfea777$var$boundsRingEnd() {
    $49962ef16bfea777$var$boundsRingPoint($49962ef16bfea777$var$lambda00, $49962ef16bfea777$var$phi00);
    (0, $jguXh.areaStream).lineEnd();
    if ((0, $ikW5Q.abs)($49962ef16bfea777$var$deltaSum) > (0, $ikW5Q.epsilon)) $49962ef16bfea777$var$lambda0 = -($49962ef16bfea777$var$lambda1 = 180);
    $49962ef16bfea777$var$range[0] = $49962ef16bfea777$var$lambda0, $49962ef16bfea777$var$range[1] = $49962ef16bfea777$var$lambda1;
    $49962ef16bfea777$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $49962ef16bfea777$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $49962ef16bfea777$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $49962ef16bfea777$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $49962ef16bfea777$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $49962ef16bfea777$var$phi1 = $49962ef16bfea777$var$lambda1 = -($49962ef16bfea777$var$lambda0 = $49962ef16bfea777$var$phi0 = Infinity);
    $49962ef16bfea777$var$ranges = [];
    (0, $3oRPQ.default)(feature, $49962ef16bfea777$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $49962ef16bfea777$var$ranges.length) {
        $49962ef16bfea777$var$ranges.sort($49962ef16bfea777$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $49962ef16bfea777$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $49962ef16bfea777$var$ranges[i];
            if ($49962ef16bfea777$var$rangeContains(a, b[0]) || $49962ef16bfea777$var$rangeContains(a, b[1])) {
                if ($49962ef16bfea777$var$angle(a[0], b[1]) > $49962ef16bfea777$var$angle(a[0], a[1])) a[1] = b[1];
                if ($49962ef16bfea777$var$angle(b[0], a[1]) > $49962ef16bfea777$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $49962ef16bfea777$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $49962ef16bfea777$var$lambda0 = b[0], $49962ef16bfea777$var$lambda1 = a[1];
        }
    }
    $49962ef16bfea777$var$ranges = $49962ef16bfea777$var$range = null;
    return $49962ef16bfea777$var$lambda0 === Infinity || $49962ef16bfea777$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $49962ef16bfea777$var$lambda0,
            $49962ef16bfea777$var$phi0
        ],
        [
            $49962ef16bfea777$var$lambda1,
            $49962ef16bfea777$var$phi1
        ]
    ];
}

});
parcelRegister("6m6m0", function(module, exports) {

$parcel$export(module.exports, "spherical", () => $4a09b9e5ceff6dbb$export$12f9ad44fe773943);
$parcel$export(module.exports, "cartesian", () => $4a09b9e5ceff6dbb$export$6e6697ef026a96);
$parcel$export(module.exports, "cartesianDot", () => $4a09b9e5ceff6dbb$export$2ef80f51436a9de9);
$parcel$export(module.exports, "cartesianCross", () => $4a09b9e5ceff6dbb$export$4763f5351b14293f);
$parcel$export(module.exports, "cartesianAddInPlace", () => $4a09b9e5ceff6dbb$export$e62eba72fc898eae);
$parcel$export(module.exports, "cartesianScale", () => $4a09b9e5ceff6dbb$export$52d0ee3fc868d452);
$parcel$export(module.exports, "cartesianNormalizeInPlace", () => $4a09b9e5ceff6dbb$export$6789498aec2cb34b);

var $ikW5Q = parcelRequire("ikW5Q");
function $4a09b9e5ceff6dbb$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $ikW5Q.atan2)(cartesian[1], cartesian[0]),
        (0, $ikW5Q.asin)(cartesian[2])
    ];
}
function $4a09b9e5ceff6dbb$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $ikW5Q.cos)(phi);
    return [
        cosPhi * (0, $ikW5Q.cos)(lambda),
        cosPhi * (0, $ikW5Q.sin)(lambda),
        (0, $ikW5Q.sin)(phi)
    ];
}
function $4a09b9e5ceff6dbb$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $4a09b9e5ceff6dbb$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $4a09b9e5ceff6dbb$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $4a09b9e5ceff6dbb$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $4a09b9e5ceff6dbb$export$6789498aec2cb34b(d) {
    var l = (0, $ikW5Q.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

});


parcelRegister("77YGd", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $a3voy = parcelRequire("a3voy");

var $3oRPQ = parcelRequire("3oRPQ");
var $53084197dc980b6f$var$W0, $53084197dc980b6f$var$W1, $53084197dc980b6f$var$X0, $53084197dc980b6f$var$Y0, $53084197dc980b6f$var$Z0, $53084197dc980b6f$var$X1, $53084197dc980b6f$var$Y1, $53084197dc980b6f$var$Z1, $53084197dc980b6f$var$X2, $53084197dc980b6f$var$Y2, $53084197dc980b6f$var$Z2, $53084197dc980b6f$var$lambda00, $53084197dc980b6f$var$phi00, $53084197dc980b6f$var$x0, $53084197dc980b6f$var$y0, $53084197dc980b6f$var$z0; // previous point
var $53084197dc980b6f$var$centroidStream = {
    sphere: (0, $a3voy.default),
    point: $53084197dc980b6f$var$centroidPoint,
    lineStart: $53084197dc980b6f$var$centroidLineStart,
    lineEnd: $53084197dc980b6f$var$centroidLineEnd,
    polygonStart: function() {
        $53084197dc980b6f$var$centroidStream.lineStart = $53084197dc980b6f$var$centroidRingStart;
        $53084197dc980b6f$var$centroidStream.lineEnd = $53084197dc980b6f$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $53084197dc980b6f$var$centroidStream.lineStart = $53084197dc980b6f$var$centroidLineStart;
        $53084197dc980b6f$var$centroidStream.lineEnd = $53084197dc980b6f$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $53084197dc980b6f$var$centroidPoint(lambda, phi) {
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    var cosPhi = (0, $ikW5Q.cos)(phi);
    $53084197dc980b6f$var$centroidPointCartesian(cosPhi * (0, $ikW5Q.cos)(lambda), cosPhi * (0, $ikW5Q.sin)(lambda), (0, $ikW5Q.sin)(phi));
}
function $53084197dc980b6f$var$centroidPointCartesian(x, y, z) {
    ++$53084197dc980b6f$var$W0;
    $53084197dc980b6f$var$X0 += (x - $53084197dc980b6f$var$X0) / $53084197dc980b6f$var$W0;
    $53084197dc980b6f$var$Y0 += (y - $53084197dc980b6f$var$Y0) / $53084197dc980b6f$var$W0;
    $53084197dc980b6f$var$Z0 += (z - $53084197dc980b6f$var$Z0) / $53084197dc980b6f$var$W0;
}
function $53084197dc980b6f$var$centroidLineStart() {
    $53084197dc980b6f$var$centroidStream.point = $53084197dc980b6f$var$centroidLinePointFirst;
}
function $53084197dc980b6f$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    var cosPhi = (0, $ikW5Q.cos)(phi);
    $53084197dc980b6f$var$x0 = cosPhi * (0, $ikW5Q.cos)(lambda);
    $53084197dc980b6f$var$y0 = cosPhi * (0, $ikW5Q.sin)(lambda);
    $53084197dc980b6f$var$z0 = (0, $ikW5Q.sin)(phi);
    $53084197dc980b6f$var$centroidStream.point = $53084197dc980b6f$var$centroidLinePoint;
    $53084197dc980b6f$var$centroidPointCartesian($53084197dc980b6f$var$x0, $53084197dc980b6f$var$y0, $53084197dc980b6f$var$z0);
}
function $53084197dc980b6f$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    var cosPhi = (0, $ikW5Q.cos)(phi), x = cosPhi * (0, $ikW5Q.cos)(lambda), y = cosPhi * (0, $ikW5Q.sin)(lambda), z = (0, $ikW5Q.sin)(phi), w = (0, $ikW5Q.atan2)((0, $ikW5Q.sqrt)((w = $53084197dc980b6f$var$y0 * z - $53084197dc980b6f$var$z0 * y) * w + (w = $53084197dc980b6f$var$z0 * x - $53084197dc980b6f$var$x0 * z) * w + (w = $53084197dc980b6f$var$x0 * y - $53084197dc980b6f$var$y0 * x) * w), $53084197dc980b6f$var$x0 * x + $53084197dc980b6f$var$y0 * y + $53084197dc980b6f$var$z0 * z);
    $53084197dc980b6f$var$W1 += w;
    $53084197dc980b6f$var$X1 += w * ($53084197dc980b6f$var$x0 + ($53084197dc980b6f$var$x0 = x));
    $53084197dc980b6f$var$Y1 += w * ($53084197dc980b6f$var$y0 + ($53084197dc980b6f$var$y0 = y));
    $53084197dc980b6f$var$Z1 += w * ($53084197dc980b6f$var$z0 + ($53084197dc980b6f$var$z0 = z));
    $53084197dc980b6f$var$centroidPointCartesian($53084197dc980b6f$var$x0, $53084197dc980b6f$var$y0, $53084197dc980b6f$var$z0);
}
function $53084197dc980b6f$var$centroidLineEnd() {
    $53084197dc980b6f$var$centroidStream.point = $53084197dc980b6f$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $53084197dc980b6f$var$centroidRingStart() {
    $53084197dc980b6f$var$centroidStream.point = $53084197dc980b6f$var$centroidRingPointFirst;
}
function $53084197dc980b6f$var$centroidRingEnd() {
    $53084197dc980b6f$var$centroidRingPoint($53084197dc980b6f$var$lambda00, $53084197dc980b6f$var$phi00);
    $53084197dc980b6f$var$centroidStream.point = $53084197dc980b6f$var$centroidPoint;
}
function $53084197dc980b6f$var$centroidRingPointFirst(lambda, phi) {
    $53084197dc980b6f$var$lambda00 = lambda, $53084197dc980b6f$var$phi00 = phi;
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    $53084197dc980b6f$var$centroidStream.point = $53084197dc980b6f$var$centroidRingPoint;
    var cosPhi = (0, $ikW5Q.cos)(phi);
    $53084197dc980b6f$var$x0 = cosPhi * (0, $ikW5Q.cos)(lambda);
    $53084197dc980b6f$var$y0 = cosPhi * (0, $ikW5Q.sin)(lambda);
    $53084197dc980b6f$var$z0 = (0, $ikW5Q.sin)(phi);
    $53084197dc980b6f$var$centroidPointCartesian($53084197dc980b6f$var$x0, $53084197dc980b6f$var$y0, $53084197dc980b6f$var$z0);
}
function $53084197dc980b6f$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    var cosPhi = (0, $ikW5Q.cos)(phi), x = cosPhi * (0, $ikW5Q.cos)(lambda), y = cosPhi * (0, $ikW5Q.sin)(lambda), z = (0, $ikW5Q.sin)(phi), cx = $53084197dc980b6f$var$y0 * z - $53084197dc980b6f$var$z0 * y, cy = $53084197dc980b6f$var$z0 * x - $53084197dc980b6f$var$x0 * z, cz = $53084197dc980b6f$var$x0 * y - $53084197dc980b6f$var$y0 * x, m = (0, $ikW5Q.sqrt)(cx * cx + cy * cy + cz * cz), w = (0, $ikW5Q.asin)(m), v = m && -w / m; // area weight multiplier
    $53084197dc980b6f$var$X2 += v * cx;
    $53084197dc980b6f$var$Y2 += v * cy;
    $53084197dc980b6f$var$Z2 += v * cz;
    $53084197dc980b6f$var$W1 += w;
    $53084197dc980b6f$var$X1 += w * ($53084197dc980b6f$var$x0 + ($53084197dc980b6f$var$x0 = x));
    $53084197dc980b6f$var$Y1 += w * ($53084197dc980b6f$var$y0 + ($53084197dc980b6f$var$y0 = y));
    $53084197dc980b6f$var$Z1 += w * ($53084197dc980b6f$var$z0 + ($53084197dc980b6f$var$z0 = z));
    $53084197dc980b6f$var$centroidPointCartesian($53084197dc980b6f$var$x0, $53084197dc980b6f$var$y0, $53084197dc980b6f$var$z0);
}
function $53084197dc980b6f$export$2e2bcd8739ae039(object) {
    $53084197dc980b6f$var$W0 = $53084197dc980b6f$var$W1 = $53084197dc980b6f$var$X0 = $53084197dc980b6f$var$Y0 = $53084197dc980b6f$var$Z0 = $53084197dc980b6f$var$X1 = $53084197dc980b6f$var$Y1 = $53084197dc980b6f$var$Z1 = $53084197dc980b6f$var$X2 = $53084197dc980b6f$var$Y2 = $53084197dc980b6f$var$Z2 = 0;
    (0, $3oRPQ.default)(object, $53084197dc980b6f$var$centroidStream);
    var x = $53084197dc980b6f$var$X2, y = $53084197dc980b6f$var$Y2, z = $53084197dc980b6f$var$Z2, m = x * x + y * y + z * z;
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $ikW5Q.epsilon2)) {
        x = $53084197dc980b6f$var$X1, y = $53084197dc980b6f$var$Y1, z = $53084197dc980b6f$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($53084197dc980b6f$var$W1 < (0, $ikW5Q.epsilon)) x = $53084197dc980b6f$var$X0, y = $53084197dc980b6f$var$Y0, z = $53084197dc980b6f$var$Z0;
        m = x * x + y * y + z * z;
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $ikW5Q.epsilon2)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $ikW5Q.atan2)(y, x) * (0, $ikW5Q.degrees),
        (0, $ikW5Q.asin)(z / (0, $ikW5Q.sqrt)(m)) * (0, $ikW5Q.degrees)
    ];
}

});

parcelRegister("kl3aS", function(module, exports) {

$parcel$export(module.exports, "circleStream", () => $ece83b2e9a5bd6ae$export$b5441eb324cd8d4e);

var $6m6m0 = parcelRequire("6m6m0");

var $j9bTC = parcelRequire("j9bTC");

var $ikW5Q = parcelRequire("ikW5Q");

var $eftTt = parcelRequire("eftTt");
function $ece83b2e9a5bd6ae$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $ikW5Q.cos)(radius), sinRadius = (0, $ikW5Q.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $ikW5Q.tau);
        t1 = radius - step / 2;
    } else {
        t0 = $ece83b2e9a5bd6ae$var$circleRadius(cosRadius, t0);
        t1 = $ece83b2e9a5bd6ae$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $ikW5Q.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $6m6m0.spherical)([
            cosRadius,
            -sinRadius * (0, $ikW5Q.cos)(t),
            -sinRadius * (0, $ikW5Q.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $ece83b2e9a5bd6ae$var$circleRadius(cosRadius, point) {
    point = (0, $6m6m0.cartesian)(point), point[0] -= cosRadius;
    (0, $6m6m0.cartesianNormalizeInPlace)(point);
    var radius = (0, $ikW5Q.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $ikW5Q.tau) - (0, $ikW5Q.epsilon)) % (0, $ikW5Q.tau);
}
function $ece83b2e9a5bd6ae$export$2e2bcd8739ae039() {
    var center = (0, $j9bTC.default)([
        0,
        0
    ]), radius = (0, $j9bTC.default)(90), precision = (0, $j9bTC.default)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $ikW5Q.degrees), x[1] *= (0, $ikW5Q.degrees);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $ikW5Q.radians), p = precision.apply(this, arguments) * (0, $ikW5Q.radians);
        ring = [];
        rotate = (0, $eftTt.rotateRadians)(-c[0] * (0, $ikW5Q.radians), -c[1] * (0, $ikW5Q.radians), 0).invert;
        $ece83b2e9a5bd6ae$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $j9bTC.default)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $j9bTC.default)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $j9bTC.default)(+_), circle) : precision;
    };
    return circle;
}

});
parcelRegister("j9bTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $df0815e9098a3d21$export$2e2bcd8739ae039);
function $df0815e9098a3d21$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("eftTt", function(module, exports) {

$parcel$export(module.exports, "rotateRadians", () => $a5f9a7adb602235f$export$a2ba89726971a90f);
$parcel$export(module.exports, "default", () => $a5f9a7adb602235f$export$2e2bcd8739ae039);

var $ia0ZW = parcelRequire("ia0ZW");

var $ikW5Q = parcelRequire("ikW5Q");
function $a5f9a7adb602235f$var$rotationIdentity(lambda, phi) {
    return [
        lambda > (0, $ikW5Q.pi) ? lambda - (0, $ikW5Q.tau) : lambda < -(0, $ikW5Q.pi) ? lambda + (0, $ikW5Q.tau) : lambda,
        phi
    ];
}
$a5f9a7adb602235f$var$rotationIdentity.invert = $a5f9a7adb602235f$var$rotationIdentity;
function $a5f9a7adb602235f$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $ikW5Q.tau)) ? deltaPhi || deltaGamma ? (0, $ia0ZW.default)($a5f9a7adb602235f$var$rotationLambda(deltaLambda), $a5f9a7adb602235f$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $a5f9a7adb602235f$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $a5f9a7adb602235f$var$rotationPhiGamma(deltaPhi, deltaGamma) : $a5f9a7adb602235f$var$rotationIdentity;
}
function $a5f9a7adb602235f$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, $ikW5Q.pi) ? lambda - (0, $ikW5Q.tau) : lambda < -(0, $ikW5Q.pi) ? lambda + (0, $ikW5Q.tau) : lambda,
            phi
        ];
    };
}
function $a5f9a7adb602235f$var$rotationLambda(deltaLambda) {
    var rotation = $a5f9a7adb602235f$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $a5f9a7adb602235f$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $a5f9a7adb602235f$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $ikW5Q.cos)(deltaPhi), sinDeltaPhi = (0, $ikW5Q.sin)(deltaPhi), cosDeltaGamma = (0, $ikW5Q.cos)(deltaGamma), sinDeltaGamma = (0, $ikW5Q.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $ikW5Q.cos)(phi), x = (0, $ikW5Q.cos)(lambda) * cosPhi, y = (0, $ikW5Q.sin)(lambda) * cosPhi, z = (0, $ikW5Q.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $ikW5Q.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $ikW5Q.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $ikW5Q.cos)(phi), x = (0, $ikW5Q.cos)(lambda) * cosPhi, y = (0, $ikW5Q.sin)(lambda) * cosPhi, z = (0, $ikW5Q.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $ikW5Q.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $ikW5Q.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $a5f9a7adb602235f$export$2e2bcd8739ae039(rotate) {
    rotate = $a5f9a7adb602235f$export$a2ba89726971a90f(rotate[0] * (0, $ikW5Q.radians), rotate[1] * (0, $ikW5Q.radians), rotate.length > 2 ? rotate[2] * (0, $ikW5Q.radians) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $ikW5Q.radians), coordinates[1] * (0, $ikW5Q.radians));
        return coordinates[0] *= (0, $ikW5Q.degrees), coordinates[1] *= (0, $ikW5Q.degrees), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $ikW5Q.radians), coordinates[1] * (0, $ikW5Q.radians));
        return coordinates[0] *= (0, $ikW5Q.degrees), coordinates[1] *= (0, $ikW5Q.degrees), coordinates;
    };
    return forward;
}

});
parcelRegister("ia0ZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d389ef6154b05d1a$export$2e2bcd8739ae039);
function $d389ef6154b05d1a$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}

});



parcelRegister("j4qqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $de22e390eb3e19fd$export$2e2bcd8739ae039);

var $7L9MP = parcelRequire("7L9MP");

var $ikW5Q = parcelRequire("ikW5Q");
var $de22e390eb3e19fd$export$2e2bcd8739ae039 = (0, $7L9MP.default)(function() {
    return true;
}, $de22e390eb3e19fd$var$clipAntimeridianLine, $de22e390eb3e19fd$var$clipAntimeridianInterpolate, [
    -(0, $ikW5Q.pi),
    -(0, $ikW5Q.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $de22e390eb3e19fd$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $ikW5Q.pi) : -(0, $ikW5Q.pi), delta = (0, $ikW5Q.abs)(lambda1 - lambda0);
            if ((0, $ikW5Q.abs)(delta - (0, $ikW5Q.pi)) < (0, $ikW5Q.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $ikW5Q.halfPi) : -(0, $ikW5Q.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $ikW5Q.pi)) {
                if ((0, $ikW5Q.abs)(lambda0 - sign0) < (0, $ikW5Q.epsilon)) lambda0 -= sign0 * (0, $ikW5Q.epsilon); // handle degeneracies
                if ((0, $ikW5Q.abs)(lambda1 - sign1) < (0, $ikW5Q.epsilon)) lambda1 -= sign1 * (0, $ikW5Q.epsilon);
                phi0 = $de22e390eb3e19fd$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $de22e390eb3e19fd$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $ikW5Q.sin)(lambda0 - lambda1);
    return (0, $ikW5Q.abs)(sinLambda0Lambda1) > (0, $ikW5Q.epsilon) ? (0, $ikW5Q.atan)(((0, $ikW5Q.sin)(phi0) * (cosPhi1 = (0, $ikW5Q.cos)(phi1)) * (0, $ikW5Q.sin)(lambda1) - (0, $ikW5Q.sin)(phi1) * (cosPhi0 = (0, $ikW5Q.cos)(phi0)) * (0, $ikW5Q.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $de22e390eb3e19fd$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $ikW5Q.halfPi);
        stream.point(-(0, $ikW5Q.pi), phi);
        stream.point(0, phi);
        stream.point((0, $ikW5Q.pi), phi);
        stream.point((0, $ikW5Q.pi), 0);
        stream.point((0, $ikW5Q.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $ikW5Q.pi), -phi);
        stream.point(-(0, $ikW5Q.pi), 0);
        stream.point(-(0, $ikW5Q.pi), phi);
    } else if ((0, $ikW5Q.abs)(from[0] - to[0]) > (0, $ikW5Q.epsilon)) {
        var lambda = from[0] < to[0] ? (0, $ikW5Q.pi) : -(0, $ikW5Q.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

});
parcelRegister("7L9MP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a648392f5122000$export$2e2bcd8739ae039);

var $fRZtZ = parcelRequire("fRZtZ");

var $dc916 = parcelRequire("dc916");

var $ikW5Q = parcelRequire("ikW5Q");

var $bFkZC = parcelRequire("bFkZC");
parcelRequire("eSYWb");
var $kHs81 = parcelRequire("kHs81");
function $5a648392f5122000$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $fRZtZ.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $kHs81.default)(segments);
                var startInside = (0, $bFkZC.default)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $dc916.default)(segments, $5a648392f5122000$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($5a648392f5122000$var$validSegment));
        }
        return clip;
    };
}
function $5a648392f5122000$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $5a648392f5122000$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $ikW5Q.halfPi) - (0, $ikW5Q.epsilon) : (0, $ikW5Q.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $ikW5Q.halfPi) - (0, $ikW5Q.epsilon) : (0, $ikW5Q.halfPi) - b[1]);
}

});
parcelRegister("fRZtZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8db7f738813a02a$export$2e2bcd8739ae039);

var $a3voy = parcelRequire("a3voy");
function $b8db7f738813a02a$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y) {
            line.push([
                x,
                y
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $a3voy.default),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}

});

parcelRegister("dc916", function(module, exports) {

$parcel$export(module.exports, "default", () => $99b363e0f8739f82$export$2e2bcd8739ae039);

var $bZ2S2 = parcelRequire("bZ2S2");
function $99b363e0f8739f82$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $99b363e0f8739f82$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        // If the first and last points of a segment are coincident, then treat as a
        // closed ring. TODO if all rings are closed, then the winding order of the
        // exterior ring should be checked.
        if ((0, $bZ2S2.default)(p0, p1)) {
            stream.lineStart();
            for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
            stream.lineEnd();
            return;
        }
        subject.push(x = new $99b363e0f8739f82$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $99b363e0f8739f82$var$Intersection(p0, null, x, false));
        subject.push(x = new $99b363e0f8739f82$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $99b363e0f8739f82$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $99b363e0f8739f82$var$link(subject);
    $99b363e0f8739f82$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $99b363e0f8739f82$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

});
parcelRegister("bZ2S2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b979e3a8b4242d2$export$2e2bcd8739ae039);

var $ikW5Q = parcelRequire("ikW5Q");
function $8b979e3a8b4242d2$export$2e2bcd8739ae039(a, b) {
    return (0, $ikW5Q.abs)(a[0] - b[0]) < (0, $ikW5Q.epsilon) && (0, $ikW5Q.abs)(a[1] - b[1]) < (0, $ikW5Q.epsilon);
}

});


parcelRegister("bFkZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e3cec9597326e7$export$2e2bcd8739ae039);

var $2P1Jm = parcelRequire("2P1Jm");

var $6m6m0 = parcelRequire("6m6m0");

var $ikW5Q = parcelRequire("ikW5Q");
var $87e3cec9597326e7$var$sum = (0, $2P1Jm.default)();
function $87e3cec9597326e7$export$2e2bcd8739ae039(polygon, point) {
    var lambda = point[0], phi = point[1], normal = [
        (0, $ikW5Q.sin)(lambda),
        -(0, $ikW5Q.cos)(lambda),
        0
    ], angle = 0, winding = 0;
    $87e3cec9597326e7$var$sum.reset();
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = point0[0], phi0 = point0[1] / 2 + (0, $ikW5Q.quarterPi), sinPhi0 = (0, $ikW5Q.sin)(phi0), cosPhi0 = (0, $ikW5Q.cos)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = point1[0], phi1 = point1[1] / 2 + (0, $ikW5Q.quarterPi), sinPhi1 = (0, $ikW5Q.sin)(phi1), cosPhi1 = (0, $ikW5Q.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $ikW5Q.pi), k = sinPhi0 * sinPhi1;
            $87e3cec9597326e7$var$sum.add((0, $ikW5Q.atan2)(k * sign * (0, $ikW5Q.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, $ikW5Q.cos)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $ikW5Q.tau) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $6m6m0.cartesianCross)((0, $6m6m0.cartesian)(point0), (0, $6m6m0.cartesian)(point1));
                (0, $6m6m0.cartesianNormalizeInPlace)(arc);
                var intersection = (0, $6m6m0.cartesianCross)(normal, arc);
                (0, $6m6m0.cartesianNormalizeInPlace)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $ikW5Q.asin)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $ikW5Q.epsilon) || angle < (0, $ikW5Q.epsilon) && $87e3cec9597326e7$var$sum < -(0, $ikW5Q.epsilon)) ^ winding & 1;
}

});

parcelRegister("eSYWb", function(module, exports) {

$parcel$export(module.exports, "merge", () => (parcelRequire("kHs81")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("84pwy")).default);

var $7Ygxz = parcelRequire("7Ygxz");

var $afsLc = parcelRequire("afsLc");

var $9vk4y = parcelRequire("9vk4y");

var $3zpWw = parcelRequire("3zpWw");

var $gjmmP = parcelRequire("gjmmP");

var $23JI8 = parcelRequire("23JI8");

var $f8Tmw = parcelRequire("f8Tmw");

var $g5pHy = parcelRequire("g5pHy");

var $cXMQB = parcelRequire("cXMQB");

var $9EN5c = parcelRequire("9EN5c");

var $46ICs = parcelRequire("46ICs");

var $6dD8Q = parcelRequire("6dD8Q");

var $jhCYR = parcelRequire("jhCYR");

var $gnTKa = parcelRequire("gnTKa");

var $kHs81 = parcelRequire("kHs81");

var $6rPEJ = parcelRequire("6rPEJ");

var $2tLOS = parcelRequire("2tLOS");

var $l3pIz = parcelRequire("l3pIz");

var $2Bnne = parcelRequire("2Bnne");

var $84pwy = parcelRequire("84pwy");

var $bnczq = parcelRequire("bnczq");

var $7c1UE = parcelRequire("7c1UE");

var $bwvzZ = parcelRequire("bwvzZ");

var $h78cD = parcelRequire("h78cD");

var $gcbVI = parcelRequire("gcbVI");

var $lgKC6 = parcelRequire("lgKC6");

var $dEXHx = parcelRequire("dEXHx");

});
parcelRegister("7Ygxz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cdaf79bd0f455dd$export$2e2bcd8739ae039);

var $afsLc = parcelRequire("afsLc");

var $9vk4y = parcelRequire("9vk4y");
var $5cdaf79bd0f455dd$var$ascendingBisect = (0, $9vk4y.default)((0, $afsLc.default));
var $5cdaf79bd0f455dd$export$4d945ad3ad5751b0 = $5cdaf79bd0f455dd$var$ascendingBisect.right;
var $5cdaf79bd0f455dd$export$df7d25c84ebd12a5 = $5cdaf79bd0f455dd$var$ascendingBisect.left;
var $5cdaf79bd0f455dd$export$2e2bcd8739ae039 = $5cdaf79bd0f455dd$export$4d945ad3ad5751b0;

});
parcelRegister("afsLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $77619d4dd8fcec3e$export$2e2bcd8739ae039);
function $77619d4dd8fcec3e$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("9vk4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb6944ba46d4012$export$2e2bcd8739ae039);

var $afsLc = parcelRequire("afsLc");
function $6eb6944ba46d4012$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $6eb6944ba46d4012$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $6eb6944ba46d4012$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $afsLc.default)(f(d), x);
    };
}

});


parcelRegister("3zpWw", function(module, exports) {

var $2tLOS = parcelRequire("2tLOS");
function $2998c3b155781202$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $2tLOS.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("2tLOS", function(module, exports) {

$parcel$export(module.exports, "pair", () => $1ce3622cf9e487fd$export$a04cb3fe8b81dd);
function $1ce3622cf9e487fd$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $1ce3622cf9e487fd$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $1ce3622cf9e487fd$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("gjmmP", function(module, exports) {
function $bdffc556093d3d5e$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("23JI8", function(module, exports) {

$parcel$export(module.exports, "default", () => $17ff51cd4dcafec8$export$2e2bcd8739ae039);

var $lgKC6 = parcelRequire("lgKC6");
function $17ff51cd4dcafec8$export$2e2bcd8739ae039(array, f) {
    var v = (0, $lgKC6.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("lgKC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7bf401283ae92c0$export$2e2bcd8739ae039);

var $cD6y1 = parcelRequire("cD6y1");
function $f7bf401283ae92c0$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $cD6y1.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $cD6y1.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("cD6y1", function(module, exports) {

$parcel$export(module.exports, "default", () => $931e34d27ea40404$export$2e2bcd8739ae039);
function $931e34d27ea40404$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("f8Tmw", function(module, exports) {

$parcel$export(module.exports, "default", () => $02d84c9558b65a80$export$2e2bcd8739ae039);
function $02d84c9558b65a80$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("g5pHy", function(module, exports) {

var $2CGJW = parcelRequire("2CGJW");

var $7Ygxz = parcelRequire("7Ygxz");

var $M80T0 = parcelRequire("M80T0");

var $f8Tmw = parcelRequire("f8Tmw");

var $e8RiX = parcelRequire("e8RiX");

var $84pwy = parcelRequire("84pwy");

var $h78cD = parcelRequire("h78cD");

var $46ICs = parcelRequire("46ICs");
function $bb610cc5f72dcdcb$export$2e2bcd8739ae039() {
    var value = (0, $e8RiX.default), domain = (0, $f8Tmw.default), threshold = (0, $46ICs.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $h78cD.tickStep)(x0, x1, tz);
            tz = (0, $84pwy.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $7Ygxz.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $M80T0.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $M80T0.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $M80T0.default)((0, $2CGJW.slice).call(_)) : (0, $M80T0.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("2CGJW", function(module, exports) {

$parcel$export(module.exports, "slice", () => $1e9048a6abf7fdff$export$58adb3bec8346d0f);
$parcel$export(module.exports, "map", () => $1e9048a6abf7fdff$export$871de8747c9eaa88);
var $1e9048a6abf7fdff$var$array = Array.prototype;
var $1e9048a6abf7fdff$export$58adb3bec8346d0f = $1e9048a6abf7fdff$var$array.slice;
var $1e9048a6abf7fdff$export$871de8747c9eaa88 = $1e9048a6abf7fdff$var$array.map;

});

parcelRegister("M80T0", function(module, exports) {

$parcel$export(module.exports, "default", () => $090ab3151a4fefd8$export$2e2bcd8739ae039);
function $090ab3151a4fefd8$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("e8RiX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bb293eae6e074b$export$2e2bcd8739ae039);
function $a4bb293eae6e074b$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("84pwy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e027f01b45da647$export$2e2bcd8739ae039);
function $5e027f01b45da647$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("h78cD", function(module, exports) {

$parcel$export(module.exports, "tickStep", () => $c75974059b3fbede$export$81087d9b915d4ede);
var $c75974059b3fbede$var$e10 = Math.sqrt(50), $c75974059b3fbede$var$e5 = Math.sqrt(10), $c75974059b3fbede$var$e2 = Math.sqrt(2);
function $c75974059b3fbede$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $c75974059b3fbede$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $c75974059b3fbede$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $c75974059b3fbede$var$e10 ? 10 : error >= $c75974059b3fbede$var$e5 ? 5 : error >= $c75974059b3fbede$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $c75974059b3fbede$var$e10 ? 10 : error >= $c75974059b3fbede$var$e5 ? 5 : error >= $c75974059b3fbede$var$e2 ? 2 : 1);
}
function $c75974059b3fbede$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $c75974059b3fbede$var$e10) step1 *= 10;
    else if (error >= $c75974059b3fbede$var$e5) step1 *= 5;
    else if (error >= $c75974059b3fbede$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("46ICs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fda556e18a36bfd$export$2e2bcd8739ae039);
function $2fda556e18a36bfd$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("cXMQB", function(module, exports) {

var $2CGJW = parcelRequire("2CGJW");

var $afsLc = parcelRequire("afsLc");

var $cD6y1 = parcelRequire("cD6y1");

var $2Bnne = parcelRequire("2Bnne");
function $9700e2d2c2be7bac$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $2CGJW.map).call(values, (0, $cD6y1.default)).sort((0, $afsLc.default));
    return Math.ceil((max - min) / (2 * ((0, $2Bnne.default)(values, 0.75) - (0, $2Bnne.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("2Bnne", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e512afe6b98dfff$export$2e2bcd8739ae039);

var $cD6y1 = parcelRequire("cD6y1");
function $1e512afe6b98dfff$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $cD6y1.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("9EN5c", function(module, exports) {

var $23JI8 = parcelRequire("23JI8");
function $707dec51899592cf$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $23JI8.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("6dD8Q", function(module, exports) {
function $487251acd38d7dde$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("jhCYR", function(module, exports) {

var $cD6y1 = parcelRequire("cD6y1");
function $e09dd79bbb69f7ac$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $cD6y1.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $cD6y1.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("gnTKa", function(module, exports) {

var $afsLc = parcelRequire("afsLc");

var $cD6y1 = parcelRequire("cD6y1");

var $2Bnne = parcelRequire("2Bnne");
function $beda08d592dce6f1$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $cD6y1.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $cD6y1.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $2Bnne.default)(numbers.sort((0, $afsLc.default)), 0.5);
}

});

parcelRegister("kHs81", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11da47f4b1243f1$export$2e2bcd8739ae039);
function $f11da47f4b1243f1$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("6rPEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b1d5578c264b844$export$2e2bcd8739ae039);
function $4b1d5578c264b844$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("l3pIz", function(module, exports) {
function $f53dd3d805fb2187$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("bnczq", function(module, exports) {

var $afsLc = parcelRequire("afsLc");
function $847b97e1f3173107$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $afsLc.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("7c1UE", function(module, exports) {
function $53cb233e6bdd60db$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("bwvzZ", function(module, exports) {
function $863b2dea956b68b2$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("gcbVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca70561ef5b7a1e$export$2e2bcd8739ae039);

var $6rPEJ = parcelRequire("6rPEJ");
function $bca70561ef5b7a1e$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $6rPEJ.default)(matrix, $bca70561ef5b7a1e$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $bca70561ef5b7a1e$var$length(d) {
    return d.length;
}

});

parcelRegister("dEXHx", function(module, exports) {

var $gcbVI = parcelRequire("gcbVI");
function $9f1d52307bbed9bd$export$2e2bcd8739ae039() {
    return (0, $gcbVI.default)(arguments);
}

});




parcelRegister("dg7hJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a726b9db732e19e$export$2e2bcd8739ae039);

var $6m6m0 = parcelRequire("6m6m0");

var $kl3aS = parcelRequire("kl3aS");

var $ikW5Q = parcelRequire("ikW5Q");

var $bZ2S2 = parcelRequire("bZ2S2");

var $7L9MP = parcelRequire("7L9MP");
function $9a726b9db732e19e$export$2e2bcd8739ae039(radius) {
    var cr = (0, $ikW5Q.cos)(radius), delta = 6 * (0, $ikW5Q.radians), smallRadius = cr > 0, notHemisphere = (0, $ikW5Q.abs)(cr) > (0, $ikW5Q.epsilon); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $kl3aS.circleStream)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $ikW5Q.cos)(lambda) * (0, $ikW5Q.cos)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $ikW5Q.pi) : -(0, $ikW5Q.pi)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                // Handle degeneracies.
                // TODO ignore if not clipping polygons.
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $bZ2S2.default)(point0, point2) || (0, $bZ2S2.default)(point1, point2)) {
                        point1[0] += (0, $ikW5Q.epsilon);
                        point1[1] += (0, $ikW5Q.epsilon);
                        v = visible(point1[0], point1[1]);
                    }
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1]);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                        }
                    }
                }
                if (v && (!point0 || !(0, $bZ2S2.default)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $6m6m0.cartesian)(a), pb = (0, $6m6m0.cartesian)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $6m6m0.cartesianCross)(pa, pb), n2n2 = (0, $6m6m0.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $6m6m0.cartesianCross)(n1, n2), A = (0, $6m6m0.cartesianScale)(n1, c1), B = (0, $6m6m0.cartesianScale)(n2, c2);
        (0, $6m6m0.cartesianAddInPlace)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $6m6m0.cartesianDot)(A, u), uu = (0, $6m6m0.cartesianDot)(u, u), t2 = w * w - uu * ((0, $6m6m0.cartesianDot)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $ikW5Q.sqrt)(t2), q = (0, $6m6m0.cartesianScale)(u, (-w - t) / uu);
        (0, $6m6m0.cartesianAddInPlace)(q, A);
        q = (0, $6m6m0.spherical)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $ikW5Q.abs)(delta - (0, $ikW5Q.pi)) < (0, $ikW5Q.epsilon), meridian = polar || delta < (0, $ikW5Q.epsilon);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $ikW5Q.abs)(q[0] - lambda0) < (0, $ikW5Q.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $ikW5Q.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $6m6m0.cartesianScale)(u, (-w + t) / uu);
            (0, $6m6m0.cartesianAddInPlace)(q1, A);
            return [
                q,
                (0, $6m6m0.spherical)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $ikW5Q.pi) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $7L9MP.default)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $ikW5Q.pi),
        radius - (0, $ikW5Q.pi)
    ]);
}

});

parcelRegister("9vIcm", function(module, exports) {

var $ixcRH = parcelRequire("ixcRH");
function $6ec94b2faf0c2773$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = (0, $ixcRH.default)(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}

});
parcelRegister("ixcRH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7e549d1d6dc9993$export$2e2bcd8739ae039);

var $ikW5Q = parcelRequire("ikW5Q");

var $fRZtZ = parcelRequire("fRZtZ");

var $4IEap = parcelRequire("4IEap");

var $dc916 = parcelRequire("dc916");
parcelRequire("eSYWb");
var $kHs81 = parcelRequire("kHs81");
var $d7e549d1d6dc9993$var$clipMax = 1e9, $d7e549d1d6dc9993$var$clipMin = -$d7e549d1d6dc9993$var$clipMax;
function $d7e549d1d6dc9993$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $ikW5Q.abs)(p[0] - x0) < (0, $ikW5Q.epsilon) ? direction > 0 ? 0 : 3 : (0, $ikW5Q.abs)(p[0] - x1) < (0, $ikW5Q.epsilon) ? direction > 0 ? 2 : 1 : (0, $ikW5Q.abs)(p[1] - y0) < (0, $ikW5Q.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $fRZtZ.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $kHs81.default)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $dc916.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($d7e549d1d6dc9993$var$clipMin, Math.min($d7e549d1d6dc9993$var$clipMax, x_)),
                    y_ = Math.max($d7e549d1d6dc9993$var$clipMin, Math.min($d7e549d1d6dc9993$var$clipMax, y_))
                ], b = [
                    x = Math.max($d7e549d1d6dc9993$var$clipMin, Math.min($d7e549d1d6dc9993$var$clipMax, x)),
                    y = Math.max($d7e549d1d6dc9993$var$clipMin, Math.min($d7e549d1d6dc9993$var$clipMax, y))
                ];
                if ((0, $4IEap.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

});
parcelRegister("4IEap", function(module, exports) {

$parcel$export(module.exports, "default", () => $36fa6dcb48e7b029$export$2e2bcd8739ae039);
function $36fa6dcb48e7b029$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}

});



parcelRegister("fXdNB", function(module, exports) {

var $bFkZC = parcelRequire("bFkZC");

var $kOSYA = parcelRequire("kOSYA");

var $ikW5Q = parcelRequire("ikW5Q");
var $b9d711e713c2da62$var$containsObjectType = {
    Feature: function(object, point) {
        return $b9d711e713c2da62$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($b9d711e713c2da62$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $b9d711e713c2da62$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $b9d711e713c2da62$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($b9d711e713c2da62$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $b9d711e713c2da62$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($b9d711e713c2da62$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $b9d711e713c2da62$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($b9d711e713c2da62$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($b9d711e713c2da62$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $b9d711e713c2da62$var$containsGeometry(geometry, point) {
    return geometry && $b9d711e713c2da62$var$containsGeometryType.hasOwnProperty(geometry.type) ? $b9d711e713c2da62$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $b9d711e713c2da62$var$containsPoint(coordinates, point) {
    return (0, $kOSYA.default)(coordinates, point) === 0;
}
function $b9d711e713c2da62$var$containsLine(coordinates, point) {
    var ab = (0, $kOSYA.default)(coordinates[0], coordinates[1]), ao = (0, $kOSYA.default)(coordinates[0], point), ob = (0, $kOSYA.default)(point, coordinates[1]);
    return ao + ob <= ab + (0, $ikW5Q.epsilon);
}
function $b9d711e713c2da62$var$containsPolygon(coordinates, point) {
    return !!(0, $bFkZC.default)(coordinates.map($b9d711e713c2da62$var$ringRadians), $b9d711e713c2da62$var$pointRadians(point));
}
function $b9d711e713c2da62$var$ringRadians(ring) {
    return ring = ring.map($b9d711e713c2da62$var$pointRadians), ring.pop(), ring;
}
function $b9d711e713c2da62$var$pointRadians(point) {
    return [
        point[0] * (0, $ikW5Q.radians),
        point[1] * (0, $ikW5Q.radians)
    ];
}
function $b9d711e713c2da62$export$2e2bcd8739ae039(object, point) {
    return (object && $b9d711e713c2da62$var$containsObjectType.hasOwnProperty(object.type) ? $b9d711e713c2da62$var$containsObjectType[object.type] : $b9d711e713c2da62$var$containsGeometry)(object, point);
}

});
parcelRegister("kOSYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2831f4c630ad80b$export$2e2bcd8739ae039);

var $gY8Oe = parcelRequire("gY8Oe");
var $f2831f4c630ad80b$var$coordinates = [
    null,
    null
], $f2831f4c630ad80b$var$object = {
    type: "LineString",
    coordinates: $f2831f4c630ad80b$var$coordinates
};
function $f2831f4c630ad80b$export$2e2bcd8739ae039(a, b) {
    $f2831f4c630ad80b$var$coordinates[0] = a;
    $f2831f4c630ad80b$var$coordinates[1] = b;
    return (0, $gY8Oe.default)($f2831f4c630ad80b$var$object);
}

});
parcelRegister("gY8Oe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a9153c32dfb068$export$2e2bcd8739ae039);

var $2P1Jm = parcelRequire("2P1Jm");

var $ikW5Q = parcelRequire("ikW5Q");

var $a3voy = parcelRequire("a3voy");

var $3oRPQ = parcelRequire("3oRPQ");
var $c5a9153c32dfb068$var$lengthSum = (0, $2P1Jm.default)(), $c5a9153c32dfb068$var$lambda0, $c5a9153c32dfb068$var$sinPhi0, $c5a9153c32dfb068$var$cosPhi0;
var $c5a9153c32dfb068$var$lengthStream = {
    sphere: (0, $a3voy.default),
    point: (0, $a3voy.default),
    lineStart: $c5a9153c32dfb068$var$lengthLineStart,
    lineEnd: (0, $a3voy.default),
    polygonStart: (0, $a3voy.default),
    polygonEnd: (0, $a3voy.default)
};
function $c5a9153c32dfb068$var$lengthLineStart() {
    $c5a9153c32dfb068$var$lengthStream.point = $c5a9153c32dfb068$var$lengthPointFirst;
    $c5a9153c32dfb068$var$lengthStream.lineEnd = $c5a9153c32dfb068$var$lengthLineEnd;
}
function $c5a9153c32dfb068$var$lengthLineEnd() {
    $c5a9153c32dfb068$var$lengthStream.point = $c5a9153c32dfb068$var$lengthStream.lineEnd = (0, $a3voy.default);
}
function $c5a9153c32dfb068$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    $c5a9153c32dfb068$var$lambda0 = lambda, $c5a9153c32dfb068$var$sinPhi0 = (0, $ikW5Q.sin)(phi), $c5a9153c32dfb068$var$cosPhi0 = (0, $ikW5Q.cos)(phi);
    $c5a9153c32dfb068$var$lengthStream.point = $c5a9153c32dfb068$var$lengthPoint;
}
function $c5a9153c32dfb068$var$lengthPoint(lambda, phi) {
    lambda *= (0, $ikW5Q.radians), phi *= (0, $ikW5Q.radians);
    var sinPhi = (0, $ikW5Q.sin)(phi), cosPhi = (0, $ikW5Q.cos)(phi), delta = (0, $ikW5Q.abs)(lambda - $c5a9153c32dfb068$var$lambda0), cosDelta = (0, $ikW5Q.cos)(delta), sinDelta = (0, $ikW5Q.sin)(delta), x = cosPhi * sinDelta, y = $c5a9153c32dfb068$var$cosPhi0 * sinPhi - $c5a9153c32dfb068$var$sinPhi0 * cosPhi * cosDelta, z = $c5a9153c32dfb068$var$sinPhi0 * sinPhi + $c5a9153c32dfb068$var$cosPhi0 * cosPhi * cosDelta;
    $c5a9153c32dfb068$var$lengthSum.add((0, $ikW5Q.atan2)((0, $ikW5Q.sqrt)(x * x + y * y), z));
    $c5a9153c32dfb068$var$lambda0 = lambda, $c5a9153c32dfb068$var$sinPhi0 = sinPhi, $c5a9153c32dfb068$var$cosPhi0 = cosPhi;
}
function $c5a9153c32dfb068$export$2e2bcd8739ae039(object) {
    $c5a9153c32dfb068$var$lengthSum.reset();
    (0, $3oRPQ.default)(object, $c5a9153c32dfb068$var$lengthStream);
    return +$c5a9153c32dfb068$var$lengthSum;
}

});



parcelRegister("4E2vH", function(module, exports) {
parcelRequire("eSYWb");
var $84pwy = parcelRequire("84pwy");

var $ikW5Q = parcelRequire("ikW5Q");
function $361cd850d940f1a0$var$graticuleX(y0, y1, dy) {
    var y = (0, $84pwy.default)(y0, y1 - (0, $ikW5Q.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $361cd850d940f1a0$var$graticuleY(x0, x1, dx) {
    var x = (0, $84pwy.default)(x0, x1 - (0, $ikW5Q.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $361cd850d940f1a0$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $84pwy.default)((0, $ikW5Q.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, $84pwy.default)((0, $ikW5Q.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $84pwy.default)((0, $ikW5Q.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $ikW5Q.abs)(x % DX) > (0, $ikW5Q.epsilon);
        }).map(x)).concat((0, $84pwy.default)((0, $ikW5Q.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $ikW5Q.abs)(y % DY) > (0, $ikW5Q.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $361cd850d940f1a0$var$graticuleX(y0, y1, 90);
        y = $361cd850d940f1a0$var$graticuleY(x0, x1, precision);
        X = $361cd850d940f1a0$var$graticuleX(Y0, Y1, 90);
        Y = $361cd850d940f1a0$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $ikW5Q.epsilon)
        ],
        [
            180,
            90 - (0, $ikW5Q.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $ikW5Q.epsilon)
        ],
        [
            180,
            80 + (0, $ikW5Q.epsilon)
        ]
    ]);
}
function $361cd850d940f1a0$export$b8db4e9403a5b6f1() {
    return $361cd850d940f1a0$export$2e2bcd8739ae039()();
}

});

parcelRegister("11WCK", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");
function $0c035bed41f26a3d$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $ikW5Q.radians), y0 = a[1] * (0, $ikW5Q.radians), x1 = b[0] * (0, $ikW5Q.radians), y1 = b[1] * (0, $ikW5Q.radians), cy0 = (0, $ikW5Q.cos)(y0), sy0 = (0, $ikW5Q.sin)(y0), cy1 = (0, $ikW5Q.cos)(y1), sy1 = (0, $ikW5Q.sin)(y1), kx0 = cy0 * (0, $ikW5Q.cos)(x0), ky0 = cy0 * (0, $ikW5Q.sin)(x0), kx1 = cy1 * (0, $ikW5Q.cos)(x1), ky1 = cy1 * (0, $ikW5Q.sin)(x1), d = 2 * (0, $ikW5Q.asin)((0, $ikW5Q.sqrt)((0, $ikW5Q.haversin)(y1 - y0) + cy0 * cy1 * (0, $ikW5Q.haversin)(x1 - x0))), k = (0, $ikW5Q.sin)(d);
    var interpolate = d ? function(t) {
        var B = (0, $ikW5Q.sin)(t *= d) / k, A = (0, $ikW5Q.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $ikW5Q.atan2)(y, x) * (0, $ikW5Q.degrees),
            (0, $ikW5Q.atan2)(z, (0, $ikW5Q.sqrt)(x * x + y * y)) * (0, $ikW5Q.degrees)
        ];
    } : function() {
        return [
            x0 * (0, $ikW5Q.degrees),
            y0 * (0, $ikW5Q.degrees)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}

});

parcelRegister("igkLz", function(module, exports) {

var $5S0u1 = parcelRequire("5S0u1");

var $3oRPQ = parcelRequire("3oRPQ");

var $cwWBm = parcelRequire("cwWBm");

var $bxfUs = parcelRequire("bxfUs");

var $4uXug = parcelRequire("4uXug");

var $e9A1V = parcelRequire("e9A1V");

var $8owvU = parcelRequire("8owvU");

var $az39X = parcelRequire("az39X");
function $d4b9d45ea5617ff9$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $3oRPQ.default)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $3oRPQ.default)(object, projectionStream((0, $cwWBm.default)));
        return (0, $cwWBm.default).result();
    };
    path.measure = function(object) {
        (0, $3oRPQ.default)(object, projectionStream((0, $8owvU.default)));
        return (0, $8owvU.default).result();
    };
    path.bounds = function(object) {
        (0, $3oRPQ.default)(object, projectionStream((0, $bxfUs.default)));
        return (0, $bxfUs.default).result();
    };
    path.centroid = function(object) {
        (0, $3oRPQ.default)(object, projectionStream((0, $4uXug.default)));
        return (0, $4uXug.default).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $5S0u1.default) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $az39X.default)) : new (0, $e9A1V.default)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}

});
parcelRegister("5S0u1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44625ed459ee2029$export$2e2bcd8739ae039);
function $44625ed459ee2029$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("cwWBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $91f5ee3aeef1957f$export$2e2bcd8739ae039);

var $2P1Jm = parcelRequire("2P1Jm");

var $ikW5Q = parcelRequire("ikW5Q");

var $a3voy = parcelRequire("a3voy");
var $91f5ee3aeef1957f$var$areaSum = (0, $2P1Jm.default)(), $91f5ee3aeef1957f$var$areaRingSum = (0, $2P1Jm.default)(), $91f5ee3aeef1957f$var$x00, $91f5ee3aeef1957f$var$y00, $91f5ee3aeef1957f$var$x0, $91f5ee3aeef1957f$var$y0;
var $91f5ee3aeef1957f$var$areaStream = {
    point: (0, $a3voy.default),
    lineStart: (0, $a3voy.default),
    lineEnd: (0, $a3voy.default),
    polygonStart: function() {
        $91f5ee3aeef1957f$var$areaStream.lineStart = $91f5ee3aeef1957f$var$areaRingStart;
        $91f5ee3aeef1957f$var$areaStream.lineEnd = $91f5ee3aeef1957f$var$areaRingEnd;
    },
    polygonEnd: function() {
        $91f5ee3aeef1957f$var$areaStream.lineStart = $91f5ee3aeef1957f$var$areaStream.lineEnd = $91f5ee3aeef1957f$var$areaStream.point = (0, $a3voy.default);
        $91f5ee3aeef1957f$var$areaSum.add((0, $ikW5Q.abs)($91f5ee3aeef1957f$var$areaRingSum));
        $91f5ee3aeef1957f$var$areaRingSum.reset();
    },
    result: function() {
        var area = $91f5ee3aeef1957f$var$areaSum / 2;
        $91f5ee3aeef1957f$var$areaSum.reset();
        return area;
    }
};
function $91f5ee3aeef1957f$var$areaRingStart() {
    $91f5ee3aeef1957f$var$areaStream.point = $91f5ee3aeef1957f$var$areaPointFirst;
}
function $91f5ee3aeef1957f$var$areaPointFirst(x, y) {
    $91f5ee3aeef1957f$var$areaStream.point = $91f5ee3aeef1957f$var$areaPoint;
    $91f5ee3aeef1957f$var$x00 = $91f5ee3aeef1957f$var$x0 = x, $91f5ee3aeef1957f$var$y00 = $91f5ee3aeef1957f$var$y0 = y;
}
function $91f5ee3aeef1957f$var$areaPoint(x, y) {
    $91f5ee3aeef1957f$var$areaRingSum.add($91f5ee3aeef1957f$var$y0 * x - $91f5ee3aeef1957f$var$x0 * y);
    $91f5ee3aeef1957f$var$x0 = x, $91f5ee3aeef1957f$var$y0 = y;
}
function $91f5ee3aeef1957f$var$areaRingEnd() {
    $91f5ee3aeef1957f$var$areaPoint($91f5ee3aeef1957f$var$x00, $91f5ee3aeef1957f$var$y00);
}
var $91f5ee3aeef1957f$export$2e2bcd8739ae039 = $91f5ee3aeef1957f$var$areaStream;

});

parcelRegister("bxfUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $865f1e15079cbf42$export$2e2bcd8739ae039);

var $a3voy = parcelRequire("a3voy");
var $865f1e15079cbf42$var$x0 = Infinity, $865f1e15079cbf42$var$y0 = $865f1e15079cbf42$var$x0, $865f1e15079cbf42$var$x1 = -$865f1e15079cbf42$var$x0, $865f1e15079cbf42$var$y1 = $865f1e15079cbf42$var$x1;
var $865f1e15079cbf42$var$boundsStream = {
    point: $865f1e15079cbf42$var$boundsPoint,
    lineStart: (0, $a3voy.default),
    lineEnd: (0, $a3voy.default),
    polygonStart: (0, $a3voy.default),
    polygonEnd: (0, $a3voy.default),
    result: function() {
        var bounds = [
            [
                $865f1e15079cbf42$var$x0,
                $865f1e15079cbf42$var$y0
            ],
            [
                $865f1e15079cbf42$var$x1,
                $865f1e15079cbf42$var$y1
            ]
        ];
        $865f1e15079cbf42$var$x1 = $865f1e15079cbf42$var$y1 = -($865f1e15079cbf42$var$y0 = $865f1e15079cbf42$var$x0 = Infinity);
        return bounds;
    }
};
function $865f1e15079cbf42$var$boundsPoint(x, y) {
    if (x < $865f1e15079cbf42$var$x0) $865f1e15079cbf42$var$x0 = x;
    if (x > $865f1e15079cbf42$var$x1) $865f1e15079cbf42$var$x1 = x;
    if (y < $865f1e15079cbf42$var$y0) $865f1e15079cbf42$var$y0 = y;
    if (y > $865f1e15079cbf42$var$y1) $865f1e15079cbf42$var$y1 = y;
}
var $865f1e15079cbf42$export$2e2bcd8739ae039 = $865f1e15079cbf42$var$boundsStream;

});

parcelRegister("4uXug", function(module, exports) {

$parcel$export(module.exports, "default", () => $34681bad7f3697e5$export$2e2bcd8739ae039);

var $ikW5Q = parcelRequire("ikW5Q");
// TODO Enforce positive area for exterior, negative area for interior?
var $34681bad7f3697e5$var$X0 = 0, $34681bad7f3697e5$var$Y0 = 0, $34681bad7f3697e5$var$Z0 = 0, $34681bad7f3697e5$var$X1 = 0, $34681bad7f3697e5$var$Y1 = 0, $34681bad7f3697e5$var$Z1 = 0, $34681bad7f3697e5$var$X2 = 0, $34681bad7f3697e5$var$Y2 = 0, $34681bad7f3697e5$var$Z2 = 0, $34681bad7f3697e5$var$x00, $34681bad7f3697e5$var$y00, $34681bad7f3697e5$var$x0, $34681bad7f3697e5$var$y0;
var $34681bad7f3697e5$var$centroidStream = {
    point: $34681bad7f3697e5$var$centroidPoint,
    lineStart: $34681bad7f3697e5$var$centroidLineStart,
    lineEnd: $34681bad7f3697e5$var$centroidLineEnd,
    polygonStart: function() {
        $34681bad7f3697e5$var$centroidStream.lineStart = $34681bad7f3697e5$var$centroidRingStart;
        $34681bad7f3697e5$var$centroidStream.lineEnd = $34681bad7f3697e5$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $34681bad7f3697e5$var$centroidStream.point = $34681bad7f3697e5$var$centroidPoint;
        $34681bad7f3697e5$var$centroidStream.lineStart = $34681bad7f3697e5$var$centroidLineStart;
        $34681bad7f3697e5$var$centroidStream.lineEnd = $34681bad7f3697e5$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $34681bad7f3697e5$var$Z2 ? [
            $34681bad7f3697e5$var$X2 / $34681bad7f3697e5$var$Z2,
            $34681bad7f3697e5$var$Y2 / $34681bad7f3697e5$var$Z2
        ] : $34681bad7f3697e5$var$Z1 ? [
            $34681bad7f3697e5$var$X1 / $34681bad7f3697e5$var$Z1,
            $34681bad7f3697e5$var$Y1 / $34681bad7f3697e5$var$Z1
        ] : $34681bad7f3697e5$var$Z0 ? [
            $34681bad7f3697e5$var$X0 / $34681bad7f3697e5$var$Z0,
            $34681bad7f3697e5$var$Y0 / $34681bad7f3697e5$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $34681bad7f3697e5$var$X0 = $34681bad7f3697e5$var$Y0 = $34681bad7f3697e5$var$Z0 = $34681bad7f3697e5$var$X1 = $34681bad7f3697e5$var$Y1 = $34681bad7f3697e5$var$Z1 = $34681bad7f3697e5$var$X2 = $34681bad7f3697e5$var$Y2 = $34681bad7f3697e5$var$Z2 = 0;
        return centroid;
    }
};
function $34681bad7f3697e5$var$centroidPoint(x, y) {
    $34681bad7f3697e5$var$X0 += x;
    $34681bad7f3697e5$var$Y0 += y;
    ++$34681bad7f3697e5$var$Z0;
}
function $34681bad7f3697e5$var$centroidLineStart() {
    $34681bad7f3697e5$var$centroidStream.point = $34681bad7f3697e5$var$centroidPointFirstLine;
}
function $34681bad7f3697e5$var$centroidPointFirstLine(x, y) {
    $34681bad7f3697e5$var$centroidStream.point = $34681bad7f3697e5$var$centroidPointLine;
    $34681bad7f3697e5$var$centroidPoint($34681bad7f3697e5$var$x0 = x, $34681bad7f3697e5$var$y0 = y);
}
function $34681bad7f3697e5$var$centroidPointLine(x, y) {
    var dx = x - $34681bad7f3697e5$var$x0, dy = y - $34681bad7f3697e5$var$y0, z = (0, $ikW5Q.sqrt)(dx * dx + dy * dy);
    $34681bad7f3697e5$var$X1 += z * ($34681bad7f3697e5$var$x0 + x) / 2;
    $34681bad7f3697e5$var$Y1 += z * ($34681bad7f3697e5$var$y0 + y) / 2;
    $34681bad7f3697e5$var$Z1 += z;
    $34681bad7f3697e5$var$centroidPoint($34681bad7f3697e5$var$x0 = x, $34681bad7f3697e5$var$y0 = y);
}
function $34681bad7f3697e5$var$centroidLineEnd() {
    $34681bad7f3697e5$var$centroidStream.point = $34681bad7f3697e5$var$centroidPoint;
}
function $34681bad7f3697e5$var$centroidRingStart() {
    $34681bad7f3697e5$var$centroidStream.point = $34681bad7f3697e5$var$centroidPointFirstRing;
}
function $34681bad7f3697e5$var$centroidRingEnd() {
    $34681bad7f3697e5$var$centroidPointRing($34681bad7f3697e5$var$x00, $34681bad7f3697e5$var$y00);
}
function $34681bad7f3697e5$var$centroidPointFirstRing(x, y) {
    $34681bad7f3697e5$var$centroidStream.point = $34681bad7f3697e5$var$centroidPointRing;
    $34681bad7f3697e5$var$centroidPoint($34681bad7f3697e5$var$x00 = $34681bad7f3697e5$var$x0 = x, $34681bad7f3697e5$var$y00 = $34681bad7f3697e5$var$y0 = y);
}
function $34681bad7f3697e5$var$centroidPointRing(x, y) {
    var dx = x - $34681bad7f3697e5$var$x0, dy = y - $34681bad7f3697e5$var$y0, z = (0, $ikW5Q.sqrt)(dx * dx + dy * dy);
    $34681bad7f3697e5$var$X1 += z * ($34681bad7f3697e5$var$x0 + x) / 2;
    $34681bad7f3697e5$var$Y1 += z * ($34681bad7f3697e5$var$y0 + y) / 2;
    $34681bad7f3697e5$var$Z1 += z;
    z = $34681bad7f3697e5$var$y0 * x - $34681bad7f3697e5$var$x0 * y;
    $34681bad7f3697e5$var$X2 += z * ($34681bad7f3697e5$var$x0 + x);
    $34681bad7f3697e5$var$Y2 += z * ($34681bad7f3697e5$var$y0 + y);
    $34681bad7f3697e5$var$Z2 += z * 3;
    $34681bad7f3697e5$var$centroidPoint($34681bad7f3697e5$var$x0 = x, $34681bad7f3697e5$var$y0 = y);
}
var $34681bad7f3697e5$export$2e2bcd8739ae039 = $34681bad7f3697e5$var$centroidStream;

});

parcelRegister("e9A1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4dddac6aba0ef01$export$2e2bcd8739ae039);

var $ikW5Q = parcelRequire("ikW5Q");

var $a3voy = parcelRequire("a3voy");
function $a4dddac6aba0ef01$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$a4dddac6aba0ef01$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $ikW5Q.tau));
                break;
        }
    },
    result: (0, $a3voy.default)
};

});

parcelRegister("8owvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61c9c92cf89e4df4$export$2e2bcd8739ae039);

var $2P1Jm = parcelRequire("2P1Jm");

var $ikW5Q = parcelRequire("ikW5Q");

var $a3voy = parcelRequire("a3voy");
var $61c9c92cf89e4df4$var$lengthSum = (0, $2P1Jm.default)(), $61c9c92cf89e4df4$var$lengthRing, $61c9c92cf89e4df4$var$x00, $61c9c92cf89e4df4$var$y00, $61c9c92cf89e4df4$var$x0, $61c9c92cf89e4df4$var$y0;
var $61c9c92cf89e4df4$var$lengthStream = {
    point: (0, $a3voy.default),
    lineStart: function() {
        $61c9c92cf89e4df4$var$lengthStream.point = $61c9c92cf89e4df4$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($61c9c92cf89e4df4$var$lengthRing) $61c9c92cf89e4df4$var$lengthPoint($61c9c92cf89e4df4$var$x00, $61c9c92cf89e4df4$var$y00);
        $61c9c92cf89e4df4$var$lengthStream.point = (0, $a3voy.default);
    },
    polygonStart: function() {
        $61c9c92cf89e4df4$var$lengthRing = true;
    },
    polygonEnd: function() {
        $61c9c92cf89e4df4$var$lengthRing = null;
    },
    result: function() {
        var length = +$61c9c92cf89e4df4$var$lengthSum;
        $61c9c92cf89e4df4$var$lengthSum.reset();
        return length;
    }
};
function $61c9c92cf89e4df4$var$lengthPointFirst(x, y) {
    $61c9c92cf89e4df4$var$lengthStream.point = $61c9c92cf89e4df4$var$lengthPoint;
    $61c9c92cf89e4df4$var$x00 = $61c9c92cf89e4df4$var$x0 = x, $61c9c92cf89e4df4$var$y00 = $61c9c92cf89e4df4$var$y0 = y;
}
function $61c9c92cf89e4df4$var$lengthPoint(x, y) {
    $61c9c92cf89e4df4$var$x0 -= x, $61c9c92cf89e4df4$var$y0 -= y;
    $61c9c92cf89e4df4$var$lengthSum.add((0, $ikW5Q.sqrt)($61c9c92cf89e4df4$var$x0 * $61c9c92cf89e4df4$var$x0 + $61c9c92cf89e4df4$var$y0 * $61c9c92cf89e4df4$var$y0));
    $61c9c92cf89e4df4$var$x0 = x, $61c9c92cf89e4df4$var$y0 = y;
}
var $61c9c92cf89e4df4$export$2e2bcd8739ae039 = $61c9c92cf89e4df4$var$lengthStream;

});

parcelRegister("az39X", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0f9fb29512df81$export$2e2bcd8739ae039);
function $7b0f9fb29512df81$export$2e2bcd8739ae039() {
    this._string = [];
}
$7b0f9fb29512df81$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $7b0f9fb29512df81$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $7b0f9fb29512df81$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $7b0f9fb29512df81$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}

});


parcelRegister("4Izw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $36f6d254e8605d07$export$2e2bcd8739ae039);

var $kRZy5 = parcelRequire("kRZy5");
function $36f6d254e8605d07$export$2e2bcd8739ae039() {
    return (0, $kRZy5.default)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}

});
parcelRegister("kRZy5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f318802bc4aa6197$export$2e2bcd8739ae039);

var $ikW5Q = parcelRequire("ikW5Q");

var $cBwls = parcelRequire("cBwls");

var $bIeyI = parcelRequire("bIeyI");
function $f318802bc4aa6197$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $ikW5Q.sin)(y0), n = (sy0 + (0, $ikW5Q.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $ikW5Q.abs)(n) < (0, $ikW5Q.epsilon)) return (0, $bIeyI.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $ikW5Q.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, $ikW5Q.sqrt)(c - 2 * n * (0, $ikW5Q.sin)(y)) / n;
        return [
            r * (0, $ikW5Q.sin)(x *= n),
            r0 - r * (0, $ikW5Q.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y;
        return [
            (0, $ikW5Q.atan2)(x, (0, $ikW5Q.abs)(r0y)) / n * (0, $ikW5Q.sign)(r0y),
            (0, $ikW5Q.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $f318802bc4aa6197$export$2e2bcd8739ae039() {
    return (0, $cBwls.conicProjection)($f318802bc4aa6197$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}

});
parcelRegister("cBwls", function(module, exports) {

$parcel$export(module.exports, "conicProjection", () => $92d207d24cf63ad5$export$228272587c4d24d8);

var $ikW5Q = parcelRequire("ikW5Q");

var $aaHGl = parcelRequire("aaHGl");
function $92d207d24cf63ad5$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $ikW5Q.pi) / 3, m = (0, $aaHGl.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $ikW5Q.radians), phi1 = _[1] * (0, $ikW5Q.radians)) : [
            phi0 * (0, $ikW5Q.degrees),
            phi1 * (0, $ikW5Q.degrees)
        ];
    };
    return p;
}

});
parcelRegister("aaHGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $767cb8e1ae4cb9b3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "projectionMutator", () => $767cb8e1ae4cb9b3$export$155d5a6fa6fddeba);

var $j4qqr = parcelRequire("j4qqr");

var $dg7hJ = parcelRequire("dg7hJ");

var $ixcRH = parcelRequire("ixcRH");

var $ia0ZW = parcelRequire("ia0ZW");

var $5S0u1 = parcelRequire("5S0u1");

var $ikW5Q = parcelRequire("ikW5Q");

var $eftTt = parcelRequire("eftTt");

var $ibZDC = parcelRequire("ibZDC");

var $9TWZ9 = parcelRequire("9TWZ9");

var $kXVmr = parcelRequire("kXVmr");
var $767cb8e1ae4cb9b3$var$transformRadians = (0, $ibZDC.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, $ikW5Q.radians), y * (0, $ikW5Q.radians));
    }
});
function $767cb8e1ae4cb9b3$var$transformRotate(rotate) {
    return (0, $ibZDC.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $767cb8e1ae4cb9b3$export$2e2bcd8739ae039(project) {
    return $767cb8e1ae4cb9b3$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $767cb8e1ae4cb9b3$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, dx, dy, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, theta = null, preclip = (0, $j4qqr.default), x0 = null, y0, x1, y1, postclip = (0, $5S0u1.default), delta2 = 0.5, projectResample = (0, $kXVmr.default)(projectTransform, delta2), cache, cacheStream;
    function projection(point) {
        point = projectRotate(point[0] * (0, $ikW5Q.radians), point[1] * (0, $ikW5Q.radians));
        return [
            point[0] * k + dx,
            dy - point[1] * k
        ];
    }
    function invert(point) {
        point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
        return point && [
            point[0] * (0, $ikW5Q.degrees),
            point[1] * (0, $ikW5Q.degrees)
        ];
    }
    function projectTransform(x, y) {
        return x = project(x, y), [
            x[0] * k + dx,
            dy - x[1] * k
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $767cb8e1ae4cb9b3$var$transformRadians($767cb8e1ae4cb9b3$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $dg7hJ.default)(theta = _ * (0, $ikW5Q.radians)) : (theta = null, $j4qqr.default), reset()) : theta * (0, $ikW5Q.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $5S0u1.default) : (0, $ixcRH.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $ikW5Q.radians), phi = _[1] % 360 * (0, $ikW5Q.radians), recenter()) : [
            lambda * (0, $ikW5Q.degrees),
            phi * (0, $ikW5Q.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $ikW5Q.radians), deltaPhi = _[1] % 360 * (0, $ikW5Q.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $ikW5Q.radians) : 0, recenter()) : [
            deltaLambda * (0, $ikW5Q.degrees),
            deltaPhi * (0, $ikW5Q.degrees),
            deltaGamma * (0, $ikW5Q.degrees)
        ];
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $kXVmr.default)(projectTransform, delta2 = _ * _), reset()) : (0, $ikW5Q.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $9TWZ9.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $9TWZ9.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $9TWZ9.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $9TWZ9.fitHeight)(projection, height, object);
    };
    function recenter() {
        projectRotate = (0, $ia0ZW.default)(rotate = (0, $eftTt.rotateRadians)(deltaLambda, deltaPhi, deltaGamma), project);
        var center = project(lambda, phi);
        dx = x - center[0] * k;
        dy = y + center[1] * k;
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

});
parcelRegister("ibZDC", function(module, exports) {

$parcel$export(module.exports, "transformer", () => $d3e9111b8d10d498$export$6b468dcfb64c653c);
function $d3e9111b8d10d498$export$2e2bcd8739ae039(methods) {
    return {
        stream: $d3e9111b8d10d498$export$6b468dcfb64c653c(methods)
    };
}
function $d3e9111b8d10d498$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $d3e9111b8d10d498$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $d3e9111b8d10d498$var$TransformStream() {}
$d3e9111b8d10d498$var$TransformStream.prototype = {
    constructor: $d3e9111b8d10d498$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

});

parcelRegister("9TWZ9", function(module, exports) {

$parcel$export(module.exports, "fitExtent", () => $7357015a39c78dfc$export$e450184041869e7f);
$parcel$export(module.exports, "fitSize", () => $7357015a39c78dfc$export$33a367fa1728c3ba);
$parcel$export(module.exports, "fitWidth", () => $7357015a39c78dfc$export$7d8f2192ef31c5a7);
$parcel$export(module.exports, "fitHeight", () => $7357015a39c78dfc$export$7069bab0d2ced675);

var $3oRPQ = parcelRequire("3oRPQ");

var $bxfUs = parcelRequire("bxfUs");
function $7357015a39c78dfc$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $3oRPQ.default)(object, projection.stream((0, $bxfUs.default)));
    fitBounds((0, $bxfUs.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $7357015a39c78dfc$export$e450184041869e7f(projection, extent, object) {
    return $7357015a39c78dfc$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $7357015a39c78dfc$export$33a367fa1728c3ba(projection, size, object) {
    return $7357015a39c78dfc$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $7357015a39c78dfc$export$7d8f2192ef31c5a7(projection, width, object) {
    return $7357015a39c78dfc$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $7357015a39c78dfc$export$7069bab0d2ced675(projection, height, object) {
    return $7357015a39c78dfc$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

});

parcelRegister("kXVmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f435d00d05b09006$export$2e2bcd8739ae039);

var $6m6m0 = parcelRequire("6m6m0");

var $ikW5Q = parcelRequire("ikW5Q");

var $ibZDC = parcelRequire("ibZDC");
var $f435d00d05b09006$var$maxDepth = 16, $f435d00d05b09006$var$cosMinDistance = (0, $ikW5Q.cos)(30 * (0, $ikW5Q.radians)); // cos(minimum angular distance)
function $f435d00d05b09006$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $f435d00d05b09006$var$resample(project, delta2) : $f435d00d05b09006$var$resampleNone(project);
}
function $f435d00d05b09006$var$resampleNone(project) {
    return (0, $ibZDC.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $f435d00d05b09006$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $ikW5Q.sqrt)(a * a + b * b + c * c), phi2 = (0, $ikW5Q.asin)(c /= m), lambda2 = (0, $ikW5Q.abs)((0, $ikW5Q.abs)(c) - 1) < (0, $ikW5Q.epsilon) || (0, $ikW5Q.abs)(lambda0 - lambda1) < (0, $ikW5Q.epsilon) ? (lambda0 + lambda1) / 2 : (0, $ikW5Q.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $ikW5Q.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $f435d00d05b09006$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $6m6m0.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $f435d00d05b09006$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $f435d00d05b09006$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

});



parcelRegister("bIeyI", function(module, exports) {

$parcel$export(module.exports, "cylindricalEqualAreaRaw", () => $886f18e19930e7b8$export$ae68c6db8b65046a);

var $ikW5Q = parcelRequire("ikW5Q");
function $886f18e19930e7b8$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $ikW5Q.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $ikW5Q.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $ikW5Q.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

});



parcelRegister("8qywC", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $4Izw5 = parcelRequire("4Izw5");

var $kRZy5 = parcelRequire("kRZy5");

var $9TWZ9 = parcelRequire("9TWZ9");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $622b886a57225f55$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $622b886a57225f55$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $4Izw5.default)(), lower48Point, alaska = (0, $kRZy5.default)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $kRZy5.default)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $622b886a57225f55$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $ikW5Q.epsilon),
                y + 0.120 * k + (0, $ikW5Q.epsilon)
            ],
            [
                x - 0.214 * k - (0, $ikW5Q.epsilon),
                y + 0.234 * k - (0, $ikW5Q.epsilon)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $ikW5Q.epsilon),
                y + 0.166 * k + (0, $ikW5Q.epsilon)
            ],
            [
                x - 0.115 * k - (0, $ikW5Q.epsilon),
                y + 0.234 * k - (0, $ikW5Q.epsilon)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $9TWZ9.fitExtent)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $9TWZ9.fitSize)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $9TWZ9.fitWidth)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $9TWZ9.fitHeight)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}

});

parcelRegister("2hrzz", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $aSsuM = parcelRequire("aSsuM");

var $aaHGl = parcelRequire("aaHGl");
var $1a928eb1e0797676$export$5e11f94fc4a8d2c6 = (0, $aSsuM.azimuthalRaw)(function(cxcy) {
    return (0, $ikW5Q.sqrt)(2 / (1 + cxcy));
});
$1a928eb1e0797676$export$5e11f94fc4a8d2c6.invert = (0, $aSsuM.azimuthalInvert)(function(z) {
    return 2 * (0, $ikW5Q.asin)(z / 2);
});
function $1a928eb1e0797676$export$2e2bcd8739ae039() {
    return (0, $aaHGl.default)($1a928eb1e0797676$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}

});
parcelRegister("aSsuM", function(module, exports) {

$parcel$export(module.exports, "azimuthalRaw", () => $7eb50d2091902d9a$export$f1211ac1bdb0796);
$parcel$export(module.exports, "azimuthalInvert", () => $7eb50d2091902d9a$export$3cee429f13e44eac);

var $ikW5Q = parcelRequire("ikW5Q");
function $7eb50d2091902d9a$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $ikW5Q.cos)(x), cy = (0, $ikW5Q.cos)(y), k = scale(cx * cy);
        return [
            k * cy * (0, $ikW5Q.sin)(x),
            k * (0, $ikW5Q.sin)(y)
        ];
    };
}
function $7eb50d2091902d9a$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $ikW5Q.sqrt)(x * x + y * y), c = angle(z), sc = (0, $ikW5Q.sin)(c), cc = (0, $ikW5Q.cos)(c);
        return [
            (0, $ikW5Q.atan2)(x * sc, z * cc),
            (0, $ikW5Q.asin)(z && y * sc / z)
        ];
    };
}

});


parcelRegister("2r1O0", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $aSsuM = parcelRequire("aSsuM");

var $aaHGl = parcelRequire("aaHGl");
var $1c5f80eca7ee70ca$export$b94a4d6aa3dd25c = (0, $aSsuM.azimuthalRaw)(function(c) {
    return (c = (0, $ikW5Q.acos)(c)) && c / (0, $ikW5Q.sin)(c);
});
$1c5f80eca7ee70ca$export$b94a4d6aa3dd25c.invert = (0, $aSsuM.azimuthalInvert)(function(z) {
    return z;
});
function $1c5f80eca7ee70ca$export$2e2bcd8739ae039() {
    return (0, $aaHGl.default)($1c5f80eca7ee70ca$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}

});

parcelRegister("6jeWn", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $cBwls = parcelRequire("cBwls");

var $6B3gM = parcelRequire("6B3gM");
function $49801b529cfb6894$var$tany(y) {
    return (0, $ikW5Q.tan)(((0, $ikW5Q.halfPi) + y) / 2);
}
function $49801b529cfb6894$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $ikW5Q.cos)(y0), n = y0 === y1 ? (0, $ikW5Q.sin)(y0) : (0, $ikW5Q.log)(cy0 / (0, $ikW5Q.cos)(y1)) / (0, $ikW5Q.log)($49801b529cfb6894$var$tany(y1) / $49801b529cfb6894$var$tany(y0)), f = cy0 * (0, $ikW5Q.pow)($49801b529cfb6894$var$tany(y0), n) / n;
    if (!n) return 0, $6B3gM.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $ikW5Q.halfPi) + (0, $ikW5Q.epsilon)) y = -(0, $ikW5Q.halfPi) + (0, $ikW5Q.epsilon);
        } else if (y > (0, $ikW5Q.halfPi) - (0, $ikW5Q.epsilon)) y = (0, $ikW5Q.halfPi) - (0, $ikW5Q.epsilon);
        var r = f / (0, $ikW5Q.pow)($49801b529cfb6894$var$tany(y), n);
        return [
            r * (0, $ikW5Q.sin)(n * x),
            f - r * (0, $ikW5Q.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $ikW5Q.sign)(n) * (0, $ikW5Q.sqrt)(x * x + fy * fy);
        return [
            (0, $ikW5Q.atan2)(x, (0, $ikW5Q.abs)(fy)) / n * (0, $ikW5Q.sign)(fy),
            2 * (0, $ikW5Q.atan)((0, $ikW5Q.pow)(f / r, 1 / n)) - (0, $ikW5Q.halfPi)
        ];
    };
    return project;
}
function $49801b529cfb6894$export$2e2bcd8739ae039() {
    return (0, $cBwls.conicProjection)($49801b529cfb6894$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}

});
parcelRegister("6B3gM", function(module, exports) {

$parcel$export(module.exports, "mercatorRaw", () => $4cd8bc0e9afb4b2a$export$94ff8a57e9b91cc3);
$parcel$export(module.exports, "mercatorProjection", () => $4cd8bc0e9afb4b2a$export$44b9b66a01f2127b);

var $ikW5Q = parcelRequire("ikW5Q");

var $eftTt = parcelRequire("eftTt");

var $aaHGl = parcelRequire("aaHGl");
function $4cd8bc0e9afb4b2a$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $ikW5Q.log)((0, $ikW5Q.tan)(((0, $ikW5Q.halfPi) + phi) / 2))
    ];
}
$4cd8bc0e9afb4b2a$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $ikW5Q.atan)((0, $ikW5Q.exp)(y)) - (0, $ikW5Q.halfPi)
    ];
};
function $4cd8bc0e9afb4b2a$export$2e2bcd8739ae039() {
    return $4cd8bc0e9afb4b2a$export$44b9b66a01f2127b($4cd8bc0e9afb4b2a$export$94ff8a57e9b91cc3).scale(961 / (0, $ikW5Q.tau));
}
function $4cd8bc0e9afb4b2a$export$44b9b66a01f2127b(project) {
    var m = (0, $aaHGl.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $ikW5Q.pi) * scale(), t = m((0, $eftTt.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $4cd8bc0e9afb4b2a$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

});


parcelRegister("32vMa", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $cBwls = parcelRequire("cBwls");

var $cQbjj = parcelRequire("cQbjj");
function $236a350e7343b4a9$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $ikW5Q.cos)(y0), n = y0 === y1 ? (0, $ikW5Q.sin)(y0) : (cy0 - (0, $ikW5Q.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $ikW5Q.abs)(n) < (0, $ikW5Q.epsilon)) return 0, $cQbjj.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $ikW5Q.sin)(nx),
            g - gy * (0, $ikW5Q.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y;
        return [
            (0, $ikW5Q.atan2)(x, (0, $ikW5Q.abs)(gy)) / n * (0, $ikW5Q.sign)(gy),
            g - (0, $ikW5Q.sign)(n) * (0, $ikW5Q.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}
function $236a350e7343b4a9$export$2e2bcd8739ae039() {
    return (0, $cBwls.conicProjection)($236a350e7343b4a9$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}

});
parcelRegister("cQbjj", function(module, exports) {

$parcel$export(module.exports, "equirectangularRaw", () => $95931d687860ba3a$export$f5fee52180f2f058);

var $aaHGl = parcelRequire("aaHGl");
function $95931d687860ba3a$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$95931d687860ba3a$export$f5fee52180f2f058.invert = $95931d687860ba3a$export$f5fee52180f2f058;
function $95931d687860ba3a$export$2e2bcd8739ae039() {
    return (0, $aaHGl.default)($95931d687860ba3a$export$f5fee52180f2f058).scale(152.63);
}

});


parcelRegister("kuA5r", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $aSsuM = parcelRequire("aSsuM");

var $aaHGl = parcelRequire("aaHGl");
function $eeb29a149307a27d$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $ikW5Q.cos)(y), k = (0, $ikW5Q.cos)(x) * cy;
    return [
        cy * (0, $ikW5Q.sin)(x) / k,
        (0, $ikW5Q.sin)(y) / k
    ];
}
$eeb29a149307a27d$export$dc8c6ddfc8b22c85.invert = (0, $aSsuM.azimuthalInvert)((0, $ikW5Q.atan));
function $eeb29a149307a27d$export$2e2bcd8739ae039() {
    return (0, $aaHGl.default)($eeb29a149307a27d$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}

});

parcelRegister("4go3B", function(module, exports) {

var $ixcRH = parcelRequire("ixcRH");

var $5S0u1 = parcelRequire("5S0u1");

var $ibZDC = parcelRequire("ibZDC");

var $9TWZ9 = parcelRequire("9TWZ9");
function $31ab514797e60f8f$var$scaleTranslate(kx, ky, tx, ty) {
    return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? (0, $5S0u1.default) : (0, $ibZDC.transformer)({
        point: function(x, y) {
            this.stream.point(x * kx + tx, y * ky + ty);
        }
    });
}
function $31ab514797e60f8f$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = (0, $5S0u1.default), x0 = null, y0, x1, y1, postclip = (0, $5S0u1.default), cache, cacheStream, projection;
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return projection = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        },
        postclip: function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        },
        clipExtent: function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $5S0u1.default) : (0, $ixcRH.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        },
        scale: function(_) {
            return arguments.length ? (transform = $31ab514797e60f8f$var$scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
        },
        translate: function(_) {
            return arguments.length ? (transform = $31ab514797e60f8f$var$scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [
                tx,
                ty
            ];
        },
        reflectX: function(_) {
            return arguments.length ? (transform = $31ab514797e60f8f$var$scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
        },
        reflectY: function(_) {
            return arguments.length ? (transform = $31ab514797e60f8f$var$scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
        },
        fitExtent: function(extent, object) {
            return (0, $9TWZ9.fitExtent)(projection, extent, object);
        },
        fitSize: function(size, object) {
            return (0, $9TWZ9.fitSize)(projection, size, object);
        },
        fitWidth: function(width, object) {
            return (0, $9TWZ9.fitWidth)(projection, width, object);
        },
        fitHeight: function(height, object) {
            return (0, $9TWZ9.fitHeight)(projection, height, object);
        }
    };
}

});

parcelRegister("e7x84", function(module, exports) {

var $aaHGl = parcelRequire("aaHGl");

var $ikW5Q = parcelRequire("ikW5Q");
function $a47b6aeb7ffc1d36$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$a47b6aeb7ffc1d36$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $ikW5Q.abs)(delta) > (0, $ikW5Q.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $a47b6aeb7ffc1d36$export$2e2bcd8739ae039() {
    return (0, $aaHGl.default)($a47b6aeb7ffc1d36$export$acb6def22fe878e6).scale(175.295);
}

});

parcelRegister("2Sjve", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $aSsuM = parcelRequire("aSsuM");

var $aaHGl = parcelRequire("aaHGl");
function $217fc0c3f35267af$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $ikW5Q.cos)(y) * (0, $ikW5Q.sin)(x),
        (0, $ikW5Q.sin)(y)
    ];
}
$217fc0c3f35267af$export$1cd9c2eb846182a.invert = (0, $aSsuM.azimuthalInvert)((0, $ikW5Q.asin));
function $217fc0c3f35267af$export$2e2bcd8739ae039() {
    return (0, $aaHGl.default)($217fc0c3f35267af$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $ikW5Q.epsilon));
}

});

parcelRegister("cJ2JL", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $aSsuM = parcelRequire("aSsuM");

var $aaHGl = parcelRequire("aaHGl");
function $943bcf86bfaafc25$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $ikW5Q.cos)(y), k = 1 + (0, $ikW5Q.cos)(x) * cy;
    return [
        cy * (0, $ikW5Q.sin)(x) / k,
        (0, $ikW5Q.sin)(y) / k
    ];
}
$943bcf86bfaafc25$export$f9ccbb0dcb3dcd2b.invert = (0, $aSsuM.azimuthalInvert)(function(z) {
    return 2 * (0, $ikW5Q.atan)(z);
});
function $943bcf86bfaafc25$export$2e2bcd8739ae039() {
    return (0, $aaHGl.default)($943bcf86bfaafc25$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}

});

parcelRegister("7DhQ2", function(module, exports) {

var $ikW5Q = parcelRequire("ikW5Q");

var $6B3gM = parcelRequire("6B3gM");
function $58ea033f5a151964$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $ikW5Q.log)((0, $ikW5Q.tan)(((0, $ikW5Q.halfPi) + phi) / 2)),
        -lambda
    ];
}
$58ea033f5a151964$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $ikW5Q.atan)((0, $ikW5Q.exp)(x)) - (0, $ikW5Q.halfPi)
    ];
};
function $58ea033f5a151964$export$2e2bcd8739ae039() {
    var m = (0, $6B3gM.mercatorProjection)($58ea033f5a151964$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}

});


parcelRegister("8nWhQ", function(module, exports) {

var $7Xhrz = parcelRequire("7Xhrz");

var $7u0Mc = parcelRequire("7u0Mc");

var $aAtTE = parcelRequire("aAtTE");

var $kJdQr = parcelRequire("kJdQr");

var $6zwur = parcelRequire("6zwur");

var $l79ey = parcelRequire("l79ey");

var $at6hU = parcelRequire("at6hU");

var $1QzTC = parcelRequire("1QzTC");

var $haJ21 = parcelRequire("haJ21");

var $4tzGu = parcelRequire("4tzGu");

var $jWAIu = parcelRequire("jWAIu");

var $dhR46 = parcelRequire("dhR46");

var $2w2j8 = parcelRequire("2w2j8");

var $is4B8 = parcelRequire("is4B8");

var $023Lf = parcelRequire("023Lf");

});
parcelRegister("7Xhrz", function(module, exports) {
function $5cab930c6a26b3d3$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $5cab930c6a26b3d3$var$meanX(children) {
    return children.reduce($5cab930c6a26b3d3$var$meanXReduce, 0) / children.length;
}
function $5cab930c6a26b3d3$var$meanXReduce(x, c) {
    return x + c.x;
}
function $5cab930c6a26b3d3$var$maxY(children) {
    return 1 + children.reduce($5cab930c6a26b3d3$var$maxYReduce, 0);
}
function $5cab930c6a26b3d3$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $5cab930c6a26b3d3$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $5cab930c6a26b3d3$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $5cab930c6a26b3d3$export$2e2bcd8739ae039() {
    var separation = $5cab930c6a26b3d3$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $5cab930c6a26b3d3$var$meanX(children);
                node.y = $5cab930c6a26b3d3$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $5cab930c6a26b3d3$var$leafLeft(root), right = $5cab930c6a26b3d3$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}

});

parcelRegister("7u0Mc", function(module, exports) {

$parcel$export(module.exports, "Node", () => $572befea9317df72$export$85c928794f8d04d4);
$parcel$export(module.exports, "computeHeight", () => $572befea9317df72$export$5af32d52ab5dfd57);

var $drgcY = parcelRequire("drgcY");

var $5HO2l = parcelRequire("5HO2l");

var $NleiF = parcelRequire("NleiF");

var $jTRaJ = parcelRequire("jTRaJ");

var $dXkIa = parcelRequire("dXkIa");

var $9qYFy = parcelRequire("9qYFy");

var $4V1MC = parcelRequire("4V1MC");

var $2Shom = parcelRequire("2Shom");

var $6t26B = parcelRequire("6t26B");

var $3PicZ = parcelRequire("3PicZ");

var $8Fao0 = parcelRequire("8Fao0");
function $572befea9317df72$export$2e2bcd8739ae039(data, children) {
    var root = new $572befea9317df72$export$85c928794f8d04d4(data), valued = +data.value && (root.value = data.value), node, nodes = [
        root
    ], child, childs, i, n;
    if (children == null) children = $572befea9317df72$var$defaultChildren;
    while(node = nodes.pop()){
        if (valued) node.value = +node.data.value;
        if ((childs = children(node.data)) && (n = childs.length)) {
            node.children = new Array(n);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new $572befea9317df72$export$85c928794f8d04d4(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
    }
    return root.eachBefore($572befea9317df72$export$5af32d52ab5dfd57);
}
function $572befea9317df72$var$node_copy() {
    return $572befea9317df72$export$2e2bcd8739ae039(this).eachBefore($572befea9317df72$var$copyData);
}
function $572befea9317df72$var$defaultChildren(d) {
    return d.children;
}
function $572befea9317df72$var$copyData(node) {
    node.data = node.data.data;
}
function $572befea9317df72$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $572befea9317df72$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$572befea9317df72$export$85c928794f8d04d4.prototype = $572befea9317df72$export$2e2bcd8739ae039.prototype = {
    constructor: $572befea9317df72$export$85c928794f8d04d4,
    count: (0, $drgcY.default),
    each: (0, $5HO2l.default),
    eachAfter: (0, $jTRaJ.default),
    eachBefore: (0, $NleiF.default),
    sum: (0, $dXkIa.default),
    sort: (0, $9qYFy.default),
    path: (0, $4V1MC.default),
    ancestors: (0, $2Shom.default),
    descendants: (0, $6t26B.default),
    leaves: (0, $3PicZ.default),
    links: (0, $8Fao0.default),
    copy: $572befea9317df72$var$node_copy
};

});
parcelRegister("drgcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8a5e94bb33497b$export$2e2bcd8739ae039);
function $9c8a5e94bb33497b$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $9c8a5e94bb33497b$export$2e2bcd8739ae039() {
    return this.eachAfter($9c8a5e94bb33497b$var$count);
}

});

parcelRegister("5HO2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $4277c827db45b4a5$export$2e2bcd8739ae039);
function $4277c827db45b4a5$export$2e2bcd8739ae039(callback) {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            callback(node), children = node.children;
            if (children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
    return this;
}

});

parcelRegister("NleiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $09450b7bc0b91cda$export$2e2bcd8739ae039);
function $09450b7bc0b91cda$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], children, i;
    while(node = nodes.pop()){
        callback(node), children = node.children;
        if (children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}

});

parcelRegister("jTRaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7cc663aa4ac532f$export$2e2bcd8739ae039);
function $e7cc663aa4ac532f$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n;
    while(node = nodes.pop()){
        next.push(node), children = node.children;
        if (children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback(node);
    return this;
}

});

parcelRegister("dXkIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a290d9e278a0a8a7$export$2e2bcd8739ae039);
function $a290d9e278a0a8a7$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}

});

parcelRegister("9qYFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de59a6d27bd6fcc$export$2e2bcd8739ae039);
function $6de59a6d27bd6fcc$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}

});

parcelRegister("4V1MC", function(module, exports) {

$parcel$export(module.exports, "default", () => $394dde66a411857e$export$2e2bcd8739ae039);
function $394dde66a411857e$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $394dde66a411857e$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $394dde66a411857e$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

});

parcelRegister("2Shom", function(module, exports) {

$parcel$export(module.exports, "default", () => $217e1d9655a43100$export$2e2bcd8739ae039);
function $217e1d9655a43100$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}

});

parcelRegister("6t26B", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b5715a37681b887$export$2e2bcd8739ae039);
function $4b5715a37681b887$export$2e2bcd8739ae039() {
    var nodes = [];
    this.each(function(node) {
        nodes.push(node);
    });
    return nodes;
}

});

parcelRegister("3PicZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c94425eda1c9921$export$2e2bcd8739ae039);
function $2c94425eda1c9921$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}

});

parcelRegister("8Fao0", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ea35857f017e57$export$2e2bcd8739ae039);
function $64ea35857f017e57$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}

});


parcelRegister("aAtTE", function(module, exports) {

var $kJdQr = parcelRequire("kJdQr");

var $8zQ8b = parcelRequire("8zQ8b");

var $1OAyt = parcelRequire("1OAyt");
function $7b5475052f8be861$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $7b5475052f8be861$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $1OAyt.constantZero);
    function pack(root) {
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($7b5475052f8be861$var$radiusLeaf(radius)).eachAfter($7b5475052f8be861$var$packChildren(padding, 0.5)).eachBefore($7b5475052f8be861$var$translateChild(1));
        else root.eachBefore($7b5475052f8be861$var$radiusLeaf($7b5475052f8be861$var$defaultRadius)).eachAfter($7b5475052f8be861$var$packChildren((0, $1OAyt.constantZero), 1)).eachAfter($7b5475052f8be861$var$packChildren(padding, root.r / Math.min(dx, dy))).eachBefore($7b5475052f8be861$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $8zQ8b.optional)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $1OAyt.default)(+x), pack) : padding;
    };
    return pack;
}
function $7b5475052f8be861$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $7b5475052f8be861$var$packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $kJdQr.packEnclose)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $7b5475052f8be861$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

});
parcelRegister("kJdQr", function(module, exports) {

$parcel$export(module.exports, "packEnclose", () => $f172bfef68badd92$export$b86b5dcbc4bfc7a7);

var $6zwur = parcelRequire("6zwur");
function $f172bfef68badd92$var$place(a, b, c) {
    var ax = a.x, ay = a.y, da = b.r + c.r, db = a.r + c.r, dx = b.x - ax, dy = b.y - ay, dc = dx * dx + dy * dy;
    if (dc) {
        var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
        c.x = ax + x * dx + y * dy;
        c.y = ay + x * dy - y * dx;
    } else {
        c.x = ax + db;
        c.y = ay;
    }
}
function $f172bfef68badd92$var$intersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return dr * dr - 1e-6 > dx * dx + dy * dy;
}
function $f172bfef68badd92$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $f172bfef68badd92$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $f172bfef68badd92$export$b86b5dcbc4bfc7a7(circles) {
    if (!(n = circles.length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $f172bfef68badd92$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $f172bfef68badd92$var$Node(a), b = new $f172bfef68badd92$var$Node(b), c = new $f172bfef68badd92$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $f172bfef68badd92$var$place(a._, b._, c = circles[i]), c = new $f172bfef68badd92$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($f172bfef68badd92$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($f172bfef68badd92$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $f172bfef68badd92$var$score(a);
        while((c = c.next) !== b)if ((ca = $f172bfef68badd92$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $6zwur.default)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $f172bfef68badd92$export$2e2bcd8739ae039(circles) {
    $f172bfef68badd92$export$b86b5dcbc4bfc7a7(circles);
    return circles;
}

});
parcelRegister("6zwur", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8f36cfdba5b2b5$export$2e2bcd8739ae039);

var $c4W5X = parcelRequire("c4W5X");
function $4c8f36cfdba5b2b5$export$2e2bcd8739ae039(circles) {
    var i = 0, n = (circles = (0, $c4W5X.shuffle)((0, $c4W5X.slice).call(circles))).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $4c8f36cfdba5b2b5$var$enclosesWeak(e, p)) ++i;
        else e = $4c8f36cfdba5b2b5$var$encloseBasis(B = $4c8f36cfdba5b2b5$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $4c8f36cfdba5b2b5$var$extendBasis(B, p) {
    var i, j;
    if ($4c8f36cfdba5b2b5$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($4c8f36cfdba5b2b5$var$enclosesNot(p, B[i]) && $4c8f36cfdba5b2b5$var$enclosesWeakAll($4c8f36cfdba5b2b5$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($4c8f36cfdba5b2b5$var$enclosesNot($4c8f36cfdba5b2b5$var$encloseBasis2(B[i], B[j]), p) && $4c8f36cfdba5b2b5$var$enclosesNot($4c8f36cfdba5b2b5$var$encloseBasis2(B[i], p), B[j]) && $4c8f36cfdba5b2b5$var$enclosesNot($4c8f36cfdba5b2b5$var$encloseBasis2(B[j], p), B[i]) && $4c8f36cfdba5b2b5$var$enclosesWeakAll($4c8f36cfdba5b2b5$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $4c8f36cfdba5b2b5$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $4c8f36cfdba5b2b5$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $4c8f36cfdba5b2b5$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$4c8f36cfdba5b2b5$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $4c8f36cfdba5b2b5$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $4c8f36cfdba5b2b5$var$encloseBasis1(B[0]);
        case 2:
            return $4c8f36cfdba5b2b5$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $4c8f36cfdba5b2b5$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $4c8f36cfdba5b2b5$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $4c8f36cfdba5b2b5$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $4c8f36cfdba5b2b5$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

});
parcelRegister("c4W5X", function(module, exports) {

$parcel$export(module.exports, "slice", () => $8cb2ec3a7c026146$export$58adb3bec8346d0f);
$parcel$export(module.exports, "shuffle", () => $8cb2ec3a7c026146$export$448332262467e042);
var $8cb2ec3a7c026146$export$58adb3bec8346d0f = Array.prototype.slice;
function $8cb2ec3a7c026146$export$448332262467e042(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

});



parcelRegister("8zQ8b", function(module, exports) {

$parcel$export(module.exports, "optional", () => $63ea07bfce23db00$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "required", () => $63ea07bfce23db00$export$a7a0278c004aac3f);
function $63ea07bfce23db00$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $63ea07bfce23db00$export$a7a0278c004aac3f(f);
}
function $63ea07bfce23db00$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

});

parcelRegister("1OAyt", function(module, exports) {

$parcel$export(module.exports, "constantZero", () => $1526d100574f539e$export$99e2e371aa6a9db);
$parcel$export(module.exports, "default", () => $1526d100574f539e$export$2e2bcd8739ae039);
function $1526d100574f539e$export$99e2e371aa6a9db() {
    return 0;
}
function $1526d100574f539e$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("l79ey", function(module, exports) {

var $3A0tv = parcelRequire("3A0tv");

var $jWAIu = parcelRequire("jWAIu");
function $f5f16a09a971ca86$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $3A0tv.default));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $jWAIu.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}

});
parcelRegister("3A0tv", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b51a3859441370$export$2e2bcd8739ae039);
function $29b51a3859441370$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}

});

parcelRegister("jWAIu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e84fea39a0055c64$export$2e2bcd8739ae039);
function $e84fea39a0055c64$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}

});


parcelRegister("at6hU", function(module, exports) {

var $8zQ8b = parcelRequire("8zQ8b");

var $7u0Mc = parcelRequire("7u0Mc");
var $79f17d710d31fcfd$var$keyPrefix = "$", $79f17d710d31fcfd$var$preroot = {
    depth: -1
}, $79f17d710d31fcfd$var$ambiguous = {};
function $79f17d710d31fcfd$var$defaultId(d) {
    return d.id;
}
function $79f17d710d31fcfd$var$defaultParentId(d) {
    return d.parentId;
}
function $79f17d710d31fcfd$export$2e2bcd8739ae039() {
    var id = $79f17d710d31fcfd$var$defaultId, parentId = $79f17d710d31fcfd$var$defaultParentId;
    function stratify(data) {
        var d, i, n = data.length, root, parent, node, nodes = new Array(n), nodeId, nodeKey, nodeByKey = {};
        for(i = 0; i < n; ++i){
            d = data[i], node = nodes[i] = new (0, $7u0Mc.Node)(d);
            if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
                nodeKey = $79f17d710d31fcfd$var$keyPrefix + (node.id = nodeId);
                nodeByKey[nodeKey] = nodeKey in nodeByKey ? $79f17d710d31fcfd$var$ambiguous : node;
            }
        }
        for(i = 0; i < n; ++i){
            node = nodes[i], nodeId = parentId(data[i], i, data);
            if (nodeId == null || !(nodeId += "")) {
                if (root) throw new Error("multiple roots");
                root = node;
            } else {
                parent = nodeByKey[$79f17d710d31fcfd$var$keyPrefix + nodeId];
                if (!parent) throw new Error("missing: " + nodeId);
                if (parent === $79f17d710d31fcfd$var$ambiguous) throw new Error("ambiguous: " + nodeId);
                if (parent.children) parent.children.push(node);
                else parent.children = [
                    node
                ];
                node.parent = parent;
            }
        }
        if (!root) throw new Error("no root");
        root.parent = $79f17d710d31fcfd$var$preroot;
        root.eachBefore(function(node) {
            node.depth = node.parent.depth + 1;
            --n;
        }).eachBefore((0, $7u0Mc.computeHeight));
        root.parent = null;
        if (n > 0) throw new Error("cycle");
        return root;
    }
    stratify.id = function(x) {
        return arguments.length ? (id = (0, $8zQ8b.required)(x), stratify) : id;
    };
    stratify.parentId = function(x) {
        return arguments.length ? (parentId = (0, $8zQ8b.required)(x), stratify) : parentId;
    };
    return stratify;
}

});

parcelRegister("1QzTC", function(module, exports) {

var $7u0Mc = parcelRequire("7u0Mc");
function $15867dfdd0753df3$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $15867dfdd0753df3$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $15867dfdd0753df3$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $15867dfdd0753df3$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $15867dfdd0753df3$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $15867dfdd0753df3$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $15867dfdd0753df3$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$15867dfdd0753df3$var$TreeNode.prototype = Object.create((0, $7u0Mc.Node).prototype);
function $15867dfdd0753df3$var$treeRoot(root) {
    var tree = new $15867dfdd0753df3$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $15867dfdd0753df3$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $15867dfdd0753df3$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $15867dfdd0753df3$export$2e2bcd8739ae039() {
    var separation = $15867dfdd0753df3$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $15867dfdd0753df3$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $15867dfdd0753df3$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $15867dfdd0753df3$var$nextRight(vim), vip = $15867dfdd0753df3$var$nextLeft(vip), vim && vip){
                vom = $15867dfdd0753df3$var$nextLeft(vom);
                vop = $15867dfdd0753df3$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $15867dfdd0753df3$var$moveSubtree($15867dfdd0753df3$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$15867dfdd0753df3$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$15867dfdd0753df3$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}

});

parcelRegister("haJ21", function(module, exports) {

var $3A0tv = parcelRequire("3A0tv");

var $is4B8 = parcelRequire("is4B8");

var $8zQ8b = parcelRequire("8zQ8b");

var $1OAyt = parcelRequire("1OAyt");
function $c8064d281296da7c$export$2e2bcd8739ae039() {
    var tile = (0, $is4B8.default), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $1OAyt.constantZero), paddingTop = (0, $1OAyt.constantZero), paddingRight = (0, $1OAyt.constantZero), paddingBottom = (0, $1OAyt.constantZero), paddingLeft = (0, $1OAyt.constantZero);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $3A0tv.default));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $8zQ8b.required)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $1OAyt.default)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $1OAyt.default)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $1OAyt.default)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $1OAyt.default)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $1OAyt.default)(+x), treemap) : paddingLeft;
    };
    return treemap;
}

});
parcelRegister("is4B8", function(module, exports) {

$parcel$export(module.exports, "phi", () => $d6ee689735de9bf0$export$324943737027944a);
$parcel$export(module.exports, "squarifyRatio", () => $d6ee689735de9bf0$export$9ff1217655212093);
$parcel$export(module.exports, "default", () => $d6ee689735de9bf0$export$2e2bcd8739ae039);

var $jWAIu = parcelRequire("jWAIu");

var $dhR46 = parcelRequire("dhR46");
var $d6ee689735de9bf0$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $d6ee689735de9bf0$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $jWAIu.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $dhR46.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $d6ee689735de9bf0$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $d6ee689735de9bf0$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($d6ee689735de9bf0$export$324943737027944a);

});
parcelRegister("dhR46", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ac606842e9d8465$export$2e2bcd8739ae039);
function $9ac606842e9d8465$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}

});



parcelRegister("4tzGu", function(module, exports) {
function $34258d0a9d215da4$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = (x0 * valueRight + x1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = (y0 * valueRight + y1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}

});

parcelRegister("2w2j8", function(module, exports) {

var $jWAIu = parcelRequire("jWAIu");

var $dhR46 = parcelRequire("dhR46");
function $1d505c29687debdb$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $dhR46.default) : (0, $jWAIu.default))(parent, x0, y0, x1, y1);
}

});

parcelRegister("023Lf", function(module, exports) {

var $jWAIu = parcelRequire("jWAIu");

var $dhR46 = parcelRequire("dhR46");

var $is4B8 = parcelRequire("is4B8");
var $00631ae71326ee01$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $jWAIu.default)(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
                else (0, $dhR46.default)(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $is4B8.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $is4B8.phi));

});


parcelRegister("jzbvG", function(module, exports) {

var $kezdq = parcelRequire("kezdq");

var $7O16m = parcelRequire("7O16m");

var $dMOES = parcelRequire("dMOES");

var $ajShH = parcelRequire("ajShH");

var $QiQpE = parcelRequire("QiQpE");

var $97pRx = parcelRequire("97pRx");

var $g23VI = parcelRequire("g23VI");

var $c987g = parcelRequire("c987g");

var $doclr = parcelRequire("doclr");

var $9inkl = parcelRequire("9inkl");

var $jjh3X = parcelRequire("jjh3X");

var $axHM2 = parcelRequire("axHM2");

var $eXmcV = parcelRequire("eXmcV");

var $bax4T = parcelRequire("bax4T");

var $dlTJs = parcelRequire("dlTJs");

var $4XeqG = parcelRequire("4XeqG");

var $bqctG = parcelRequire("bqctG");

});
parcelRegister("kezdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb06e86ed9d8716$export$2e2bcd8739ae039);

var $liAIU = parcelRequire("liAIU");

var $axHM2 = parcelRequire("axHM2");

var $7O16m = parcelRequire("7O16m");

var $QiQpE = parcelRequire("QiQpE");

var $97pRx = parcelRequire("97pRx");

var $g23VI = parcelRequire("g23VI");

var $doclr = parcelRequire("doclr");

var $8q8iP = parcelRequire("8q8iP");
function $ebb06e86ed9d8716$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $8q8iP.default)(b) : (t === "number" ? (0, $97pRx.default) : t === "string" ? (c = (0, $liAIU.default)(b)) ? (b = c, $axHM2.default) : (0, $doclr.default) : b instanceof (0, $liAIU.default) ? (0, $axHM2.default) : b instanceof Date ? (0, $QiQpE.default) : Array.isArray(b) ? (0, $7O16m.default) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $g23VI.default) : (0, $97pRx.default))(a, b);
}

});
parcelRegister("liAIU", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bxt9Y = parcelRequire("bxt9Y");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bxt9Y.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bxt9Y.default)(Rgb, rgb, (0, $bxt9Y.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bxt9Y.default)(Hsl, hsl, (0, $bxt9Y.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bxt9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $86696555a7537b6b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $86696555a7537b6b$export$8b58be045bf06082);
function $86696555a7537b6b$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $86696555a7537b6b$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("axHM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7acef1031922c1aa$export$2e2bcd8739ae039);

var $liAIU = parcelRequire("liAIU");

var $dMOES = parcelRequire("dMOES");

var $ajShH = parcelRequire("ajShH");

var $dWHnm = parcelRequire("dWHnm");
var $7acef1031922c1aa$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $dWHnm.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $liAIU.rgb)(start)).r, (end = (0, $liAIU.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $dWHnm.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $7acef1031922c1aa$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $liAIU.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $7acef1031922c1aa$export$2c0e28f2e2852d3f = $7acef1031922c1aa$var$rgbSpline((0, $dMOES.default));
var $7acef1031922c1aa$export$53d5214f625ccd4c = $7acef1031922c1aa$var$rgbSpline((0, $ajShH.default));

});
parcelRegister("dMOES", function(module, exports) {

$parcel$export(module.exports, "basis", () => $a0970dc421249774$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $a0970dc421249774$export$2e2bcd8739ae039);
function $a0970dc421249774$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $a0970dc421249774$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $a0970dc421249774$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("ajShH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7835c97b333ce405$export$2e2bcd8739ae039);

var $dMOES = parcelRequire("dMOES");
function $7835c97b333ce405$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dMOES.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("dWHnm", function(module, exports) {

$parcel$export(module.exports, "hue", () => $a27256ad6f887375$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $a27256ad6f887375$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $a27256ad6f887375$export$2e2bcd8739ae039);

var $8q8iP = parcelRequire("8q8iP");
function $a27256ad6f887375$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $a27256ad6f887375$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $a27256ad6f887375$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $a27256ad6f887375$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $8q8iP.default)(isNaN(a) ? b : a);
}
function $a27256ad6f887375$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $a27256ad6f887375$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $a27256ad6f887375$var$exponential(a, b, y) : (0, $8q8iP.default)(isNaN(a) ? b : a);
    };
}
function $a27256ad6f887375$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $a27256ad6f887375$var$linear(a, d) : (0, $8q8iP.default)(isNaN(a) ? b : a);
}

});
parcelRegister("8q8iP", function(module, exports) {

$parcel$export(module.exports, "default", () => $62173129b1e61c3b$export$2e2bcd8739ae039);
function $62173129b1e61c3b$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("7O16m", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aee0ea8505820a3$export$2e2bcd8739ae039);

var $kezdq = parcelRequire("kezdq");
function $5aee0ea8505820a3$export$2e2bcd8739ae039(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $kezdq.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});

parcelRegister("QiQpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $09d3798ad2a42fe8$export$2e2bcd8739ae039);
function $09d3798ad2a42fe8$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b -= a, function(t) {
        return d.setTime(a + b * t), d;
    };
}

});

parcelRegister("97pRx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a38d446aef7bfde$export$2e2bcd8739ae039);
function $6a38d446aef7bfde$export$2e2bcd8739ae039(a, b) {
    return a = +a, b -= a, function(t) {
        return a + b * t;
    };
}

});

parcelRegister("g23VI", function(module, exports) {

$parcel$export(module.exports, "default", () => $babfe1a35336c96b$export$2e2bcd8739ae039);

var $kezdq = parcelRequire("kezdq");
function $babfe1a35336c96b$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $kezdq.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("doclr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf717b39fa79940$export$2e2bcd8739ae039);

var $97pRx = parcelRequire("97pRx");
var $9bf717b39fa79940$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $9bf717b39fa79940$var$reB = new RegExp($9bf717b39fa79940$var$reA.source, "g");
function $9bf717b39fa79940$var$zero(b) {
    return function() {
        return b;
    };
}
function $9bf717b39fa79940$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $9bf717b39fa79940$export$2e2bcd8739ae039(a, b) {
    var bi = $9bf717b39fa79940$var$reA.lastIndex = $9bf717b39fa79940$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $9bf717b39fa79940$var$reA.exec(a)) && (bm = $9bf717b39fa79940$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $97pRx.default)(am, bm)
            });
        }
        bi = $9bf717b39fa79940$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $9bf717b39fa79940$var$one(q[0].x) : $9bf717b39fa79940$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("c987g", function(module, exports) {
function $8d7c9f03cb65387a$export$2e2bcd8739ae039(a, b) {
    return a = +a, b -= a, function(t) {
        return Math.round(a + b * t);
    };
}

});

parcelRegister("9inkl", function(module, exports) {

var $97pRx = parcelRequire("97pRx");

var $4ojDY = parcelRequire("4ojDY");
function $6c47e3c99d59735b$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $97pRx.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $97pRx.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $97pRx.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $97pRx.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $97pRx.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $97pRx.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $6c47e3c99d59735b$export$56bec7123bb3589a = $6c47e3c99d59735b$var$interpolateTransform((0, $4ojDY.parseCss), "px, ", "px)", "deg)");
var $6c47e3c99d59735b$export$da8cba906d64c082 = $6c47e3c99d59735b$var$interpolateTransform((0, $4ojDY.parseSvg), ", ", ")", ")");

});
parcelRegister("4ojDY", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $3328a42c16ab1dc9$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $3328a42c16ab1dc9$export$f9ef43f9a1d89a18);

var $9bu3N = parcelRequire("9bu3N");
var $3328a42c16ab1dc9$var$cssNode, $3328a42c16ab1dc9$var$cssRoot, $3328a42c16ab1dc9$var$cssView, $3328a42c16ab1dc9$var$svgNode;
function $3328a42c16ab1dc9$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $9bu3N.identity;
    if (!$3328a42c16ab1dc9$var$cssNode) $3328a42c16ab1dc9$var$cssNode = document.createElement("DIV"), $3328a42c16ab1dc9$var$cssRoot = document.documentElement, $3328a42c16ab1dc9$var$cssView = document.defaultView;
    $3328a42c16ab1dc9$var$cssNode.style.transform = value;
    value = $3328a42c16ab1dc9$var$cssView.getComputedStyle($3328a42c16ab1dc9$var$cssRoot.appendChild($3328a42c16ab1dc9$var$cssNode), null).getPropertyValue("transform");
    $3328a42c16ab1dc9$var$cssRoot.removeChild($3328a42c16ab1dc9$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $9bu3N.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $3328a42c16ab1dc9$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $9bu3N.identity;
    if (!$3328a42c16ab1dc9$var$svgNode) $3328a42c16ab1dc9$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $3328a42c16ab1dc9$var$svgNode.setAttribute("transform", value);
    if (!(value = $3328a42c16ab1dc9$var$svgNode.transform.baseVal.consolidate())) return 0, $9bu3N.identity;
    value = value.matrix;
    return (0, $9bu3N.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("9bu3N", function(module, exports) {

$parcel$export(module.exports, "identity", () => $6afc7579296d0843$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $6afc7579296d0843$export$2e2bcd8739ae039);
var $6afc7579296d0843$var$degrees = 180 / Math.PI;
var $6afc7579296d0843$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $6afc7579296d0843$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $6afc7579296d0843$var$degrees,
        skewX: Math.atan(skewX) * $6afc7579296d0843$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("jjh3X", function(module, exports) {
var $e0ed0702ba91d301$var$rho = Math.SQRT2, $e0ed0702ba91d301$var$rho2 = 2, $e0ed0702ba91d301$var$rho4 = 4, $e0ed0702ba91d301$var$epsilon2 = 1e-12;
function $e0ed0702ba91d301$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e0ed0702ba91d301$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e0ed0702ba91d301$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
function $e0ed0702ba91d301$export$2e2bcd8739ae039(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    // Special case for u0 ≅ u1.
    if (d2 < $e0ed0702ba91d301$var$epsilon2) {
        S = Math.log(w1 / w0) / $e0ed0702ba91d301$var$rho;
        i = function(t) {
            return [
                ux0 + t * dx,
                uy0 + t * dy,
                w0 * Math.exp($e0ed0702ba91d301$var$rho * t * S)
            ];
        };
    } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + $e0ed0702ba91d301$var$rho4 * d2) / (2 * w0 * $e0ed0702ba91d301$var$rho2 * d1), b1 = (w1 * w1 - w0 * w0 - $e0ed0702ba91d301$var$rho4 * d2) / (2 * w1 * $e0ed0702ba91d301$var$rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / $e0ed0702ba91d301$var$rho;
        i = function(t) {
            var s = t * S, coshr0 = $e0ed0702ba91d301$var$cosh(r0), u = w0 / ($e0ed0702ba91d301$var$rho2 * d1) * (coshr0 * $e0ed0702ba91d301$var$tanh($e0ed0702ba91d301$var$rho * s + r0) - $e0ed0702ba91d301$var$sinh(r0));
            return [
                ux0 + u * dx,
                uy0 + u * dy,
                w0 * coshr0 / $e0ed0702ba91d301$var$cosh($e0ed0702ba91d301$var$rho * s + r0)
            ];
        };
    }
    i.duration = S * 1000;
    return i;
}

});

parcelRegister("eXmcV", function(module, exports) {

var $liAIU = parcelRequire("liAIU");

var $dWHnm = parcelRequire("dWHnm");
function $ae37cd4dc183333b$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $liAIU.hsl)(start)).h, (end = (0, $liAIU.hsl)(end)).h), s = (0, $dWHnm.default)(start.s, end.s), l = (0, $dWHnm.default)(start.l, end.l), opacity = (0, $dWHnm.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $ae37cd4dc183333b$export$2e2bcd8739ae039 = $ae37cd4dc183333b$var$hsl((0, $dWHnm.hue));
var $ae37cd4dc183333b$export$a2c535e270a59256 = $ae37cd4dc183333b$var$hsl((0, $dWHnm.default));

});

parcelRegister("bax4T", function(module, exports) {

var $fucLN = parcelRequire("fucLN");

var $dWHnm = parcelRequire("dWHnm");
function $821a497c55015cdd$export$2e2bcd8739ae039(start, end) {
    var l = (0, $dWHnm.default)((start = (0, $fucLN.default)(start)).l, (end = (0, $fucLN.default)(end)).l), a = (0, $dWHnm.default)(start.a, end.a), b = (0, $dWHnm.default)(start.b, end.b), opacity = (0, $dWHnm.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});
parcelRegister("fucLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b46390316958afa3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "hcl", () => $b46390316958afa3$export$d0e870ba50062ff1);

var $bxt9Y = parcelRequire("bxt9Y");

var $liAIU = parcelRequire("liAIU");

var $jhAUL = parcelRequire("jhAUL");
// https://observablehq.com/@mbostock/lab-and-rgb
var $b46390316958afa3$var$K = 18, $b46390316958afa3$var$Xn = 0.96422, $b46390316958afa3$var$Yn = 1, $b46390316958afa3$var$Zn = 0.82521, $b46390316958afa3$var$t0 = 4 / 29, $b46390316958afa3$var$t1 = 6 / 29, $b46390316958afa3$var$t2 = 3 * $b46390316958afa3$var$t1 * $b46390316958afa3$var$t1, $b46390316958afa3$var$t3 = $b46390316958afa3$var$t1 * $b46390316958afa3$var$t1 * $b46390316958afa3$var$t1;
function $b46390316958afa3$var$labConvert(o) {
    if (o instanceof $b46390316958afa3$export$f2722c70a60257f7) return new $b46390316958afa3$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $b46390316958afa3$export$d9397e094a5fbb9a) return $b46390316958afa3$var$hcl2lab(o);
    if (!(o instanceof (0, $liAIU.Rgb))) o = (0, $liAIU.rgbConvert)(o);
    var r = $b46390316958afa3$var$rgb2lrgb(o.r), g = $b46390316958afa3$var$rgb2lrgb(o.g), b = $b46390316958afa3$var$rgb2lrgb(o.b), y = $b46390316958afa3$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $b46390316958afa3$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $b46390316958afa3$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $b46390316958afa3$var$Xn);
        z = $b46390316958afa3$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $b46390316958afa3$var$Zn);
    }
    return new $b46390316958afa3$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $b46390316958afa3$export$3e2c219d3ab79d01(l, opacity) {
    return new $b46390316958afa3$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $b46390316958afa3$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $b46390316958afa3$var$labConvert(l) : new $b46390316958afa3$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $b46390316958afa3$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bxt9Y.default)($b46390316958afa3$export$f2722c70a60257f7, $b46390316958afa3$export$2e2bcd8739ae039, (0, $bxt9Y.extend)((0, $liAIU.Color), {
    brighter: function(k) {
        return new $b46390316958afa3$export$f2722c70a60257f7(this.l + $b46390316958afa3$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $b46390316958afa3$export$f2722c70a60257f7(this.l - $b46390316958afa3$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $b46390316958afa3$var$Xn * $b46390316958afa3$var$lab2xyz(x);
        y = $b46390316958afa3$var$Yn * $b46390316958afa3$var$lab2xyz(y);
        z = $b46390316958afa3$var$Zn * $b46390316958afa3$var$lab2xyz(z);
        return new (0, $liAIU.Rgb)($b46390316958afa3$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $b46390316958afa3$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $b46390316958afa3$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $b46390316958afa3$var$xyz2lab(t) {
    return t > $b46390316958afa3$var$t3 ? Math.pow(t, 1 / 3) : t / $b46390316958afa3$var$t2 + $b46390316958afa3$var$t0;
}
function $b46390316958afa3$var$lab2xyz(t) {
    return t > $b46390316958afa3$var$t1 ? t * t * t : $b46390316958afa3$var$t2 * (t - $b46390316958afa3$var$t0);
}
function $b46390316958afa3$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $b46390316958afa3$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $b46390316958afa3$var$hclConvert(o) {
    if (o instanceof $b46390316958afa3$export$d9397e094a5fbb9a) return new $b46390316958afa3$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $b46390316958afa3$export$f2722c70a60257f7)) o = $b46390316958afa3$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $b46390316958afa3$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $jhAUL.rad2deg);
    return new $b46390316958afa3$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $b46390316958afa3$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $b46390316958afa3$var$hclConvert(l) : new $b46390316958afa3$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $b46390316958afa3$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $b46390316958afa3$var$hclConvert(h) : new $b46390316958afa3$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $b46390316958afa3$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $b46390316958afa3$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $b46390316958afa3$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $jhAUL.deg2rad);
    return new $b46390316958afa3$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $bxt9Y.default)($b46390316958afa3$export$d9397e094a5fbb9a, $b46390316958afa3$export$d0e870ba50062ff1, (0, $bxt9Y.extend)((0, $liAIU.Color), {
    brighter: function(k) {
        return new $b46390316958afa3$export$d9397e094a5fbb9a(this.h, this.c, this.l + $b46390316958afa3$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $b46390316958afa3$export$d9397e094a5fbb9a(this.h, this.c, this.l - $b46390316958afa3$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $b46390316958afa3$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("jhAUL", function(module, exports) {

$parcel$export(module.exports, "deg2rad", () => $e09c3d4d49064d32$export$b1b275608b2b1b8);
$parcel$export(module.exports, "rad2deg", () => $e09c3d4d49064d32$export$b2ba2578f2c43d74);
var $e09c3d4d49064d32$export$b1b275608b2b1b8 = Math.PI / 180;
var $e09c3d4d49064d32$export$b2ba2578f2c43d74 = 180 / Math.PI;

});



parcelRegister("dlTJs", function(module, exports) {

var $fucLN = parcelRequire("fucLN");

var $dWHnm = parcelRequire("dWHnm");
function $9b8877c1844aed8f$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $fucLN.hcl)(start)).h, (end = (0, $fucLN.hcl)(end)).h), c = (0, $dWHnm.default)(start.c, end.c), l = (0, $dWHnm.default)(start.l, end.l), opacity = (0, $dWHnm.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $9b8877c1844aed8f$export$2e2bcd8739ae039 = $9b8877c1844aed8f$var$hcl((0, $dWHnm.hue));
var $9b8877c1844aed8f$export$5aaa50f7615f9b70 = $9b8877c1844aed8f$var$hcl((0, $dWHnm.default));

});

parcelRegister("4XeqG", function(module, exports) {

var $4wxof = parcelRequire("4wxof");

var $dWHnm = parcelRequire("dWHnm");
function $39b7dd7e5a204a3f$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $4wxof.default)(start)).h, (end = (0, $4wxof.default)(end)).h), s = (0, $dWHnm.default)(start.s, end.s), l = (0, $dWHnm.default)(start.l, end.l), opacity = (0, $dWHnm.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $39b7dd7e5a204a3f$export$2e2bcd8739ae039 = $39b7dd7e5a204a3f$var$cubehelix((0, $dWHnm.hue));
var $39b7dd7e5a204a3f$export$934fa09ad474a1b4 = $39b7dd7e5a204a3f$var$cubehelix((0, $dWHnm.default));

});
parcelRegister("4wxof", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b40d2a5b8c5318$export$2e2bcd8739ae039);

var $bxt9Y = parcelRequire("bxt9Y");

var $liAIU = parcelRequire("liAIU");

var $jhAUL = parcelRequire("jhAUL");
var $34b40d2a5b8c5318$var$A = -0.14861, $34b40d2a5b8c5318$var$B = 1.78277, $34b40d2a5b8c5318$var$C = -0.29227, $34b40d2a5b8c5318$var$D = -0.90649, $34b40d2a5b8c5318$var$E = 1.97294, $34b40d2a5b8c5318$var$ED = $34b40d2a5b8c5318$var$E * $34b40d2a5b8c5318$var$D, $34b40d2a5b8c5318$var$EB = $34b40d2a5b8c5318$var$E * $34b40d2a5b8c5318$var$B, $34b40d2a5b8c5318$var$BC_DA = $34b40d2a5b8c5318$var$B * $34b40d2a5b8c5318$var$C - $34b40d2a5b8c5318$var$D * $34b40d2a5b8c5318$var$A;
function $34b40d2a5b8c5318$var$cubehelixConvert(o) {
    if (o instanceof $34b40d2a5b8c5318$export$57ed4bde61a1e2f2) return new $34b40d2a5b8c5318$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $liAIU.Rgb))) o = (0, $liAIU.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($34b40d2a5b8c5318$var$BC_DA * b + $34b40d2a5b8c5318$var$ED * r - $34b40d2a5b8c5318$var$EB * g) / ($34b40d2a5b8c5318$var$BC_DA + $34b40d2a5b8c5318$var$ED - $34b40d2a5b8c5318$var$EB), bl = b - l, k = ($34b40d2a5b8c5318$var$E * (g - l) - $34b40d2a5b8c5318$var$C * bl) / $34b40d2a5b8c5318$var$D, s = Math.sqrt(k * k + bl * bl) / ($34b40d2a5b8c5318$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $jhAUL.rad2deg) - 120 : NaN;
    return new $34b40d2a5b8c5318$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $34b40d2a5b8c5318$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $34b40d2a5b8c5318$var$cubehelixConvert(h) : new $34b40d2a5b8c5318$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $34b40d2a5b8c5318$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bxt9Y.default)($34b40d2a5b8c5318$export$57ed4bde61a1e2f2, $34b40d2a5b8c5318$export$2e2bcd8739ae039, (0, $bxt9Y.extend)((0, $liAIU.Color), {
    brighter: function(k) {
        k = k == null ? (0, $liAIU.brighter) : Math.pow((0, $liAIU.brighter), k);
        return new $34b40d2a5b8c5318$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $liAIU.darker) : Math.pow((0, $liAIU.darker), k);
        return new $34b40d2a5b8c5318$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $jhAUL.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $liAIU.Rgb)(255 * (l + a * ($34b40d2a5b8c5318$var$A * cosh + $34b40d2a5b8c5318$var$B * sinh)), 255 * (l + a * ($34b40d2a5b8c5318$var$C * cosh + $34b40d2a5b8c5318$var$D * sinh)), 255 * (l + a * ($34b40d2a5b8c5318$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("bqctG", function(module, exports) {
function $850bcd39089c3518$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("4AYSz", function(module, exports) {

var $1rKEb = parcelRequire("1rKEb");

});
parcelRegister("1rKEb", function(module, exports) {
var $10dc7f3261668f10$var$pi = Math.PI, $10dc7f3261668f10$var$tau = 2 * $10dc7f3261668f10$var$pi, $10dc7f3261668f10$var$epsilon = 1e-6, $10dc7f3261668f10$var$tauEpsilon = $10dc7f3261668f10$var$tau - $10dc7f3261668f10$var$epsilon;
function $10dc7f3261668f10$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $10dc7f3261668f10$var$path() {
    return new $10dc7f3261668f10$var$Path;
}
$10dc7f3261668f10$var$Path.prototype = $10dc7f3261668f10$var$path.prototype = {
    constructor: $10dc7f3261668f10$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $10dc7f3261668f10$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $10dc7f3261668f10$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($10dc7f3261668f10$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $10dc7f3261668f10$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $10dc7f3261668f10$var$epsilon || Math.abs(this._y1 - y0) > $10dc7f3261668f10$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $10dc7f3261668f10$var$tau + $10dc7f3261668f10$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $10dc7f3261668f10$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $10dc7f3261668f10$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $10dc7f3261668f10$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $10dc7f3261668f10$export$2e2bcd8739ae039 = $10dc7f3261668f10$var$path;

});


parcelRegister("2dfim", function(module, exports) {

var $f5BpG = parcelRequire("f5BpG");

var $lWLLT = parcelRequire("lWLLT");

var $4uUkR = parcelRequire("4uUkR");

var $e7CR5 = parcelRequire("e7CR5");

var $a6nD8 = parcelRequire("a6nD8");

});
parcelRegister("f5BpG", function(module, exports) {
function $afc4582293d184fc$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        area += a[1] * b[0] - a[0] * b[1];
    }
    return area / 2;
}

});

parcelRegister("lWLLT", function(module, exports) {
function $ffa4122bddb0a790$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
    }
    return k *= 3, [
        x / k,
        y / k
    ];
}

});

parcelRegister("4uUkR", function(module, exports) {

var $fogWp = parcelRequire("fogWp");
function $3465a9cac73d5351$var$lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function $3465a9cac73d5351$var$computeUpperHullIndexes(points) {
    var n = points.length, indexes = [
        0,
        1
    ], size = 2;
    for(var i = 2; i < n; ++i){
        while(size > 1 && (0, $fogWp.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}
function $3465a9cac73d5351$export$2e2bcd8739ae039(points) {
    if ((n = points.length) < 3) return null;
    var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
    for(i = 0; i < n; ++i)sortedPoints[i] = [
        +points[i][0],
        +points[i][1],
        i
    ];
    sortedPoints.sort($3465a9cac73d5351$var$lexicographicOrder);
    for(i = 0; i < n; ++i)flippedPoints[i] = [
        sortedPoints[i][0],
        -sortedPoints[i][1]
    ];
    var upperIndexes = $3465a9cac73d5351$var$computeUpperHullIndexes(sortedPoints), lowerIndexes = $3465a9cac73d5351$var$computeUpperHullIndexes(flippedPoints);
    // Construct the hull polygon, removing possible duplicate endpoints.
    var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
    // Add upper hull in right-to-l order.
    // Then add lower hull in left-to-right order.
    for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
    for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
    return hull;
}

});
parcelRegister("fogWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3463d0eb656854c$export$2e2bcd8739ae039);
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function $b3463d0eb656854c$export$2e2bcd8739ae039(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}

});


parcelRegister("e7CR5", function(module, exports) {
function $a47fdbf5505c3313$export$2e2bcd8739ae039(polygon, point) {
    var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
    for(var i = 0; i < n; ++i){
        p = polygon[i], x1 = p[0], y1 = p[1];
        if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
        x0 = x1, y0 = y1;
    }
    return inside;
}

});

parcelRegister("a6nD8", function(module, exports) {
function $75accb5f299d5641$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = polygon[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.sqrt(xa * xa + ya * ya);
    }
    return perimeter;
}

});


parcelRegister("dtSPP", function(module, exports) {

var $8LqXV = parcelRequire("8LqXV");

});
parcelRegister("8LqXV", function(module, exports) {

var $ivVdG = parcelRequire("ivVdG");

var $fBfr1 = parcelRequire("fBfr1");

var $ay7jh = parcelRequire("ay7jh");

var $lJNjQ = parcelRequire("lJNjQ");

var $aNkic = parcelRequire("aNkic");

var $ieeOX = parcelRequire("ieeOX");

var $8AgWK = parcelRequire("8AgWK");

var $58P5C = parcelRequire("58P5C");

var $6GD93 = parcelRequire("6GD93");

var $1EDbo = parcelRequire("1EDbo");

var $6cvlp = parcelRequire("6cvlp");

var $8z913 = parcelRequire("8z913");
function $6617a152793e35e3$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $6617a152793e35e3$var$Quadtree(x == null ? (0, $6cvlp.defaultX) : x, y == null ? (0, $8z913.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $6617a152793e35e3$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $6617a152793e35e3$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $6617a152793e35e3$var$treeProto = $6617a152793e35e3$export$2e2bcd8739ae039.prototype = $6617a152793e35e3$var$Quadtree.prototype;
$6617a152793e35e3$var$treeProto.copy = function() {
    var copy = new $6617a152793e35e3$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $6617a152793e35e3$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $6617a152793e35e3$var$leaf_copy(child);
        }
    }
    return copy;
};
$6617a152793e35e3$var$treeProto.add = (0, $ivVdG.default);
$6617a152793e35e3$var$treeProto.addAll = (0, $ivVdG.addAll);
$6617a152793e35e3$var$treeProto.cover = (0, $fBfr1.default);
$6617a152793e35e3$var$treeProto.data = (0, $ay7jh.default);
$6617a152793e35e3$var$treeProto.extent = (0, $lJNjQ.default);
$6617a152793e35e3$var$treeProto.find = (0, $aNkic.default);
$6617a152793e35e3$var$treeProto.remove = (0, $ieeOX.default);
$6617a152793e35e3$var$treeProto.removeAll = (0, $ieeOX.removeAll);
$6617a152793e35e3$var$treeProto.root = (0, $8AgWK.default);
$6617a152793e35e3$var$treeProto.size = (0, $58P5C.default);
$6617a152793e35e3$var$treeProto.visit = (0, $6GD93.default);
$6617a152793e35e3$var$treeProto.visitAfter = (0, $1EDbo.default);
$6617a152793e35e3$var$treeProto.x = (0, $6cvlp.default);
$6617a152793e35e3$var$treeProto.y = (0, $8z913.default);

});
parcelRegister("ivVdG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7a781e28f558288$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addAll", () => $d7a781e28f558288$export$32ed0561867ec8a1);
function $d7a781e28f558288$export$2e2bcd8739ae039(d) {
    var x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $d7a781e28f558288$var$add(this.cover(x, y), x, y, d);
}
function $d7a781e28f558288$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $d7a781e28f558288$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, inherit the existing extent.
    if (x1 < x0) x0 = this._x0, x1 = this._x1;
    if (y1 < y0) y0 = this._y0, y1 = this._y1;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$d7a781e28f558288$var$add(this, xz[i], yz[i], data[i]);
    return this;
}

});

parcelRegister("fBfr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b648c4d866d782$export$2e2bcd8739ae039);
function $b5b648c4d866d782$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else if (x0 > x || x > x1 || y0 > y || y > y1) {
        var z = x1 - x0, node = this._root, parent, i;
        switch(i = (y < (y0 + y1) / 2) << 1 | x < (x0 + x1) / 2){
            case 0:
                do parent = new Array(4), parent[i] = node, node = parent;
                while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
                break;
            case 1:
                do parent = new Array(4), parent[i] = node, node = parent;
                while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
                break;
            case 2:
                do parent = new Array(4), parent[i] = node, node = parent;
                while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
                break;
            case 3:
                do parent = new Array(4), parent[i] = node, node = parent;
                while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
                break;
        }
        if (this._root && this._root.length) this._root = node;
    } else return this;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}

});

parcelRegister("ay7jh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae2bffa7fc0fbef$export$2e2bcd8739ae039);
function $7ae2bffa7fc0fbef$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}

});

parcelRegister("lJNjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd340eae0474ba71$export$2e2bcd8739ae039);
function $fd340eae0474ba71$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}

});

parcelRegister("aNkic", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbe38a3b5ed79aa$export$2e2bcd8739ae039);

var $gspR9 = parcelRequire("gspR9");
function $7dbe38a3b5ed79aa$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $gspR9.default)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $gspR9.default)(node[3], xm, ym, x2, y2), new (0, $gspR9.default)(node[2], x1, ym, xm, y2), new (0, $gspR9.default)(node[1], xm, y1, x2, ym), new (0, $gspR9.default)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}

});
parcelRegister("gspR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb3515f5f9a0418$export$2e2bcd8739ae039);
function $bfb3515f5f9a0418$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}

});


parcelRegister("ieeOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d45507ee1fedd650$export$2e2bcd8739ae039);
$parcel$export(module.exports, "removeAll", () => $d45507ee1fedd650$export$1cfc7aad5cb1833b);
function $d45507ee1fedd650$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $d45507ee1fedd650$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

});

parcelRegister("8AgWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $63fed4be26f9fecf$export$2e2bcd8739ae039);
function $63fed4be26f9fecf$export$2e2bcd8739ae039() {
    return this._root;
}

});

parcelRegister("58P5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $3be5547327bf6902$export$2e2bcd8739ae039);
function $3be5547327bf6902$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}

});

parcelRegister("6GD93", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de507b4fc06a3b1$export$2e2bcd8739ae039);

var $gspR9 = parcelRequire("gspR9");
function $4de507b4fc06a3b1$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $gspR9.default)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $gspR9.default)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $gspR9.default)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $gspR9.default)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $gspR9.default)(child, x0, y0, xm, ym));
    }
    return this;
}

});

parcelRegister("1EDbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1347ebc2bb87c808$export$2e2bcd8739ae039);

var $gspR9 = parcelRequire("gspR9");
function $1347ebc2bb87c808$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $gspR9.default)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $gspR9.default)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $gspR9.default)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $gspR9.default)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $gspR9.default)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}

});

parcelRegister("6cvlp", function(module, exports) {

$parcel$export(module.exports, "defaultX", () => $483c2d670198f1d2$export$e6fafc98131d2a44);
$parcel$export(module.exports, "default", () => $483c2d670198f1d2$export$2e2bcd8739ae039);
function $483c2d670198f1d2$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $483c2d670198f1d2$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}

});

parcelRegister("8z913", function(module, exports) {

$parcel$export(module.exports, "defaultY", () => $63c89604f9b4c940$export$6f0a21aeb844a64c);
$parcel$export(module.exports, "default", () => $63c89604f9b4c940$export$2e2bcd8739ae039);
function $63c89604f9b4c940$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $63c89604f9b4c940$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}

});



parcelRegister("iqCIa", function(module, exports) {

var $g1VpL = parcelRequire("g1VpL");

});
parcelRegister("g1VpL", function(module, exports) {

var $e9WIu = parcelRequire("e9WIu");
var $bab946a71449b235$var$noabort = {};
function $bab946a71449b235$var$Queue(size) {
    this._size = size;
    this._call = this._error = null;
    this._tasks = [];
    this._data = [];
    this._waiting = this._active = this._ended = this._start = 0; // inside a synchronous task callback?
}
$bab946a71449b235$var$Queue.prototype = $bab946a71449b235$export$2e2bcd8739ae039.prototype = {
    constructor: $bab946a71449b235$var$Queue,
    defer: function(callback) {
        if (typeof callback !== "function") throw new Error("invalid callback");
        if (this._call) throw new Error("defer after await");
        if (this._error != null) return this;
        var t = (0, $e9WIu.slice).call(arguments, 1);
        t.push(callback);
        ++this._waiting, this._tasks.push(t);
        $bab946a71449b235$var$poke(this);
        return this;
    },
    abort: function() {
        if (this._error == null) $bab946a71449b235$var$abort(this, new Error("abort"));
        return this;
    },
    await: function(callback) {
        if (typeof callback !== "function") throw new Error("invalid callback");
        if (this._call) throw new Error("multiple await");
        this._call = function(error, results) {
            callback.apply(null, [
                error
            ].concat(results));
        };
        $bab946a71449b235$var$maybeNotify(this);
        return this;
    },
    awaitAll: function(callback) {
        if (typeof callback !== "function") throw new Error("invalid callback");
        if (this._call) throw new Error("multiple await");
        this._call = callback;
        $bab946a71449b235$var$maybeNotify(this);
        return this;
    }
};
function $bab946a71449b235$var$poke(q) {
    if (!q._start) try {
        $bab946a71449b235$var$start(q);
    } catch (e) {
        if (q._tasks[q._ended + q._active - 1]) $bab946a71449b235$var$abort(q, e); // task errored synchronously
        else if (!q._data) throw e; // await callback errored synchronously
    }
}
function $bab946a71449b235$var$start(q) {
    while(q._start = q._waiting && q._active < q._size){
        var i = q._ended + q._active, t = q._tasks[i], j = t.length - 1, c = t[j];
        t[j] = $bab946a71449b235$var$end(q, i);
        --q._waiting, ++q._active;
        t = c.apply(null, t);
        if (!q._tasks[i]) continue; // task finished synchronously
        q._tasks[i] = t || $bab946a71449b235$var$noabort;
    }
}
function $bab946a71449b235$var$end(q, i) {
    return function(e, r) {
        if (!q._tasks[i]) return; // ignore multiple callbacks
        --q._active, ++q._ended;
        q._tasks[i] = null;
        if (q._error != null) return; // ignore secondary errors
        if (e != null) $bab946a71449b235$var$abort(q, e);
        else {
            q._data[i] = r;
            if (q._waiting) $bab946a71449b235$var$poke(q);
            else $bab946a71449b235$var$maybeNotify(q);
        }
    };
}
function $bab946a71449b235$var$abort(q, e) {
    var i = q._tasks.length, t;
    q._error = e; // ignore active callbacks
    q._data = undefined; // allow gc
    q._waiting = NaN; // prevent starting
    while(--i >= 0)if (t = q._tasks[i]) {
        q._tasks[i] = null;
        if (t.abort) try {
            t.abort();
        } catch (e) {}
    }
    q._active = NaN; // allow notification
    $bab946a71449b235$var$maybeNotify(q);
}
function $bab946a71449b235$var$maybeNotify(q) {
    if (!q._active && q._call) {
        var d = q._data;
        q._data = undefined; // allow gc
        q._call(q._error, d);
    }
}
function $bab946a71449b235$export$2e2bcd8739ae039(concurrency) {
    if (concurrency == null) concurrency = Infinity;
    else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
    return new $bab946a71449b235$var$Queue(concurrency);
}

});
parcelRegister("e9WIu", function(module, exports) {

$parcel$export(module.exports, "slice", () => $a4ef73da13d8df16$export$58adb3bec8346d0f);
var $a4ef73da13d8df16$export$58adb3bec8346d0f = [].slice;

});



parcelRegister("h44gN", function(module, exports) {

var $5qJrr = parcelRequire("5qJrr");

var $4zyNc = parcelRequire("4zyNc");

var $jnraC = parcelRequire("jnraC");

var $4MPNl = parcelRequire("4MPNl");

var $4UB2m = parcelRequire("4UB2m");

var $hd8jp = parcelRequire("hd8jp");

});
parcelRegister("5qJrr", function(module, exports) {

var $8y93i = parcelRequire("8y93i");
var $3f42a138ed3939c3$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $8y93i.default));

});
parcelRegister("8y93i", function(module, exports) {

$parcel$export(module.exports, "default", () => $6398854ad1581155$export$2e2bcd8739ae039);
function $6398854ad1581155$export$2e2bcd8739ae039() {
    return Math.random();
}

});


parcelRegister("4zyNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $35456b61edda65bf$export$2e2bcd8739ae039);

var $8y93i = parcelRequire("8y93i");
var $35456b61edda65bf$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $8y93i.default));

});

parcelRegister("jnraC", function(module, exports) {

var $8y93i = parcelRequire("8y93i");

var $4zyNc = parcelRequire("4zyNc");
var $e1b53dbb59e61b64$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    function randomLogNormal() {
        var randomNormal = (0, $4zyNc.default).source(source).apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $8y93i.default));

});

parcelRegister("4MPNl", function(module, exports) {

var $8y93i = parcelRequire("8y93i");

var $4UB2m = parcelRequire("4UB2m");
var $37c3d28188e46922$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    function randomBates(n) {
        var randomIrwinHall = (0, $4UB2m.default).source(source)(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $8y93i.default));

});
parcelRegister("4UB2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $39391f3376460795$export$2e2bcd8739ae039);

var $8y93i = parcelRequire("8y93i");
var $39391f3376460795$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        return function() {
            for(var sum = 0, i = 0; i < n; ++i)sum += source();
            return sum;
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $8y93i.default));

});


parcelRegister("hd8jp", function(module, exports) {

var $8y93i = parcelRequire("8y93i");
var $c87a19270670fa42$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log(1 - source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $8y93i.default));

});


parcelRegister("fDxci", function(module, exports) {

$parcel$export(module.exports, "request", () => (parcelRequire("fWcxG")).default);

var $fWcxG = parcelRequire("fWcxG");

var $kWeV5 = parcelRequire("kWeV5");

var $55gmY = parcelRequire("55gmY");

var $gyFZM = parcelRequire("gyFZM");

var $gT6Lq = parcelRequire("gT6Lq");

var $hmiEm = parcelRequire("hmiEm");

var $kSNW2 = parcelRequire("kSNW2");

});
parcelRegister("fWcxG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a6006ac6917382$export$2e2bcd8739ae039);
parcelRequire("gz1Te");
var $5Mltl = parcelRequire("5Mltl");

var $4h5V5 = parcelRequire("4h5V5");
function $b9a6006ac6917382$export$2e2bcd8739ae039(url, callback) {
    var request, event = (0, $4h5V5.default)("beforesend", "progress", "load", "error"), mimeType, headers = (0, $5Mltl.default)(), xhr = new XMLHttpRequest, user = null, password = null, response, responseType, timeout = 0;
    // If IE does not support CORS, use XDomainRequest.
    if (typeof XDomainRequest !== "undefined" && !("withCredentials" in xhr) && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
    "onload" in xhr ? xhr.onload = xhr.onerror = xhr.ontimeout = respond : xhr.onreadystatechange = function(o) {
        xhr.readyState > 3 && respond(o);
    };
    function respond(o) {
        var status = xhr.status, result;
        if (!status && $b9a6006ac6917382$var$hasResponse(xhr) || status >= 200 && status < 300 || status === 304) {
            if (response) try {
                result = response.call(request, xhr);
            } catch (e) {
                event.call("error", request, e);
                return;
            }
            else result = xhr;
            event.call("load", request, result);
        } else event.call("error", request, o);
    }
    xhr.onprogress = function(e) {
        event.call("progress", request, e);
    };
    request = {
        header: function(name, value) {
            name = (name + "").toLowerCase();
            if (arguments.length < 2) return headers.get(name);
            if (value == null) headers.remove(name);
            else headers.set(name, value + "");
            return request;
        },
        // If mimeType is non-null and no Accept header is set, a default is used.
        mimeType: function(value) {
            if (!arguments.length) return mimeType;
            mimeType = value == null ? null : value + "";
            return request;
        },
        // Specifies what type the response value should take;
        // for instance, arraybuffer, blob, document, or text.
        responseType: function(value) {
            if (!arguments.length) return responseType;
            responseType = value;
            return request;
        },
        timeout: function(value) {
            if (!arguments.length) return timeout;
            timeout = +value;
            return request;
        },
        user: function(value) {
            return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
        },
        password: function(value) {
            return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
        },
        // Specify how to convert the response content to a specific type;
        // changes the callback value on "load" events.
        response: function(value) {
            response = value;
            return request;
        },
        // Alias for send("GET", …).
        get: function(data, callback) {
            return request.send("GET", data, callback);
        },
        // Alias for send("POST", …).
        post: function(data, callback) {
            return request.send("POST", data, callback);
        },
        // If callback is non-null, it will be used for error and load events.
        send: function(method, data, callback) {
            xhr.open(method, url, true, user, password);
            if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
            if (xhr.setRequestHeader) headers.each(function(value, name) {
                xhr.setRequestHeader(name, value);
            });
            if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
            if (responseType != null) xhr.responseType = responseType;
            if (timeout > 0) xhr.timeout = timeout;
            if (callback == null && typeof data === "function") callback = data, data = null;
            if (callback != null && callback.length === 1) callback = $b9a6006ac6917382$var$fixCallback(callback);
            if (callback != null) request.on("error", callback).on("load", function(xhr) {
                callback(null, xhr);
            });
            event.call("beforesend", request, xhr);
            xhr.send(data == null ? null : data);
            return request;
        },
        abort: function() {
            xhr.abort();
            return request;
        },
        on: function() {
            var value = event.on.apply(event, arguments);
            return value === event ? request : value;
        }
    };
    if (callback != null) {
        if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
        return request.get(callback);
    }
    return request;
}
function $b9a6006ac6917382$var$fixCallback(callback) {
    return function(error, xhr) {
        callback(error == null ? xhr : null);
    };
}
function $b9a6006ac6917382$var$hasResponse(xhr) {
    var type = xhr.responseType;
    return type && type !== "text" ? xhr.response // null on error
     : xhr.responseText; // "" on error
}

});

parcelRegister("kWeV5", function(module, exports) {

var $gTX0G = parcelRequire("gTX0G");
var $f3e4cc33f2854c63$export$2e2bcd8739ae039 = (0, $gTX0G.default)("text/html", function(xhr) {
    return document.createRange().createContextualFragment(xhr.responseText);
});

});
parcelRegister("gTX0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4df8e8d49334f61$export$2e2bcd8739ae039);

var $fWcxG = parcelRequire("fWcxG");
function $c4df8e8d49334f61$export$2e2bcd8739ae039(defaultMimeType, response) {
    return function(url, callback) {
        var r = (0, $fWcxG.default)(url).mimeType(defaultMimeType).response(response);
        if (callback != null) {
            if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
            return r.get(callback);
        }
        return r;
    };
}

});


parcelRegister("55gmY", function(module, exports) {

var $gTX0G = parcelRequire("gTX0G");
var $3b3a1e0ce8b5e9cc$export$2e2bcd8739ae039 = (0, $gTX0G.default)("application/json", function(xhr) {
    return JSON.parse(xhr.responseText);
});

});

parcelRegister("gyFZM", function(module, exports) {

var $gTX0G = parcelRequire("gTX0G");
var $c0e065bf7f296a68$export$2e2bcd8739ae039 = (0, $gTX0G.default)("text/plain", function(xhr) {
    return xhr.responseText;
});

});

parcelRegister("gT6Lq", function(module, exports) {

var $gTX0G = parcelRequire("gTX0G");
var $c4b7078ce337602d$export$2e2bcd8739ae039 = (0, $gTX0G.default)("application/xml", function(xhr) {
    var xml = xhr.responseXML;
    if (!xml) throw new Error("parse error");
    return xml;
});

});

parcelRegister("hmiEm", function(module, exports) {

var $aGeJV = parcelRequire("aGeJV");

var $ePrGJ = parcelRequire("ePrGJ");
var $ca32f538f6217bbd$export$2e2bcd8739ae039 = (0, $ePrGJ.default)("text/csv", (0, $aGeJV.csvParse));

});
parcelRegister("aGeJV", function(module, exports) {

$parcel$export(module.exports, "csvParse", () => $7c69429df3ecd000$export$289d25497b0f4c16);
$parcel$export(module.exports, "csvParseRows", () => $7c69429df3ecd000$export$c82550ca942d869);
$parcel$export(module.exports, "csvFormat", () => $7c69429df3ecd000$export$afe767551074aa08);
$parcel$export(module.exports, "csvFormatBody", () => $7c69429df3ecd000$export$b46fa59a5e3bc8a2);
$parcel$export(module.exports, "csvFormatRows", () => $7c69429df3ecd000$export$3f42a65843fbd1d9);
$parcel$export(module.exports, "csvFormatRow", () => $7c69429df3ecd000$export$c30212b87b2d080f);
$parcel$export(module.exports, "csvFormatValue", () => $7c69429df3ecd000$export$2771de09a60fc648);

var $jDNx7 = parcelRequire("jDNx7");
var $7c69429df3ecd000$var$csv = (0, $jDNx7.default)(",");
var $7c69429df3ecd000$export$289d25497b0f4c16 = $7c69429df3ecd000$var$csv.parse;
var $7c69429df3ecd000$export$c82550ca942d869 = $7c69429df3ecd000$var$csv.parseRows;
var $7c69429df3ecd000$export$afe767551074aa08 = $7c69429df3ecd000$var$csv.format;
var $7c69429df3ecd000$export$b46fa59a5e3bc8a2 = $7c69429df3ecd000$var$csv.formatBody;
var $7c69429df3ecd000$export$3f42a65843fbd1d9 = $7c69429df3ecd000$var$csv.formatRows;
var $7c69429df3ecd000$export$c30212b87b2d080f = $7c69429df3ecd000$var$csv.formatRow;
var $7c69429df3ecd000$export$2771de09a60fc648 = $7c69429df3ecd000$var$csv.formatValue;

});
parcelRegister("jDNx7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c8151b2e3e6f2f$export$2e2bcd8739ae039);
var $e4c8151b2e3e6f2f$var$EOL = {}, $e4c8151b2e3e6f2f$var$EOF = {}, $e4c8151b2e3e6f2f$var$QUOTE = 34, $e4c8151b2e3e6f2f$var$NEWLINE = 10, $e4c8151b2e3e6f2f$var$RETURN = 13;
function $e4c8151b2e3e6f2f$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function $e4c8151b2e3e6f2f$var$customConverter(columns, f) {
    var object = $e4c8151b2e3e6f2f$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $e4c8151b2e3e6f2f$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $e4c8151b2e3e6f2f$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $e4c8151b2e3e6f2f$var$formatYear(year) {
    return year < 0 ? "-" + $e4c8151b2e3e6f2f$var$pad(-year, 6) : year > 9999 ? "+" + $e4c8151b2e3e6f2f$var$pad(year, 6) : $e4c8151b2e3e6f2f$var$pad(year, 4);
}
function $e4c8151b2e3e6f2f$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $e4c8151b2e3e6f2f$var$formatYear(date.getUTCFullYear(), 4) + "-" + $e4c8151b2e3e6f2f$var$pad(date.getUTCMonth() + 1, 2) + "-" + $e4c8151b2e3e6f2f$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $e4c8151b2e3e6f2f$var$pad(hours, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(minutes, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(seconds, 2) + "." + $e4c8151b2e3e6f2f$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $e4c8151b2e3e6f2f$var$pad(hours, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(minutes, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $e4c8151b2e3e6f2f$var$pad(hours, 2) + ":" + $e4c8151b2e3e6f2f$var$pad(minutes, 2) + "Z" : "");
}
function $e4c8151b2e3e6f2f$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $e4c8151b2e3e6f2f$var$customConverter(row, f) : $e4c8151b2e3e6f2f$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $e4c8151b2e3e6f2f$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $e4c8151b2e3e6f2f$var$RETURN) --N;
        function token() {
            if (eof) return $e4c8151b2e3e6f2f$var$EOF;
            if (eol) return eol = false, $e4c8151b2e3e6f2f$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $e4c8151b2e3e6f2f$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $e4c8151b2e3e6f2f$var$QUOTE || text.charCodeAt(++I) === $e4c8151b2e3e6f2f$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $e4c8151b2e3e6f2f$var$NEWLINE) eol = true;
                else if (c === $e4c8151b2e3e6f2f$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $e4c8151b2e3e6f2f$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, "\"");
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $e4c8151b2e3e6f2f$var$NEWLINE) eol = true;
                else if (c === $e4c8151b2e3e6f2f$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $e4c8151b2e3e6f2f$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $e4c8151b2e3e6f2f$var$EOF){
            var row = [];
            while(t !== $e4c8151b2e3e6f2f$var$EOL && t !== $e4c8151b2e3e6f2f$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $e4c8151b2e3e6f2f$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $e4c8151b2e3e6f2f$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $e4c8151b2e3e6f2f$var$formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}

});


parcelRegister("ePrGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $acbb4e6b21ade262$export$2e2bcd8739ae039);

var $fWcxG = parcelRequire("fWcxG");
function $acbb4e6b21ade262$export$2e2bcd8739ae039(defaultMimeType, parse) {
    return function(url, row, callback) {
        if (arguments.length < 3) callback = row, row = null;
        var r = (0, $fWcxG.default)(url).mimeType(defaultMimeType);
        r.row = function(_) {
            return arguments.length ? r.response($acbb4e6b21ade262$var$responseOf(parse, row = _)) : row;
        };
        r.row(row);
        return callback ? r.get(callback) : r;
    };
}
function $acbb4e6b21ade262$var$responseOf(parse, row) {
    return function(request) {
        return parse(request.responseText, row);
    };
}

});


parcelRegister("kSNW2", function(module, exports) {

var $lShYg = parcelRequire("lShYg");

var $ePrGJ = parcelRequire("ePrGJ");
var $f33f95df637de9bd$export$2e2bcd8739ae039 = (0, $ePrGJ.default)("text/tab-separated-values", (0, $lShYg.tsvParse));

});
parcelRegister("lShYg", function(module, exports) {

$parcel$export(module.exports, "tsvParse", () => $fecc94c7e75a3a08$export$f913251db2f734ee);
$parcel$export(module.exports, "tsvParseRows", () => $fecc94c7e75a3a08$export$8de3b5abc40a067f);
$parcel$export(module.exports, "tsvFormat", () => $fecc94c7e75a3a08$export$77e754c4f8504293);
$parcel$export(module.exports, "tsvFormatBody", () => $fecc94c7e75a3a08$export$9d44987d460c9cb3);
$parcel$export(module.exports, "tsvFormatRows", () => $fecc94c7e75a3a08$export$ae461973f6adc981);
$parcel$export(module.exports, "tsvFormatRow", () => $fecc94c7e75a3a08$export$5d61cf35a4a738d2);
$parcel$export(module.exports, "tsvFormatValue", () => $fecc94c7e75a3a08$export$4280e6a416cd92a3);

var $jDNx7 = parcelRequire("jDNx7");
var $fecc94c7e75a3a08$var$tsv = (0, $jDNx7.default)("\t");
var $fecc94c7e75a3a08$export$f913251db2f734ee = $fecc94c7e75a3a08$var$tsv.parse;
var $fecc94c7e75a3a08$export$8de3b5abc40a067f = $fecc94c7e75a3a08$var$tsv.parseRows;
var $fecc94c7e75a3a08$export$77e754c4f8504293 = $fecc94c7e75a3a08$var$tsv.format;
var $fecc94c7e75a3a08$export$9d44987d460c9cb3 = $fecc94c7e75a3a08$var$tsv.formatBody;
var $fecc94c7e75a3a08$export$ae461973f6adc981 = $fecc94c7e75a3a08$var$tsv.formatRows;
var $fecc94c7e75a3a08$export$5d61cf35a4a738d2 = $fecc94c7e75a3a08$var$tsv.formatRow;
var $fecc94c7e75a3a08$export$4280e6a416cd92a3 = $fecc94c7e75a3a08$var$tsv.formatValue;

});



parcelRegister("ePEak", function(module, exports) {

$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("cQ6wP")).default);

var $eQq5K = parcelRequire("eQq5K");

var $fm4Fv = parcelRequire("fm4Fv");

var $cQ6wP = parcelRequire("cQ6wP");

var $eLL7r = parcelRequire("eLL7r");

var $haeJ1 = parcelRequire("haeJ1");

var $1M46x = parcelRequire("1M46x");

var $fWGA7 = parcelRequire("fWGA7");

var $iNMp0 = parcelRequire("iNMp0");

var $ePluM = parcelRequire("ePluM");

var $1IQyN = parcelRequire("1IQyN");

var $bXt6n = parcelRequire("bXt6n");

var $doRe7 = parcelRequire("doRe7");

var $iEj9K = parcelRequire("iEj9K");

var $7B5L5 = parcelRequire("7B5L5");

var $cOGES = parcelRequire("cOGES");

var $hXxFT = parcelRequire("hXxFT");

var $acnYy = parcelRequire("acnYy");

var $hTAJK = parcelRequire("hTAJK");

var $gohzG = parcelRequire("gohzG");

});
parcelRegister("eQq5K", function(module, exports) {
parcelRequire("hEBRK");
var $jYfdq = parcelRequire("jYfdq");

var $haeJ1 = parcelRequire("haeJ1");
function $acea294a15385f83$export$2e2bcd8739ae039() {
    var scale = (0, $haeJ1.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $jYfdq.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $acea294a15385f83$export$2e2bcd8739ae039().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return rescale();
}
function $acea294a15385f83$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $acea294a15385f83$var$pointish(copy());
    };
    return scale;
}
function $acea294a15385f83$export$105684a3041cb6f3() {
    return $acea294a15385f83$var$pointish($acea294a15385f83$export$2e2bcd8739ae039().paddingInner(1));
}

});
parcelRegister("hEBRK", function(module, exports) {

$parcel$export(module.exports, "bisect", () => (parcelRequire("dpLCA")).default);
$parcel$export(module.exports, "ascending", () => (parcelRequire("lWEwg")).default);
$parcel$export(module.exports, "bisector", () => (parcelRequire("6BNjt")).default);
$parcel$export(module.exports, "quantile", () => (parcelRequire("5zbjP")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("jYfdq")).default);
$parcel$export(module.exports, "ticks", () => (parcelRequire("4nr0T")).default);
$parcel$export(module.exports, "tickIncrement", () => (parcelRequire("4nr0T")).tickIncrement);
$parcel$export(module.exports, "tickStep", () => (parcelRequire("4nr0T")).tickStep);

var $dpLCA = parcelRequire("dpLCA");

var $lWEwg = parcelRequire("lWEwg");

var $6BNjt = parcelRequire("6BNjt");

var $lKFjR = parcelRequire("lKFjR");

var $lBObz = parcelRequire("lBObz");

var $ahZiD = parcelRequire("ahZiD");

var $c1xEZ = parcelRequire("c1xEZ");

var $73e42 = parcelRequire("73e42");

var $8oGef = parcelRequire("8oGef");

var $4hhMD = parcelRequire("4hhMD");

var $aLdA7 = parcelRequire("aLdA7");

var $2bllj = parcelRequire("2bllj");

var $9EoqN = parcelRequire("9EoqN");

var $gQKCX = parcelRequire("gQKCX");

var $azkyr = parcelRequire("azkyr");

var $98nAE = parcelRequire("98nAE");

var $3QPrP = parcelRequire("3QPrP");

var $eKlgf = parcelRequire("eKlgf");

var $5zbjP = parcelRequire("5zbjP");

var $jYfdq = parcelRequire("jYfdq");

var $2fulK = parcelRequire("2fulK");

var $63wx6 = parcelRequire("63wx6");

var $eDQha = parcelRequire("eDQha");

var $4nr0T = parcelRequire("4nr0T");

var $2Y6Ju = parcelRequire("2Y6Ju");

var $2fCrH = parcelRequire("2fCrH");

var $jpeRV = parcelRequire("jpeRV");

});
parcelRegister("dpLCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c428cc32ba8f901$export$2e2bcd8739ae039);

var $lWEwg = parcelRequire("lWEwg");

var $6BNjt = parcelRequire("6BNjt");
var $9c428cc32ba8f901$var$ascendingBisect = (0, $6BNjt.default)((0, $lWEwg.default));
var $9c428cc32ba8f901$export$4d945ad3ad5751b0 = $9c428cc32ba8f901$var$ascendingBisect.right;
var $9c428cc32ba8f901$export$df7d25c84ebd12a5 = $9c428cc32ba8f901$var$ascendingBisect.left;
var $9c428cc32ba8f901$export$2e2bcd8739ae039 = $9c428cc32ba8f901$export$4d945ad3ad5751b0;

});
parcelRegister("lWEwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9e7215e5d7063a$export$2e2bcd8739ae039);
function $ff9e7215e5d7063a$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("6BNjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfc734eff761e3c$export$2e2bcd8739ae039);

var $lWEwg = parcelRequire("lWEwg");
function $4cfc734eff761e3c$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $4cfc734eff761e3c$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $4cfc734eff761e3c$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $lWEwg.default)(f(d), x);
    };
}

});


parcelRegister("lKFjR", function(module, exports) {

var $3QPrP = parcelRequire("3QPrP");
function $fd5df20288a9ffc5$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $3QPrP.pair);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}

});
parcelRegister("3QPrP", function(module, exports) {

$parcel$export(module.exports, "pair", () => $2cde22ebb505904a$export$a04cb3fe8b81dd);
function $2cde22ebb505904a$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $2cde22ebb505904a$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $2cde22ebb505904a$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}

});


parcelRegister("lBObz", function(module, exports) {
function $fbb3fb7fa257eccb$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("ahZiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $77db0ac117ade634$export$2e2bcd8739ae039);

var $2fCrH = parcelRequire("2fCrH");
function $77db0ac117ade634$export$2e2bcd8739ae039(array, f) {
    var v = (0, $2fCrH.default)(array, f);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("2fCrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3ace00dc8ba816$export$2e2bcd8739ae039);

var $chY5j = parcelRequire("chY5j");
function $1a3ace00dc8ba816$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $chY5j.default)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $chY5j.default)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}

});
parcelRegister("chY5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f25ae212e3d83eb$export$2e2bcd8739ae039);
function $8f25ae212e3d83eb$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}

});



parcelRegister("c1xEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0fb03ab2f829a8$export$2e2bcd8739ae039);
function $8c0fb03ab2f829a8$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("73e42", function(module, exports) {

var $fCkqQ = parcelRequire("fCkqQ");

var $dpLCA = parcelRequire("dpLCA");

var $dBdZ9 = parcelRequire("dBdZ9");

var $c1xEZ = parcelRequire("c1xEZ");

var $gfrFH = parcelRequire("gfrFH");

var $jYfdq = parcelRequire("jYfdq");

var $4nr0T = parcelRequire("4nr0T");

var $aLdA7 = parcelRequire("aLdA7");
function $5223b90fec15768d$export$2e2bcd8739ae039() {
    var value = (0, $gfrFH.default), domain = (0, $c1xEZ.default), threshold = (0, $aLdA7.default);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $4nr0T.tickStep)(x0, x1, tz);
            tz = (0, $jYfdq.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $dpLCA.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $dBdZ9.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $dBdZ9.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $dBdZ9.default)((0, $fCkqQ.slice).call(_)) : (0, $dBdZ9.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("fCkqQ", function(module, exports) {

$parcel$export(module.exports, "slice", () => $b5ea4103373313ba$export$58adb3bec8346d0f);
$parcel$export(module.exports, "map", () => $b5ea4103373313ba$export$871de8747c9eaa88);
var $b5ea4103373313ba$var$array = Array.prototype;
var $b5ea4103373313ba$export$58adb3bec8346d0f = $b5ea4103373313ba$var$array.slice;
var $b5ea4103373313ba$export$871de8747c9eaa88 = $b5ea4103373313ba$var$array.map;

});

parcelRegister("dBdZ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6994419a2b821b$export$2e2bcd8739ae039);
function $9e6994419a2b821b$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("gfrFH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd43830eb76d22ca$export$2e2bcd8739ae039);
function $bd43830eb76d22ca$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("jYfdq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e89f6c6e9d48b9ac$export$2e2bcd8739ae039);
function $e89f6c6e9d48b9ac$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("4nr0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $32fe43b82d6600af$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $32fe43b82d6600af$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $32fe43b82d6600af$export$81087d9b915d4ede);
var $32fe43b82d6600af$var$e10 = Math.sqrt(50), $32fe43b82d6600af$var$e5 = Math.sqrt(10), $32fe43b82d6600af$var$e2 = Math.sqrt(2);
function $32fe43b82d6600af$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $32fe43b82d6600af$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $32fe43b82d6600af$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $32fe43b82d6600af$var$e10 ? 10 : error >= $32fe43b82d6600af$var$e5 ? 5 : error >= $32fe43b82d6600af$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $32fe43b82d6600af$var$e10 ? 10 : error >= $32fe43b82d6600af$var$e5 ? 5 : error >= $32fe43b82d6600af$var$e2 ? 2 : 1);
}
function $32fe43b82d6600af$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $32fe43b82d6600af$var$e10) step1 *= 10;
    else if (error >= $32fe43b82d6600af$var$e5) step1 *= 5;
    else if (error >= $32fe43b82d6600af$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("aLdA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d58d42b8b53e360$export$2e2bcd8739ae039);
function $7d58d42b8b53e360$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}

});


parcelRegister("8oGef", function(module, exports) {

var $fCkqQ = parcelRequire("fCkqQ");

var $lWEwg = parcelRequire("lWEwg");

var $chY5j = parcelRequire("chY5j");

var $5zbjP = parcelRequire("5zbjP");
function $61d1525e6dc9b1ca$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $fCkqQ.map).call(values, (0, $chY5j.default)).sort((0, $lWEwg.default));
    return Math.ceil((max - min) / (2 * ((0, $5zbjP.default)(values, 0.75) - (0, $5zbjP.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}

});
parcelRegister("5zbjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $40d9004bfe91a945$export$2e2bcd8739ae039);

var $chY5j = parcelRequire("chY5j");
function $40d9004bfe91a945$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $chY5j.default);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});


parcelRegister("4hhMD", function(module, exports) {

var $ahZiD = parcelRequire("ahZiD");
function $31d68b5aacb1132a$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $ahZiD.default)(values) * Math.pow(values.length, -1 / 3)));
}

});

parcelRegister("2bllj", function(module, exports) {
function $196d2a17ebfce642$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}

});

parcelRegister("9EoqN", function(module, exports) {

var $chY5j = parcelRequire("chY5j");
function $706acd072b2be7dc$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $chY5j.default)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $chY5j.default)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}

});

parcelRegister("gQKCX", function(module, exports) {

var $lWEwg = parcelRequire("lWEwg");

var $chY5j = parcelRequire("chY5j");

var $5zbjP = parcelRequire("5zbjP");
function $c445abdfbc59b05a$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $chY5j.default)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $chY5j.default)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $5zbjP.default)(numbers.sort((0, $lWEwg.default)), 0.5);
}

});

parcelRegister("azkyr", function(module, exports) {
function $7b1d1df6bfc0100d$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}

});

parcelRegister("98nAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a6728ed2ea3debe$export$2e2bcd8739ae039);
function $6a6728ed2ea3debe$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}

});

parcelRegister("eKlgf", function(module, exports) {
function $abc5da90b4a620aa$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}

});

parcelRegister("2fulK", function(module, exports) {

var $lWEwg = parcelRequire("lWEwg");
function $1a34865369acb0f9$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $lWEwg.default);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}

});

parcelRegister("63wx6", function(module, exports) {
function $468c423f506d238a$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}

});

parcelRegister("eDQha", function(module, exports) {
function $aa8d42186031d2e0$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("2Y6Ju", function(module, exports) {

$parcel$export(module.exports, "default", () => $2296685b140b6061$export$2e2bcd8739ae039);

var $98nAE = parcelRequire("98nAE");
function $2296685b140b6061$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $98nAE.default)(matrix, $2296685b140b6061$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $2296685b140b6061$var$length(d) {
    return d.length;
}

});

parcelRegister("jpeRV", function(module, exports) {

var $2Y6Ju = parcelRequire("2Y6Ju");
function $e20be2bfb33a670a$export$2e2bcd8739ae039() {
    return (0, $2Y6Ju.default)(arguments);
}

});


parcelRegister("haeJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7eecaf25d503199$export$2e2bcd8739ae039);
parcelRequire("5TS5K");
var $5R0qr = parcelRequire("5R0qr");

var $eQN6I = parcelRequire("eQN6I");
var $c7eecaf25d503199$export$e4f898ab14d9d460 = {
    name: "implicit"
};
function $c7eecaf25d503199$export$2e2bcd8739ae039(range) {
    var index = (0, $5R0qr.default)(), domain = [], unknown = $c7eecaf25d503199$export$e4f898ab14d9d460;
    range = range == null ? [] : (0, $eQN6I.slice).call(range);
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $c7eecaf25d503199$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, $5R0qr.default)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $eQN6I.slice).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c7eecaf25d503199$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return scale;
}

});
parcelRegister("5TS5K", function(module, exports) {

$parcel$export(module.exports, "map", () => (parcelRequire("5R0qr")).default);

var $km3bd = parcelRequire("km3bd");

var $636bL = parcelRequire("636bL");

var $5R0qr = parcelRequire("5R0qr");

var $5hqDA = parcelRequire("5hqDA");

var $ehd23 = parcelRequire("ehd23");

var $gD9JK = parcelRequire("gD9JK");

});
parcelRegister("km3bd", function(module, exports) {

var $5R0qr = parcelRequire("5R0qr");
function $ed1854318e2ea3ec$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $5R0qr.default)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $ed1854318e2ea3ec$var$createObject, $ed1854318e2ea3ec$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $ed1854318e2ea3ec$var$createMap, $ed1854318e2ea3ec$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $ed1854318e2ea3ec$var$createMap, $ed1854318e2ea3ec$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $ed1854318e2ea3ec$var$createObject() {
    return {};
}
function $ed1854318e2ea3ec$var$setObject(object, key, value) {
    object[key] = value;
}
function $ed1854318e2ea3ec$var$createMap() {
    return (0, $5R0qr.default)();
}
function $ed1854318e2ea3ec$var$setMap(map, key, value) {
    map.set(key, value);
}

});
parcelRegister("5R0qr", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $44323b7a1b2bbe51$export$82e9f45cca5ba907);
$parcel$export(module.exports, "default", () => $44323b7a1b2bbe51$export$2e2bcd8739ae039);
var $44323b7a1b2bbe51$export$82e9f45cca5ba907 = "$";
function $44323b7a1b2bbe51$var$Map() {}
$44323b7a1b2bbe51$var$Map.prototype = $44323b7a1b2bbe51$var$map.prototype = {
    constructor: $44323b7a1b2bbe51$var$Map,
    has: function(key) {
        return $44323b7a1b2bbe51$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$44323b7a1b2bbe51$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$44323b7a1b2bbe51$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $44323b7a1b2bbe51$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $44323b7a1b2bbe51$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $44323b7a1b2bbe51$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $44323b7a1b2bbe51$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $44323b7a1b2bbe51$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $44323b7a1b2bbe51$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $44323b7a1b2bbe51$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $44323b7a1b2bbe51$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $44323b7a1b2bbe51$var$map(object, f) {
    var map = new $44323b7a1b2bbe51$var$Map;
    // Copy constructor.
    if (object instanceof $44323b7a1b2bbe51$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $44323b7a1b2bbe51$export$2e2bcd8739ae039 = $44323b7a1b2bbe51$var$map;

});


parcelRegister("636bL", function(module, exports) {

var $5R0qr = parcelRequire("5R0qr");
function $4677d2d505951fe2$var$Set() {}
var $4677d2d505951fe2$var$proto = (0, $5R0qr.default).prototype;
$4677d2d505951fe2$var$Set.prototype = $4677d2d505951fe2$var$set.prototype = {
    constructor: $4677d2d505951fe2$var$Set,
    has: $4677d2d505951fe2$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $5R0qr.prefix) + value] = value;
        return this;
    },
    remove: $4677d2d505951fe2$var$proto.remove,
    clear: $4677d2d505951fe2$var$proto.clear,
    values: $4677d2d505951fe2$var$proto.keys,
    size: $4677d2d505951fe2$var$proto.size,
    empty: $4677d2d505951fe2$var$proto.empty,
    each: $4677d2d505951fe2$var$proto.each
};
function $4677d2d505951fe2$var$set(object, f) {
    var set = new $4677d2d505951fe2$var$Set;
    // Copy constructor.
    if (object instanceof $4677d2d505951fe2$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $4677d2d505951fe2$export$2e2bcd8739ae039 = $4677d2d505951fe2$var$set;

});

parcelRegister("5hqDA", function(module, exports) {
function $3d8333edd1647d65$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}

});

parcelRegister("ehd23", function(module, exports) {
function $a64cc32210c10479$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}

});

parcelRegister("gD9JK", function(module, exports) {
function $c1b7d76bd9d548ed$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}

});


parcelRegister("eQN6I", function(module, exports) {

$parcel$export(module.exports, "map", () => $acfc03b01bd802ca$export$871de8747c9eaa88);
$parcel$export(module.exports, "slice", () => $acfc03b01bd802ca$export$58adb3bec8346d0f);
var $acfc03b01bd802ca$var$array = Array.prototype;
var $acfc03b01bd802ca$export$871de8747c9eaa88 = $acfc03b01bd802ca$var$array.map;
var $acfc03b01bd802ca$export$58adb3bec8346d0f = $acfc03b01bd802ca$var$array.slice;

});



parcelRegister("fm4Fv", function(module, exports) {

var $eQN6I = parcelRequire("eQN6I");

var $cQ6wP = parcelRequire("cQ6wP");

var $cU12T = parcelRequire("cU12T");
function $b2dc88285f995065$export$2e2bcd8739ae039() {
    var domain = [
        0,
        1
    ];
    function scale(x) {
        return +x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, $eQN6I.map).call(_, (0, $cU12T.default)), scale) : domain.slice();
    };
    scale.copy = function() {
        return $b2dc88285f995065$export$2e2bcd8739ae039().domain(domain);
    };
    return (0, $cQ6wP.linearish)(scale);
}

});
parcelRegister("cQ6wP", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $958f67cbe6267639$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $958f67cbe6267639$export$2e2bcd8739ae039);
parcelRequire("hEBRK");
var $4nr0T = parcelRequire("4nr0T");

var $hwFWY = parcelRequire("hwFWY");

var $jCRDA = parcelRequire("jCRDA");

var $4mgkQ = parcelRequire("4mgkQ");
function $958f67cbe6267639$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $4nr0T.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        return (0, $4mgkQ.default)(domain(), count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, $4nr0T.tickIncrement)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, $4nr0T.tickIncrement)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, $4nr0T.tickIncrement)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function $958f67cbe6267639$export$2e2bcd8739ae039() {
    var scale = (0, $jCRDA.default)((0, $jCRDA.deinterpolateLinear), (0, $hwFWY.default));
    scale.copy = function() {
        return (0, $jCRDA.copy)(scale, $958f67cbe6267639$export$2e2bcd8739ae039());
    };
    return $958f67cbe6267639$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("hwFWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc25f7412b9fcc9e$export$2e2bcd8739ae039);
function $cc25f7412b9fcc9e$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("jCRDA", function(module, exports) {

$parcel$export(module.exports, "deinterpolateLinear", () => $e49b2c3b066e356c$export$774010690f7452c2);
$parcel$export(module.exports, "copy", () => $e49b2c3b066e356c$export$784d13d8ee351f07);
$parcel$export(module.exports, "default", () => $e49b2c3b066e356c$export$2e2bcd8739ae039);
parcelRequire("hEBRK");
var $dpLCA = parcelRequire("dpLCA");

var $8cRZr = parcelRequire("8cRZr");
var $ID0nS = parcelRequire("ID0nS");

var $eQN6I = parcelRequire("eQN6I");

var $jCWvd = parcelRequire("jCWvd");

var $cU12T = parcelRequire("cU12T");
var $e49b2c3b066e356c$var$unit = [
    0,
    1
];
function $e49b2c3b066e356c$export$774010690f7452c2(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $jCWvd.default)(b);
}
function $e49b2c3b066e356c$var$deinterpolateClamp(deinterpolate) {
    return function(a, b) {
        var d = deinterpolate(a = +a, b = +b);
        return function(x) {
            return x <= a ? 0 : x >= b ? 1 : d(x);
        };
    };
}
function $e49b2c3b066e356c$var$reinterpolateClamp(reinterpolate) {
    return function(a, b) {
        var r = reinterpolate(a = +a, b = +b);
        return function(t) {
            return t <= 0 ? a : t >= 1 ? b : r(t);
        };
    };
}
function $e49b2c3b066e356c$var$bimap(domain, range, deinterpolate, reinterpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
    else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $e49b2c3b066e356c$var$polymap(domain, range, deinterpolate, reinterpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = deinterpolate(domain[i], domain[i + 1]);
        r[i] = reinterpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $dpLCA.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $e49b2c3b066e356c$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp());
}
function $e49b2c3b066e356c$export$2e2bcd8739ae039(deinterpolate, reinterpolate) {
    var domain = $e49b2c3b066e356c$var$unit, range = $e49b2c3b066e356c$var$unit, interpolate = (0, $8cRZr.default), clamp = false, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? $e49b2c3b066e356c$var$polymap : $e49b2c3b066e356c$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return (output || (output = piecewise(domain, range, clamp ? $e49b2c3b066e356c$var$deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
    }
    scale.invert = function(y) {
        return (input || (input = piecewise(range, domain, $e49b2c3b066e356c$export$774010690f7452c2, clamp ? $e49b2c3b066e356c$var$reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $eQN6I.map).call(_, (0, $cU12T.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $eQN6I.slice).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, $eQN6I.slice).call(_), interpolate = (0, $ID0nS.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, rescale()) : clamp;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    return rescale();
}

});
parcelRegister("8cRZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f99530478167862$export$2e2bcd8739ae039);

var $4dvJV = parcelRequire("4dvJV");

var $dHcnZ = parcelRequire("dHcnZ");

var $aSsDa = parcelRequire("aSsDa");

var $a1Zqf = parcelRequire("a1Zqf");

var $hwFWY = parcelRequire("hwFWY");

var $eQ16T = parcelRequire("eQ16T");

var $6GEk5 = parcelRequire("6GEk5");

var $16LAV = parcelRequire("16LAV");

var $9K1te = parcelRequire("9K1te");
function $5f99530478167862$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $16LAV.default)(b) : (t === "number" ? (0, $hwFWY.default) : t === "string" ? (c = (0, $4dvJV.default)(b)) ? (b = c, $dHcnZ.default) : (0, $6GEk5.default) : b instanceof (0, $4dvJV.default) ? (0, $dHcnZ.default) : b instanceof Date ? (0, $a1Zqf.default) : (0, $9K1te.isNumberArray)(b) ? (0, $9K1te.default) : Array.isArray(b) ? (0, $aSsDa.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $eQ16T.default) : (0, $hwFWY.default))(a, b);
}

});
parcelRegister("4dvJV", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $gi1Bk = parcelRequire("gi1Bk");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $gi1Bk.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $gi1Bk.default)(Rgb, rgb, (0, $gi1Bk.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $gi1Bk.default)(Hsl, hsl, (0, $gi1Bk.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("gi1Bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdbf91bd7f0ace1c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $bdbf91bd7f0ace1c$export$8b58be045bf06082);
function $bdbf91bd7f0ace1c$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $bdbf91bd7f0ace1c$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("dHcnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f88e6194542e9fa$export$2e2bcd8739ae039);

var $4dvJV = parcelRequire("4dvJV");

var $3Oi2G = parcelRequire("3Oi2G");

var $5TJ2O = parcelRequire("5TJ2O");

var $h6YmJ = parcelRequire("h6YmJ");
var $9f88e6194542e9fa$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $h6YmJ.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $4dvJV.rgb)(start)).r, (end = (0, $4dvJV.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $h6YmJ.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $9f88e6194542e9fa$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $4dvJV.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $9f88e6194542e9fa$export$2c0e28f2e2852d3f = $9f88e6194542e9fa$var$rgbSpline((0, $3Oi2G.default));
var $9f88e6194542e9fa$export$53d5214f625ccd4c = $9f88e6194542e9fa$var$rgbSpline((0, $5TJ2O.default));

});
parcelRegister("3Oi2G", function(module, exports) {

$parcel$export(module.exports, "basis", () => $2c64096bffad3e2d$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $2c64096bffad3e2d$export$2e2bcd8739ae039);
function $2c64096bffad3e2d$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $2c64096bffad3e2d$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $2c64096bffad3e2d$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("5TJ2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b507b1e1163dbf$export$2e2bcd8739ae039);

var $3Oi2G = parcelRequire("3Oi2G");
function $44b507b1e1163dbf$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $3Oi2G.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("h6YmJ", function(module, exports) {

$parcel$export(module.exports, "hue", () => $c751d293b6ede0fd$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $c751d293b6ede0fd$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $c751d293b6ede0fd$export$2e2bcd8739ae039);

var $16LAV = parcelRequire("16LAV");
function $c751d293b6ede0fd$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $c751d293b6ede0fd$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $c751d293b6ede0fd$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $c751d293b6ede0fd$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $16LAV.default)(isNaN(a) ? b : a);
}
function $c751d293b6ede0fd$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $c751d293b6ede0fd$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $c751d293b6ede0fd$var$exponential(a, b, y) : (0, $16LAV.default)(isNaN(a) ? b : a);
    };
}
function $c751d293b6ede0fd$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $c751d293b6ede0fd$var$linear(a, d) : (0, $16LAV.default)(isNaN(a) ? b : a);
}

});
parcelRegister("16LAV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ceb4546a732814e$export$2e2bcd8739ae039);
function $0ceb4546a732814e$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("aSsDa", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $7eb52804bda3c2a1$export$15d09067c6a5ee49);

var $8cRZr = parcelRequire("8cRZr");

var $9K1te = parcelRequire("9K1te");
function $7eb52804bda3c2a1$export$2e2bcd8739ae039(a, b) {
    return ((0, $9K1te.isNumberArray)(b) ? (0, $9K1te.default) : $7eb52804bda3c2a1$export$15d09067c6a5ee49)(a, b);
}
function $7eb52804bda3c2a1$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8cRZr.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("9K1te", function(module, exports) {

$parcel$export(module.exports, "default", () => $71798cf035b7cfa5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $71798cf035b7cfa5$export$5cd576d1827d40c8);
function $71798cf035b7cfa5$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $71798cf035b7cfa5$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("a1Zqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e27a656e266e29$export$2e2bcd8739ae039);
function $01e27a656e266e29$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("eQ16T", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd6c877f795d6f6$export$2e2bcd8739ae039);

var $8cRZr = parcelRequire("8cRZr");
function $acd6c877f795d6f6$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8cRZr.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("6GEk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de5f19aeed02904$export$2e2bcd8739ae039);

var $hwFWY = parcelRequire("hwFWY");
var $4de5f19aeed02904$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $4de5f19aeed02904$var$reB = new RegExp($4de5f19aeed02904$var$reA.source, "g");
function $4de5f19aeed02904$var$zero(b) {
    return function() {
        return b;
    };
}
function $4de5f19aeed02904$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $4de5f19aeed02904$export$2e2bcd8739ae039(a, b) {
    var bi = $4de5f19aeed02904$var$reA.lastIndex = $4de5f19aeed02904$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $4de5f19aeed02904$var$reA.exec(a)) && (bm = $4de5f19aeed02904$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $hwFWY.default)(am, bm)
            });
        }
        bi = $4de5f19aeed02904$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $4de5f19aeed02904$var$one(q[0].x) : $4de5f19aeed02904$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("ID0nS", function(module, exports) {

$parcel$export(module.exports, "default", () => $08625dcb82198a58$export$2e2bcd8739ae039);
function $08625dcb82198a58$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("jCWvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49ef251bb59dfff$export$2e2bcd8739ae039);
function $e49ef251bb59dfff$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("cU12T", function(module, exports) {

$parcel$export(module.exports, "default", () => $964b86a597e20675$export$2e2bcd8739ae039);
function $964b86a597e20675$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("4mgkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c5e356a84cf194$export$2e2bcd8739ae039);
parcelRequire("hEBRK");
var $4nr0T = parcelRequire("4nr0T");

var $l0WsL = parcelRequire("l0WsL");
var $iZAvL = parcelRequire("iZAvL");
var $3FZSy = parcelRequire("3FZSy");
var $5A1aK = parcelRequire("5A1aK");
var $k9bFA = parcelRequire("k9bFA");
function $32c5e356a84cf194$export$2e2bcd8739ae039(domain, count, specifier) {
    var start = domain[0], stop = domain[domain.length - 1], step = (0, $4nr0T.tickStep)(start, stop, count == null ? 10 : count), precision;
    specifier = (0, $iZAvL.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $5A1aK.default)(step, value))) specifier.precision = precision;
            return (0, $l0WsL.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $k9bFA.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $3FZSy.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $l0WsL.format)(specifier);
}

});
parcelRegister("l0WsL", function(module, exports) {

$parcel$export(module.exports, "format", () => $f4c6f296d883a2ef$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $f4c6f296d883a2ef$export$8d85692a469dde6f);

var $kmJw2 = parcelRequire("kmJw2");
var $f4c6f296d883a2ef$var$locale;
var $f4c6f296d883a2ef$export$d9468344d3651243;
var $f4c6f296d883a2ef$export$8d85692a469dde6f;
$f4c6f296d883a2ef$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $f4c6f296d883a2ef$export$2e2bcd8739ae039(definition) {
    $f4c6f296d883a2ef$var$locale = (0, $kmJw2.default)(definition);
    $f4c6f296d883a2ef$export$d9468344d3651243 = $f4c6f296d883a2ef$var$locale.format;
    $f4c6f296d883a2ef$export$8d85692a469dde6f = $f4c6f296d883a2ef$var$locale.formatPrefix;
    return $f4c6f296d883a2ef$var$locale;
}

});
parcelRegister("kmJw2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed392b375a0cf68c$export$2e2bcd8739ae039);

var $8uOr3 = parcelRequire("8uOr3");

var $9FM8m = parcelRequire("9FM8m");

var $vqhxz = parcelRequire("vqhxz");

var $iZAvL = parcelRequire("iZAvL");

var $8nwkq = parcelRequire("8nwkq");

var $bFOxF = parcelRequire("bFOxF");

var $fePaO = parcelRequire("fePaO");

var $cp9py = parcelRequire("cp9py");
var $ed392b375a0cf68c$var$map = Array.prototype.map, $ed392b375a0cf68c$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $ed392b375a0cf68c$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $cp9py.default) : (0, $9FM8m.default)($ed392b375a0cf68c$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $cp9py.default) : (0, $vqhxz.default)($ed392b375a0cf68c$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $iZAvL.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $bFOxF.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $bFOxF.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $8nwkq.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $ed392b375a0cf68c$var$prefixes[8 + (0, $fePaO.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $iZAvL.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $8uOr3.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $ed392b375a0cf68c$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("8uOr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f83f7a26a6ff42$export$2e2bcd8739ae039);

var $eg9Lm = parcelRequire("eg9Lm");
function $62f83f7a26a6ff42$export$2e2bcd8739ae039(x) {
    return x = (0, $eg9Lm.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("eg9Lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a61a2208d4f0e5ac$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $a61a2208d4f0e5ac$export$8f8e23dd27dc19f5);
function $a61a2208d4f0e5ac$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $a61a2208d4f0e5ac$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("9FM8m", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ad47c857df95d5$export$2e2bcd8739ae039);
function $70ad47c857df95d5$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("vqhxz", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e74867b1a317b1$export$2e2bcd8739ae039);
function $05e74867b1a317b1$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("iZAvL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd3a3edff5819a07$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $dd3a3edff5819a07$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $dd3a3edff5819a07$export$2e2bcd8739ae039(specifier) {
    if (!(match = $dd3a3edff5819a07$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $dd3a3edff5819a07$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$dd3a3edff5819a07$export$2e2bcd8739ae039.prototype = $dd3a3edff5819a07$export$963aac351db36ed4.prototype; // instanceof
function $dd3a3edff5819a07$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$dd3a3edff5819a07$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("8nwkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61998c79d35c4d0a$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $61998c79d35c4d0a$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("bFOxF", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fabaa210d170d4$export$2e2bcd8739ae039);

var $eg9Lm = parcelRequire("eg9Lm");

var $fePaO = parcelRequire("fePaO");

var $cisXF = parcelRequire("cisXF");
var $87fabaa210d170d4$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $eg9Lm.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $cisXF.default)(x * 100, p);
    },
    "r": (0, $cisXF.default),
    "s": (0, $fePaO.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

});
parcelRegister("fePaO", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $b17fdbcec9562aae$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $b17fdbcec9562aae$export$2e2bcd8739ae039);

var $eg9Lm = parcelRequire("eg9Lm");
var $b17fdbcec9562aae$export$6863724d9a42263;
function $b17fdbcec9562aae$export$2e2bcd8739ae039(x, p) {
    var d = (0, $eg9Lm.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($b17fdbcec9562aae$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $eg9Lm.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("cisXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3da194fba8ccf7$export$2e2bcd8739ae039);

var $eg9Lm = parcelRequire("eg9Lm");
function $8f3da194fba8ccf7$export$2e2bcd8739ae039(x, p) {
    var d = (0, $eg9Lm.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("cp9py", function(module, exports) {

$parcel$export(module.exports, "default", () => $907f1eb0d8ed2563$export$2e2bcd8739ae039);
function $907f1eb0d8ed2563$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("3FZSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad5334c0627f742$export$2e2bcd8739ae039);

var $8uOr3 = parcelRequire("8uOr3");
function $2ad5334c0627f742$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $8uOr3.default)(Math.abs(step)));
}

});

parcelRegister("5A1aK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4101395a13656f12$export$2e2bcd8739ae039);

var $8uOr3 = parcelRequire("8uOr3");
function $4101395a13656f12$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $8uOr3.default)(value) / 3))) * 3 - (0, $8uOr3.default)(Math.abs(step)));
}

});

parcelRegister("k9bFA", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaadb34d233c8bbb$export$2e2bcd8739ae039);

var $8uOr3 = parcelRequire("8uOr3");
function $eaadb34d233c8bbb$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $8uOr3.default)(max) - (0, $8uOr3.default)(step)) + 1;
}

});




parcelRegister("eLL7r", function(module, exports) {
parcelRequire("hEBRK");
var $4nr0T = parcelRequire("4nr0T");

var $l0WsL = parcelRequire("l0WsL");

var $jCWvd = parcelRequire("jCWvd");

var $aNkgZ = parcelRequire("aNkgZ");

var $jCRDA = parcelRequire("jCRDA");
function $ac0a01574af5ac43$var$deinterpolate(a, b) {
    return (b = Math.log(b / a)) ? function(x) {
        return Math.log(x / a) / b;
    } : (0, $jCWvd.default)(b);
}
function $ac0a01574af5ac43$var$reinterpolate(a, b) {
    return a < 0 ? function(t) {
        return -Math.pow(-b, t) * Math.pow(-a, 1 - t);
    } : function(t) {
        return Math.pow(b, t) * Math.pow(a, 1 - t);
    };
}
function $ac0a01574af5ac43$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $ac0a01574af5ac43$var$powp(base) {
    return base === 10 ? $ac0a01574af5ac43$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $ac0a01574af5ac43$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $ac0a01574af5ac43$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $ac0a01574af5ac43$export$2e2bcd8739ae039() {
    var scale = (0, $jCRDA.default)($ac0a01574af5ac43$var$deinterpolate, $ac0a01574af5ac43$var$reinterpolate).domain([
        1,
        10
    ]), domain = scale.domain, base = 10, logs = $ac0a01574af5ac43$var$logp(10), pows = $ac0a01574af5ac43$var$powp(10);
    function rescale() {
        logs = $ac0a01574af5ac43$var$logp(base), pows = $ac0a01574af5ac43$var$powp(base);
        if (domain()[0] < 0) logs = $ac0a01574af5ac43$var$reflect(logs), pows = $ac0a01574af5ac43$var$reflect(pows);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, $4nr0T.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $l0WsL.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $aNkgZ.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    scale.copy = function() {
        return (0, $jCRDA.copy)(scale, $ac0a01574af5ac43$export$2e2bcd8739ae039().base(base));
    };
    return scale;
}

});
parcelRegister("aNkgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbe34cbc0183f1d$export$2e2bcd8739ae039);
function $7dbe34cbc0183f1d$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("1M46x", function(module, exports) {

var $jCWvd = parcelRequire("jCWvd");

var $cQ6wP = parcelRequire("cQ6wP");

var $jCRDA = parcelRequire("jCRDA");
function $14ad7532b6550500$var$raise(x, exponent) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}
function $14ad7532b6550500$export$2e2bcd8739ae039() {
    var exponent = 1, scale = (0, $jCRDA.default)(deinterpolate, reinterpolate), domain = scale.domain;
    function deinterpolate(a, b) {
        return (b = $14ad7532b6550500$var$raise(b, exponent) - (a = $14ad7532b6550500$var$raise(a, exponent))) ? function(x) {
            return ($14ad7532b6550500$var$raise(x, exponent) - a) / b;
        } : (0, $jCWvd.default)(b);
    }
    function reinterpolate(a, b) {
        b = $14ad7532b6550500$var$raise(b, exponent) - (a = $14ad7532b6550500$var$raise(a, exponent));
        return function(t) {
            return $14ad7532b6550500$var$raise(a + b * t, 1 / exponent);
        };
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, domain(domain())) : exponent;
    };
    scale.copy = function() {
        return (0, $jCRDA.copy)(scale, $14ad7532b6550500$export$2e2bcd8739ae039().exponent(exponent));
    };
    return (0, $cQ6wP.linearish)(scale);
}
function $14ad7532b6550500$export$eba8049fb5020b81() {
    return $14ad7532b6550500$export$2e2bcd8739ae039().exponent(0.5);
}

});

parcelRegister("fWGA7", function(module, exports) {
parcelRequire("hEBRK");
var $lWEwg = parcelRequire("lWEwg");
var $dpLCA = parcelRequire("dpLCA");
var $5zbjP = parcelRequire("5zbjP");

var $eQN6I = parcelRequire("eQN6I");
function $b9bd4d9cb4cd9e32$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [];
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $5zbjP.default)(domain, i / n);
        return scale;
    }
    function scale(x) {
        if (!isNaN(x = +x)) return range[(0, $dpLCA.default)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $lWEwg.default));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $eQN6I.slice).call(_), rescale()) : range.slice();
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $b9bd4d9cb4cd9e32$export$2e2bcd8739ae039().domain(domain).range(range);
    };
    return scale;
}

});

parcelRegister("iNMp0", function(module, exports) {
parcelRequire("hEBRK");
var $dpLCA = parcelRequire("dpLCA");

var $eQN6I = parcelRequire("eQN6I");

var $cQ6wP = parcelRequire("cQ6wP");
function $db02594c7dd5a326$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ];
    function scale(x) {
        if (x <= x) return range[(0, $dpLCA.default)(domain, x, 0, n)];
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, $eQN6I.slice).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.copy = function() {
        return $db02594c7dd5a326$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range);
    };
    return (0, $cQ6wP.linearish)(scale);
}

});

parcelRegister("ePluM", function(module, exports) {
parcelRequire("hEBRK");
var $dpLCA = parcelRequire("dpLCA");

var $eQN6I = parcelRequire("eQN6I");
function $acb680ad03387f52$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], n = 1;
    function scale(x) {
        if (x <= x) return range[(0, $dpLCA.default)(domain, x, 0, n)];
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $eQN6I.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $eQN6I.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.copy = function() {
        return $acb680ad03387f52$export$2e2bcd8739ae039().domain(domain).range(range);
    };
    return scale;
}

});

parcelRegister("1IQyN", function(module, exports) {

$parcel$export(module.exports, "calendar", () => $1412abe0d4c66114$export$56bbcdb8aca31149);
parcelRequire("hEBRK");
var $6BNjt = parcelRequire("6BNjt");
var $4nr0T = parcelRequire("4nr0T");

var $hwFWY = parcelRequire("hwFWY");

var $8H8zA = parcelRequire("8H8zA");
var $dhXxr = parcelRequire("dhXxr");
var $8yIyf = parcelRequire("8yIyf");
var $AxSaf = parcelRequire("AxSaf");
var $ep3ws = parcelRequire("ep3ws");
var $4wzN2 = parcelRequire("4wzN2");
var $31Dbv = parcelRequire("31Dbv");
var $bbkCj = parcelRequire("bbkCj");

var $81hXH = parcelRequire("81hXH");

var $eQN6I = parcelRequire("eQN6I");

var $jCRDA = parcelRequire("jCRDA");

var $aNkgZ = parcelRequire("aNkgZ");
var $1412abe0d4c66114$var$durationSecond = 1000, $1412abe0d4c66114$var$durationMinute = $1412abe0d4c66114$var$durationSecond * 60, $1412abe0d4c66114$var$durationHour = $1412abe0d4c66114$var$durationMinute * 60, $1412abe0d4c66114$var$durationDay = $1412abe0d4c66114$var$durationHour * 24, $1412abe0d4c66114$var$durationWeek = $1412abe0d4c66114$var$durationDay * 7, $1412abe0d4c66114$var$durationMonth = $1412abe0d4c66114$var$durationDay * 30, $1412abe0d4c66114$var$durationYear = $1412abe0d4c66114$var$durationDay * 365;
function $1412abe0d4c66114$var$date(t) {
    return new Date(t);
}
function $1412abe0d4c66114$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $1412abe0d4c66114$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, $jCRDA.default)((0, $jCRDA.deinterpolateLinear), (0, $hwFWY.default)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            $1412abe0d4c66114$var$durationSecond
        ],
        [
            second,
            5,
            5 * $1412abe0d4c66114$var$durationSecond
        ],
        [
            second,
            15,
            15 * $1412abe0d4c66114$var$durationSecond
        ],
        [
            second,
            30,
            30 * $1412abe0d4c66114$var$durationSecond
        ],
        [
            minute,
            1,
            $1412abe0d4c66114$var$durationMinute
        ],
        [
            minute,
            5,
            5 * $1412abe0d4c66114$var$durationMinute
        ],
        [
            minute,
            15,
            15 * $1412abe0d4c66114$var$durationMinute
        ],
        [
            minute,
            30,
            30 * $1412abe0d4c66114$var$durationMinute
        ],
        [
            hour,
            1,
            $1412abe0d4c66114$var$durationHour
        ],
        [
            hour,
            3,
            3 * $1412abe0d4c66114$var$durationHour
        ],
        [
            hour,
            6,
            6 * $1412abe0d4c66114$var$durationHour
        ],
        [
            hour,
            12,
            12 * $1412abe0d4c66114$var$durationHour
        ],
        [
            day,
            1,
            $1412abe0d4c66114$var$durationDay
        ],
        [
            day,
            2,
            2 * $1412abe0d4c66114$var$durationDay
        ],
        [
            week,
            1,
            $1412abe0d4c66114$var$durationWeek
        ],
        [
            month,
            1,
            $1412abe0d4c66114$var$durationMonth
        ],
        [
            month,
            3,
            3 * $1412abe0d4c66114$var$durationMonth
        ],
        [
            year,
            1,
            $1412abe0d4c66114$var$durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, $6BNjt.default)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, $4nr0T.tickStep)(start / $1412abe0d4c66114$var$durationYear, stop / $1412abe0d4c66114$var$durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, $4nr0T.tickStep)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, $eQN6I.map).call(_, $1412abe0d4c66114$var$number)) : domain().map($1412abe0d4c66114$var$date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, $aNkgZ.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $jCRDA.copy)(scale, $1412abe0d4c66114$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}
function $1412abe0d4c66114$export$2e2bcd8739ae039() {
    return $1412abe0d4c66114$export$56bbcdb8aca31149((0, $bbkCj.default), (0, $ep3ws.default), (0, $31Dbv.sunday), (0, $8H8zA.default), (0, $dhXxr.default), (0, $AxSaf.default), (0, $4wzN2.default), (0, $8yIyf.default), (0, $81hXH.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]);
}

});
parcelRegister("8H8zA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6548fd4b36ca98ed$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
var $6548fd4b36ca98ed$var$day = (0, $inD8T.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $9S5Vt.durationMinute)) / (0, $9S5Vt.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
var $6548fd4b36ca98ed$export$2e2bcd8739ae039 = $6548fd4b36ca98ed$var$day;
var $6548fd4b36ca98ed$export$3cf5dda4201cc0f2 = $6548fd4b36ca98ed$var$day.range;

});
parcelRegister("inD8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $d618bcd4ac83d0f5$export$2e2bcd8739ae039);
var $d618bcd4ac83d0f5$var$t0 = new Date, $d618bcd4ac83d0f5$var$t1 = new Date;
function $d618bcd4ac83d0f5$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $d618bcd4ac83d0f5$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $d618bcd4ac83d0f5$var$t0.setTime(+start), $d618bcd4ac83d0f5$var$t1.setTime(+end);
            floori($d618bcd4ac83d0f5$var$t0), floori($d618bcd4ac83d0f5$var$t1);
            return Math.floor(count($d618bcd4ac83d0f5$var$t0, $d618bcd4ac83d0f5$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("9S5Vt", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $72fdc0f8a0b6b107$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $72fdc0f8a0b6b107$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $72fdc0f8a0b6b107$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $72fdc0f8a0b6b107$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $72fdc0f8a0b6b107$export$c241eb88520d5016);
var $72fdc0f8a0b6b107$export$79ef0e34099623dc = 1e3;
var $72fdc0f8a0b6b107$export$683905d551c33fa9 = 6e4;
var $72fdc0f8a0b6b107$export$4157bf0c8e241659 = 36e5;
var $72fdc0f8a0b6b107$export$353686095f4fbf45 = 864e5;
var $72fdc0f8a0b6b107$export$c241eb88520d5016 = 6048e5;

});


parcelRegister("dhXxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9acb0bfbbce4b17f$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
var $9acb0bfbbce4b17f$var$hour = (0, $inD8T.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $9S5Vt.durationSecond) - date.getMinutes() * (0, $9S5Vt.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $9S5Vt.durationHour));
}, function(start, end) {
    return (end - start) / (0, $9S5Vt.durationHour);
}, function(date) {
    return date.getHours();
});
var $9acb0bfbbce4b17f$export$2e2bcd8739ae039 = $9acb0bfbbce4b17f$var$hour;
var $9acb0bfbbce4b17f$export$8d468796d69cdad1 = $9acb0bfbbce4b17f$var$hour.range;

});

parcelRegister("8yIyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b40eade0ea0d37$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");
var $63b40eade0ea0d37$var$millisecond = (0, $inD8T.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$63b40eade0ea0d37$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $63b40eade0ea0d37$var$millisecond;
    return (0, $inD8T.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $63b40eade0ea0d37$export$2e2bcd8739ae039 = $63b40eade0ea0d37$var$millisecond;
var $63b40eade0ea0d37$export$9a27fac83d67afd3 = $63b40eade0ea0d37$var$millisecond.range;

});

parcelRegister("AxSaf", function(module, exports) {

$parcel$export(module.exports, "default", () => $06dda34dd348875d$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
var $06dda34dd348875d$var$minute = (0, $inD8T.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $9S5Vt.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $9S5Vt.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $9S5Vt.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $06dda34dd348875d$export$2e2bcd8739ae039 = $06dda34dd348875d$var$minute;
var $06dda34dd348875d$export$666252b437cce0c7 = $06dda34dd348875d$var$minute.range;

});

parcelRegister("ep3ws", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7c621ff221943da$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");
var $a7c621ff221943da$var$month = (0, $inD8T.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $a7c621ff221943da$export$2e2bcd8739ae039 = $a7c621ff221943da$var$month;
var $a7c621ff221943da$export$16352d1b10c5eb38 = $a7c621ff221943da$var$month.range;

});

parcelRegister("4wzN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b5e9b8d3b48a6b$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
var $34b5e9b8d3b48a6b$var$second = (0, $inD8T.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $9S5Vt.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $9S5Vt.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $34b5e9b8d3b48a6b$export$2e2bcd8739ae039 = $34b5e9b8d3b48a6b$var$second;
var $34b5e9b8d3b48a6b$export$4792e48abc550fa1 = $34b5e9b8d3b48a6b$var$second.range;

});

parcelRegister("31Dbv", function(module, exports) {

$parcel$export(module.exports, "sunday", () => $233fdc5095cf830c$export$fb3ee18ed410cc21);
$parcel$export(module.exports, "monday", () => $233fdc5095cf830c$export$6416afaab03bc9b8);
$parcel$export(module.exports, "thursday", () => $233fdc5095cf830c$export$2f2b56683a3e5629);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
function $233fdc5095cf830c$var$weekday(i) {
    return (0, $inD8T.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $9S5Vt.durationMinute)) / (0, $9S5Vt.durationWeek);
    });
}
var $233fdc5095cf830c$export$fb3ee18ed410cc21 = $233fdc5095cf830c$var$weekday(0);
var $233fdc5095cf830c$export$6416afaab03bc9b8 = $233fdc5095cf830c$var$weekday(1);
var $233fdc5095cf830c$export$cb8f040f5d17ac7b = $233fdc5095cf830c$var$weekday(2);
var $233fdc5095cf830c$export$347581849975dfc8 = $233fdc5095cf830c$var$weekday(3);
var $233fdc5095cf830c$export$2f2b56683a3e5629 = $233fdc5095cf830c$var$weekday(4);
var $233fdc5095cf830c$export$59b8c2ccd931d806 = $233fdc5095cf830c$var$weekday(5);
var $233fdc5095cf830c$export$478ceadebff4d377 = $233fdc5095cf830c$var$weekday(6);
var $233fdc5095cf830c$export$e8daabaa40641211 = $233fdc5095cf830c$export$fb3ee18ed410cc21.range;
var $233fdc5095cf830c$export$74e5b559c235c00e = $233fdc5095cf830c$export$6416afaab03bc9b8.range;
var $233fdc5095cf830c$export$e7d6aa4fb107bc56 = $233fdc5095cf830c$export$cb8f040f5d17ac7b.range;
var $233fdc5095cf830c$export$fcd5880b20bb06a8 = $233fdc5095cf830c$export$347581849975dfc8.range;
var $233fdc5095cf830c$export$682716b7bbe33641 = $233fdc5095cf830c$export$2f2b56683a3e5629.range;
var $233fdc5095cf830c$export$482924968ca86084 = $233fdc5095cf830c$export$59b8c2ccd931d806.range;
var $233fdc5095cf830c$export$7d755172c9cda9d2 = $233fdc5095cf830c$export$478ceadebff4d377.range;

});

parcelRegister("bbkCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8240b6dfa3cf70a3$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");
var $8240b6dfa3cf70a3$var$year = (0, $inD8T.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$8240b6dfa3cf70a3$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $inD8T.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $8240b6dfa3cf70a3$export$2e2bcd8739ae039 = $8240b6dfa3cf70a3$var$year;
var $8240b6dfa3cf70a3$export$6fda41c7fb23acf9 = $8240b6dfa3cf70a3$var$year.range;

});

parcelRegister("81hXH", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $5d6c59912f5f8d02$export$94f4d87fad5dcf9a);
$parcel$export(module.exports, "utcFormat", () => $5d6c59912f5f8d02$export$1a08fe38f63ebbbb);

var $aR1SP = parcelRequire("aR1SP");
var $5d6c59912f5f8d02$var$locale;
var $5d6c59912f5f8d02$export$94f4d87fad5dcf9a;
var $5d6c59912f5f8d02$export$32b9cd16e1b8c8d2;
var $5d6c59912f5f8d02$export$1a08fe38f63ebbbb;
var $5d6c59912f5f8d02$export$3edae9cf8e233729;
$5d6c59912f5f8d02$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $5d6c59912f5f8d02$export$2e2bcd8739ae039(definition) {
    $5d6c59912f5f8d02$var$locale = (0, $aR1SP.default)(definition);
    $5d6c59912f5f8d02$export$94f4d87fad5dcf9a = $5d6c59912f5f8d02$var$locale.format;
    $5d6c59912f5f8d02$export$32b9cd16e1b8c8d2 = $5d6c59912f5f8d02$var$locale.parse;
    $5d6c59912f5f8d02$export$1a08fe38f63ebbbb = $5d6c59912f5f8d02$var$locale.utcFormat;
    $5d6c59912f5f8d02$export$3edae9cf8e233729 = $5d6c59912f5f8d02$var$locale.utcParse;
    return $5d6c59912f5f8d02$var$locale;
}

});
parcelRegister("aR1SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e70509cea7a2db9$export$2e2bcd8739ae039);

var $8H8zA = parcelRequire("8H8zA");
var $31Dbv = parcelRequire("31Dbv");
var $bbkCj = parcelRequire("bbkCj");
var $j6ABC = parcelRequire("j6ABC");
var $7VBQC = parcelRequire("7VBQC");
var $2RX52 = parcelRequire("2RX52");
function $7e70509cea7a2db9$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $7e70509cea7a2db9$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $7e70509cea7a2db9$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $7e70509cea7a2db9$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $7e70509cea7a2db9$var$formatRe(locale_periods), periodLookup = $7e70509cea7a2db9$var$formatLookup(locale_periods), weekdayRe = $7e70509cea7a2db9$var$formatRe(locale_weekdays), weekdayLookup = $7e70509cea7a2db9$var$formatLookup(locale_weekdays), shortWeekdayRe = $7e70509cea7a2db9$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $7e70509cea7a2db9$var$formatLookup(locale_shortWeekdays), monthRe = $7e70509cea7a2db9$var$formatRe(locale_months), monthLookup = $7e70509cea7a2db9$var$formatLookup(locale_months), shortMonthRe = $7e70509cea7a2db9$var$formatRe(locale_shortMonths), shortMonthLookup = $7e70509cea7a2db9$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $7e70509cea7a2db9$var$formatDayOfMonth,
        "e": $7e70509cea7a2db9$var$formatDayOfMonth,
        "f": $7e70509cea7a2db9$var$formatMicroseconds,
        "g": $7e70509cea7a2db9$var$formatYearISO,
        "G": $7e70509cea7a2db9$var$formatFullYearISO,
        "H": $7e70509cea7a2db9$var$formatHour24,
        "I": $7e70509cea7a2db9$var$formatHour12,
        "j": $7e70509cea7a2db9$var$formatDayOfYear,
        "L": $7e70509cea7a2db9$var$formatMilliseconds,
        "m": $7e70509cea7a2db9$var$formatMonthNumber,
        "M": $7e70509cea7a2db9$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $7e70509cea7a2db9$var$formatUnixTimestamp,
        "s": $7e70509cea7a2db9$var$formatUnixTimestampSeconds,
        "S": $7e70509cea7a2db9$var$formatSeconds,
        "u": $7e70509cea7a2db9$var$formatWeekdayNumberMonday,
        "U": $7e70509cea7a2db9$var$formatWeekNumberSunday,
        "V": $7e70509cea7a2db9$var$formatWeekNumberISO,
        "w": $7e70509cea7a2db9$var$formatWeekdayNumberSunday,
        "W": $7e70509cea7a2db9$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $7e70509cea7a2db9$var$formatYear,
        "Y": $7e70509cea7a2db9$var$formatFullYear,
        "Z": $7e70509cea7a2db9$var$formatZone,
        "%": $7e70509cea7a2db9$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $7e70509cea7a2db9$var$formatUTCDayOfMonth,
        "e": $7e70509cea7a2db9$var$formatUTCDayOfMonth,
        "f": $7e70509cea7a2db9$var$formatUTCMicroseconds,
        "g": $7e70509cea7a2db9$var$formatUTCYearISO,
        "G": $7e70509cea7a2db9$var$formatUTCFullYearISO,
        "H": $7e70509cea7a2db9$var$formatUTCHour24,
        "I": $7e70509cea7a2db9$var$formatUTCHour12,
        "j": $7e70509cea7a2db9$var$formatUTCDayOfYear,
        "L": $7e70509cea7a2db9$var$formatUTCMilliseconds,
        "m": $7e70509cea7a2db9$var$formatUTCMonthNumber,
        "M": $7e70509cea7a2db9$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $7e70509cea7a2db9$var$formatUnixTimestamp,
        "s": $7e70509cea7a2db9$var$formatUnixTimestampSeconds,
        "S": $7e70509cea7a2db9$var$formatUTCSeconds,
        "u": $7e70509cea7a2db9$var$formatUTCWeekdayNumberMonday,
        "U": $7e70509cea7a2db9$var$formatUTCWeekNumberSunday,
        "V": $7e70509cea7a2db9$var$formatUTCWeekNumberISO,
        "w": $7e70509cea7a2db9$var$formatUTCWeekdayNumberSunday,
        "W": $7e70509cea7a2db9$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $7e70509cea7a2db9$var$formatUTCYear,
        "Y": $7e70509cea7a2db9$var$formatUTCFullYear,
        "Z": $7e70509cea7a2db9$var$formatUTCZone,
        "%": $7e70509cea7a2db9$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $7e70509cea7a2db9$var$parseDayOfMonth,
        "e": $7e70509cea7a2db9$var$parseDayOfMonth,
        "f": $7e70509cea7a2db9$var$parseMicroseconds,
        "g": $7e70509cea7a2db9$var$parseYear,
        "G": $7e70509cea7a2db9$var$parseFullYear,
        "H": $7e70509cea7a2db9$var$parseHour24,
        "I": $7e70509cea7a2db9$var$parseHour24,
        "j": $7e70509cea7a2db9$var$parseDayOfYear,
        "L": $7e70509cea7a2db9$var$parseMilliseconds,
        "m": $7e70509cea7a2db9$var$parseMonthNumber,
        "M": $7e70509cea7a2db9$var$parseMinutes,
        "p": parsePeriod,
        "q": $7e70509cea7a2db9$var$parseQuarter,
        "Q": $7e70509cea7a2db9$var$parseUnixTimestamp,
        "s": $7e70509cea7a2db9$var$parseUnixTimestampSeconds,
        "S": $7e70509cea7a2db9$var$parseSeconds,
        "u": $7e70509cea7a2db9$var$parseWeekdayNumberMonday,
        "U": $7e70509cea7a2db9$var$parseWeekNumberSunday,
        "V": $7e70509cea7a2db9$var$parseWeekNumberISO,
        "w": $7e70509cea7a2db9$var$parseWeekdayNumberSunday,
        "W": $7e70509cea7a2db9$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $7e70509cea7a2db9$var$parseYear,
        "Y": $7e70509cea7a2db9$var$parseFullYear,
        "Z": $7e70509cea7a2db9$var$parseZone,
        "%": $7e70509cea7a2db9$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $7e70509cea7a2db9$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $7e70509cea7a2db9$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $7e70509cea7a2db9$var$utcDate($7e70509cea7a2db9$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $7VBQC.utcMonday).ceil(week) : (0, $7VBQC.utcMonday)(week);
                    week = (0, $j6ABC.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $7e70509cea7a2db9$var$localDate($7e70509cea7a2db9$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $31Dbv.monday).ceil(week) : (0, $31Dbv.monday)(week);
                    week = (0, $8H8zA.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $7e70509cea7a2db9$var$utcDate($7e70509cea7a2db9$var$newDate(d.y, 0, 1)).getUTCDay() : $7e70509cea7a2db9$var$localDate($7e70509cea7a2db9$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $7e70509cea7a2db9$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $7e70509cea7a2db9$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $7e70509cea7a2db9$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $7e70509cea7a2db9$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $7e70509cea7a2db9$var$numberRe = /^\s*\d+/, $7e70509cea7a2db9$var$percentRe = /^%/, $7e70509cea7a2db9$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $7e70509cea7a2db9$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $7e70509cea7a2db9$var$requote(s) {
    return s.replace($7e70509cea7a2db9$var$requoteRe, "\\$&");
}
function $7e70509cea7a2db9$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($7e70509cea7a2db9$var$requote).join("|") + ")", "i");
}
function $7e70509cea7a2db9$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $7e70509cea7a2db9$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseWeekNumberSunday(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseWeekNumberISO(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseWeekNumberMonday(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseFullYear(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseYear(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseQuarter(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseMonthNumber(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseDayOfMonth(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseDayOfYear(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseHour24(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseMinutes(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseSeconds(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseMilliseconds(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseMicroseconds(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseLiteralPercent(d, string, i) {
    var n = $7e70509cea7a2db9$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $7e70509cea7a2db9$var$parseUnixTimestamp(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $7e70509cea7a2db9$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $7e70509cea7a2db9$var$formatDayOfMonth(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getDate(), p, 2);
}
function $7e70509cea7a2db9$var$formatHour24(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getHours(), p, 2);
}
function $7e70509cea7a2db9$var$formatHour12(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $7e70509cea7a2db9$var$formatDayOfYear(d, p) {
    return $7e70509cea7a2db9$var$pad(1 + (0, $8H8zA.default).count((0, $bbkCj.default)(d), d), p, 3);
}
function $7e70509cea7a2db9$var$formatMilliseconds(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getMilliseconds(), p, 3);
}
function $7e70509cea7a2db9$var$formatMicroseconds(d, p) {
    return $7e70509cea7a2db9$var$formatMilliseconds(d, p) + "000";
}
function $7e70509cea7a2db9$var$formatMonthNumber(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getMonth() + 1, p, 2);
}
function $7e70509cea7a2db9$var$formatMinutes(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getMinutes(), p, 2);
}
function $7e70509cea7a2db9$var$formatSeconds(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getSeconds(), p, 2);
}
function $7e70509cea7a2db9$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $7e70509cea7a2db9$var$formatWeekNumberSunday(d, p) {
    return $7e70509cea7a2db9$var$pad((0, $31Dbv.sunday).count((0, $bbkCj.default)(d) - 1, d), p, 2);
}
function $7e70509cea7a2db9$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $31Dbv.thursday)(d) : (0, $31Dbv.thursday).ceil(d);
}
function $7e70509cea7a2db9$var$formatWeekNumberISO(d, p) {
    d = $7e70509cea7a2db9$var$dISO(d);
    return $7e70509cea7a2db9$var$pad((0, $31Dbv.thursday).count((0, $bbkCj.default)(d), d) + ((0, $bbkCj.default)(d).getDay() === 4), p, 2);
}
function $7e70509cea7a2db9$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $7e70509cea7a2db9$var$formatWeekNumberMonday(d, p) {
    return $7e70509cea7a2db9$var$pad((0, $31Dbv.monday).count((0, $bbkCj.default)(d) - 1, d), p, 2);
}
function $7e70509cea7a2db9$var$formatYear(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getFullYear() % 100, p, 2);
}
function $7e70509cea7a2db9$var$formatYearISO(d, p) {
    d = $7e70509cea7a2db9$var$dISO(d);
    return $7e70509cea7a2db9$var$pad(d.getFullYear() % 100, p, 2);
}
function $7e70509cea7a2db9$var$formatFullYear(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getFullYear() % 10000, p, 4);
}
function $7e70509cea7a2db9$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $31Dbv.thursday)(d) : (0, $31Dbv.thursday).ceil(d);
    return $7e70509cea7a2db9$var$pad(d.getFullYear() % 10000, p, 4);
}
function $7e70509cea7a2db9$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $7e70509cea7a2db9$var$pad(z / 60 | 0, "0", 2) + $7e70509cea7a2db9$var$pad(z % 60, "0", 2);
}
function $7e70509cea7a2db9$var$formatUTCDayOfMonth(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCDate(), p, 2);
}
function $7e70509cea7a2db9$var$formatUTCHour24(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCHours(), p, 2);
}
function $7e70509cea7a2db9$var$formatUTCHour12(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $7e70509cea7a2db9$var$formatUTCDayOfYear(d, p) {
    return $7e70509cea7a2db9$var$pad(1 + (0, $j6ABC.default).count((0, $2RX52.default)(d), d), p, 3);
}
function $7e70509cea7a2db9$var$formatUTCMilliseconds(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $7e70509cea7a2db9$var$formatUTCMicroseconds(d, p) {
    return $7e70509cea7a2db9$var$formatUTCMilliseconds(d, p) + "000";
}
function $7e70509cea7a2db9$var$formatUTCMonthNumber(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $7e70509cea7a2db9$var$formatUTCMinutes(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCMinutes(), p, 2);
}
function $7e70509cea7a2db9$var$formatUTCSeconds(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCSeconds(), p, 2);
}
function $7e70509cea7a2db9$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $7e70509cea7a2db9$var$formatUTCWeekNumberSunday(d, p) {
    return $7e70509cea7a2db9$var$pad((0, $7VBQC.utcSunday).count((0, $2RX52.default)(d) - 1, d), p, 2);
}
function $7e70509cea7a2db9$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $7VBQC.utcThursday)(d) : (0, $7VBQC.utcThursday).ceil(d);
}
function $7e70509cea7a2db9$var$formatUTCWeekNumberISO(d, p) {
    d = $7e70509cea7a2db9$var$UTCdISO(d);
    return $7e70509cea7a2db9$var$pad((0, $7VBQC.utcThursday).count((0, $2RX52.default)(d), d) + ((0, $2RX52.default)(d).getUTCDay() === 4), p, 2);
}
function $7e70509cea7a2db9$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $7e70509cea7a2db9$var$formatUTCWeekNumberMonday(d, p) {
    return $7e70509cea7a2db9$var$pad((0, $7VBQC.utcMonday).count((0, $2RX52.default)(d) - 1, d), p, 2);
}
function $7e70509cea7a2db9$var$formatUTCYear(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $7e70509cea7a2db9$var$formatUTCYearISO(d, p) {
    d = $7e70509cea7a2db9$var$UTCdISO(d);
    return $7e70509cea7a2db9$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $7e70509cea7a2db9$var$formatUTCFullYear(d, p) {
    return $7e70509cea7a2db9$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $7e70509cea7a2db9$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $7VBQC.utcThursday)(d) : (0, $7VBQC.utcThursday).ceil(d);
    return $7e70509cea7a2db9$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $7e70509cea7a2db9$var$formatUTCZone() {
    return "+0000";
}
function $7e70509cea7a2db9$var$formatLiteralPercent() {
    return "%";
}
function $7e70509cea7a2db9$var$formatUnixTimestamp(d) {
    return +d;
}
function $7e70509cea7a2db9$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});
parcelRegister("j6ABC", function(module, exports) {

$parcel$export(module.exports, "default", () => $de8af904171afa0b$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
var $de8af904171afa0b$var$utcDay = (0, $inD8T.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $9S5Vt.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $de8af904171afa0b$export$2e2bcd8739ae039 = $de8af904171afa0b$var$utcDay;
var $de8af904171afa0b$export$d277e198508549a1 = $de8af904171afa0b$var$utcDay.range;

});

parcelRegister("7VBQC", function(module, exports) {

$parcel$export(module.exports, "utcSunday", () => $5c5b370ef7b45339$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $5c5b370ef7b45339$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcThursday", () => $5c5b370ef7b45339$export$1db08111baec2f53);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
function $5c5b370ef7b45339$var$utcWeekday(i) {
    return (0, $inD8T.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $9S5Vt.durationWeek);
    });
}
var $5c5b370ef7b45339$export$4898b06303a92011 = $5c5b370ef7b45339$var$utcWeekday(0);
var $5c5b370ef7b45339$export$9cfc53b9cfafd080 = $5c5b370ef7b45339$var$utcWeekday(1);
var $5c5b370ef7b45339$export$2a6d545f77eceb15 = $5c5b370ef7b45339$var$utcWeekday(2);
var $5c5b370ef7b45339$export$a5c25d8ed64433c4 = $5c5b370ef7b45339$var$utcWeekday(3);
var $5c5b370ef7b45339$export$1db08111baec2f53 = $5c5b370ef7b45339$var$utcWeekday(4);
var $5c5b370ef7b45339$export$29265e34dd5921f7 = $5c5b370ef7b45339$var$utcWeekday(5);
var $5c5b370ef7b45339$export$85b74dad05049604 = $5c5b370ef7b45339$var$utcWeekday(6);
var $5c5b370ef7b45339$export$6f3e1c2b0f7d7880 = $5c5b370ef7b45339$export$4898b06303a92011.range;
var $5c5b370ef7b45339$export$1d2d8b858bb366f9 = $5c5b370ef7b45339$export$9cfc53b9cfafd080.range;
var $5c5b370ef7b45339$export$1d5f6785fc7f30f8 = $5c5b370ef7b45339$export$2a6d545f77eceb15.range;
var $5c5b370ef7b45339$export$7a75faf0e37ef4af = $5c5b370ef7b45339$export$a5c25d8ed64433c4.range;
var $5c5b370ef7b45339$export$417eb959611b2f2f = $5c5b370ef7b45339$export$1db08111baec2f53.range;
var $5c5b370ef7b45339$export$59d308db7af08c64 = $5c5b370ef7b45339$export$29265e34dd5921f7.range;
var $5c5b370ef7b45339$export$a124108a0a7f34c8 = $5c5b370ef7b45339$export$85b74dad05049604.range;

});

parcelRegister("2RX52", function(module, exports) {

$parcel$export(module.exports, "default", () => $216e5c19e67a659b$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");
var $216e5c19e67a659b$var$utcYear = (0, $inD8T.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$216e5c19e67a659b$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $inD8T.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $216e5c19e67a659b$export$2e2bcd8739ae039 = $216e5c19e67a659b$var$utcYear;
var $216e5c19e67a659b$export$3e24d311e17f5802 = $216e5c19e67a659b$var$utcYear.range;

});




parcelRegister("bXt6n", function(module, exports) {

var $1IQyN = parcelRequire("1IQyN");

var $81hXH = parcelRequire("81hXH");

var $j6ABC = parcelRequire("j6ABC");
var $4gtef = parcelRequire("4gtef");
var $8yIyf = parcelRequire("8yIyf");
var $k1yeb = parcelRequire("k1yeb");
var $efUJO = parcelRequire("efUJO");
var $4wzN2 = parcelRequire("4wzN2");
var $7VBQC = parcelRequire("7VBQC");
var $2RX52 = parcelRequire("2RX52");
function $8b4bc76c3f21d61f$export$2e2bcd8739ae039() {
    return (0, $1IQyN.calendar)((0, $2RX52.default), (0, $efUJO.default), (0, $7VBQC.utcSunday), (0, $j6ABC.default), (0, $4gtef.default), (0, $k1yeb.default), (0, $4wzN2.default), (0, $8yIyf.default), (0, $81hXH.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]);
}

});
parcelRegister("4gtef", function(module, exports) {

$parcel$export(module.exports, "default", () => $31af544af9885599$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
var $31af544af9885599$var$utcHour = (0, $inD8T.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $9S5Vt.durationHour));
}, function(start, end) {
    return (end - start) / (0, $9S5Vt.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $31af544af9885599$export$2e2bcd8739ae039 = $31af544af9885599$var$utcHour;
var $31af544af9885599$export$6e7a76cd5f50b719 = $31af544af9885599$var$utcHour.range;

});

parcelRegister("k1yeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93e73918441e289$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");

var $9S5Vt = parcelRequire("9S5Vt");
var $e93e73918441e289$var$utcMinute = (0, $inD8T.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $9S5Vt.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $9S5Vt.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $e93e73918441e289$export$2e2bcd8739ae039 = $e93e73918441e289$var$utcMinute;
var $e93e73918441e289$export$cedd563624e8ee50 = $e93e73918441e289$var$utcMinute.range;

});

parcelRegister("efUJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a60e7a5992f60b72$export$2e2bcd8739ae039);

var $inD8T = parcelRequire("inD8T");
var $a60e7a5992f60b72$var$utcMonth = (0, $inD8T.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $a60e7a5992f60b72$export$2e2bcd8739ae039 = $a60e7a5992f60b72$var$utcMonth;
var $a60e7a5992f60b72$export$49159f585997498 = $a60e7a5992f60b72$var$utcMonth.range;

});


parcelRegister("doRe7", function(module, exports) {

var $gK4CI = parcelRequire("gK4CI");
var $9c16cdf627ecbeb7$export$2e2bcd8739ae039 = (0, $gK4CI.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

});
parcelRegister("gK4CI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c304875b8fd500e6$export$2e2bcd8739ae039);
function $c304875b8fd500e6$export$2e2bcd8739ae039(s) {
    return s.match(/.{6}/g).map(function(x) {
        return "#" + x;
    });
}

});


parcelRegister("iEj9K", function(module, exports) {

var $gK4CI = parcelRequire("gK4CI");
var $d93ad271c506e4c7$export$2e2bcd8739ae039 = (0, $gK4CI.default)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");

});

parcelRegister("7B5L5", function(module, exports) {

var $gK4CI = parcelRequire("gK4CI");
var $5880749730b04708$export$2e2bcd8739ae039 = (0, $gK4CI.default)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");

});

parcelRegister("cOGES", function(module, exports) {

var $gK4CI = parcelRequire("gK4CI");
var $954b3e97ed802480$export$2e2bcd8739ae039 = (0, $gK4CI.default)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");

});

parcelRegister("hXxFT", function(module, exports) {

var $h07Ma = parcelRequire("h07Ma");

var $6NPVs = parcelRequire("6NPVs");
var $d13211736525cbd6$export$2e2bcd8739ae039 = (0, $6NPVs.cubehelixLong)((0, $h07Ma.default)(300, 0.5, 0.0), (0, $h07Ma.default)(-240, 0.5, 1.0));

});
parcelRegister("h07Ma", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60877e16bd4c593$export$2e2bcd8739ae039);

var $gi1Bk = parcelRequire("gi1Bk");

var $4dvJV = parcelRequire("4dvJV");

var $lcMXc = parcelRequire("lcMXc");
var $c60877e16bd4c593$var$A = -0.14861, $c60877e16bd4c593$var$B = 1.78277, $c60877e16bd4c593$var$C = -0.29227, $c60877e16bd4c593$var$D = -0.90649, $c60877e16bd4c593$var$E = 1.97294, $c60877e16bd4c593$var$ED = $c60877e16bd4c593$var$E * $c60877e16bd4c593$var$D, $c60877e16bd4c593$var$EB = $c60877e16bd4c593$var$E * $c60877e16bd4c593$var$B, $c60877e16bd4c593$var$BC_DA = $c60877e16bd4c593$var$B * $c60877e16bd4c593$var$C - $c60877e16bd4c593$var$D * $c60877e16bd4c593$var$A;
function $c60877e16bd4c593$var$cubehelixConvert(o) {
    if (o instanceof $c60877e16bd4c593$export$57ed4bde61a1e2f2) return new $c60877e16bd4c593$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $4dvJV.Rgb))) o = (0, $4dvJV.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($c60877e16bd4c593$var$BC_DA * b + $c60877e16bd4c593$var$ED * r - $c60877e16bd4c593$var$EB * g) / ($c60877e16bd4c593$var$BC_DA + $c60877e16bd4c593$var$ED - $c60877e16bd4c593$var$EB), bl = b - l, k = ($c60877e16bd4c593$var$E * (g - l) - $c60877e16bd4c593$var$C * bl) / $c60877e16bd4c593$var$D, s = Math.sqrt(k * k + bl * bl) / ($c60877e16bd4c593$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $lcMXc.rad2deg) - 120 : NaN;
    return new $c60877e16bd4c593$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $c60877e16bd4c593$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $c60877e16bd4c593$var$cubehelixConvert(h) : new $c60877e16bd4c593$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $c60877e16bd4c593$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $gi1Bk.default)($c60877e16bd4c593$export$57ed4bde61a1e2f2, $c60877e16bd4c593$export$2e2bcd8739ae039, (0, $gi1Bk.extend)((0, $4dvJV.Color), {
    brighter: function(k) {
        k = k == null ? (0, $4dvJV.brighter) : Math.pow((0, $4dvJV.brighter), k);
        return new $c60877e16bd4c593$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $4dvJV.darker) : Math.pow((0, $4dvJV.darker), k);
        return new $c60877e16bd4c593$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $lcMXc.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $4dvJV.Rgb)(255 * (l + a * ($c60877e16bd4c593$var$A * cosh + $c60877e16bd4c593$var$B * sinh)), 255 * (l + a * ($c60877e16bd4c593$var$C * cosh + $c60877e16bd4c593$var$D * sinh)), 255 * (l + a * ($c60877e16bd4c593$var$E * cosh)), this.opacity);
    }
}));

});
parcelRegister("lcMXc", function(module, exports) {

$parcel$export(module.exports, "deg2rad", () => $f700b130fbc4d581$export$b1b275608b2b1b8);
$parcel$export(module.exports, "rad2deg", () => $f700b130fbc4d581$export$b2ba2578f2c43d74);
var $f700b130fbc4d581$export$b1b275608b2b1b8 = Math.PI / 180;
var $f700b130fbc4d581$export$b2ba2578f2c43d74 = 180 / Math.PI;

});


parcelRegister("6NPVs", function(module, exports) {

$parcel$export(module.exports, "cubehelixLong", () => $4f3f991306dff1cf$export$934fa09ad474a1b4);

var $h07Ma = parcelRequire("h07Ma");

var $h6YmJ = parcelRequire("h6YmJ");
function $4f3f991306dff1cf$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $h07Ma.default)(start)).h, (end = (0, $h07Ma.default)(end)).h), s = (0, $h6YmJ.default)(start.s, end.s), l = (0, $h6YmJ.default)(start.l, end.l), opacity = (0, $h6YmJ.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $4f3f991306dff1cf$export$2e2bcd8739ae039 = $4f3f991306dff1cf$var$cubehelix((0, $h6YmJ.hue));
var $4f3f991306dff1cf$export$934fa09ad474a1b4 = $4f3f991306dff1cf$var$cubehelix((0, $h6YmJ.default));

});


parcelRegister("acnYy", function(module, exports) {

var $h07Ma = parcelRequire("h07Ma");

var $6NPVs = parcelRequire("6NPVs");
var $76cd9f746a36ba44$export$fc70efcec537be98 = (0, $6NPVs.cubehelixLong)((0, $h07Ma.default)(-100, 0.75, 0.35), (0, $h07Ma.default)(80, 1.50, 0.8));
var $76cd9f746a36ba44$export$c5cedbc1ab3be2c3 = (0, $6NPVs.cubehelixLong)((0, $h07Ma.default)(260, 0.75, 0.35), (0, $h07Ma.default)(80, 1.50, 0.8));
var $76cd9f746a36ba44$var$rainbow = (0, $h07Ma.default)();
function $76cd9f746a36ba44$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $76cd9f746a36ba44$var$rainbow.h = 360 * t - 100;
    $76cd9f746a36ba44$var$rainbow.s = 1.5 - 1.5 * ts;
    $76cd9f746a36ba44$var$rainbow.l = 0.8 - 0.9 * ts;
    return $76cd9f746a36ba44$var$rainbow + "";
}

});

parcelRegister("hTAJK", function(module, exports) {

var $gK4CI = parcelRequire("gK4CI");
function $d07411e514f5cd8b$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $d07411e514f5cd8b$export$2e2bcd8739ae039 = $d07411e514f5cd8b$var$ramp((0, $gK4CI.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $d07411e514f5cd8b$export$c41e69203f572e8d = $d07411e514f5cd8b$var$ramp((0, $gK4CI.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $d07411e514f5cd8b$export$ad0c8285c8ea6dbd = $d07411e514f5cd8b$var$ramp((0, $gK4CI.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $d07411e514f5cd8b$export$6664860a633d9daf = $d07411e514f5cd8b$var$ramp((0, $gK4CI.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

});

parcelRegister("gohzG", function(module, exports) {

var $cQ6wP = parcelRequire("cQ6wP");
function $beec852a2e1aebd1$export$2e2bcd8739ae039(interpolator) {
    var x0 = 0, x1 = 1, clamp = false;
    function scale(x) {
        var t = (x - x0) / (x1 - x0);
        return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return $beec852a2e1aebd1$export$2e2bcd8739ae039(interpolator).domain([
            x0,
            x1
        ]).clamp(clamp);
    };
    return (0, $cQ6wP.linearish)(scale);
}

});


parcelRegister("bGdDD", function(module, exports) {

var $1aMBt = parcelRequire("1aMBt");

var $bX5dz = parcelRequire("bX5dz");

var $6JkI6 = parcelRequire("6JkI6");

var $7jrWt = parcelRequire("7jrWt");

var $5XzBI = parcelRequire("5XzBI");

var $cbCW0 = parcelRequire("cbCW0");

var $3hJ4A = parcelRequire("3hJ4A");

var $goBzB = parcelRequire("goBzB");

var $iYSOk = parcelRequire("iYSOk");

var $j4aRi = parcelRequire("j4aRi");

var $dkAvv = parcelRequire("dkAvv");

var $3rDBG = parcelRequire("3rDBG");

var $iszkA = parcelRequire("iszkA");

var $cpkMQ = parcelRequire("cpkMQ");

var $hKz3u = parcelRequire("hKz3u");

var $kR6LU = parcelRequire("kR6LU");

var $kW83d = parcelRequire("kW83d");

var $gMBWy = parcelRequire("gMBWy");

});
parcelRegister("1aMBt", function(module, exports) {

var $bX5dz = parcelRequire("bX5dz");

var $iYSOk = parcelRequire("iYSOk");
function $0dac6d3e4c278064$export$2e2bcd8739ae039(name) {
    return (0, $iYSOk.default)((0, $bX5dz.default)(name).call(document.documentElement));
}

});
parcelRegister("bX5dz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b39408acce9bd07$export$2e2bcd8739ae039);

var $cbCW0 = parcelRequire("cbCW0");

var $3hJ4A = parcelRequire("3hJ4A");
function $8b39408acce9bd07$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $3hJ4A.xhtml) && document.documentElement.namespaceURI === (0, $3hJ4A.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8b39408acce9bd07$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8b39408acce9bd07$export$2e2bcd8739ae039(name) {
    var fullname = (0, $cbCW0.default)(name);
    return (fullname.local ? $8b39408acce9bd07$var$creatorFixed : $8b39408acce9bd07$var$creatorInherit)(fullname);
}

});
parcelRegister("cbCW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df4b6b32a22f9e1$export$2e2bcd8739ae039);

var $3hJ4A = parcelRequire("3hJ4A");
function $8df4b6b32a22f9e1$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $3hJ4A.default).hasOwnProperty(prefix) ? {
        space: (0, $3hJ4A.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("3hJ4A", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $2645ec2a9bd138b4$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $2645ec2a9bd138b4$export$2e2bcd8739ae039);
var $2645ec2a9bd138b4$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $2645ec2a9bd138b4$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $2645ec2a9bd138b4$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("iYSOk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1858dd40d4d714$export$2e2bcd8739ae039);

var $dkAvv = parcelRequire("dkAvv");
function $dd1858dd40d4d714$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $dkAvv.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $dkAvv.Selection)([
        [
            selector
        ]
    ], (0, $dkAvv.root));
}

});
parcelRegister("dkAvv", function(module, exports) {

$parcel$export(module.exports, "root", () => $9b497633580acd16$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $9b497633580acd16$export$52baac22726c72bf);

var $f9k9L = parcelRequire("f9k9L");

var $dWi1a = parcelRequire("dWi1a");

var $lfDbm = parcelRequire("lfDbm");

var $7GrJU = parcelRequire("7GrJU");

var $8RLYv = parcelRequire("8RLYv");

var $89iC5 = parcelRequire("89iC5");

var $cYhWw = parcelRequire("cYhWw");

var $gZZqZ = parcelRequire("gZZqZ");

var $6KMA1 = parcelRequire("6KMA1");

var $hF3NT = parcelRequire("hF3NT");

var $eikYH = parcelRequire("eikYH");

var $dYVmP = parcelRequire("dYVmP");

var $9pwHH = parcelRequire("9pwHH");

var $b96uN = parcelRequire("b96uN");

var $7xwKI = parcelRequire("7xwKI");

var $6XL0r = parcelRequire("6XL0r");

var $cpkMQ = parcelRequire("cpkMQ");

var $4g8nF = parcelRequire("4g8nF");

var $bfOrt = parcelRequire("bfOrt");

var $7s8T0 = parcelRequire("7s8T0");

var $5LpTm = parcelRequire("5LpTm");

var $lbvnL = parcelRequire("lbvnL");

var $91H6R = parcelRequire("91H6R");

var $lJGxu = parcelRequire("lJGxu");

var $jwaQj = parcelRequire("jwaQj");

var $huPk7 = parcelRequire("huPk7");

var $iZ1iQ = parcelRequire("iZ1iQ");

var $caF24 = parcelRequire("caF24");

var $gMBWy = parcelRequire("gMBWy");

var $14BKM = parcelRequire("14BKM");
var $9b497633580acd16$export$e8e78c978b129247 = [
    null
];
function $9b497633580acd16$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $9b497633580acd16$var$selection() {
    return new $9b497633580acd16$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $9b497633580acd16$export$e8e78c978b129247);
}
$9b497633580acd16$export$52baac22726c72bf.prototype = $9b497633580acd16$var$selection.prototype = {
    constructor: $9b497633580acd16$export$52baac22726c72bf,
    select: (0, $f9k9L.default),
    selectAll: (0, $dWi1a.default),
    filter: (0, $lfDbm.default),
    data: (0, $7GrJU.default),
    enter: (0, $8RLYv.default),
    exit: (0, $89iC5.default),
    merge: (0, $cYhWw.default),
    order: (0, $gZZqZ.default),
    sort: (0, $6KMA1.default),
    call: (0, $hF3NT.default),
    nodes: (0, $eikYH.default),
    node: (0, $dYVmP.default),
    size: (0, $9pwHH.default),
    empty: (0, $b96uN.default),
    each: (0, $7xwKI.default),
    attr: (0, $6XL0r.default),
    style: (0, $cpkMQ.default),
    property: (0, $4g8nF.default),
    classed: (0, $bfOrt.default),
    text: (0, $7s8T0.default),
    html: (0, $5LpTm.default),
    raise: (0, $lbvnL.default),
    lower: (0, $91H6R.default),
    append: (0, $lJGxu.default),
    insert: (0, $jwaQj.default),
    remove: (0, $huPk7.default),
    clone: (0, $iZ1iQ.default),
    datum: (0, $caF24.default),
    on: (0, $gMBWy.default),
    dispatch: (0, $14BKM.default)
};
var $9b497633580acd16$export$2e2bcd8739ae039 = $9b497633580acd16$var$selection;

});
parcelRegister("f9k9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07754f47c207fd4$export$2e2bcd8739ae039);

var $dkAvv = parcelRequire("dkAvv");

var $3rDBG = parcelRequire("3rDBG");
function $b07754f47c207fd4$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $3rDBG.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $dkAvv.Selection)(subgroups, this._parents);
}

});
parcelRegister("3rDBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $28229dcc2f864a46$export$2e2bcd8739ae039);
function $28229dcc2f864a46$var$none() {}
function $28229dcc2f864a46$export$2e2bcd8739ae039(selector) {
    return selector == null ? $28229dcc2f864a46$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("dWi1a", function(module, exports) {

$parcel$export(module.exports, "default", () => $a25eab177eccb55d$export$2e2bcd8739ae039);

var $dkAvv = parcelRequire("dkAvv");

var $iszkA = parcelRequire("iszkA");
function $a25eab177eccb55d$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $iszkA.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $dkAvv.Selection)(subgroups, parents);
}

});
parcelRegister("iszkA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7063f8ba02c8149$export$2e2bcd8739ae039);
function $d7063f8ba02c8149$var$empty() {
    return [];
}
function $d7063f8ba02c8149$export$2e2bcd8739ae039(selector) {
    return selector == null ? $d7063f8ba02c8149$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("lfDbm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7896476ad9803c2$export$2e2bcd8739ae039);

var $dkAvv = parcelRequire("dkAvv");

var $7jrWt = parcelRequire("7jrWt");
function $f7896476ad9803c2$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $7jrWt.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $dkAvv.Selection)(subgroups, this._parents);
}

});
parcelRegister("7jrWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $552ffb79bfab8b87$export$2e2bcd8739ae039);
var $552ffb79bfab8b87$var$matcher = function(selector) {
    return function() {
        return this.matches(selector);
    };
};
if (typeof document !== "undefined") {
    var $552ffb79bfab8b87$var$element = document.documentElement;
    if (!$552ffb79bfab8b87$var$element.matches) {
        var $552ffb79bfab8b87$var$vendorMatches = $552ffb79bfab8b87$var$element.webkitMatchesSelector || $552ffb79bfab8b87$var$element.msMatchesSelector || $552ffb79bfab8b87$var$element.mozMatchesSelector || $552ffb79bfab8b87$var$element.oMatchesSelector;
        $552ffb79bfab8b87$var$matcher = function(selector) {
            return function() {
                return $552ffb79bfab8b87$var$vendorMatches.call(this, selector);
            };
        };
    }
}
var $552ffb79bfab8b87$export$2e2bcd8739ae039 = $552ffb79bfab8b87$var$matcher;

});


parcelRegister("7GrJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5981f91b9cf1c1dd$export$2e2bcd8739ae039);

var $dkAvv = parcelRequire("dkAvv");

var $8RLYv = parcelRequire("8RLYv");

var $j9bG3 = parcelRequire("j9bG3");
var $5981f91b9cf1c1dd$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $5981f91b9cf1c1dd$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $8RLYv.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $5981f91b9cf1c1dd$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $5981f91b9cf1c1dd$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $5981f91b9cf1c1dd$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $8RLYv.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $5981f91b9cf1c1dd$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $5981f91b9cf1c1dd$var$bindKey : $5981f91b9cf1c1dd$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $j9bG3.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $dkAvv.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("8RLYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $67487ccd0411af9d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $67487ccd0411af9d$export$67b01759a14cf6a4);

var $9Jmzi = parcelRequire("9Jmzi");

var $dkAvv = parcelRequire("dkAvv");
function $67487ccd0411af9d$export$2e2bcd8739ae039() {
    return new (0, $dkAvv.Selection)(this._enter || this._groups.map((0, $9Jmzi.default)), this._parents);
}
function $67487ccd0411af9d$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$67487ccd0411af9d$export$67b01759a14cf6a4.prototype = {
    constructor: $67487ccd0411af9d$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("9Jmzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7159d29eda824028$export$2e2bcd8739ae039);
function $7159d29eda824028$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("j9bG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $df07ea72fd940820$export$2e2bcd8739ae039);
function $df07ea72fd940820$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("89iC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eed9a36773a9347$export$2e2bcd8739ae039);

var $9Jmzi = parcelRequire("9Jmzi");

var $dkAvv = parcelRequire("dkAvv");
function $5eed9a36773a9347$export$2e2bcd8739ae039() {
    return new (0, $dkAvv.Selection)(this._exit || this._groups.map((0, $9Jmzi.default)), this._parents);
}

});

parcelRegister("cYhWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $971901b9b4e499e2$export$2e2bcd8739ae039);

var $dkAvv = parcelRequire("dkAvv");
function $971901b9b4e499e2$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $dkAvv.Selection)(merges, this._parents);
}

});

parcelRegister("gZZqZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c601ff6fd11fec25$export$2e2bcd8739ae039);
function $c601ff6fd11fec25$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("6KMA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eacb8e866046454$export$2e2bcd8739ae039);

var $dkAvv = parcelRequire("dkAvv");
function $4eacb8e866046454$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $4eacb8e866046454$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $dkAvv.Selection)(sortgroups, this._parents).order();
}
function $4eacb8e866046454$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("hF3NT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdb9375eadc17f72$export$2e2bcd8739ae039);
function $cdb9375eadc17f72$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("eikYH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68304f175edae56$export$2e2bcd8739ae039);
function $a68304f175edae56$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("dYVmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2dd60e13989bc20$export$2e2bcd8739ae039);
function $a2dd60e13989bc20$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("9pwHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d9fd12c84464614$export$2e2bcd8739ae039);
function $6d9fd12c84464614$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("b96uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d592dd06e78103$export$2e2bcd8739ae039);
function $81d592dd06e78103$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("7xwKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $57d505717b00f97e$export$2e2bcd8739ae039);
function $57d505717b00f97e$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("6XL0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $511cb730adec5638$export$2e2bcd8739ae039);

var $cbCW0 = parcelRequire("cbCW0");
function $511cb730adec5638$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $511cb730adec5638$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $511cb730adec5638$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $511cb730adec5638$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $511cb730adec5638$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $511cb730adec5638$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $511cb730adec5638$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $cbCW0.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $511cb730adec5638$var$attrRemoveNS : $511cb730adec5638$var$attrRemove : typeof value === "function" ? fullname.local ? $511cb730adec5638$var$attrFunctionNS : $511cb730adec5638$var$attrFunction : fullname.local ? $511cb730adec5638$var$attrConstantNS : $511cb730adec5638$var$attrConstant)(fullname, value));
}

});

parcelRegister("cpkMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9087f1aa3fb52702$export$2e2bcd8739ae039);

var $kW83d = parcelRequire("kW83d");
function $9087f1aa3fb52702$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $9087f1aa3fb52702$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $9087f1aa3fb52702$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $9087f1aa3fb52702$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $9087f1aa3fb52702$var$styleRemove : typeof value === "function" ? $9087f1aa3fb52702$var$styleFunction : $9087f1aa3fb52702$var$styleConstant)(name, value, priority == null ? "" : priority)) : $9087f1aa3fb52702$export$5e3cec964f0b5efd(this.node(), name);
}
function $9087f1aa3fb52702$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $kW83d.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("kW83d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3df7825dada7a18$export$2e2bcd8739ae039);
function $f3df7825dada7a18$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("4g8nF", function(module, exports) {

$parcel$export(module.exports, "default", () => $319f2849b4f66750$export$2e2bcd8739ae039);
function $319f2849b4f66750$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $319f2849b4f66750$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $319f2849b4f66750$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $319f2849b4f66750$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $319f2849b4f66750$var$propertyRemove : typeof value === "function" ? $319f2849b4f66750$var$propertyFunction : $319f2849b4f66750$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("bfOrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8318392f5f5d6a2e$export$2e2bcd8739ae039);
function $8318392f5f5d6a2e$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $8318392f5f5d6a2e$var$classList(node) {
    return node.classList || new $8318392f5f5d6a2e$var$ClassList(node);
}
function $8318392f5f5d6a2e$var$ClassList(node) {
    this._node = node;
    this._names = $8318392f5f5d6a2e$var$classArray(node.getAttribute("class") || "");
}
$8318392f5f5d6a2e$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $8318392f5f5d6a2e$var$classedAdd(node, names) {
    var list = $8318392f5f5d6a2e$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $8318392f5f5d6a2e$var$classedRemove(node, names) {
    var list = $8318392f5f5d6a2e$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $8318392f5f5d6a2e$var$classedTrue(names) {
    return function() {
        $8318392f5f5d6a2e$var$classedAdd(this, names);
    };
}
function $8318392f5f5d6a2e$var$classedFalse(names) {
    return function() {
        $8318392f5f5d6a2e$var$classedRemove(this, names);
    };
}
function $8318392f5f5d6a2e$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $8318392f5f5d6a2e$var$classedAdd : $8318392f5f5d6a2e$var$classedRemove)(this, names);
    };
}
function $8318392f5f5d6a2e$export$2e2bcd8739ae039(name, value) {
    var names = $8318392f5f5d6a2e$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $8318392f5f5d6a2e$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $8318392f5f5d6a2e$var$classedFunction : value ? $8318392f5f5d6a2e$var$classedTrue : $8318392f5f5d6a2e$var$classedFalse)(names, value));
}

});

parcelRegister("7s8T0", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d20a8ff4c0c54c$export$2e2bcd8739ae039);
function $56d20a8ff4c0c54c$var$textRemove() {
    this.textContent = "";
}
function $56d20a8ff4c0c54c$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $56d20a8ff4c0c54c$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $56d20a8ff4c0c54c$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $56d20a8ff4c0c54c$var$textRemove : (typeof value === "function" ? $56d20a8ff4c0c54c$var$textFunction : $56d20a8ff4c0c54c$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("5LpTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $43256d2479c714fc$export$2e2bcd8739ae039);
function $43256d2479c714fc$var$htmlRemove() {
    this.innerHTML = "";
}
function $43256d2479c714fc$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $43256d2479c714fc$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $43256d2479c714fc$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $43256d2479c714fc$var$htmlRemove : (typeof value === "function" ? $43256d2479c714fc$var$htmlFunction : $43256d2479c714fc$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("lbvnL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6c2f7f268b02894$export$2e2bcd8739ae039);
function $f6c2f7f268b02894$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $f6c2f7f268b02894$export$2e2bcd8739ae039() {
    return this.each($f6c2f7f268b02894$var$raise);
}

});

parcelRegister("91H6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $6925a5bed126d5cf$export$2e2bcd8739ae039);
function $6925a5bed126d5cf$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $6925a5bed126d5cf$export$2e2bcd8739ae039() {
    return this.each($6925a5bed126d5cf$var$lower);
}

});

parcelRegister("lJGxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd2ecc556444105a$export$2e2bcd8739ae039);

var $bX5dz = parcelRequire("bX5dz");
function $fd2ecc556444105a$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $bX5dz.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});

parcelRegister("jwaQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3596a9eb92c6dae$export$2e2bcd8739ae039);

var $bX5dz = parcelRequire("bX5dz");

var $3rDBG = parcelRequire("3rDBG");
function $e3596a9eb92c6dae$var$constantNull() {
    return null;
}
function $e3596a9eb92c6dae$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $bX5dz.default)(name), select = before == null ? $e3596a9eb92c6dae$var$constantNull : typeof before === "function" ? before : (0, $3rDBG.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("huPk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbcd0cc90be848be$export$2e2bcd8739ae039);
function $cbcd0cc90be848be$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $cbcd0cc90be848be$export$2e2bcd8739ae039() {
    return this.each($cbcd0cc90be848be$var$remove);
}

});

parcelRegister("iZ1iQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1eef3f135635ac$export$2e2bcd8739ae039);
function $dd1eef3f135635ac$var$selection_cloneShallow() {
    return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}
function $dd1eef3f135635ac$var$selection_cloneDeep() {
    return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}
function $dd1eef3f135635ac$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $dd1eef3f135635ac$var$selection_cloneDeep : $dd1eef3f135635ac$var$selection_cloneShallow);
}

});

parcelRegister("caF24", function(module, exports) {

$parcel$export(module.exports, "default", () => $0249641e89e6dc56$export$2e2bcd8739ae039);
function $0249641e89e6dc56$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("gMBWy", function(module, exports) {

$parcel$export(module.exports, "event", () => $c37e8fcbcaa35be3$export$6cd530ed55e06764);
$parcel$export(module.exports, "default", () => $c37e8fcbcaa35be3$export$2e2bcd8739ae039);
var $c37e8fcbcaa35be3$var$filterEvents = {};
var $c37e8fcbcaa35be3$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $c37e8fcbcaa35be3$var$element = document.documentElement;
    if (!("onmouseenter" in $c37e8fcbcaa35be3$var$element)) $c37e8fcbcaa35be3$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $c37e8fcbcaa35be3$var$filterContextListener(listener, index, group) {
    listener = $c37e8fcbcaa35be3$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $c37e8fcbcaa35be3$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $c37e8fcbcaa35be3$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $c37e8fcbcaa35be3$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $c37e8fcbcaa35be3$export$6cd530ed55e06764 = event0;
        }
    };
}
function $c37e8fcbcaa35be3$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $c37e8fcbcaa35be3$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $c37e8fcbcaa35be3$var$onAdd(typename, value, capture) {
    var wrap = $c37e8fcbcaa35be3$var$filterEvents.hasOwnProperty(typename.type) ? $c37e8fcbcaa35be3$var$filterContextListener : $c37e8fcbcaa35be3$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $c37e8fcbcaa35be3$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $c37e8fcbcaa35be3$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $c37e8fcbcaa35be3$var$onAdd : $c37e8fcbcaa35be3$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $c37e8fcbcaa35be3$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $c37e8fcbcaa35be3$export$6cd530ed55e06764;
    event1.sourceEvent = $c37e8fcbcaa35be3$export$6cd530ed55e06764;
    $c37e8fcbcaa35be3$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $c37e8fcbcaa35be3$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("14BKM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c837338c69fb8aa$export$2e2bcd8739ae039);

var $kW83d = parcelRequire("kW83d");
function $0c837338c69fb8aa$var$dispatchEvent(node, type, params) {
    var window = (0, $kW83d.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $0c837338c69fb8aa$var$dispatchConstant(type, params) {
    return function() {
        return $0c837338c69fb8aa$var$dispatchEvent(this, type, params);
    };
}
function $0c837338c69fb8aa$var$dispatchFunction(type, params) {
    return function() {
        return $0c837338c69fb8aa$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $0c837338c69fb8aa$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $0c837338c69fb8aa$var$dispatchFunction : $0c837338c69fb8aa$var$dispatchConstant)(type, params));
}

});




parcelRegister("6JkI6", function(module, exports) {
var $4e6702ab34c36e03$var$nextId = 0;
function $4e6702ab34c36e03$export$2e2bcd8739ae039() {
    return new $4e6702ab34c36e03$var$Local;
}
function $4e6702ab34c36e03$var$Local() {
    this._ = "@" + (++$4e6702ab34c36e03$var$nextId).toString(36);
}
$4e6702ab34c36e03$var$Local.prototype = $4e6702ab34c36e03$export$2e2bcd8739ae039.prototype = {
    constructor: $4e6702ab34c36e03$var$Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

});

parcelRegister("5XzBI", function(module, exports) {

var $1CGOK = parcelRequire("1CGOK");

var $goBzB = parcelRequire("goBzB");
function $456e154b7d1df018$export$2e2bcd8739ae039(node) {
    var event = (0, $1CGOK.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $goBzB.default)(node, event);
}

});
parcelRegister("1CGOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ea8db7478d4205$export$2e2bcd8739ae039);

var $gMBWy = parcelRequire("gMBWy");
function $12ea8db7478d4205$export$2e2bcd8739ae039() {
    var current = (0, $gMBWy.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("goBzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $befc087c11a4beab$export$2e2bcd8739ae039);
function $befc087c11a4beab$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("j4aRi", function(module, exports) {

var $dkAvv = parcelRequire("dkAvv");
function $de16d059ff68b8a1$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $dkAvv.Selection)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $dkAvv.Selection)([
        selector == null ? [] : selector
    ], (0, $dkAvv.root));
}

});

parcelRegister("hKz3u", function(module, exports) {

var $1CGOK = parcelRequire("1CGOK");

var $goBzB = parcelRequire("goBzB");
function $cec1eccb7c5bec5d$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $1CGOK.default)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $goBzB.default)(node, touch);
    }
    return null;
}

});

parcelRegister("kR6LU", function(module, exports) {

var $1CGOK = parcelRequire("1CGOK");

var $goBzB = parcelRequire("goBzB");
function $f2ee029ccedaef07$export$2e2bcd8739ae039(node, touches) {
    if (touches == null) touches = (0, $1CGOK.default)().touches;
    for(var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i)points[i] = (0, $goBzB.default)(node, touches[i]);
    return points;
}

});


parcelRegister("4dA5O", function(module, exports) {

var $4Yk8j = parcelRequire("4Yk8j");

var $86Dyx = parcelRequire("86Dyx");

var $jREKp = parcelRequire("jREKp");

var $gQFkg = parcelRequire("gQFkg");

var $iGTP5 = parcelRequire("iGTP5");

var $9AqDm = parcelRequire("9AqDm");

var $8ARDp = parcelRequire("8ARDp");

var $dMwNz = parcelRequire("dMwNz");

var $4KqZU = parcelRequire("4KqZU");

var $9d0pj = parcelRequire("9d0pj");

var $8eA5S = parcelRequire("8eA5S");

var $34tKT = parcelRequire("34tKT");

var $i7ebc = parcelRequire("i7ebc");

var $7UEbQ = parcelRequire("7UEbQ");

var $ljekh = parcelRequire("ljekh");

var $1NJ4a = parcelRequire("1NJ4a");

var $yLErv = parcelRequire("yLErv");

var $fz6qh = parcelRequire("fz6qh");

var $2tbPW = parcelRequire("2tbPW");

var $anOYK = parcelRequire("anOYK");

var $7GwZy = parcelRequire("7GwZy");

var $auvMq = parcelRequire("auvMq");

var $8EKmp = parcelRequire("8EKmp");

var $3BzBx = parcelRequire("3BzBx");

var $lgFkl = parcelRequire("lgFkl");

var $c2zwZ = parcelRequire("c2zwZ");

var $h93l9 = parcelRequire("h93l9");

var $iJ8pa = parcelRequire("iJ8pa");

var $9xWrC = parcelRequire("9xWrC");

var $cd1sL = parcelRequire("cd1sL");

var $cBBx7 = parcelRequire("cBBx7");

var $4cLaB = parcelRequire("4cLaB");

var $kLluJ = parcelRequire("kLluJ");

var $1rWoH = parcelRequire("1rWoH");

var $3QQYh = parcelRequire("3QQYh");

var $kbDdk = parcelRequire("kbDdk");

var $OEGAc = parcelRequire("OEGAc");

var $4dEcc = parcelRequire("4dEcc");

var $9CYAy = parcelRequire("9CYAy");

var $6V20Y = parcelRequire("6V20Y");

var $1Tls8 = parcelRequire("1Tls8");

var $b3Gb1 = parcelRequire("b3Gb1");

});
parcelRegister("4Yk8j", function(module, exports) {

var $76PqN = parcelRequire("76PqN");

var $gvXoN = parcelRequire("gvXoN");

var $ioK9O = parcelRequire("ioK9O");
function $39ec6201652110ed$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $39ec6201652110ed$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $39ec6201652110ed$var$arcStartAngle(d) {
    return d.startAngle;
}
function $39ec6201652110ed$var$arcEndAngle(d) {
    return d.endAngle;
}
function $39ec6201652110ed$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $39ec6201652110ed$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $39ec6201652110ed$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $ioK9O.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $ioK9O.sqrt)((0, $ioK9O.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $39ec6201652110ed$export$2e2bcd8739ae039() {
    var innerRadius = $39ec6201652110ed$var$arcInnerRadius, outerRadius = $39ec6201652110ed$var$arcOuterRadius, cornerRadius = (0, $gvXoN.default)(0), padRadius = null, startAngle = $39ec6201652110ed$var$arcStartAngle, endAngle = $39ec6201652110ed$var$arcEndAngle, padAngle = $39ec6201652110ed$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $ioK9O.halfPi), a1 = endAngle.apply(this, arguments) - (0, $ioK9O.halfPi), da = (0, $ioK9O.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $76PqN.default)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $ioK9O.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $ioK9O.tau) - (0, $ioK9O.epsilon)) {
            context.moveTo(r1 * (0, $ioK9O.cos)(a0), r1 * (0, $ioK9O.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $ioK9O.epsilon)) {
                context.moveTo(r0 * (0, $ioK9O.cos)(a1), r0 * (0, $ioK9O.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $ioK9O.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $ioK9O.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $ioK9O.min)((0, $ioK9O.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $ioK9O.epsilon)) {
                var p0 = (0, $ioK9O.asin)(rp / r0 * (0, $ioK9O.sin)(ap)), p1 = (0, $ioK9O.asin)(rp / r1 * (0, $ioK9O.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $ioK9O.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $ioK9O.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $ioK9O.cos)(a01), y01 = r1 * (0, $ioK9O.sin)(a01), x10 = r0 * (0, $ioK9O.cos)(a10), y10 = r0 * (0, $ioK9O.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $ioK9O.epsilon)) {
                var x11 = r1 * (0, $ioK9O.cos)(a11), y11 = r1 * (0, $ioK9O.sin)(a11), x00 = r0 * (0, $ioK9O.cos)(a00), y00 = r0 * (0, $ioK9O.sin)(a00);
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $ioK9O.pi)) {
                    var oc = da0 > (0, $ioK9O.epsilon) ? $39ec6201652110ed$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [
                        x10,
                        y10
                    ], ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $ioK9O.sin)((0, $ioK9O.acos)((ax * bx + ay * by) / ((0, $ioK9O.sqrt)(ax * ax + ay * ay) * (0, $ioK9O.sqrt)(bx * bx + by * by))) / 2), lc = (0, $ioK9O.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $ioK9O.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $ioK9O.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $ioK9O.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $ioK9O.epsilon)) {
                t0 = $39ec6201652110ed$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $39ec6201652110ed$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $ioK9O.atan2)(t0.y01, t0.x01), (0, $ioK9O.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $ioK9O.atan2)(t0.y01, t0.x01), (0, $ioK9O.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $ioK9O.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $ioK9O.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $ioK9O.atan2)(t1.y11, t1.x11), (0, $ioK9O.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $ioK9O.epsilon)) || !(da0 > (0, $ioK9O.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $ioK9O.epsilon)) {
                t0 = $39ec6201652110ed$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $39ec6201652110ed$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $ioK9O.atan2)(t0.y01, t0.x01), (0, $ioK9O.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $ioK9O.atan2)(t0.y01, t0.x01), (0, $ioK9O.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $ioK9O.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $ioK9O.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $ioK9O.atan2)(t1.y11, t1.x11), (0, $ioK9O.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $ioK9O.pi) / 2;
        return [
            (0, $ioK9O.cos)(a) * r,
            (0, $ioK9O.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("76PqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d0fd1a56520952$export$2e2bcd8739ae039);
var $52d0fd1a56520952$var$pi = Math.PI, $52d0fd1a56520952$var$tau = 2 * $52d0fd1a56520952$var$pi, $52d0fd1a56520952$var$epsilon = 1e-6, $52d0fd1a56520952$var$tauEpsilon = $52d0fd1a56520952$var$tau - $52d0fd1a56520952$var$epsilon;
function $52d0fd1a56520952$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $52d0fd1a56520952$var$path() {
    return new $52d0fd1a56520952$var$Path;
}
$52d0fd1a56520952$var$Path.prototype = $52d0fd1a56520952$var$path.prototype = {
    constructor: $52d0fd1a56520952$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $52d0fd1a56520952$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $52d0fd1a56520952$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($52d0fd1a56520952$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $52d0fd1a56520952$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $52d0fd1a56520952$var$epsilon || Math.abs(this._y1 - y0) > $52d0fd1a56520952$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $52d0fd1a56520952$var$tau + $52d0fd1a56520952$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $52d0fd1a56520952$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $52d0fd1a56520952$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $52d0fd1a56520952$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $52d0fd1a56520952$export$2e2bcd8739ae039 = $52d0fd1a56520952$var$path;

});

parcelRegister("gvXoN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05d9df766472e6a$export$2e2bcd8739ae039);
function $c05d9df766472e6a$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("ioK9O", function(module, exports) {

$parcel$export(module.exports, "abs", () => $d64e45bf48adf219$export$2335f513bbd82c6d);
$parcel$export(module.exports, "atan2", () => $d64e45bf48adf219$export$b8b770ee6a0d9760);
$parcel$export(module.exports, "cos", () => $d64e45bf48adf219$export$50d414a77b60d802);
$parcel$export(module.exports, "max", () => $d64e45bf48adf219$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $d64e45bf48adf219$export$96ec731ed4dcb222);
$parcel$export(module.exports, "sin", () => $d64e45bf48adf219$export$5de3937cb4b592ed);
$parcel$export(module.exports, "sqrt", () => $d64e45bf48adf219$export$eba8049fb5020b81);
$parcel$export(module.exports, "epsilon", () => $d64e45bf48adf219$export$6c421550c66a327d);
$parcel$export(module.exports, "pi", () => $d64e45bf48adf219$export$18c7bea995a110f);
$parcel$export(module.exports, "halfPi", () => $d64e45bf48adf219$export$e51408a300e8929a);
$parcel$export(module.exports, "tau", () => $d64e45bf48adf219$export$a4b4b4d4d776fe92);
$parcel$export(module.exports, "acos", () => $d64e45bf48adf219$export$fd6306be3fde5b04);
$parcel$export(module.exports, "asin", () => $d64e45bf48adf219$export$41726bdb1fc63f);
var $d64e45bf48adf219$export$2335f513bbd82c6d = Math.abs;
var $d64e45bf48adf219$export$b8b770ee6a0d9760 = Math.atan2;
var $d64e45bf48adf219$export$50d414a77b60d802 = Math.cos;
var $d64e45bf48adf219$export$8960430cfd85939f = Math.max;
var $d64e45bf48adf219$export$96ec731ed4dcb222 = Math.min;
var $d64e45bf48adf219$export$5de3937cb4b592ed = Math.sin;
var $d64e45bf48adf219$export$eba8049fb5020b81 = Math.sqrt;
var $d64e45bf48adf219$export$6c421550c66a327d = 1e-12;
var $d64e45bf48adf219$export$18c7bea995a110f = Math.PI;
var $d64e45bf48adf219$export$e51408a300e8929a = $d64e45bf48adf219$export$18c7bea995a110f / 2;
var $d64e45bf48adf219$export$a4b4b4d4d776fe92 = 2 * $d64e45bf48adf219$export$18c7bea995a110f;
function $d64e45bf48adf219$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $d64e45bf48adf219$export$18c7bea995a110f : Math.acos(x);
}
function $d64e45bf48adf219$export$41726bdb1fc63f(x) {
    return x >= 1 ? $d64e45bf48adf219$export$e51408a300e8929a : x <= -1 ? -$d64e45bf48adf219$export$e51408a300e8929a : Math.asin(x);
}

});


parcelRegister("86Dyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6d914928c8ee2f$export$2e2bcd8739ae039);

var $76PqN = parcelRequire("76PqN");

var $gvXoN = parcelRequire("gvXoN");

var $iJ8pa = parcelRequire("iJ8pa");

var $jREKp = parcelRequire("jREKp");

var $l2Ukv = parcelRequire("l2Ukv");
function $5e6d914928c8ee2f$export$2e2bcd8739ae039() {
    var x0 = (0, $l2Ukv.x), x1 = null, y0 = (0, $gvXoN.default)(0), y1 = (0, $l2Ukv.y), defined = (0, $gvXoN.default)(true), context = null, curve = (0, $iJ8pa.default), output = null;
    function area(data) {
        var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $76PqN.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $jREKp.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $gvXoN.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("iJ8pa", function(module, exports) {

$parcel$export(module.exports, "default", () => $da22f304ecff12be$export$2e2bcd8739ae039);
function $da22f304ecff12be$var$Linear(context) {
    this._context = context;
}
$da22f304ecff12be$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $da22f304ecff12be$export$2e2bcd8739ae039(context) {
    return new $da22f304ecff12be$var$Linear(context);
}

});

parcelRegister("jREKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e762932bbeee006c$export$2e2bcd8739ae039);

var $76PqN = parcelRequire("76PqN");

var $gvXoN = parcelRequire("gvXoN");

var $iJ8pa = parcelRequire("iJ8pa");

var $l2Ukv = parcelRequire("l2Ukv");
function $e762932bbeee006c$export$2e2bcd8739ae039() {
    var x = (0, $l2Ukv.x), y = (0, $l2Ukv.y), defined = (0, $gvXoN.default)(true), context = null, curve = (0, $iJ8pa.default), output = null;
    function line(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $76PqN.default)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $gvXoN.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("l2Ukv", function(module, exports) {

$parcel$export(module.exports, "x", () => $f5257ac7cdf55740$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $f5257ac7cdf55740$export$4a5767248b18ef41);
function $f5257ac7cdf55740$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $f5257ac7cdf55740$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("gQFkg", function(module, exports) {

var $gvXoN = parcelRequire("gvXoN");

var $hdNhJ = parcelRequire("hdNhJ");

var $bkPLh = parcelRequire("bkPLh");

var $ioK9O = parcelRequire("ioK9O");
function $c4418f247b963951$export$2e2bcd8739ae039() {
    var value = (0, $bkPLh.default), sortValues = (0, $hdNhJ.default), sort = null, startAngle = (0, $gvXoN.default)(0), endAngle = (0, $gvXoN.default)((0, $ioK9O.tau)), padAngle = (0, $gvXoN.default)(0);
    function pie(data) {
        var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $ioK9O.tau), Math.max(-(0, $ioK9O.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("hdNhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c899e18756dc0f11$export$2e2bcd8739ae039);
function $c899e18756dc0f11$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("bkPLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8409b6b944c3f38d$export$2e2bcd8739ae039);
function $8409b6b944c3f38d$export$2e2bcd8739ae039(d) {
    return d;
}

});


parcelRegister("iGTP5", function(module, exports) {

var $csJsT = parcelRequire("csJsT");

var $86Dyx = parcelRequire("86Dyx");

var $9AqDm = parcelRequire("9AqDm");
function $d9b77386c4c6cefa$export$2e2bcd8739ae039() {
    var a = (0, $86Dyx.default)().curve((0, $csJsT.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $9AqDm.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $9AqDm.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $9AqDm.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $9AqDm.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $csJsT.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("csJsT", function(module, exports) {

$parcel$export(module.exports, "curveRadialLinear", () => $912b5df24925901e$export$22d25ffb9fb15b6f);
$parcel$export(module.exports, "default", () => $912b5df24925901e$export$2e2bcd8739ae039);

var $iJ8pa = parcelRequire("iJ8pa");
var $912b5df24925901e$export$22d25ffb9fb15b6f = $912b5df24925901e$export$2e2bcd8739ae039((0, $iJ8pa.default));
function $912b5df24925901e$var$Radial(curve) {
    this._curve = curve;
}
$912b5df24925901e$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $912b5df24925901e$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $912b5df24925901e$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("9AqDm", function(module, exports) {

$parcel$export(module.exports, "lineRadial", () => $6fac22c72aff8256$export$4d8815a75dc8cd4d);

var $csJsT = parcelRequire("csJsT");

var $jREKp = parcelRequire("jREKp");
function $6fac22c72aff8256$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $csJsT.default)(_)) : c()._curve;
    };
    return l;
}
function $6fac22c72aff8256$export$2e2bcd8739ae039() {
    return $6fac22c72aff8256$export$4d8815a75dc8cd4d((0, $jREKp.default)().curve((0, $csJsT.curveRadialLinear)));
}

});


parcelRegister("8ARDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $641b4a419e06f279$export$2e2bcd8739ae039);
function $641b4a419e06f279$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("dMwNz", function(module, exports) {

var $76PqN = parcelRequire("76PqN");

var $dzymJ = parcelRequire("dzymJ");

var $gvXoN = parcelRequire("gvXoN");

var $l2Ukv = parcelRequire("l2Ukv");

var $8ARDp = parcelRequire("8ARDp");
function $a0893326df72e6aa$var$linkSource(d) {
    return d.source;
}
function $a0893326df72e6aa$var$linkTarget(d) {
    return d.target;
}
function $a0893326df72e6aa$var$link(curve) {
    var source = $a0893326df72e6aa$var$linkSource, target = $a0893326df72e6aa$var$linkTarget, x = (0, $l2Ukv.x), y = (0, $l2Ukv.y), context = null;
    function link() {
        var buffer, argv = (0, $dzymJ.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, $76PqN.default)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function $a0893326df72e6aa$var$curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function $a0893326df72e6aa$var$curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function $a0893326df72e6aa$var$curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, $8ARDp.default)(x0, y0), p1 = (0, $8ARDp.default)(x0, y0 = (y0 + y1) / 2), p2 = (0, $8ARDp.default)(x1, y0), p3 = (0, $8ARDp.default)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function $a0893326df72e6aa$export$e7c381889b2cd14d() {
    return $a0893326df72e6aa$var$link($a0893326df72e6aa$var$curveHorizontal);
}
function $a0893326df72e6aa$export$75de4c8c66884e04() {
    return $a0893326df72e6aa$var$link($a0893326df72e6aa$var$curveVertical);
}
function $a0893326df72e6aa$export$7739cfe68d4e0799() {
    var l = $a0893326df72e6aa$var$link($a0893326df72e6aa$var$curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("dzymJ", function(module, exports) {

$parcel$export(module.exports, "slice", () => $9e193388dacd3dd3$export$58adb3bec8346d0f);
var $9e193388dacd3dd3$export$58adb3bec8346d0f = Array.prototype.slice;

});


parcelRegister("4KqZU", function(module, exports) {

var $76PqN = parcelRequire("76PqN");

var $9d0pj = parcelRequire("9d0pj");

var $8eA5S = parcelRequire("8eA5S");

var $34tKT = parcelRequire("34tKT");

var $7UEbQ = parcelRequire("7UEbQ");

var $i7ebc = parcelRequire("i7ebc");

var $ljekh = parcelRequire("ljekh");

var $1NJ4a = parcelRequire("1NJ4a");

var $gvXoN = parcelRequire("gvXoN");
var $375066755245a420$export$47616e9f7f5fe113 = [
    (0, $9d0pj.default),
    (0, $8eA5S.default),
    (0, $34tKT.default),
    (0, $i7ebc.default),
    (0, $7UEbQ.default),
    (0, $ljekh.default),
    (0, $1NJ4a.default)
];
function $375066755245a420$export$2e2bcd8739ae039() {
    var type = (0, $gvXoN.default)((0, $9d0pj.default)), size = (0, $gvXoN.default)(64), context = null;
    function symbol() {
        var buffer;
        if (!context) context = buffer = (0, $76PqN.default)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $gvXoN.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("9d0pj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b45a4d5a77f2d1b$export$2e2bcd8739ae039);

var $ioK9O = parcelRequire("ioK9O");
var $6b45a4d5a77f2d1b$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / (0, $ioK9O.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $ioK9O.tau));
    }
};

});

parcelRegister("8eA5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $5feba10104a972e8$export$2e2bcd8739ae039);
var $5feba10104a972e8$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

});

parcelRegister("34tKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23c8d39e1ad1a10b$export$2e2bcd8739ae039);
var $23c8d39e1ad1a10b$var$tan30 = Math.sqrt(1 / 3), $23c8d39e1ad1a10b$var$tan30_2 = $23c8d39e1ad1a10b$var$tan30 * 2;
var $23c8d39e1ad1a10b$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = Math.sqrt(size / $23c8d39e1ad1a10b$var$tan30_2), x = y * $23c8d39e1ad1a10b$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

});

parcelRegister("7UEbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c2cf046a8a8b2d2$export$2e2bcd8739ae039);

var $ioK9O = parcelRequire("ioK9O");
var $5c2cf046a8a8b2d2$var$ka = 0.89081309152928522810, $5c2cf046a8a8b2d2$var$kr = Math.sin((0, $ioK9O.pi) / 10) / Math.sin(7 * (0, $ioK9O.pi) / 10), $5c2cf046a8a8b2d2$var$kx = Math.sin((0, $ioK9O.tau) / 10) * $5c2cf046a8a8b2d2$var$kr, $5c2cf046a8a8b2d2$var$ky = -Math.cos((0, $ioK9O.tau) / 10) * $5c2cf046a8a8b2d2$var$kr;
var $5c2cf046a8a8b2d2$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size * $5c2cf046a8a8b2d2$var$ka), x = $5c2cf046a8a8b2d2$var$kx * r, y = $5c2cf046a8a8b2d2$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, $ioK9O.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

});

parcelRegister("i7ebc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d303e13cf2695755$export$2e2bcd8739ae039);
var $d303e13cf2695755$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};

});

parcelRegister("ljekh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8367c2fbc7d4e50$export$2e2bcd8739ae039);
var $f8367c2fbc7d4e50$var$sqrt3 = Math.sqrt(3);
var $f8367c2fbc7d4e50$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = -Math.sqrt(size / ($f8367c2fbc7d4e50$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$f8367c2fbc7d4e50$var$sqrt3 * y, -y);
        context.lineTo($f8367c2fbc7d4e50$var$sqrt3 * y, -y);
        context.closePath();
    }
};

});

parcelRegister("1NJ4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $14fd534583681c8c$export$2e2bcd8739ae039);
var $14fd534583681c8c$var$c = -0.5, $14fd534583681c8c$var$s = Math.sqrt(3) / 2, $14fd534583681c8c$var$k = 1 / Math.sqrt(12), $14fd534583681c8c$var$a = ($14fd534583681c8c$var$k / 2 + 1) * 3;
var $14fd534583681c8c$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / $14fd534583681c8c$var$a), x0 = r / 2, y0 = r * $14fd534583681c8c$var$k, x1 = x0, y1 = r * $14fd534583681c8c$var$k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($14fd534583681c8c$var$c * x0 - $14fd534583681c8c$var$s * y0, $14fd534583681c8c$var$s * x0 + $14fd534583681c8c$var$c * y0);
        context.lineTo($14fd534583681c8c$var$c * x1 - $14fd534583681c8c$var$s * y1, $14fd534583681c8c$var$s * x1 + $14fd534583681c8c$var$c * y1);
        context.lineTo($14fd534583681c8c$var$c * x2 - $14fd534583681c8c$var$s * y2, $14fd534583681c8c$var$s * x2 + $14fd534583681c8c$var$c * y2);
        context.lineTo($14fd534583681c8c$var$c * x0 + $14fd534583681c8c$var$s * y0, $14fd534583681c8c$var$c * y0 - $14fd534583681c8c$var$s * x0);
        context.lineTo($14fd534583681c8c$var$c * x1 + $14fd534583681c8c$var$s * y1, $14fd534583681c8c$var$c * y1 - $14fd534583681c8c$var$s * x1);
        context.lineTo($14fd534583681c8c$var$c * x2 + $14fd534583681c8c$var$s * y2, $14fd534583681c8c$var$c * y2 - $14fd534583681c8c$var$s * x2);
        context.closePath();
    }
};

});


parcelRegister("yLErv", function(module, exports) {

var $heDqy = parcelRequire("heDqy");

var $2tbPW = parcelRequire("2tbPW");
function $068823a57bdd971d$var$BasisClosed(context) {
    this._context = context;
}
$068823a57bdd971d$var$BasisClosed.prototype = {
    areaStart: (0, $heDqy.default),
    areaEnd: (0, $heDqy.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $2tbPW.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $068823a57bdd971d$export$2e2bcd8739ae039(context) {
    return new $068823a57bdd971d$var$BasisClosed(context);
}

});
parcelRegister("heDqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c253eeab83bc09$export$2e2bcd8739ae039);
function $c8c253eeab83bc09$export$2e2bcd8739ae039() {}

});

parcelRegister("2tbPW", function(module, exports) {

$parcel$export(module.exports, "point", () => $1cc778b8b7b24c52$export$105684a3041cb6f3);
$parcel$export(module.exports, "Basis", () => $1cc778b8b7b24c52$export$957f7263e89bedd2);
function $1cc778b8b7b24c52$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $1cc778b8b7b24c52$export$957f7263e89bedd2(context) {
    this._context = context;
}
$1cc778b8b7b24c52$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $1cc778b8b7b24c52$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $1cc778b8b7b24c52$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $1cc778b8b7b24c52$export$2e2bcd8739ae039(context) {
    return new $1cc778b8b7b24c52$export$957f7263e89bedd2(context);
}

});


parcelRegister("fz6qh", function(module, exports) {

var $2tbPW = parcelRequire("2tbPW");
function $b54f1b5755e98715$var$BasisOpen(context) {
    this._context = context;
}
$b54f1b5755e98715$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $2tbPW.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $b54f1b5755e98715$export$2e2bcd8739ae039(context) {
    return new $b54f1b5755e98715$var$BasisOpen(context);
}

});

parcelRegister("anOYK", function(module, exports) {

var $2tbPW = parcelRequire("2tbPW");
function $78f398ae3e4c5b3d$var$Bundle(context, beta) {
    this._basis = new (0, $2tbPW.Basis)(context);
    this._beta = beta;
}
$78f398ae3e4c5b3d$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $78f398ae3e4c5b3d$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $2tbPW.Basis)(context) : new $78f398ae3e4c5b3d$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

});

parcelRegister("7GwZy", function(module, exports) {

$parcel$export(module.exports, "CardinalClosed", () => $59860c258b369f50$export$da3940d7e9162858);

var $heDqy = parcelRequire("heDqy");

var $8EKmp = parcelRequire("8EKmp");
function $59860c258b369f50$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$59860c258b369f50$export$da3940d7e9162858.prototype = {
    areaStart: (0, $heDqy.default),
    areaEnd: (0, $heDqy.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $8EKmp.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $59860c258b369f50$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $59860c258b369f50$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});
parcelRegister("8EKmp", function(module, exports) {

$parcel$export(module.exports, "point", () => $64d6056501d8d315$export$105684a3041cb6f3);
$parcel$export(module.exports, "Cardinal", () => $64d6056501d8d315$export$ee51ff373511cbeb);
function $64d6056501d8d315$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $64d6056501d8d315$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$64d6056501d8d315$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $64d6056501d8d315$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $64d6056501d8d315$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $64d6056501d8d315$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $64d6056501d8d315$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("auvMq", function(module, exports) {

$parcel$export(module.exports, "CardinalOpen", () => $7a355b975ef8cc2b$export$cd7d1a617282f2f1);

var $8EKmp = parcelRequire("8EKmp");
function $7a355b975ef8cc2b$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$7a355b975ef8cc2b$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $8EKmp.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $7a355b975ef8cc2b$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $7a355b975ef8cc2b$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});

parcelRegister("3BzBx", function(module, exports) {

var $7GwZy = parcelRequire("7GwZy");

var $heDqy = parcelRequire("heDqy");

var $c2zwZ = parcelRequire("c2zwZ");
function $2a00721c68ad9cf6$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$2a00721c68ad9cf6$var$CatmullRomClosed.prototype = {
    areaStart: (0, $heDqy.default),
    areaEnd: (0, $heDqy.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $c2zwZ.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $2a00721c68ad9cf6$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $2a00721c68ad9cf6$var$CatmullRomClosed(context, alpha) : new (0, $7GwZy.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("c2zwZ", function(module, exports) {

$parcel$export(module.exports, "point", () => point);

var $ioK9O = parcelRequire("ioK9O");

var $8EKmp = parcelRequire("8EKmp");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $ioK9O.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $ioK9O.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $8c413bae10fdc6b3$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $8EKmp.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});


parcelRegister("lgFkl", function(module, exports) {

var $auvMq = parcelRequire("auvMq");

var $c2zwZ = parcelRequire("c2zwZ");
function $f7bb2648d2cf4383$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f7bb2648d2cf4383$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $c2zwZ.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f7bb2648d2cf4383$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f7bb2648d2cf4383$var$CatmullRomOpen(context, alpha) : new (0, $auvMq.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});

parcelRegister("h93l9", function(module, exports) {

var $heDqy = parcelRequire("heDqy");
function $c7b5de3a40b28f27$var$LinearClosed(context) {
    this._context = context;
}
$c7b5de3a40b28f27$var$LinearClosed.prototype = {
    areaStart: (0, $heDqy.default),
    areaEnd: (0, $heDqy.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $c7b5de3a40b28f27$export$2e2bcd8739ae039(context) {
    return new $c7b5de3a40b28f27$var$LinearClosed(context);
}

});

parcelRegister("9xWrC", function(module, exports) {
function $6f3487f682009b75$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $6f3487f682009b75$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($6f3487f682009b75$var$sign(s0) + $6f3487f682009b75$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $6f3487f682009b75$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $6f3487f682009b75$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $6f3487f682009b75$var$MonotoneX(context) {
    this._context = context;
}
$6f3487f682009b75$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $6f3487f682009b75$var$point(this, this._t0, $6f3487f682009b75$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $6f3487f682009b75$var$point(this, $6f3487f682009b75$var$slope2(this, t1 = $6f3487f682009b75$var$slope3(this, x, y)), t1);
                break;
            default:
                $6f3487f682009b75$var$point(this, this._t0, t1 = $6f3487f682009b75$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $6f3487f682009b75$var$MonotoneY(context) {
    this._context = new $6f3487f682009b75$var$ReflectContext(context);
}
($6f3487f682009b75$var$MonotoneY.prototype = Object.create($6f3487f682009b75$var$MonotoneX.prototype)).point = function(x, y) {
    $6f3487f682009b75$var$MonotoneX.prototype.point.call(this, y, x);
};
function $6f3487f682009b75$var$ReflectContext(context) {
    this._context = context;
}
$6f3487f682009b75$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $6f3487f682009b75$export$99563b5420dbdc55(context) {
    return new $6f3487f682009b75$var$MonotoneX(context);
}
function $6f3487f682009b75$export$8b5360456d6bdb88(context) {
    return new $6f3487f682009b75$var$MonotoneY(context);
}

});

parcelRegister("cd1sL", function(module, exports) {
function $8e37d570fa6e1780$var$Natural(context) {
    this._context = context;
}
$8e37d570fa6e1780$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $8e37d570fa6e1780$var$controlPoints(x), py = $8e37d570fa6e1780$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $8e37d570fa6e1780$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $8e37d570fa6e1780$export$2e2bcd8739ae039(context) {
    return new $8e37d570fa6e1780$var$Natural(context);
}

});

parcelRegister("cBBx7", function(module, exports) {
function $92d60e0a9a853607$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$92d60e0a9a853607$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $92d60e0a9a853607$export$2e2bcd8739ae039(context) {
    return new $92d60e0a9a853607$var$Step(context, 0.5);
}
function $92d60e0a9a853607$export$10eafa5b7478b343(context) {
    return new $92d60e0a9a853607$var$Step(context, 0);
}
function $92d60e0a9a853607$export$793b3db073781cbb(context) {
    return new $92d60e0a9a853607$var$Step(context, 1);
}

});

parcelRegister("4cLaB", function(module, exports) {

var $dzymJ = parcelRequire("dzymJ");

var $gvXoN = parcelRequire("gvXoN");

var $3QQYh = parcelRequire("3QQYh");

var $1Tls8 = parcelRequire("1Tls8");
function $30fcdf648b6c0640$var$stackValue(d, key) {
    return d[key];
}
function $30fcdf648b6c0640$export$2e2bcd8739ae039() {
    var keys = (0, $gvXoN.default)([]), order = (0, $1Tls8.default), offset = (0, $3QQYh.default), value = $30fcdf648b6c0640$var$stackValue;
    function stack(data) {
        var kz = keys.apply(this, arguments), i, m = data.length, n = kz.length, sz = new Array(n), oz;
        for(i = 0; i < n; ++i){
            for(var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j){
                si[j] = sij = [
                    0,
                    +value(data[j], ki, j, data)
                ];
                sij.data = data[j];
            }
            si.key = ki;
        }
        for(i = 0, oz = order(sz); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $gvXoN.default)((0, $dzymJ.slice).call(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $gvXoN.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $1Tls8.default) : typeof _ === "function" ? _ : (0, $gvXoN.default)((0, $dzymJ.slice).call(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $3QQYh.default) : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("3QQYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cdf51642a7491a3$export$2e2bcd8739ae039);
function $2cdf51642a7491a3$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("1Tls8", function(module, exports) {

$parcel$export(module.exports, "default", () => $160b919148a6b0a5$export$2e2bcd8739ae039);
function $160b919148a6b0a5$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("kLluJ", function(module, exports) {

var $3QQYh = parcelRequire("3QQYh");
function $f1d8ded8d1c258a4$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $3QQYh.default)(series, order);
}

});

parcelRegister("1rWoH", function(module, exports) {
function $10e59c92274de5ed$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = yp;
    }
}

});

parcelRegister("kbDdk", function(module, exports) {

var $3QQYh = parcelRequire("3QQYh");
function $eb2340d07724ba0e$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $3QQYh.default)(series, order);
}

});

parcelRegister("OEGAc", function(module, exports) {

var $3QQYh = parcelRequire("3QQYh");
function $09843afb8bda26ba$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $3QQYh.default)(series, order);
}

});

parcelRegister("4dEcc", function(module, exports) {

$parcel$export(module.exports, "default", () => $31278e590f489be7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sum", () => $31278e590f489be7$export$8a63f25cc62965f1);

var $1Tls8 = parcelRequire("1Tls8");
function $31278e590f489be7$export$2e2bcd8739ae039(series) {
    var sums = series.map($31278e590f489be7$export$8a63f25cc62965f1);
    return (0, $1Tls8.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $31278e590f489be7$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("9CYAy", function(module, exports) {

var $4dEcc = parcelRequire("4dEcc");
function $7026a950ad24ab65$export$2e2bcd8739ae039(series) {
    return (0, $4dEcc.default)(series).reverse();
}

});

parcelRegister("6V20Y", function(module, exports) {

var $1Tls8 = parcelRequire("1Tls8");

var $4dEcc = parcelRequire("4dEcc");
function $5099a10d24d2805b$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $4dEcc.sum)), order = (0, $1Tls8.default)(series).sort(function(a, b) {
        return sums[b] - sums[a];
    }), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("b3Gb1", function(module, exports) {

var $1Tls8 = parcelRequire("1Tls8");
function $80d0b0f784e71242$export$2e2bcd8739ae039(series) {
    return (0, $1Tls8.default)(series).reverse();
}

});


parcelRegister("fMuq7", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $iFSjD = parcelRequire("iFSjD");

var $7T3TW = parcelRequire("7T3TW");

var $3gFGy = parcelRequire("3gFGy");

var $aBK7d = parcelRequire("aBK7d");

var $krb4U = parcelRequire("krb4U");

var $2Cphk = parcelRequire("2Cphk");

var $g1T1P = parcelRequire("g1T1P");

var $4OwUZ = parcelRequire("4OwUZ");

var $RrQ58 = parcelRequire("RrQ58");

var $a4nNK = parcelRequire("a4nNK");

var $aYhFR = parcelRequire("aYhFR");

var $82ON7 = parcelRequire("82ON7");

var $3MNdX = parcelRequire("3MNdX");

var $6HrVj = parcelRequire("6HrVj");

});
parcelRegister("fsHiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b41b0f8341e9d13d$export$2e2bcd8739ae039);
var $b41b0f8341e9d13d$var$t0 = new Date, $b41b0f8341e9d13d$var$t1 = new Date;
function $b41b0f8341e9d13d$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = new Date(+date)), date;
    }
    interval.floor = interval;
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $b41b0f8341e9d13d$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $b41b0f8341e9d13d$var$t0.setTime(+start), $b41b0f8341e9d13d$var$t1.setTime(+end);
            floori($b41b0f8341e9d13d$var$t0), floori($b41b0f8341e9d13d$var$t1);
            return Math.floor(count($b41b0f8341e9d13d$var$t0, $b41b0f8341e9d13d$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("iFSjD", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");
var $d986304f7a9c44a6$var$millisecond = (0, $fsHiO.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$d986304f7a9c44a6$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $d986304f7a9c44a6$var$millisecond;
    return (0, $fsHiO.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $d986304f7a9c44a6$export$2e2bcd8739ae039 = $d986304f7a9c44a6$var$millisecond;
var $d986304f7a9c44a6$export$9a27fac83d67afd3 = $d986304f7a9c44a6$var$millisecond.range;

});

parcelRegister("7T3TW", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
var $5be0b229cad216d7$var$second = (0, $fsHiO.default)(function(date) {
    date.setTime(Math.floor(date / (0, $b8wM6.durationSecond)) * (0, $b8wM6.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, $b8wM6.durationSecond));
}, function(start, end) {
    return (end - start) / (0, $b8wM6.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var $5be0b229cad216d7$export$2e2bcd8739ae039 = $5be0b229cad216d7$var$second;
var $5be0b229cad216d7$export$4792e48abc550fa1 = $5be0b229cad216d7$var$second.range;

});
parcelRegister("b8wM6", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $81b9dd7a56643c2a$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $81b9dd7a56643c2a$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $81b9dd7a56643c2a$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $81b9dd7a56643c2a$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $81b9dd7a56643c2a$export$c241eb88520d5016);
var $81b9dd7a56643c2a$export$79ef0e34099623dc = 1e3;
var $81b9dd7a56643c2a$export$683905d551c33fa9 = 6e4;
var $81b9dd7a56643c2a$export$4157bf0c8e241659 = 36e5;
var $81b9dd7a56643c2a$export$353686095f4fbf45 = 864e5;
var $81b9dd7a56643c2a$export$c241eb88520d5016 = 6048e5;

});


parcelRegister("3gFGy", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
var $2613338d3ae20ae2$var$minute = (0, $fsHiO.default)(function(date) {
    date.setTime(Math.floor(date / (0, $b8wM6.durationMinute)) * (0, $b8wM6.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, $b8wM6.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $b8wM6.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var $2613338d3ae20ae2$export$2e2bcd8739ae039 = $2613338d3ae20ae2$var$minute;
var $2613338d3ae20ae2$export$666252b437cce0c7 = $2613338d3ae20ae2$var$minute.range;

});

parcelRegister("aBK7d", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
var $7b9121a694f65929$var$hour = (0, $fsHiO.default)(function(date) {
    var offset = date.getTimezoneOffset() * (0, $b8wM6.durationMinute) % (0, $b8wM6.durationHour);
    if (offset < 0) offset += (0, $b8wM6.durationHour);
    date.setTime(Math.floor((+date - offset) / (0, $b8wM6.durationHour)) * (0, $b8wM6.durationHour) + offset);
}, function(date, step) {
    date.setTime(+date + step * (0, $b8wM6.durationHour));
}, function(start, end) {
    return (end - start) / (0, $b8wM6.durationHour);
}, function(date) {
    return date.getHours();
});
var $7b9121a694f65929$export$2e2bcd8739ae039 = $7b9121a694f65929$var$hour;
var $7b9121a694f65929$export$8d468796d69cdad1 = $7b9121a694f65929$var$hour.range;

});

parcelRegister("krb4U", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
var $ee0eec2c9f99f956$var$day = (0, $fsHiO.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $b8wM6.durationMinute)) / (0, $b8wM6.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
var $ee0eec2c9f99f956$export$2e2bcd8739ae039 = $ee0eec2c9f99f956$var$day;
var $ee0eec2c9f99f956$export$3cf5dda4201cc0f2 = $ee0eec2c9f99f956$var$day.range;

});

parcelRegister("2Cphk", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
function $1e82bd2a032d8d8e$var$weekday(i) {
    return (0, $fsHiO.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $b8wM6.durationMinute)) / (0, $b8wM6.durationWeek);
    });
}
var $1e82bd2a032d8d8e$export$fb3ee18ed410cc21 = $1e82bd2a032d8d8e$var$weekday(0);
var $1e82bd2a032d8d8e$export$6416afaab03bc9b8 = $1e82bd2a032d8d8e$var$weekday(1);
var $1e82bd2a032d8d8e$export$cb8f040f5d17ac7b = $1e82bd2a032d8d8e$var$weekday(2);
var $1e82bd2a032d8d8e$export$347581849975dfc8 = $1e82bd2a032d8d8e$var$weekday(3);
var $1e82bd2a032d8d8e$export$2f2b56683a3e5629 = $1e82bd2a032d8d8e$var$weekday(4);
var $1e82bd2a032d8d8e$export$59b8c2ccd931d806 = $1e82bd2a032d8d8e$var$weekday(5);
var $1e82bd2a032d8d8e$export$478ceadebff4d377 = $1e82bd2a032d8d8e$var$weekday(6);
var $1e82bd2a032d8d8e$export$e8daabaa40641211 = $1e82bd2a032d8d8e$export$fb3ee18ed410cc21.range;
var $1e82bd2a032d8d8e$export$74e5b559c235c00e = $1e82bd2a032d8d8e$export$6416afaab03bc9b8.range;
var $1e82bd2a032d8d8e$export$e7d6aa4fb107bc56 = $1e82bd2a032d8d8e$export$cb8f040f5d17ac7b.range;
var $1e82bd2a032d8d8e$export$fcd5880b20bb06a8 = $1e82bd2a032d8d8e$export$347581849975dfc8.range;
var $1e82bd2a032d8d8e$export$682716b7bbe33641 = $1e82bd2a032d8d8e$export$2f2b56683a3e5629.range;
var $1e82bd2a032d8d8e$export$482924968ca86084 = $1e82bd2a032d8d8e$export$59b8c2ccd931d806.range;
var $1e82bd2a032d8d8e$export$7d755172c9cda9d2 = $1e82bd2a032d8d8e$export$478ceadebff4d377.range;

});

parcelRegister("g1T1P", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");
var $bab76cdcf8201d5e$var$month = (0, $fsHiO.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $bab76cdcf8201d5e$export$2e2bcd8739ae039 = $bab76cdcf8201d5e$var$month;
var $bab76cdcf8201d5e$export$16352d1b10c5eb38 = $bab76cdcf8201d5e$var$month.range;

});

parcelRegister("4OwUZ", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");
var $38155dca6a86f877$var$year = (0, $fsHiO.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$38155dca6a86f877$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $fsHiO.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $38155dca6a86f877$export$2e2bcd8739ae039 = $38155dca6a86f877$var$year;
var $38155dca6a86f877$export$6fda41c7fb23acf9 = $38155dca6a86f877$var$year.range;

});

parcelRegister("RrQ58", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
var $0a0a8b9a8427a8de$var$utcMinute = (0, $fsHiO.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $b8wM6.durationMinute));
}, function(start, end) {
    return (end - start) / (0, $b8wM6.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var $0a0a8b9a8427a8de$export$2e2bcd8739ae039 = $0a0a8b9a8427a8de$var$utcMinute;
var $0a0a8b9a8427a8de$export$cedd563624e8ee50 = $0a0a8b9a8427a8de$var$utcMinute.range;

});

parcelRegister("a4nNK", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
var $754cbd934cc3e22f$var$utcHour = (0, $fsHiO.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $b8wM6.durationHour));
}, function(start, end) {
    return (end - start) / (0, $b8wM6.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var $754cbd934cc3e22f$export$2e2bcd8739ae039 = $754cbd934cc3e22f$var$utcHour;
var $754cbd934cc3e22f$export$6e7a76cd5f50b719 = $754cbd934cc3e22f$var$utcHour.range;

});

parcelRegister("aYhFR", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
var $7fcd37afa328b4d8$var$utcDay = (0, $fsHiO.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $b8wM6.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $7fcd37afa328b4d8$export$2e2bcd8739ae039 = $7fcd37afa328b4d8$var$utcDay;
var $7fcd37afa328b4d8$export$d277e198508549a1 = $7fcd37afa328b4d8$var$utcDay.range;

});

parcelRegister("82ON7", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");

var $b8wM6 = parcelRequire("b8wM6");
function $5db5e8b3cfe3b685$var$utcWeekday(i) {
    return (0, $fsHiO.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $b8wM6.durationWeek);
    });
}
var $5db5e8b3cfe3b685$export$4898b06303a92011 = $5db5e8b3cfe3b685$var$utcWeekday(0);
var $5db5e8b3cfe3b685$export$9cfc53b9cfafd080 = $5db5e8b3cfe3b685$var$utcWeekday(1);
var $5db5e8b3cfe3b685$export$2a6d545f77eceb15 = $5db5e8b3cfe3b685$var$utcWeekday(2);
var $5db5e8b3cfe3b685$export$a5c25d8ed64433c4 = $5db5e8b3cfe3b685$var$utcWeekday(3);
var $5db5e8b3cfe3b685$export$1db08111baec2f53 = $5db5e8b3cfe3b685$var$utcWeekday(4);
var $5db5e8b3cfe3b685$export$29265e34dd5921f7 = $5db5e8b3cfe3b685$var$utcWeekday(5);
var $5db5e8b3cfe3b685$export$85b74dad05049604 = $5db5e8b3cfe3b685$var$utcWeekday(6);
var $5db5e8b3cfe3b685$export$6f3e1c2b0f7d7880 = $5db5e8b3cfe3b685$export$4898b06303a92011.range;
var $5db5e8b3cfe3b685$export$1d2d8b858bb366f9 = $5db5e8b3cfe3b685$export$9cfc53b9cfafd080.range;
var $5db5e8b3cfe3b685$export$1d5f6785fc7f30f8 = $5db5e8b3cfe3b685$export$2a6d545f77eceb15.range;
var $5db5e8b3cfe3b685$export$7a75faf0e37ef4af = $5db5e8b3cfe3b685$export$a5c25d8ed64433c4.range;
var $5db5e8b3cfe3b685$export$417eb959611b2f2f = $5db5e8b3cfe3b685$export$1db08111baec2f53.range;
var $5db5e8b3cfe3b685$export$59d308db7af08c64 = $5db5e8b3cfe3b685$export$29265e34dd5921f7.range;
var $5db5e8b3cfe3b685$export$a124108a0a7f34c8 = $5db5e8b3cfe3b685$export$85b74dad05049604.range;

});

parcelRegister("3MNdX", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");
var $2c1c09aaafd3f201$var$utcMonth = (0, $fsHiO.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $2c1c09aaafd3f201$export$2e2bcd8739ae039 = $2c1c09aaafd3f201$var$utcMonth;
var $2c1c09aaafd3f201$export$49159f585997498 = $2c1c09aaafd3f201$var$utcMonth.range;

});

parcelRegister("6HrVj", function(module, exports) {

var $fsHiO = parcelRequire("fsHiO");
var $4e0c6b3ceac4a92f$var$utcYear = (0, $fsHiO.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$4e0c6b3ceac4a92f$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $fsHiO.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $4e0c6b3ceac4a92f$export$2e2bcd8739ae039 = $4e0c6b3ceac4a92f$var$utcYear;
var $4e0c6b3ceac4a92f$export$3e24d311e17f5802 = $4e0c6b3ceac4a92f$var$utcYear.range;

});


parcelRegister("7q3aS", function(module, exports) {

var $lwmlZ = parcelRequire("lwmlZ");

var $cuUJy = parcelRequire("cuUJy");

var $jfFuR = parcelRequire("jfFuR");

var $dHI80 = parcelRequire("dHI80");

});
parcelRegister("lwmlZ", function(module, exports) {

$parcel$export(module.exports, "utcFormat", () => $faaded209c1ef50b$export$1a08fe38f63ebbbb);
$parcel$export(module.exports, "utcParse", () => $faaded209c1ef50b$export$3edae9cf8e233729);

var $cuUJy = parcelRequire("cuUJy");
var $faaded209c1ef50b$var$locale;
var $faaded209c1ef50b$export$94f4d87fad5dcf9a;
var $faaded209c1ef50b$export$32b9cd16e1b8c8d2;
var $faaded209c1ef50b$export$1a08fe38f63ebbbb;
var $faaded209c1ef50b$export$3edae9cf8e233729;
$faaded209c1ef50b$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $faaded209c1ef50b$export$2e2bcd8739ae039(definition) {
    $faaded209c1ef50b$var$locale = (0, $cuUJy.default)(definition);
    $faaded209c1ef50b$export$94f4d87fad5dcf9a = $faaded209c1ef50b$var$locale.format;
    $faaded209c1ef50b$export$32b9cd16e1b8c8d2 = $faaded209c1ef50b$var$locale.parse;
    $faaded209c1ef50b$export$1a08fe38f63ebbbb = $faaded209c1ef50b$var$locale.utcFormat;
    $faaded209c1ef50b$export$3edae9cf8e233729 = $faaded209c1ef50b$var$locale.utcParse;
    return $faaded209c1ef50b$var$locale;
}

});
parcelRegister("cuUJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $91944b830a2fdf61$export$2e2bcd8739ae039);

var $fucbR = parcelRequire("fucbR");
var $hHoaP = parcelRequire("hHoaP");
var $7BX5j = parcelRequire("7BX5j");
var $kTmIK = parcelRequire("kTmIK");
var $3G5QG = parcelRequire("3G5QG");
var $hiuwV = parcelRequire("hiuwV");
function $91944b830a2fdf61$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $91944b830a2fdf61$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $91944b830a2fdf61$var$newYear(y) {
    return {
        y: y,
        m: 0,
        d: 1,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $91944b830a2fdf61$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $91944b830a2fdf61$var$formatRe(locale_periods), periodLookup = $91944b830a2fdf61$var$formatLookup(locale_periods), weekdayRe = $91944b830a2fdf61$var$formatRe(locale_weekdays), weekdayLookup = $91944b830a2fdf61$var$formatLookup(locale_weekdays), shortWeekdayRe = $91944b830a2fdf61$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $91944b830a2fdf61$var$formatLookup(locale_shortWeekdays), monthRe = $91944b830a2fdf61$var$formatRe(locale_months), monthLookup = $91944b830a2fdf61$var$formatLookup(locale_months), shortMonthRe = $91944b830a2fdf61$var$formatRe(locale_shortMonths), shortMonthLookup = $91944b830a2fdf61$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $91944b830a2fdf61$var$formatDayOfMonth,
        "e": $91944b830a2fdf61$var$formatDayOfMonth,
        "f": $91944b830a2fdf61$var$formatMicroseconds,
        "H": $91944b830a2fdf61$var$formatHour24,
        "I": $91944b830a2fdf61$var$formatHour12,
        "j": $91944b830a2fdf61$var$formatDayOfYear,
        "L": $91944b830a2fdf61$var$formatMilliseconds,
        "m": $91944b830a2fdf61$var$formatMonthNumber,
        "M": $91944b830a2fdf61$var$formatMinutes,
        "p": formatPeriod,
        "Q": $91944b830a2fdf61$var$formatUnixTimestamp,
        "s": $91944b830a2fdf61$var$formatUnixTimestampSeconds,
        "S": $91944b830a2fdf61$var$formatSeconds,
        "u": $91944b830a2fdf61$var$formatWeekdayNumberMonday,
        "U": $91944b830a2fdf61$var$formatWeekNumberSunday,
        "V": $91944b830a2fdf61$var$formatWeekNumberISO,
        "w": $91944b830a2fdf61$var$formatWeekdayNumberSunday,
        "W": $91944b830a2fdf61$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $91944b830a2fdf61$var$formatYear,
        "Y": $91944b830a2fdf61$var$formatFullYear,
        "Z": $91944b830a2fdf61$var$formatZone,
        "%": $91944b830a2fdf61$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $91944b830a2fdf61$var$formatUTCDayOfMonth,
        "e": $91944b830a2fdf61$var$formatUTCDayOfMonth,
        "f": $91944b830a2fdf61$var$formatUTCMicroseconds,
        "H": $91944b830a2fdf61$var$formatUTCHour24,
        "I": $91944b830a2fdf61$var$formatUTCHour12,
        "j": $91944b830a2fdf61$var$formatUTCDayOfYear,
        "L": $91944b830a2fdf61$var$formatUTCMilliseconds,
        "m": $91944b830a2fdf61$var$formatUTCMonthNumber,
        "M": $91944b830a2fdf61$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "Q": $91944b830a2fdf61$var$formatUnixTimestamp,
        "s": $91944b830a2fdf61$var$formatUnixTimestampSeconds,
        "S": $91944b830a2fdf61$var$formatUTCSeconds,
        "u": $91944b830a2fdf61$var$formatUTCWeekdayNumberMonday,
        "U": $91944b830a2fdf61$var$formatUTCWeekNumberSunday,
        "V": $91944b830a2fdf61$var$formatUTCWeekNumberISO,
        "w": $91944b830a2fdf61$var$formatUTCWeekdayNumberSunday,
        "W": $91944b830a2fdf61$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $91944b830a2fdf61$var$formatUTCYear,
        "Y": $91944b830a2fdf61$var$formatUTCFullYear,
        "Z": $91944b830a2fdf61$var$formatUTCZone,
        "%": $91944b830a2fdf61$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $91944b830a2fdf61$var$parseDayOfMonth,
        "e": $91944b830a2fdf61$var$parseDayOfMonth,
        "f": $91944b830a2fdf61$var$parseMicroseconds,
        "H": $91944b830a2fdf61$var$parseHour24,
        "I": $91944b830a2fdf61$var$parseHour24,
        "j": $91944b830a2fdf61$var$parseDayOfYear,
        "L": $91944b830a2fdf61$var$parseMilliseconds,
        "m": $91944b830a2fdf61$var$parseMonthNumber,
        "M": $91944b830a2fdf61$var$parseMinutes,
        "p": parsePeriod,
        "Q": $91944b830a2fdf61$var$parseUnixTimestamp,
        "s": $91944b830a2fdf61$var$parseUnixTimestampSeconds,
        "S": $91944b830a2fdf61$var$parseSeconds,
        "u": $91944b830a2fdf61$var$parseWeekdayNumberMonday,
        "U": $91944b830a2fdf61$var$parseWeekNumberSunday,
        "V": $91944b830a2fdf61$var$parseWeekNumberISO,
        "w": $91944b830a2fdf61$var$parseWeekdayNumberSunday,
        "W": $91944b830a2fdf61$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $91944b830a2fdf61$var$parseYear,
        "Y": $91944b830a2fdf61$var$parseFullYear,
        "Z": $91944b830a2fdf61$var$parseZone,
        "%": $91944b830a2fdf61$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $91944b830a2fdf61$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, newDate) {
        return function(string) {
            var d = $91944b830a2fdf61$var$newYear(1900), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $91944b830a2fdf61$var$utcDate($91944b830a2fdf61$var$newYear(d.y)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $3G5QG.utcMonday).ceil(week) : (0, $3G5QG.utcMonday)(week);
                    week = (0, $kTmIK.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = newDate($91944b830a2fdf61$var$newYear(d.y)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $hHoaP.monday).ceil(week) : (0, $hHoaP.monday)(week);
                    week = (0, $fucbR.default).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $91944b830a2fdf61$var$utcDate($91944b830a2fdf61$var$newYear(d.y)).getUTCDay() : newDate($91944b830a2fdf61$var$newYear(d.y)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $91944b830a2fdf61$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return newDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $91944b830a2fdf61$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", $91944b830a2fdf61$var$localDate);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier, $91944b830a2fdf61$var$utcDate);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $91944b830a2fdf61$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $91944b830a2fdf61$var$numberRe = /^\s*\d+/, $91944b830a2fdf61$var$percentRe = /^%/, $91944b830a2fdf61$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $91944b830a2fdf61$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $91944b830a2fdf61$var$requote(s) {
    return s.replace($91944b830a2fdf61$var$requoteRe, "\\$&");
}
function $91944b830a2fdf61$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($91944b830a2fdf61$var$requote).join("|") + ")", "i");
}
function $91944b830a2fdf61$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $91944b830a2fdf61$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseWeekNumberSunday(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseWeekNumberISO(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseWeekNumberMonday(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseFullYear(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseYear(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseMonthNumber(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseDayOfMonth(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseDayOfYear(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseHour24(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseMinutes(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseSeconds(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseMilliseconds(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseMicroseconds(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseLiteralPercent(d, string, i) {
    var n = $91944b830a2fdf61$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $91944b830a2fdf61$var$parseUnixTimestamp(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $91944b830a2fdf61$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0] * 1000, i + n[0].length) : -1;
}
function $91944b830a2fdf61$var$formatDayOfMonth(d, p) {
    return $91944b830a2fdf61$var$pad(d.getDate(), p, 2);
}
function $91944b830a2fdf61$var$formatHour24(d, p) {
    return $91944b830a2fdf61$var$pad(d.getHours(), p, 2);
}
function $91944b830a2fdf61$var$formatHour12(d, p) {
    return $91944b830a2fdf61$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $91944b830a2fdf61$var$formatDayOfYear(d, p) {
    return $91944b830a2fdf61$var$pad(1 + (0, $fucbR.default).count((0, $7BX5j.default)(d), d), p, 3);
}
function $91944b830a2fdf61$var$formatMilliseconds(d, p) {
    return $91944b830a2fdf61$var$pad(d.getMilliseconds(), p, 3);
}
function $91944b830a2fdf61$var$formatMicroseconds(d, p) {
    return $91944b830a2fdf61$var$formatMilliseconds(d, p) + "000";
}
function $91944b830a2fdf61$var$formatMonthNumber(d, p) {
    return $91944b830a2fdf61$var$pad(d.getMonth() + 1, p, 2);
}
function $91944b830a2fdf61$var$formatMinutes(d, p) {
    return $91944b830a2fdf61$var$pad(d.getMinutes(), p, 2);
}
function $91944b830a2fdf61$var$formatSeconds(d, p) {
    return $91944b830a2fdf61$var$pad(d.getSeconds(), p, 2);
}
function $91944b830a2fdf61$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $91944b830a2fdf61$var$formatWeekNumberSunday(d, p) {
    return $91944b830a2fdf61$var$pad((0, $hHoaP.sunday).count((0, $7BX5j.default)(d), d), p, 2);
}
function $91944b830a2fdf61$var$formatWeekNumberISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $hHoaP.thursday)(d) : (0, $hHoaP.thursday).ceil(d);
    return $91944b830a2fdf61$var$pad((0, $hHoaP.thursday).count((0, $7BX5j.default)(d), d) + ((0, $7BX5j.default)(d).getDay() === 4), p, 2);
}
function $91944b830a2fdf61$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $91944b830a2fdf61$var$formatWeekNumberMonday(d, p) {
    return $91944b830a2fdf61$var$pad((0, $hHoaP.monday).count((0, $7BX5j.default)(d), d), p, 2);
}
function $91944b830a2fdf61$var$formatYear(d, p) {
    return $91944b830a2fdf61$var$pad(d.getFullYear() % 100, p, 2);
}
function $91944b830a2fdf61$var$formatFullYear(d, p) {
    return $91944b830a2fdf61$var$pad(d.getFullYear() % 10000, p, 4);
}
function $91944b830a2fdf61$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $91944b830a2fdf61$var$pad(z / 60 | 0, "0", 2) + $91944b830a2fdf61$var$pad(z % 60, "0", 2);
}
function $91944b830a2fdf61$var$formatUTCDayOfMonth(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCDate(), p, 2);
}
function $91944b830a2fdf61$var$formatUTCHour24(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCHours(), p, 2);
}
function $91944b830a2fdf61$var$formatUTCHour12(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $91944b830a2fdf61$var$formatUTCDayOfYear(d, p) {
    return $91944b830a2fdf61$var$pad(1 + (0, $kTmIK.default).count((0, $hiuwV.default)(d), d), p, 3);
}
function $91944b830a2fdf61$var$formatUTCMilliseconds(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $91944b830a2fdf61$var$formatUTCMicroseconds(d, p) {
    return $91944b830a2fdf61$var$formatUTCMilliseconds(d, p) + "000";
}
function $91944b830a2fdf61$var$formatUTCMonthNumber(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $91944b830a2fdf61$var$formatUTCMinutes(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCMinutes(), p, 2);
}
function $91944b830a2fdf61$var$formatUTCSeconds(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCSeconds(), p, 2);
}
function $91944b830a2fdf61$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $91944b830a2fdf61$var$formatUTCWeekNumberSunday(d, p) {
    return $91944b830a2fdf61$var$pad((0, $3G5QG.utcSunday).count((0, $hiuwV.default)(d), d), p, 2);
}
function $91944b830a2fdf61$var$formatUTCWeekNumberISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $3G5QG.utcThursday)(d) : (0, $3G5QG.utcThursday).ceil(d);
    return $91944b830a2fdf61$var$pad((0, $3G5QG.utcThursday).count((0, $hiuwV.default)(d), d) + ((0, $hiuwV.default)(d).getUTCDay() === 4), p, 2);
}
function $91944b830a2fdf61$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $91944b830a2fdf61$var$formatUTCWeekNumberMonday(d, p) {
    return $91944b830a2fdf61$var$pad((0, $3G5QG.utcMonday).count((0, $hiuwV.default)(d), d), p, 2);
}
function $91944b830a2fdf61$var$formatUTCYear(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $91944b830a2fdf61$var$formatUTCFullYear(d, p) {
    return $91944b830a2fdf61$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $91944b830a2fdf61$var$formatUTCZone() {
    return "+0000";
}
function $91944b830a2fdf61$var$formatLiteralPercent() {
    return "%";
}
function $91944b830a2fdf61$var$formatUnixTimestamp(d) {
    return +d;
}
function $91944b830a2fdf61$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});
parcelRegister("fucbR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4631d1c3a3c1b74$export$2e2bcd8739ae039);

var $gj2B1 = parcelRequire("gj2B1");

var $j7ICq = parcelRequire("j7ICq");
var $b4631d1c3a3c1b74$var$day = (0, $gj2B1.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $j7ICq.durationMinute)) / (0, $j7ICq.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
var $b4631d1c3a3c1b74$export$2e2bcd8739ae039 = $b4631d1c3a3c1b74$var$day;
var $b4631d1c3a3c1b74$export$3cf5dda4201cc0f2 = $b4631d1c3a3c1b74$var$day.range;

});
parcelRegister("gj2B1", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdf06f3b3944f2f8$export$2e2bcd8739ae039);
var $bdf06f3b3944f2f8$var$t0 = new Date, $bdf06f3b3944f2f8$var$t1 = new Date;
function $bdf06f3b3944f2f8$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $bdf06f3b3944f2f8$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $bdf06f3b3944f2f8$var$t0.setTime(+start), $bdf06f3b3944f2f8$var$t1.setTime(+end);
            floori($bdf06f3b3944f2f8$var$t0), floori($bdf06f3b3944f2f8$var$t1);
            return Math.floor(count($bdf06f3b3944f2f8$var$t0, $bdf06f3b3944f2f8$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("j7ICq", function(module, exports) {

$parcel$export(module.exports, "durationMinute", () => $dec148232e492332$export$683905d551c33fa9);
$parcel$export(module.exports, "durationDay", () => $dec148232e492332$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $dec148232e492332$export$c241eb88520d5016);
var $dec148232e492332$export$79ef0e34099623dc = 1e3;
var $dec148232e492332$export$683905d551c33fa9 = 6e4;
var $dec148232e492332$export$4157bf0c8e241659 = 36e5;
var $dec148232e492332$export$353686095f4fbf45 = 864e5;
var $dec148232e492332$export$c241eb88520d5016 = 6048e5;

});


parcelRegister("hHoaP", function(module, exports) {

$parcel$export(module.exports, "sunday", () => $ce29343718f4bbc9$export$fb3ee18ed410cc21);
$parcel$export(module.exports, "monday", () => $ce29343718f4bbc9$export$6416afaab03bc9b8);
$parcel$export(module.exports, "thursday", () => $ce29343718f4bbc9$export$2f2b56683a3e5629);

var $gj2B1 = parcelRequire("gj2B1");

var $j7ICq = parcelRequire("j7ICq");
function $ce29343718f4bbc9$var$weekday(i) {
    return (0, $gj2B1.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $j7ICq.durationMinute)) / (0, $j7ICq.durationWeek);
    });
}
var $ce29343718f4bbc9$export$fb3ee18ed410cc21 = $ce29343718f4bbc9$var$weekday(0);
var $ce29343718f4bbc9$export$6416afaab03bc9b8 = $ce29343718f4bbc9$var$weekday(1);
var $ce29343718f4bbc9$export$cb8f040f5d17ac7b = $ce29343718f4bbc9$var$weekday(2);
var $ce29343718f4bbc9$export$347581849975dfc8 = $ce29343718f4bbc9$var$weekday(3);
var $ce29343718f4bbc9$export$2f2b56683a3e5629 = $ce29343718f4bbc9$var$weekday(4);
var $ce29343718f4bbc9$export$59b8c2ccd931d806 = $ce29343718f4bbc9$var$weekday(5);
var $ce29343718f4bbc9$export$478ceadebff4d377 = $ce29343718f4bbc9$var$weekday(6);
var $ce29343718f4bbc9$export$e8daabaa40641211 = $ce29343718f4bbc9$export$fb3ee18ed410cc21.range;
var $ce29343718f4bbc9$export$74e5b559c235c00e = $ce29343718f4bbc9$export$6416afaab03bc9b8.range;
var $ce29343718f4bbc9$export$e7d6aa4fb107bc56 = $ce29343718f4bbc9$export$cb8f040f5d17ac7b.range;
var $ce29343718f4bbc9$export$fcd5880b20bb06a8 = $ce29343718f4bbc9$export$347581849975dfc8.range;
var $ce29343718f4bbc9$export$682716b7bbe33641 = $ce29343718f4bbc9$export$2f2b56683a3e5629.range;
var $ce29343718f4bbc9$export$482924968ca86084 = $ce29343718f4bbc9$export$59b8c2ccd931d806.range;
var $ce29343718f4bbc9$export$7d755172c9cda9d2 = $ce29343718f4bbc9$export$478ceadebff4d377.range;

});

parcelRegister("7BX5j", function(module, exports) {

$parcel$export(module.exports, "default", () => $58a9d21a1cc3d904$export$2e2bcd8739ae039);

var $gj2B1 = parcelRequire("gj2B1");
var $58a9d21a1cc3d904$var$year = (0, $gj2B1.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$58a9d21a1cc3d904$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $gj2B1.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $58a9d21a1cc3d904$export$2e2bcd8739ae039 = $58a9d21a1cc3d904$var$year;
var $58a9d21a1cc3d904$export$6fda41c7fb23acf9 = $58a9d21a1cc3d904$var$year.range;

});

parcelRegister("kTmIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35a918d205360a7$export$2e2bcd8739ae039);

var $gj2B1 = parcelRequire("gj2B1");

var $j7ICq = parcelRequire("j7ICq");
var $f35a918d205360a7$var$utcDay = (0, $gj2B1.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $j7ICq.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $f35a918d205360a7$export$2e2bcd8739ae039 = $f35a918d205360a7$var$utcDay;
var $f35a918d205360a7$export$d277e198508549a1 = $f35a918d205360a7$var$utcDay.range;

});

parcelRegister("3G5QG", function(module, exports) {

$parcel$export(module.exports, "utcSunday", () => $2ad9d4c5afe9027a$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $2ad9d4c5afe9027a$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcThursday", () => $2ad9d4c5afe9027a$export$1db08111baec2f53);

var $gj2B1 = parcelRequire("gj2B1");

var $j7ICq = parcelRequire("j7ICq");
function $2ad9d4c5afe9027a$var$utcWeekday(i) {
    return (0, $gj2B1.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $j7ICq.durationWeek);
    });
}
var $2ad9d4c5afe9027a$export$4898b06303a92011 = $2ad9d4c5afe9027a$var$utcWeekday(0);
var $2ad9d4c5afe9027a$export$9cfc53b9cfafd080 = $2ad9d4c5afe9027a$var$utcWeekday(1);
var $2ad9d4c5afe9027a$export$2a6d545f77eceb15 = $2ad9d4c5afe9027a$var$utcWeekday(2);
var $2ad9d4c5afe9027a$export$a5c25d8ed64433c4 = $2ad9d4c5afe9027a$var$utcWeekday(3);
var $2ad9d4c5afe9027a$export$1db08111baec2f53 = $2ad9d4c5afe9027a$var$utcWeekday(4);
var $2ad9d4c5afe9027a$export$29265e34dd5921f7 = $2ad9d4c5afe9027a$var$utcWeekday(5);
var $2ad9d4c5afe9027a$export$85b74dad05049604 = $2ad9d4c5afe9027a$var$utcWeekday(6);
var $2ad9d4c5afe9027a$export$6f3e1c2b0f7d7880 = $2ad9d4c5afe9027a$export$4898b06303a92011.range;
var $2ad9d4c5afe9027a$export$1d2d8b858bb366f9 = $2ad9d4c5afe9027a$export$9cfc53b9cfafd080.range;
var $2ad9d4c5afe9027a$export$1d5f6785fc7f30f8 = $2ad9d4c5afe9027a$export$2a6d545f77eceb15.range;
var $2ad9d4c5afe9027a$export$7a75faf0e37ef4af = $2ad9d4c5afe9027a$export$a5c25d8ed64433c4.range;
var $2ad9d4c5afe9027a$export$417eb959611b2f2f = $2ad9d4c5afe9027a$export$1db08111baec2f53.range;
var $2ad9d4c5afe9027a$export$59d308db7af08c64 = $2ad9d4c5afe9027a$export$29265e34dd5921f7.range;
var $2ad9d4c5afe9027a$export$a124108a0a7f34c8 = $2ad9d4c5afe9027a$export$85b74dad05049604.range;

});

parcelRegister("hiuwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c97bccbe70127d05$export$2e2bcd8739ae039);

var $gj2B1 = parcelRequire("gj2B1");
var $c97bccbe70127d05$var$utcYear = (0, $gj2B1.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$c97bccbe70127d05$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $gj2B1.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $c97bccbe70127d05$export$2e2bcd8739ae039 = $c97bccbe70127d05$var$utcYear;
var $c97bccbe70127d05$export$3e24d311e17f5802 = $c97bccbe70127d05$var$utcYear.range;

});



parcelRegister("jfFuR", function(module, exports) {

$parcel$export(module.exports, "isoSpecifier", () => $e03f9b705a7d6570$export$491f7bf2e88d83ce);

var $lwmlZ = parcelRequire("lwmlZ");
var $e03f9b705a7d6570$export$491f7bf2e88d83ce = "%Y-%m-%dT%H:%M:%S.%LZ";
function $e03f9b705a7d6570$var$formatIsoNative(date) {
    return date.toISOString();
}
var $e03f9b705a7d6570$var$formatIso = Date.prototype.toISOString ? $e03f9b705a7d6570$var$formatIsoNative : (0, $lwmlZ.utcFormat)($e03f9b705a7d6570$export$491f7bf2e88d83ce);
var $e03f9b705a7d6570$export$2e2bcd8739ae039 = $e03f9b705a7d6570$var$formatIso;

});

parcelRegister("dHI80", function(module, exports) {

var $jfFuR = parcelRequire("jfFuR");

var $lwmlZ = parcelRequire("lwmlZ");
function $9fa18573d1af7743$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $9fa18573d1af7743$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $9fa18573d1af7743$var$parseIsoNative : (0, $lwmlZ.utcParse)((0, $jfFuR.isoSpecifier));
var $9fa18573d1af7743$export$2e2bcd8739ae039 = $9fa18573d1af7743$var$parseIso;

});


parcelRegister("3pidO", function(module, exports) {

var $lRlCn = parcelRequire("lRlCn");

var $1SFZi = parcelRequire("1SFZi");

var $3iLNM = parcelRequire("3iLNM");

});
parcelRegister("lRlCn", function(module, exports) {

$parcel$export(module.exports, "now", () => $fe9f511633cbb727$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $fe9f511633cbb727$export$c57e9b2d8b9e4de);
var $fe9f511633cbb727$var$frame = 0, $fe9f511633cbb727$var$timeout = 0, $fe9f511633cbb727$var$interval = 0, $fe9f511633cbb727$var$pokeDelay = 1000, $fe9f511633cbb727$var$taskHead, $fe9f511633cbb727$var$taskTail, $fe9f511633cbb727$var$clockLast = 0, $fe9f511633cbb727$var$clockNow = 0, $fe9f511633cbb727$var$clockSkew = 0, $fe9f511633cbb727$var$clock = typeof performance === "object" && performance.now ? performance : Date, $fe9f511633cbb727$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $fe9f511633cbb727$export$461939dd4422153() {
    return $fe9f511633cbb727$var$clockNow || ($fe9f511633cbb727$var$setFrame($fe9f511633cbb727$var$clearNow), $fe9f511633cbb727$var$clockNow = $fe9f511633cbb727$var$clock.now() + $fe9f511633cbb727$var$clockSkew);
}
function $fe9f511633cbb727$var$clearNow() {
    $fe9f511633cbb727$var$clockNow = 0;
}
function $fe9f511633cbb727$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$fe9f511633cbb727$export$c57e9b2d8b9e4de.prototype = $fe9f511633cbb727$export$9dc4ecf953986f04.prototype = {
    constructor: $fe9f511633cbb727$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $fe9f511633cbb727$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $fe9f511633cbb727$var$taskTail !== this) {
            if ($fe9f511633cbb727$var$taskTail) $fe9f511633cbb727$var$taskTail._next = this;
            else $fe9f511633cbb727$var$taskHead = this;
            $fe9f511633cbb727$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $fe9f511633cbb727$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $fe9f511633cbb727$var$sleep();
        }
    }
};
function $fe9f511633cbb727$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $fe9f511633cbb727$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $fe9f511633cbb727$export$d60154c1d7f3990e() {
    $fe9f511633cbb727$export$461939dd4422153(); // Get the current time, if not already set.
    ++$fe9f511633cbb727$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $fe9f511633cbb727$var$taskHead, e;
    while(t){
        if ((e = $fe9f511633cbb727$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$fe9f511633cbb727$var$frame;
}
function $fe9f511633cbb727$var$wake() {
    $fe9f511633cbb727$var$clockNow = ($fe9f511633cbb727$var$clockLast = $fe9f511633cbb727$var$clock.now()) + $fe9f511633cbb727$var$clockSkew;
    $fe9f511633cbb727$var$frame = $fe9f511633cbb727$var$timeout = 0;
    try {
        $fe9f511633cbb727$export$d60154c1d7f3990e();
    } finally{
        $fe9f511633cbb727$var$frame = 0;
        $fe9f511633cbb727$var$nap();
        $fe9f511633cbb727$var$clockNow = 0;
    }
}
function $fe9f511633cbb727$var$poke() {
    var now = $fe9f511633cbb727$var$clock.now(), delay = now - $fe9f511633cbb727$var$clockLast;
    if (delay > $fe9f511633cbb727$var$pokeDelay) $fe9f511633cbb727$var$clockSkew -= delay, $fe9f511633cbb727$var$clockLast = now;
}
function $fe9f511633cbb727$var$nap() {
    var t0, t1 = $fe9f511633cbb727$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $fe9f511633cbb727$var$taskHead = t2;
    }
    $fe9f511633cbb727$var$taskTail = t0;
    $fe9f511633cbb727$var$sleep(time);
}
function $fe9f511633cbb727$var$sleep(time) {
    if ($fe9f511633cbb727$var$frame) return; // Soonest alarm already set, or will be.
    if ($fe9f511633cbb727$var$timeout) $fe9f511633cbb727$var$timeout = clearTimeout($fe9f511633cbb727$var$timeout);
    var delay = time - $fe9f511633cbb727$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $fe9f511633cbb727$var$timeout = setTimeout($fe9f511633cbb727$var$wake, time - $fe9f511633cbb727$var$clock.now() - $fe9f511633cbb727$var$clockSkew);
        if ($fe9f511633cbb727$var$interval) $fe9f511633cbb727$var$interval = clearInterval($fe9f511633cbb727$var$interval);
    } else {
        if (!$fe9f511633cbb727$var$interval) $fe9f511633cbb727$var$clockLast = $fe9f511633cbb727$var$clock.now(), $fe9f511633cbb727$var$interval = setInterval($fe9f511633cbb727$var$poke, $fe9f511633cbb727$var$pokeDelay);
        $fe9f511633cbb727$var$frame = 1, $fe9f511633cbb727$var$setFrame($fe9f511633cbb727$var$wake);
    }
}

});

parcelRegister("1SFZi", function(module, exports) {

var $lRlCn = parcelRequire("lRlCn");
function $15eb677b74681775$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $lRlCn.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});

parcelRegister("3iLNM", function(module, exports) {

var $lRlCn = parcelRequire("lRlCn");
function $26782202383728cf$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $lRlCn.Timer), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    delay = +delay, time = time == null ? (0, $lRlCn.now)() : +time;
    t.restart(function tick(elapsed) {
        elapsed += total;
        t.restart(tick, total += delay, time);
        callback(elapsed);
    }, delay, time);
    return t;
}

});


parcelRegister("8BkNz", function(module, exports) {
parcelRequire("2lkkg");

var $9imxx = parcelRequire("9imxx");

var $fujev = parcelRequire("fujev");

var $6mJfg = parcelRequire("6mJfg");

});
parcelRegister("2lkkg", function(module, exports) {

var $6vKFG = parcelRequire("6vKFG");

var $gJjsY = parcelRequire("gJjsY");

var $1KswV = parcelRequire("1KswV");
(0, $6vKFG.default).prototype.interrupt = (0, $gJjsY.default);
(0, $6vKFG.default).prototype.transition = (0, $1KswV.default);

});
parcelRegister("6vKFG", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $4bd9d7496eac7ba4$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $4bd9d7496eac7ba4$export$2e2bcd8739ae039);

var $2xNDo = parcelRequire("2xNDo");

var $2BNfg = parcelRequire("2BNfg");

var $68NP0 = parcelRequire("68NP0");

var $dobkY = parcelRequire("dobkY");

var $OHBhh = parcelRequire("OHBhh");

var $9UIKJ = parcelRequire("9UIKJ");

var $fZfou = parcelRequire("fZfou");

var $9alTc = parcelRequire("9alTc");

var $hVtgL = parcelRequire("hVtgL");

var $3wzGv = parcelRequire("3wzGv");

var $3IcBu = parcelRequire("3IcBu");

var $72kGM = parcelRequire("72kGM");

var $9DGRM = parcelRequire("9DGRM");

var $kv9MF = parcelRequire("kv9MF");

var $ajiKr = parcelRequire("ajiKr");

var $f4Qdg = parcelRequire("f4Qdg");

var $e4N1P = parcelRequire("e4N1P");

var $5INzf = parcelRequire("5INzf");

var $aHk8d = parcelRequire("aHk8d");

var $aLYbI = parcelRequire("aLYbI");

var $dF0Ez = parcelRequire("dF0Ez");

var $3JFlY = parcelRequire("3JFlY");

var $cOuDi = parcelRequire("cOuDi");

var $k34Ar = parcelRequire("k34Ar");

var $clQ2X = parcelRequire("clQ2X");

var $NdKye = parcelRequire("NdKye");

var $7ZrgU = parcelRequire("7ZrgU");

var $jR5Hs = parcelRequire("jR5Hs");

var $35xqp = parcelRequire("35xqp");

var $9utLz = parcelRequire("9utLz");

var $hSCak = parcelRequire("hSCak");
var $4bd9d7496eac7ba4$export$e8e78c978b129247 = [
    null
];
function $4bd9d7496eac7ba4$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $4bd9d7496eac7ba4$var$selection() {
    return new $4bd9d7496eac7ba4$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $4bd9d7496eac7ba4$export$e8e78c978b129247);
}
$4bd9d7496eac7ba4$export$52baac22726c72bf.prototype = $4bd9d7496eac7ba4$var$selection.prototype = {
    constructor: $4bd9d7496eac7ba4$export$52baac22726c72bf,
    select: (0, $2xNDo.default),
    selectAll: (0, $2BNfg.default),
    filter: (0, $68NP0.default),
    data: (0, $dobkY.default),
    enter: (0, $OHBhh.default),
    exit: (0, $9UIKJ.default),
    join: (0, $fZfou.default),
    merge: (0, $9alTc.default),
    order: (0, $hVtgL.default),
    sort: (0, $3wzGv.default),
    call: (0, $3IcBu.default),
    nodes: (0, $72kGM.default),
    node: (0, $9DGRM.default),
    size: (0, $kv9MF.default),
    empty: (0, $ajiKr.default),
    each: (0, $f4Qdg.default),
    attr: (0, $e4N1P.default),
    style: (0, $5INzf.default),
    property: (0, $aHk8d.default),
    classed: (0, $aLYbI.default),
    text: (0, $dF0Ez.default),
    html: (0, $3JFlY.default),
    raise: (0, $cOuDi.default),
    lower: (0, $k34Ar.default),
    append: (0, $clQ2X.default),
    insert: (0, $NdKye.default),
    remove: (0, $7ZrgU.default),
    clone: (0, $jR5Hs.default),
    datum: (0, $35xqp.default),
    on: (0, $9utLz.default),
    dispatch: (0, $hSCak.default)
};
var $4bd9d7496eac7ba4$export$2e2bcd8739ae039 = $4bd9d7496eac7ba4$var$selection;

});
parcelRegister("2xNDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1da52a2ce2b085c8$export$2e2bcd8739ae039);

var $6vKFG = parcelRequire("6vKFG");

var $APwpA = parcelRequire("APwpA");
function $1da52a2ce2b085c8$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $APwpA.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $6vKFG.Selection)(subgroups, this._parents);
}

});
parcelRegister("APwpA", function(module, exports) {

$parcel$export(module.exports, "default", () => $06eb540eda34fd6c$export$2e2bcd8739ae039);
function $06eb540eda34fd6c$var$none() {}
function $06eb540eda34fd6c$export$2e2bcd8739ae039(selector) {
    return selector == null ? $06eb540eda34fd6c$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("2BNfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e653c8b435833b6$export$2e2bcd8739ae039);

var $6vKFG = parcelRequire("6vKFG");

var $jFKx4 = parcelRequire("jFKx4");
function $1e653c8b435833b6$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $jFKx4.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $6vKFG.Selection)(subgroups, parents);
}

});
parcelRegister("jFKx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e525f10757f4c14f$export$2e2bcd8739ae039);
function $e525f10757f4c14f$var$empty() {
    return [];
}
function $e525f10757f4c14f$export$2e2bcd8739ae039(selector) {
    return selector == null ? $e525f10757f4c14f$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("68NP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $478a22fcfac9f1ad$export$2e2bcd8739ae039);

var $6vKFG = parcelRequire("6vKFG");

var $h3To8 = parcelRequire("h3To8");
function $478a22fcfac9f1ad$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $h3To8.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $6vKFG.Selection)(subgroups, this._parents);
}

});
parcelRegister("h3To8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6bdae765a2f2d41$export$2e2bcd8739ae039);
function $c6bdae765a2f2d41$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("dobkY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf64f9b49241c98$export$2e2bcd8739ae039);

var $6vKFG = parcelRequire("6vKFG");

var $OHBhh = parcelRequire("OHBhh");

var $f7RAA = parcelRequire("f7RAA");
var $9bf64f9b49241c98$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $9bf64f9b49241c98$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $OHBhh.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $9bf64f9b49241c98$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $9bf64f9b49241c98$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $9bf64f9b49241c98$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $OHBhh.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $9bf64f9b49241c98$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $9bf64f9b49241c98$var$bindKey : $9bf64f9b49241c98$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $f7RAA.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $6vKFG.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("OHBhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $09867dba8fb69739$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $09867dba8fb69739$export$67b01759a14cf6a4);

var $8LghV = parcelRequire("8LghV");

var $6vKFG = parcelRequire("6vKFG");
function $09867dba8fb69739$export$2e2bcd8739ae039() {
    return new (0, $6vKFG.Selection)(this._enter || this._groups.map((0, $8LghV.default)), this._parents);
}
function $09867dba8fb69739$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$09867dba8fb69739$export$67b01759a14cf6a4.prototype = {
    constructor: $09867dba8fb69739$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("8LghV", function(module, exports) {

$parcel$export(module.exports, "default", () => $660f59008989e7f2$export$2e2bcd8739ae039);
function $660f59008989e7f2$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("f7RAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03114214d12e3cb$export$2e2bcd8739ae039);
function $b03114214d12e3cb$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("9UIKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $737c0ef919284a39$export$2e2bcd8739ae039);

var $8LghV = parcelRequire("8LghV");

var $6vKFG = parcelRequire("6vKFG");
function $737c0ef919284a39$export$2e2bcd8739ae039() {
    return new (0, $6vKFG.Selection)(this._exit || this._groups.map((0, $8LghV.default)), this._parents);
}

});

parcelRegister("fZfou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba387e75df68f3ce$export$2e2bcd8739ae039);
function $ba387e75df68f3ce$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("9alTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac606fd31ef869e$export$2e2bcd8739ae039);

var $6vKFG = parcelRequire("6vKFG");
function $6ac606fd31ef869e$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $6vKFG.Selection)(merges, this._parents);
}

});

parcelRegister("hVtgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ce76d0f179f022$export$2e2bcd8739ae039);
function $d0ce76d0f179f022$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("3wzGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $29100a79b8d374eb$export$2e2bcd8739ae039);

var $6vKFG = parcelRequire("6vKFG");
function $29100a79b8d374eb$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $29100a79b8d374eb$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $6vKFG.Selection)(sortgroups, this._parents).order();
}
function $29100a79b8d374eb$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("3IcBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b3f41f8c2252e3a$export$2e2bcd8739ae039);
function $2b3f41f8c2252e3a$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("72kGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f8c4b4d1b3c16b$export$2e2bcd8739ae039);
function $51f8c4b4d1b3c16b$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("9DGRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $704901f6085c8900$export$2e2bcd8739ae039);
function $704901f6085c8900$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("kv9MF", function(module, exports) {

$parcel$export(module.exports, "default", () => $eece4ace5df73e2c$export$2e2bcd8739ae039);
function $eece4ace5df73e2c$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("ajiKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $781a38b799d574f1$export$2e2bcd8739ae039);
function $781a38b799d574f1$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("f4Qdg", function(module, exports) {

$parcel$export(module.exports, "default", () => $af9fbb22e260e968$export$2e2bcd8739ae039);
function $af9fbb22e260e968$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("e4N1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7786c2584596e$export$2e2bcd8739ae039);

var $blAzP = parcelRequire("blAzP");
function $a3f7786c2584596e$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $a3f7786c2584596e$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $a3f7786c2584596e$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $a3f7786c2584596e$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $a3f7786c2584596e$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $a3f7786c2584596e$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $a3f7786c2584596e$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $blAzP.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $a3f7786c2584596e$var$attrRemoveNS : $a3f7786c2584596e$var$attrRemove : typeof value === "function" ? fullname.local ? $a3f7786c2584596e$var$attrFunctionNS : $a3f7786c2584596e$var$attrFunction : fullname.local ? $a3f7786c2584596e$var$attrConstantNS : $a3f7786c2584596e$var$attrConstant)(fullname, value));
}

});
parcelRegister("blAzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $842e0741e490034b$export$2e2bcd8739ae039);

var $5mdNT = parcelRequire("5mdNT");
function $842e0741e490034b$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $5mdNT.default).hasOwnProperty(prefix) ? {
        space: (0, $5mdNT.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("5mdNT", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $3e69b6f7eeabcf76$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $3e69b6f7eeabcf76$export$2e2bcd8739ae039);
var $3e69b6f7eeabcf76$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $3e69b6f7eeabcf76$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $3e69b6f7eeabcf76$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("5INzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a782deeda6937e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $42a782deeda6937e$export$5e3cec964f0b5efd);

var $hsJLh = parcelRequire("hsJLh");
function $42a782deeda6937e$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $42a782deeda6937e$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $42a782deeda6937e$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $42a782deeda6937e$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $42a782deeda6937e$var$styleRemove : typeof value === "function" ? $42a782deeda6937e$var$styleFunction : $42a782deeda6937e$var$styleConstant)(name, value, priority == null ? "" : priority)) : $42a782deeda6937e$export$5e3cec964f0b5efd(this.node(), name);
}
function $42a782deeda6937e$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $hsJLh.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("hsJLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb688c8409eb7f2f$export$2e2bcd8739ae039);
function $cb688c8409eb7f2f$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("aHk8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9d893b3200198c$export$2e2bcd8739ae039);
function $7c9d893b3200198c$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $7c9d893b3200198c$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $7c9d893b3200198c$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $7c9d893b3200198c$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $7c9d893b3200198c$var$propertyRemove : typeof value === "function" ? $7c9d893b3200198c$var$propertyFunction : $7c9d893b3200198c$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("aLYbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d7cfb40389d4323$export$2e2bcd8739ae039);
function $7d7cfb40389d4323$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $7d7cfb40389d4323$var$classList(node) {
    return node.classList || new $7d7cfb40389d4323$var$ClassList(node);
}
function $7d7cfb40389d4323$var$ClassList(node) {
    this._node = node;
    this._names = $7d7cfb40389d4323$var$classArray(node.getAttribute("class") || "");
}
$7d7cfb40389d4323$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $7d7cfb40389d4323$var$classedAdd(node, names) {
    var list = $7d7cfb40389d4323$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $7d7cfb40389d4323$var$classedRemove(node, names) {
    var list = $7d7cfb40389d4323$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $7d7cfb40389d4323$var$classedTrue(names) {
    return function() {
        $7d7cfb40389d4323$var$classedAdd(this, names);
    };
}
function $7d7cfb40389d4323$var$classedFalse(names) {
    return function() {
        $7d7cfb40389d4323$var$classedRemove(this, names);
    };
}
function $7d7cfb40389d4323$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $7d7cfb40389d4323$var$classedAdd : $7d7cfb40389d4323$var$classedRemove)(this, names);
    };
}
function $7d7cfb40389d4323$export$2e2bcd8739ae039(name, value) {
    var names = $7d7cfb40389d4323$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $7d7cfb40389d4323$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $7d7cfb40389d4323$var$classedFunction : value ? $7d7cfb40389d4323$var$classedTrue : $7d7cfb40389d4323$var$classedFalse)(names, value));
}

});

parcelRegister("dF0Ez", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1f9c742bee7b11$export$2e2bcd8739ae039);
function $9f1f9c742bee7b11$var$textRemove() {
    this.textContent = "";
}
function $9f1f9c742bee7b11$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $9f1f9c742bee7b11$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $9f1f9c742bee7b11$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $9f1f9c742bee7b11$var$textRemove : (typeof value === "function" ? $9f1f9c742bee7b11$var$textFunction : $9f1f9c742bee7b11$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("3JFlY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b85a6fa7e801113$export$2e2bcd8739ae039);
function $2b85a6fa7e801113$var$htmlRemove() {
    this.innerHTML = "";
}
function $2b85a6fa7e801113$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $2b85a6fa7e801113$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $2b85a6fa7e801113$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $2b85a6fa7e801113$var$htmlRemove : (typeof value === "function" ? $2b85a6fa7e801113$var$htmlFunction : $2b85a6fa7e801113$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("cOuDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9541ea937815d6bd$export$2e2bcd8739ae039);
function $9541ea937815d6bd$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $9541ea937815d6bd$export$2e2bcd8739ae039() {
    return this.each($9541ea937815d6bd$var$raise);
}

});

parcelRegister("k34Ar", function(module, exports) {

$parcel$export(module.exports, "default", () => $e987a54a3d312ea3$export$2e2bcd8739ae039);
function $e987a54a3d312ea3$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $e987a54a3d312ea3$export$2e2bcd8739ae039() {
    return this.each($e987a54a3d312ea3$var$lower);
}

});

parcelRegister("clQ2X", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fdfd19910b44800$export$2e2bcd8739ae039);

var $lBJLN = parcelRequire("lBJLN");
function $8fdfd19910b44800$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $lBJLN.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("lBJLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb08e9e47517824$export$2e2bcd8739ae039);

var $blAzP = parcelRequire("blAzP");

var $5mdNT = parcelRequire("5mdNT");
function $fbb08e9e47517824$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $5mdNT.xhtml) && document.documentElement.namespaceURI === (0, $5mdNT.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $fbb08e9e47517824$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $fbb08e9e47517824$export$2e2bcd8739ae039(name) {
    var fullname = (0, $blAzP.default)(name);
    return (fullname.local ? $fbb08e9e47517824$var$creatorFixed : $fbb08e9e47517824$var$creatorInherit)(fullname);
}

});


parcelRegister("NdKye", function(module, exports) {

$parcel$export(module.exports, "default", () => $093f3e259d2e05f1$export$2e2bcd8739ae039);

var $lBJLN = parcelRequire("lBJLN");

var $APwpA = parcelRequire("APwpA");
function $093f3e259d2e05f1$var$constantNull() {
    return null;
}
function $093f3e259d2e05f1$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $lBJLN.default)(name), select = before == null ? $093f3e259d2e05f1$var$constantNull : typeof before === "function" ? before : (0, $APwpA.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("7ZrgU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d136281aaa98308$export$2e2bcd8739ae039);
function $5d136281aaa98308$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $5d136281aaa98308$export$2e2bcd8739ae039() {
    return this.each($5d136281aaa98308$var$remove);
}

});

parcelRegister("jR5Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e747636d183c2066$export$2e2bcd8739ae039);
function $e747636d183c2066$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $e747636d183c2066$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $e747636d183c2066$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $e747636d183c2066$var$selection_cloneDeep : $e747636d183c2066$var$selection_cloneShallow);
}

});

parcelRegister("35xqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $23fbc43cca3601bc$export$2e2bcd8739ae039);
function $23fbc43cca3601bc$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("9utLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e8e01578b1d58c7$export$2e2bcd8739ae039);
var $6e8e01578b1d58c7$var$filterEvents = {};
var $6e8e01578b1d58c7$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $6e8e01578b1d58c7$var$element = document.documentElement;
    if (!("onmouseenter" in $6e8e01578b1d58c7$var$element)) $6e8e01578b1d58c7$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $6e8e01578b1d58c7$var$filterContextListener(listener, index, group) {
    listener = $6e8e01578b1d58c7$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $6e8e01578b1d58c7$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $6e8e01578b1d58c7$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $6e8e01578b1d58c7$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $6e8e01578b1d58c7$export$6cd530ed55e06764 = event0;
        }
    };
}
function $6e8e01578b1d58c7$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $6e8e01578b1d58c7$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $6e8e01578b1d58c7$var$onAdd(typename, value, capture) {
    var wrap = $6e8e01578b1d58c7$var$filterEvents.hasOwnProperty(typename.type) ? $6e8e01578b1d58c7$var$filterContextListener : $6e8e01578b1d58c7$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $6e8e01578b1d58c7$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $6e8e01578b1d58c7$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $6e8e01578b1d58c7$var$onAdd : $6e8e01578b1d58c7$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $6e8e01578b1d58c7$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $6e8e01578b1d58c7$export$6cd530ed55e06764;
    event1.sourceEvent = $6e8e01578b1d58c7$export$6cd530ed55e06764;
    $6e8e01578b1d58c7$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $6e8e01578b1d58c7$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("hSCak", function(module, exports) {

$parcel$export(module.exports, "default", () => $d04515b406c82df8$export$2e2bcd8739ae039);

var $hsJLh = parcelRequire("hsJLh");
function $d04515b406c82df8$var$dispatchEvent(node, type, params) {
    var window = (0, $hsJLh.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $d04515b406c82df8$var$dispatchConstant(type, params) {
    return function() {
        return $d04515b406c82df8$var$dispatchEvent(this, type, params);
    };
}
function $d04515b406c82df8$var$dispatchFunction(type, params) {
    return function() {
        return $d04515b406c82df8$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $d04515b406c82df8$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $d04515b406c82df8$var$dispatchFunction : $d04515b406c82df8$var$dispatchConstant)(type, params));
}

});


parcelRegister("gJjsY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2dff2edffea0e1c$export$2e2bcd8739ae039);

var $6mJfg = parcelRequire("6mJfg");
function $c2dff2edffea0e1c$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $6mJfg.default)(this, name);
    });
}

});
parcelRegister("6mJfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a27e4e3a17398a2$export$2e2bcd8739ae039);

var $eEHOj = parcelRequire("eEHOj");
function $4a27e4e3a17398a2$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $eEHOj.STARTING) && schedule.state < (0, $eEHOj.ENDING);
        schedule.state = (0, $eEHOj.ENDED);
        schedule.timer.stop();
        if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("eEHOj", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", () => $aab6c8f198631485$export$584530fe98d14a84);
$parcel$export(module.exports, "STARTING", () => $aab6c8f198631485$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $aab6c8f198631485$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $aab6c8f198631485$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $aab6c8f198631485$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $aab6c8f198631485$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $aab6c8f198631485$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $aab6c8f198631485$export$adaa4cf7ef1b65be);

var $4v5bo = parcelRequire("4v5bo");

var $isMu7 = parcelRequire("isMu7");
var $k3DVA = parcelRequire("k3DVA");
var $aab6c8f198631485$var$emptyOn = (0, $4v5bo.default)("start", "end", "interrupt");
var $aab6c8f198631485$var$emptyTween = [];
var $aab6c8f198631485$export$ff39ebd4bb12b718 = 0;
var $aab6c8f198631485$export$584530fe98d14a84 = 1;
var $aab6c8f198631485$export$a5d151aee16efd42 = 2;
var $aab6c8f198631485$export$fb935ab5849a0db9 = 3;
var $aab6c8f198631485$export$1573e22b087389af = 4;
var $aab6c8f198631485$export$a2e792214ded83b2 = 5;
var $aab6c8f198631485$export$9d38167254403955 = 6;
function $aab6c8f198631485$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $aab6c8f198631485$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $aab6c8f198631485$var$emptyOn,
        tween: $aab6c8f198631485$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $aab6c8f198631485$export$ff39ebd4bb12b718
    });
}
function $aab6c8f198631485$export$2cd8252107eb640b(node, id) {
    var schedule = $aab6c8f198631485$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $aab6c8f198631485$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $aab6c8f198631485$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $aab6c8f198631485$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $aab6c8f198631485$export$a5d151aee16efd42) throw new Error("too late; already started");
    return schedule;
}
function $aab6c8f198631485$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $aab6c8f198631485$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $k3DVA.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $aab6c8f198631485$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $aab6c8f198631485$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $aab6c8f198631485$export$fb935ab5849a0db9) return (0, $isMu7.default)(start);
            // Interrupt the active transition, if any.
            // Dispatch the interrupt event.
            if (o.state === $aab6c8f198631485$export$1573e22b087389af) {
                o.state = $aab6c8f198631485$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $aab6c8f198631485$export$9d38167254403955;
                o.timer.stop();
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $isMu7.default)(function() {
            if (self.state === $aab6c8f198631485$export$fb935ab5849a0db9) {
                self.state = $aab6c8f198631485$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $aab6c8f198631485$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $aab6c8f198631485$export$a5d151aee16efd42) return; // interrupted
        self.state = $aab6c8f198631485$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $aab6c8f198631485$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(null, t);
        // Dispatch the end event.
        if (self.state === $aab6c8f198631485$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $aab6c8f198631485$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("4v5bo", function(module, exports) {

$parcel$export(module.exports, "default", () => $346e13dc9221f208$export$2e2bcd8739ae039);
var $346e13dc9221f208$var$noop = {
    value: function() {}
};
function $346e13dc9221f208$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $346e13dc9221f208$var$Dispatch(_);
}
function $346e13dc9221f208$var$Dispatch(_) {
    this._ = _;
}
function $346e13dc9221f208$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$346e13dc9221f208$var$Dispatch.prototype = $346e13dc9221f208$var$dispatch.prototype = {
    constructor: $346e13dc9221f208$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $346e13dc9221f208$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $346e13dc9221f208$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $346e13dc9221f208$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $346e13dc9221f208$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $346e13dc9221f208$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $346e13dc9221f208$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $346e13dc9221f208$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $346e13dc9221f208$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $346e13dc9221f208$export$2e2bcd8739ae039 = $346e13dc9221f208$var$dispatch;

});

parcelRegister("isMu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d710739610151839$export$2e2bcd8739ae039);

var $k3DVA = parcelRequire("k3DVA");
function $d710739610151839$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $k3DVA.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("k3DVA", function(module, exports) {

$parcel$export(module.exports, "now", () => $e9a30f4f73322838$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $e9a30f4f73322838$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $e9a30f4f73322838$export$9dc4ecf953986f04);
var $e9a30f4f73322838$var$frame = 0, $e9a30f4f73322838$var$timeout = 0, $e9a30f4f73322838$var$interval = 0, $e9a30f4f73322838$var$pokeDelay = 1000, $e9a30f4f73322838$var$taskHead, $e9a30f4f73322838$var$taskTail, $e9a30f4f73322838$var$clockLast = 0, $e9a30f4f73322838$var$clockNow = 0, $e9a30f4f73322838$var$clockSkew = 0, $e9a30f4f73322838$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e9a30f4f73322838$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e9a30f4f73322838$export$461939dd4422153() {
    return $e9a30f4f73322838$var$clockNow || ($e9a30f4f73322838$var$setFrame($e9a30f4f73322838$var$clearNow), $e9a30f4f73322838$var$clockNow = $e9a30f4f73322838$var$clock.now() + $e9a30f4f73322838$var$clockSkew);
}
function $e9a30f4f73322838$var$clearNow() {
    $e9a30f4f73322838$var$clockNow = 0;
}
function $e9a30f4f73322838$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e9a30f4f73322838$export$c57e9b2d8b9e4de.prototype = $e9a30f4f73322838$export$9dc4ecf953986f04.prototype = {
    constructor: $e9a30f4f73322838$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e9a30f4f73322838$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e9a30f4f73322838$var$taskTail !== this) {
            if ($e9a30f4f73322838$var$taskTail) $e9a30f4f73322838$var$taskTail._next = this;
            else $e9a30f4f73322838$var$taskHead = this;
            $e9a30f4f73322838$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e9a30f4f73322838$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e9a30f4f73322838$var$sleep();
        }
    }
};
function $e9a30f4f73322838$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e9a30f4f73322838$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e9a30f4f73322838$export$d60154c1d7f3990e() {
    $e9a30f4f73322838$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e9a30f4f73322838$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e9a30f4f73322838$var$taskHead, e;
    while(t){
        if ((e = $e9a30f4f73322838$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$e9a30f4f73322838$var$frame;
}
function $e9a30f4f73322838$var$wake() {
    $e9a30f4f73322838$var$clockNow = ($e9a30f4f73322838$var$clockLast = $e9a30f4f73322838$var$clock.now()) + $e9a30f4f73322838$var$clockSkew;
    $e9a30f4f73322838$var$frame = $e9a30f4f73322838$var$timeout = 0;
    try {
        $e9a30f4f73322838$export$d60154c1d7f3990e();
    } finally{
        $e9a30f4f73322838$var$frame = 0;
        $e9a30f4f73322838$var$nap();
        $e9a30f4f73322838$var$clockNow = 0;
    }
}
function $e9a30f4f73322838$var$poke() {
    var now = $e9a30f4f73322838$var$clock.now(), delay = now - $e9a30f4f73322838$var$clockLast;
    if (delay > $e9a30f4f73322838$var$pokeDelay) $e9a30f4f73322838$var$clockSkew -= delay, $e9a30f4f73322838$var$clockLast = now;
}
function $e9a30f4f73322838$var$nap() {
    var t0, t1 = $e9a30f4f73322838$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e9a30f4f73322838$var$taskHead = t2;
    }
    $e9a30f4f73322838$var$taskTail = t0;
    $e9a30f4f73322838$var$sleep(time);
}
function $e9a30f4f73322838$var$sleep(time) {
    if ($e9a30f4f73322838$var$frame) return; // Soonest alarm already set, or will be.
    if ($e9a30f4f73322838$var$timeout) $e9a30f4f73322838$var$timeout = clearTimeout($e9a30f4f73322838$var$timeout);
    var delay = time - $e9a30f4f73322838$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e9a30f4f73322838$var$timeout = setTimeout($e9a30f4f73322838$var$wake, time - $e9a30f4f73322838$var$clock.now() - $e9a30f4f73322838$var$clockSkew);
        if ($e9a30f4f73322838$var$interval) $e9a30f4f73322838$var$interval = clearInterval($e9a30f4f73322838$var$interval);
    } else {
        if (!$e9a30f4f73322838$var$interval) $e9a30f4f73322838$var$clockLast = $e9a30f4f73322838$var$clock.now(), $e9a30f4f73322838$var$interval = setInterval($e9a30f4f73322838$var$poke, $e9a30f4f73322838$var$pokeDelay);
        $e9a30f4f73322838$var$frame = 1, $e9a30f4f73322838$var$setFrame($e9a30f4f73322838$var$wake);
    }
}

});





parcelRegister("1KswV", function(module, exports) {

$parcel$export(module.exports, "default", () => $146037ca9df46a4e$export$2e2bcd8739ae039);

var $9imxx = parcelRequire("9imxx");

var $eEHOj = parcelRequire("eEHOj");

var $2eK9M = parcelRequire("2eK9M");

var $k3DVA = parcelRequire("k3DVA");
var $146037ca9df46a4e$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $2eK9M.cubicInOut)
};
function $146037ca9df46a4e$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $146037ca9df46a4e$var$defaultTiming.time = (0, $k3DVA.now)(), $146037ca9df46a4e$var$defaultTiming;
    }
    return timing;
}
function $146037ca9df46a4e$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $9imxx.Transition)) id = name._id, name = name._name;
    else id = (0, $9imxx.newId)(), (timing = $146037ca9df46a4e$var$defaultTiming).time = (0, $k3DVA.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $eEHOj.default)(node, name, id, i, group, timing || $146037ca9df46a4e$var$inherit(node, id));
    }
    return new (0, $9imxx.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("9imxx", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $6c474774258e280d$export$be58926105124dd4);
$parcel$export(module.exports, "newId", () => $6c474774258e280d$export$9ffd10a3fbdc175b);

var $6vKFG = parcelRequire("6vKFG");

var $iXEl6 = parcelRequire("iXEl6");

var $lOyWb = parcelRequire("lOyWb");

var $735jK = parcelRequire("735jK");

var $giHZ6 = parcelRequire("giHZ6");

var $6t3ES = parcelRequire("6t3ES");

var $jbMaj = parcelRequire("jbMaj");

var $7kuRW = parcelRequire("7kuRW");

var $1bvKE = parcelRequire("1bvKE");

var $fvXz0 = parcelRequire("fvXz0");

var $lravA = parcelRequire("lravA");

var $d5tmr = parcelRequire("d5tmr");

var $jByLB = parcelRequire("jByLB");

var $6nIzF = parcelRequire("6nIzF");

var $2pYDB = parcelRequire("2pYDB");

var $e1Sx7 = parcelRequire("e1Sx7");

var $h0zZV = parcelRequire("h0zZV");

var $hpX2f = parcelRequire("hpX2f");
var $6c474774258e280d$var$id = 0;
function $6c474774258e280d$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $6c474774258e280d$export$2e2bcd8739ae039(name) {
    return (0, $6vKFG.default)().transition(name);
}
function $6c474774258e280d$export$9ffd10a3fbdc175b() {
    return ++$6c474774258e280d$var$id;
}
var $6c474774258e280d$var$selection_prototype = (0, $6vKFG.default).prototype;
$6c474774258e280d$export$be58926105124dd4.prototype = $6c474774258e280d$export$2e2bcd8739ae039.prototype = {
    constructor: $6c474774258e280d$export$be58926105124dd4,
    select: (0, $lravA.default),
    selectAll: (0, $d5tmr.default),
    filter: (0, $jbMaj.default),
    merge: (0, $7kuRW.default),
    selection: (0, $jByLB.default),
    transition: (0, $h0zZV.default),
    call: $6c474774258e280d$var$selection_prototype.call,
    nodes: $6c474774258e280d$var$selection_prototype.nodes,
    node: $6c474774258e280d$var$selection_prototype.node,
    size: $6c474774258e280d$var$selection_prototype.size,
    empty: $6c474774258e280d$var$selection_prototype.empty,
    each: $6c474774258e280d$var$selection_prototype.each,
    on: (0, $1bvKE.default),
    attr: (0, $iXEl6.default),
    attrTween: (0, $lOyWb.default),
    style: (0, $6nIzF.default),
    styleTween: (0, $2pYDB.default),
    text: (0, $e1Sx7.default),
    remove: (0, $fvXz0.default),
    tween: (0, $hpX2f.default),
    delay: (0, $735jK.default),
    duration: (0, $giHZ6.default),
    ease: (0, $6t3ES.default)
};

});
parcelRegister("iXEl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcdd0742fbc32dea$export$2e2bcd8739ae039);

var $6w62Q = parcelRequire("6w62Q");

var $blAzP = parcelRequire("blAzP");

var $hpX2f = parcelRequire("hpX2f");

var $f9wbS = parcelRequire("f9wbS");
function $dcdd0742fbc32dea$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $dcdd0742fbc32dea$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $dcdd0742fbc32dea$var$attrConstant(name, interpolate, value1) {
    var value00, interpolate0;
    return function() {
        var value0 = this.getAttribute(name);
        return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
    };
}
function $dcdd0742fbc32dea$var$attrConstantNS(fullname, interpolate, value1) {
    var value00, interpolate0;
    return function() {
        var value0 = this.getAttributeNS(fullname.space, fullname.local);
        return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
    };
}
function $dcdd0742fbc32dea$var$attrFunction(name, interpolate, value) {
    var value00, value10, interpolate0;
    return function() {
        var value0, value1 = value(this);
        if (value1 == null) return void this.removeAttribute(name);
        value0 = this.getAttribute(name);
        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
    };
}
function $dcdd0742fbc32dea$var$attrFunctionNS(fullname, interpolate, value) {
    var value00, value10, interpolate0;
    return function() {
        var value0, value1 = value(this);
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        value0 = this.getAttributeNS(fullname.space, fullname.local);
        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
    };
}
function $dcdd0742fbc32dea$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $blAzP.default)(name), i = fullname === "transform" ? (0, $6w62Q.interpolateTransformSvg) : (0, $f9wbS.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $dcdd0742fbc32dea$var$attrFunctionNS : $dcdd0742fbc32dea$var$attrFunction)(fullname, i, (0, $hpX2f.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $dcdd0742fbc32dea$var$attrRemoveNS : $dcdd0742fbc32dea$var$attrRemove)(fullname) : (fullname.local ? $dcdd0742fbc32dea$var$attrConstantNS : $dcdd0742fbc32dea$var$attrConstant)(fullname, i, value + ""));
}

});
parcelRegister("6w62Q", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $4bea6ba221b0b93c$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $4bea6ba221b0b93c$export$da8cba906d64c082);

var $8n3vf = parcelRequire("8n3vf");

var $1xoms = parcelRequire("1xoms");
function $4bea6ba221b0b93c$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $8n3vf.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $8n3vf.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $8n3vf.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $8n3vf.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $8n3vf.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $8n3vf.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $4bea6ba221b0b93c$export$56bec7123bb3589a = $4bea6ba221b0b93c$var$interpolateTransform((0, $1xoms.parseCss), "px, ", "px)", "deg)");
var $4bea6ba221b0b93c$export$da8cba906d64c082 = $4bea6ba221b0b93c$var$interpolateTransform((0, $1xoms.parseSvg), ", ", ")", ")");

});
parcelRegister("8n3vf", function(module, exports) {

$parcel$export(module.exports, "default", () => $61833059542b802a$export$2e2bcd8739ae039);
function $61833059542b802a$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("1xoms", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $11ebc5222ba8bf3b$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $11ebc5222ba8bf3b$export$f9ef43f9a1d89a18);

var $5HU7y = parcelRequire("5HU7y");
var $11ebc5222ba8bf3b$var$cssNode, $11ebc5222ba8bf3b$var$cssRoot, $11ebc5222ba8bf3b$var$cssView, $11ebc5222ba8bf3b$var$svgNode;
function $11ebc5222ba8bf3b$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $5HU7y.identity;
    if (!$11ebc5222ba8bf3b$var$cssNode) $11ebc5222ba8bf3b$var$cssNode = document.createElement("DIV"), $11ebc5222ba8bf3b$var$cssRoot = document.documentElement, $11ebc5222ba8bf3b$var$cssView = document.defaultView;
    $11ebc5222ba8bf3b$var$cssNode.style.transform = value;
    value = $11ebc5222ba8bf3b$var$cssView.getComputedStyle($11ebc5222ba8bf3b$var$cssRoot.appendChild($11ebc5222ba8bf3b$var$cssNode), null).getPropertyValue("transform");
    $11ebc5222ba8bf3b$var$cssRoot.removeChild($11ebc5222ba8bf3b$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $5HU7y.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $11ebc5222ba8bf3b$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $5HU7y.identity;
    if (!$11ebc5222ba8bf3b$var$svgNode) $11ebc5222ba8bf3b$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $11ebc5222ba8bf3b$var$svgNode.setAttribute("transform", value);
    if (!(value = $11ebc5222ba8bf3b$var$svgNode.transform.baseVal.consolidate())) return 0, $5HU7y.identity;
    value = value.matrix;
    return (0, $5HU7y.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("5HU7y", function(module, exports) {

$parcel$export(module.exports, "identity", () => $427c804ee31e38f3$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $427c804ee31e38f3$export$2e2bcd8739ae039);
var $427c804ee31e38f3$var$degrees = 180 / Math.PI;
var $427c804ee31e38f3$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $427c804ee31e38f3$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $427c804ee31e38f3$var$degrees,
        skewX: Math.atan(skewX) * $427c804ee31e38f3$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("hpX2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae2909edcb089e8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $cae2909edcb089e8$export$f78ce6ab10405d82);

var $eEHOj = parcelRequire("eEHOj");
function $cae2909edcb089e8$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $eEHOj.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $cae2909edcb089e8$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $eEHOj.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $cae2909edcb089e8$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $eEHOj.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $cae2909edcb089e8$var$tweenRemove : $cae2909edcb089e8$var$tweenFunction)(id, name, value));
}
function $cae2909edcb089e8$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $eEHOj.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $eEHOj.get)(node, id).value[name];
    };
}

});

parcelRegister("f9wbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b080aaa3bdcd9945$export$2e2bcd8739ae039);

var $gq3R7 = parcelRequire("gq3R7");

var $8n3vf = parcelRequire("8n3vf");
var $2YCeT = parcelRequire("2YCeT");
var $cmn5K = parcelRequire("cmn5K");
function $b080aaa3bdcd9945$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $8n3vf.default) : b instanceof (0, $gq3R7.default) ? (0, $2YCeT.default) : (c = (0, $gq3R7.default)(b)) ? (b = c, $2YCeT.default) : (0, $cmn5K.default))(a, b);
}

});
parcelRegister("gq3R7", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $jUiQs = parcelRequire("jUiQs");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $jUiQs.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $jUiQs.default)(Rgb, rgb, (0, $jUiQs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $jUiQs.default)(Hsl, hsl, (0, $jUiQs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("jUiQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e1dd848bbe3fb9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $e7e1dd848bbe3fb9$export$8b58be045bf06082);
function $e7e1dd848bbe3fb9$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $e7e1dd848bbe3fb9$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("2YCeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $22aed8e4033a30f7$export$2e2bcd8739ae039);

var $gq3R7 = parcelRequire("gq3R7");

var $ihIHd = parcelRequire("ihIHd");

var $ldRfh = parcelRequire("ldRfh");

var $huvQj = parcelRequire("huvQj");
var $22aed8e4033a30f7$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $huvQj.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $gq3R7.rgb)(start)).r, (end = (0, $gq3R7.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $huvQj.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $22aed8e4033a30f7$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $gq3R7.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $22aed8e4033a30f7$export$2c0e28f2e2852d3f = $22aed8e4033a30f7$var$rgbSpline((0, $ihIHd.default));
var $22aed8e4033a30f7$export$53d5214f625ccd4c = $22aed8e4033a30f7$var$rgbSpline((0, $ldRfh.default));

});
parcelRegister("ihIHd", function(module, exports) {

$parcel$export(module.exports, "basis", () => $d4fc7c35f5a4c349$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $d4fc7c35f5a4c349$export$2e2bcd8739ae039);
function $d4fc7c35f5a4c349$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $d4fc7c35f5a4c349$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $d4fc7c35f5a4c349$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("ldRfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7341d4b56e7f8d1$export$2e2bcd8739ae039);

var $ihIHd = parcelRequire("ihIHd");
function $f7341d4b56e7f8d1$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $ihIHd.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("huvQj", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $cbbdf04df2577859$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $cbbdf04df2577859$export$2e2bcd8739ae039);

var $fzTmJ = parcelRequire("fzTmJ");
function $cbbdf04df2577859$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $cbbdf04df2577859$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $cbbdf04df2577859$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $cbbdf04df2577859$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $fzTmJ.default)(isNaN(a) ? b : a);
}
function $cbbdf04df2577859$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $cbbdf04df2577859$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $cbbdf04df2577859$var$exponential(a, b, y) : (0, $fzTmJ.default)(isNaN(a) ? b : a);
    };
}
function $cbbdf04df2577859$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $cbbdf04df2577859$var$linear(a, d) : (0, $fzTmJ.default)(isNaN(a) ? b : a);
}

});
parcelRegister("fzTmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5751261e38995b5$export$2e2bcd8739ae039);
function $b5751261e38995b5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("cmn5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $0252799b83fda4b8$export$2e2bcd8739ae039);

var $8n3vf = parcelRequire("8n3vf");
var $0252799b83fda4b8$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $0252799b83fda4b8$var$reB = new RegExp($0252799b83fda4b8$var$reA.source, "g");
function $0252799b83fda4b8$var$zero(b) {
    return function() {
        return b;
    };
}
function $0252799b83fda4b8$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $0252799b83fda4b8$export$2e2bcd8739ae039(a, b) {
    var bi = $0252799b83fda4b8$var$reA.lastIndex = $0252799b83fda4b8$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $0252799b83fda4b8$var$reA.exec(a)) && (bm = $0252799b83fda4b8$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $8n3vf.default)(am, bm)
            });
        }
        bi = $0252799b83fda4b8$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $0252799b83fda4b8$var$one(q[0].x) : $0252799b83fda4b8$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});



parcelRegister("lOyWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe195e545a8042ce$export$2e2bcd8739ae039);

var $blAzP = parcelRequire("blAzP");
function $fe195e545a8042ce$var$attrTweenNS(fullname, value) {
    function tween() {
        var node = this, i = value.apply(node, arguments);
        return i && function(t) {
            node.setAttributeNS(fullname.space, fullname.local, i(t));
        };
    }
    tween._value = value;
    return tween;
}
function $fe195e545a8042ce$var$attrTween(name, value) {
    function tween() {
        var node = this, i = value.apply(node, arguments);
        return i && function(t) {
            node.setAttribute(name, i(t));
        };
    }
    tween._value = value;
    return tween;
}
function $fe195e545a8042ce$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $blAzP.default)(name);
    return this.tween(key, (fullname.local ? $fe195e545a8042ce$var$attrTweenNS : $fe195e545a8042ce$var$attrTween)(fullname, value));
}

});

parcelRegister("735jK", function(module, exports) {

$parcel$export(module.exports, "default", () => $521cf02e81630e74$export$2e2bcd8739ae039);

var $eEHOj = parcelRequire("eEHOj");
function $521cf02e81630e74$var$delayFunction(id, value) {
    return function() {
        (0, $eEHOj.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $521cf02e81630e74$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $eEHOj.init)(this, id).delay = value;
    };
}
function $521cf02e81630e74$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $521cf02e81630e74$var$delayFunction : $521cf02e81630e74$var$delayConstant)(id, value)) : (0, $eEHOj.get)(this.node(), id).delay;
}

});

parcelRegister("giHZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde0722bc2898742$export$2e2bcd8739ae039);

var $eEHOj = parcelRequire("eEHOj");
function $bde0722bc2898742$var$durationFunction(id, value) {
    return function() {
        (0, $eEHOj.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $bde0722bc2898742$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $eEHOj.set)(this, id).duration = value;
    };
}
function $bde0722bc2898742$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $bde0722bc2898742$var$durationFunction : $bde0722bc2898742$var$durationConstant)(id, value)) : (0, $eEHOj.get)(this.node(), id).duration;
}

});

parcelRegister("6t3ES", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b5849f985c7eeb6$export$2e2bcd8739ae039);

var $eEHOj = parcelRequire("eEHOj");
function $4b5849f985c7eeb6$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $eEHOj.set)(this, id).ease = value;
    };
}
function $4b5849f985c7eeb6$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($4b5849f985c7eeb6$var$easeConstant(id, value)) : (0, $eEHOj.get)(this.node(), id).ease;
}

});

parcelRegister("jbMaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $df846803e76282b5$export$2e2bcd8739ae039);

var $h3To8 = parcelRequire("h3To8");

var $9imxx = parcelRequire("9imxx");
function $df846803e76282b5$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $h3To8.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $9imxx.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("7kuRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $556258a02d6020df$export$2e2bcd8739ae039);

var $9imxx = parcelRequire("9imxx");
function $556258a02d6020df$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $9imxx.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("1bvKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dcf72b35d6ddae8$export$2e2bcd8739ae039);

var $eEHOj = parcelRequire("eEHOj");
function $0dcf72b35d6ddae8$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $0dcf72b35d6ddae8$var$onFunction(id, name, listener) {
    var on0, on1, sit = $0dcf72b35d6ddae8$var$start(name) ? (0, $eEHOj.init) : (0, $eEHOj.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $0dcf72b35d6ddae8$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $eEHOj.get)(this.node(), id).on.on(name) : this.each($0dcf72b35d6ddae8$var$onFunction(id, name, listener));
}

});

parcelRegister("fvXz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4b7f459a0e07c0b$export$2e2bcd8739ae039);
function $b4b7f459a0e07c0b$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b4b7f459a0e07c0b$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b4b7f459a0e07c0b$var$removeFunction(this._id));
}

});

parcelRegister("lravA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b4455bd4391f9c$export$2e2bcd8739ae039);

var $APwpA = parcelRequire("APwpA");

var $9imxx = parcelRequire("9imxx");

var $eEHOj = parcelRequire("eEHOj");
function $f9b4455bd4391f9c$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $APwpA.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $eEHOj.default)(subgroup[i], name, id, i, subgroup, (0, $eEHOj.get)(node, id));
        }
    }
    return new (0, $9imxx.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("d5tmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $98728475d57ae2e4$export$2e2bcd8739ae039);

var $jFKx4 = parcelRequire("jFKx4");

var $9imxx = parcelRequire("9imxx");

var $eEHOj = parcelRequire("eEHOj");
function $98728475d57ae2e4$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $jFKx4.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $eEHOj.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $eEHOj.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $9imxx.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("jByLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e45c70fabee55b87$export$2e2bcd8739ae039);

var $6vKFG = parcelRequire("6vKFG");
var $e45c70fabee55b87$var$Selection = (0, $6vKFG.default).prototype.constructor;
function $e45c70fabee55b87$export$2e2bcd8739ae039() {
    return new $e45c70fabee55b87$var$Selection(this._groups, this._parents);
}

});

parcelRegister("6nIzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a5777952512ac9f$export$2e2bcd8739ae039);

var $6w62Q = parcelRequire("6w62Q");

var $5INzf = parcelRequire("5INzf");

var $hpX2f = parcelRequire("hpX2f");

var $f9wbS = parcelRequire("f9wbS");
function $4a5777952512ac9f$var$styleRemove(name, interpolate) {
    var value00, value10, interpolate0;
    return function() {
        var value0 = (0, $5INzf.styleValue)(this, name), value1 = (this.style.removeProperty(name), (0, $5INzf.styleValue)(this, name));
        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
    };
}
function $4a5777952512ac9f$var$styleRemoveEnd(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $4a5777952512ac9f$var$styleConstant(name, interpolate, value1) {
    var value00, interpolate0;
    return function() {
        var value0 = (0, $5INzf.styleValue)(this, name);
        return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
    };
}
function $4a5777952512ac9f$var$styleFunction(name, interpolate, value) {
    var value00, value10, interpolate0;
    return function() {
        var value0 = (0, $5INzf.styleValue)(this, name), value1 = value(this);
        if (value1 == null) value1 = (this.style.removeProperty(name), (0, $5INzf.styleValue)(this, name));
        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
    };
}
function $4a5777952512ac9f$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $6w62Q.interpolateTransformCss) : (0, $f9wbS.default);
    return value == null ? this.styleTween(name, $4a5777952512ac9f$var$styleRemove(name, i)).on("end.style." + name, $4a5777952512ac9f$var$styleRemoveEnd(name)) : this.styleTween(name, typeof value === "function" ? $4a5777952512ac9f$var$styleFunction(name, i, (0, $hpX2f.tweenValue)(this, "style." + name, value)) : $4a5777952512ac9f$var$styleConstant(name, i, value + ""), priority);
}

});

parcelRegister("2pYDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2cf3f4434a09ab$export$2e2bcd8739ae039);
function $1c2cf3f4434a09ab$var$styleTween(name, value, priority) {
    function tween() {
        var node = this, i = value.apply(node, arguments);
        return i && function(t) {
            node.style.setProperty(name, i(t), priority);
        };
    }
    tween._value = value;
    return tween;
}
function $1c2cf3f4434a09ab$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $1c2cf3f4434a09ab$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("e1Sx7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36b75d09bac5be1$export$2e2bcd8739ae039);

var $hpX2f = parcelRequire("hpX2f");
function $a36b75d09bac5be1$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $a36b75d09bac5be1$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $a36b75d09bac5be1$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $a36b75d09bac5be1$var$textFunction((0, $hpX2f.tweenValue)(this, "text", value)) : $a36b75d09bac5be1$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("h0zZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c61e5c26b3c0e6a4$export$2e2bcd8739ae039);

var $9imxx = parcelRequire("9imxx");

var $eEHOj = parcelRequire("eEHOj");
function $c61e5c26b3c0e6a4$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $9imxx.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $eEHOj.get)(node, id0);
            (0, $eEHOj.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $9imxx.Transition)(groups, this._parents, name, id1);
}

});


parcelRegister("2eK9M", function(module, exports) {

$parcel$export(module.exports, "cubicInOut", () => $1a10b15dfd130e6a$export$89238d3bc79d3ada);
function $1a10b15dfd130e6a$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $1a10b15dfd130e6a$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $1a10b15dfd130e6a$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("fujev", function(module, exports) {

var $9imxx = parcelRequire("9imxx");

var $eEHOj = parcelRequire("eEHOj");
var $b46893a2a253d7bd$var$root = [
    null
];
function $b46893a2a253d7bd$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $eEHOj.SCHEDULED) && schedule.name === name) return new (0, $9imxx.Transition)([
                [
                    node
                ]
            ], $b46893a2a253d7bd$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("7Jt2T", function(module, exports) {

var $9aPFO = parcelRequire("9aPFO");

});
parcelRegister("9aPFO", function(module, exports) {

var $e5sTs = parcelRequire("e5sTs");

var $gLIqb = parcelRequire("gLIqb");

var $3R9TQ = parcelRequire("3R9TQ");
function $6add2180b486c66b$export$2e2bcd8739ae039() {
    var x = (0, $gLIqb.x), y = (0, $gLIqb.y), extent = null;
    function voronoi(data) {
        return new (0, $3R9TQ.default)(data.map(function(d, i) {
            var s = [
                Math.round(x(d, i, data) / (0, $3R9TQ.epsilon)) * (0, $3R9TQ.epsilon),
                Math.round(y(d, i, data) / (0, $3R9TQ.epsilon)) * (0, $3R9TQ.epsilon)
            ];
            s.index = i;
            s.data = d;
            return s;
        }), extent);
    }
    voronoi.polygons = function(data) {
        return voronoi(data).polygons();
    };
    voronoi.links = function(data) {
        return voronoi(data).links();
    };
    voronoi.triangles = function(data) {
        return voronoi(data).triangles();
    };
    voronoi.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $e5sTs.default)(+_), voronoi) : x;
    };
    voronoi.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $e5sTs.default)(+_), voronoi) : y;
    };
    voronoi.extent = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ], voronoi) : extent && [
            [
                extent[0][0],
                extent[0][1]
            ],
            [
                extent[1][0],
                extent[1][1]
            ]
        ];
    };
    voronoi.size = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                0,
                0
            ],
            [
                +_[0],
                +_[1]
            ]
        ], voronoi) : extent && [
            extent[1][0] - extent[0][0],
            extent[1][1] - extent[0][1]
        ];
    };
    return voronoi;
}

});
parcelRegister("e5sTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a417f1f7ebdd692d$export$2e2bcd8739ae039);
function $a417f1f7ebdd692d$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("gLIqb", function(module, exports) {

$parcel$export(module.exports, "x", () => $c3537e40999ebfda$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $c3537e40999ebfda$export$4a5767248b18ef41);
function $c3537e40999ebfda$export$d141bba7fdc215a3(d) {
    return d[0];
}
function $c3537e40999ebfda$export$4a5767248b18ef41(d) {
    return d[1];
}

});

parcelRegister("3R9TQ", function(module, exports) {

$parcel$export(module.exports, "epsilon", () => epsilon);
$parcel$export(module.exports, "epsilon2", () => epsilon2);
$parcel$export(module.exports, "beaches", () => beaches);
$parcel$export(module.exports, "cells", () => cells);
$parcel$export(module.exports, "circles", () => circles);
$parcel$export(module.exports, "edges", () => edges);
$parcel$export(module.exports, "default", () => Diagram);

var $do3Rb = parcelRequire("do3Rb");

var $8QPfC = parcelRequire("8QPfC");

var $72aGh = parcelRequire("72aGh");

var $7XpNS = parcelRequire("7XpNS");

var $7X33e = parcelRequire("7X33e");
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;
function triangleArea(a, b, c) {
    return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}
function lexicographic(a, b) {
    return b[1] - a[1] || b[0] - a[0];
}
function Diagram(sites, extent) {
    var site = sites.sort(lexicographic).pop(), x, y, circle;
    edges = [];
    cells = new Array(sites.length);
    beaches = new (0, $7X33e.default);
    circles = new (0, $7X33e.default);
    while(true){
        circle = (0, $72aGh.firstCircle);
        if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
            if (site[0] !== x || site[1] !== y) {
                (0, $do3Rb.addBeach)(site);
                x = site[0], y = site[1];
            }
            site = sites.pop();
        } else if (circle) (0, $do3Rb.removeBeach)(circle.arc);
        else break;
    }
    (0, $8QPfC.sortCellHalfedges)();
    if (extent) {
        var x0 = +extent[0][0], y0 = +extent[0][1], x1 = +extent[1][0], y1 = +extent[1][1];
        (0, $7XpNS.clipEdges)(x0, y0, x1, y1);
        (0, $8QPfC.clipCells)(x0, y0, x1, y1);
    }
    this.edges = edges;
    this.cells = cells;
    beaches = circles = edges = cells = null;
}
Diagram.prototype = {
    constructor: Diagram,
    polygons: function() {
        var edges = this.edges;
        return this.cells.map(function(cell) {
            var polygon = cell.halfedges.map(function(i) {
                return (0, $8QPfC.cellHalfedgeStart)(cell, edges[i]);
            });
            polygon.data = cell.site.data;
            return polygon;
        });
    },
    triangles: function() {
        var triangles = [], edges = this.edges;
        this.cells.forEach(function(cell, i) {
            if (!(m = (halfedges = cell.halfedges).length)) return;
            var site = cell.site, halfedges, j = -1, m, s0, e1 = edges[halfedges[m - 1]], s1 = e1.left === site ? e1.right : e1.left;
            while(++j < m){
                s0 = s1;
                e1 = edges[halfedges[j]];
                s1 = e1.left === site ? e1.right : e1.left;
                if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) triangles.push([
                    site.data,
                    s0.data,
                    s1.data
                ]);
            }
        });
        return triangles;
    },
    links: function() {
        return this.edges.filter(function(edge) {
            return edge.right;
        }).map(function(edge) {
            return {
                source: edge.left.data,
                target: edge.right.data
            };
        });
    },
    find: function(x, y, radius) {
        var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
        // Use the previously-found cell, or start with an arbitrary one.
        while(!(cell = that.cells[i1]))if (++i1 >= n) return null;
        var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
        // Traverse the half-edges to find a closer cell, if any.
        do {
            cell = that.cells[i0 = i1], i1 = null;
            cell.halfedges.forEach(function(e) {
                var edge = that.edges[e], v = edge.left;
                if ((v === cell.site || !v) && !(v = edge.right)) return;
                var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
                if (v2 < d2) d2 = v2, i1 = v.index;
            });
        }while (i1 !== null);
        that._found = i0;
        return radius == null || d2 <= radius * radius ? cell.site : null;
    }
};

});
parcelRegister("do3Rb", function(module, exports) {

$parcel$export(module.exports, "removeBeach", () => $9bf082222cc5d349$export$25be321a9b2d3c3c);
$parcel$export(module.exports, "addBeach", () => $9bf082222cc5d349$export$fec167a219592370);

var $7X33e = parcelRequire("7X33e");

var $8QPfC = parcelRequire("8QPfC");

var $72aGh = parcelRequire("72aGh");

var $7XpNS = parcelRequire("7XpNS");

var $3R9TQ = parcelRequire("3R9TQ");
var $9bf082222cc5d349$var$beachPool = [];
function $9bf082222cc5d349$var$Beach() {
    (0, $7X33e.RedBlackNode)(this);
    this.edge = this.site = this.circle = null;
}
function $9bf082222cc5d349$var$createBeach(site) {
    var beach = $9bf082222cc5d349$var$beachPool.pop() || new $9bf082222cc5d349$var$Beach;
    beach.site = site;
    return beach;
}
function $9bf082222cc5d349$var$detachBeach(beach) {
    (0, $72aGh.detachCircle)(beach);
    (0, $3R9TQ.beaches).remove(beach);
    $9bf082222cc5d349$var$beachPool.push(beach);
    (0, $7X33e.RedBlackNode)(beach);
}
function $9bf082222cc5d349$export$25be321a9b2d3c3c(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = [
        x,
        y
    ], previous = beach.P, next = beach.N, disappearing = [
        beach
    ];
    $9bf082222cc5d349$var$detachBeach(beach);
    var lArc = previous;
    while(lArc.circle && Math.abs(x - lArc.circle.x) < (0, $3R9TQ.epsilon) && Math.abs(y - lArc.circle.cy) < (0, $3R9TQ.epsilon)){
        previous = lArc.P;
        disappearing.unshift(lArc);
        $9bf082222cc5d349$var$detachBeach(lArc);
        lArc = previous;
    }
    disappearing.unshift(lArc);
    (0, $72aGh.detachCircle)(lArc);
    var rArc = next;
    while(rArc.circle && Math.abs(x - rArc.circle.x) < (0, $3R9TQ.epsilon) && Math.abs(y - rArc.circle.cy) < (0, $3R9TQ.epsilon)){
        next = rArc.N;
        disappearing.push(rArc);
        $9bf082222cc5d349$var$detachBeach(rArc);
        rArc = next;
    }
    disappearing.push(rArc);
    (0, $72aGh.detachCircle)(rArc);
    var nArcs = disappearing.length, iArc;
    for(iArc = 1; iArc < nArcs; ++iArc){
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        (0, $7XpNS.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = (0, $7XpNS.createEdge)(lArc.site, rArc.site, null, vertex);
    (0, $72aGh.attachCircle)(lArc);
    (0, $72aGh.attachCircle)(rArc);
}
function $9bf082222cc5d349$export$fec167a219592370(site) {
    var x = site[0], directrix = site[1], lArc, rArc, dxl, dxr, node = (0, $3R9TQ.beaches)._;
    while(node){
        dxl = $9bf082222cc5d349$var$leftBreakPoint(node, directrix) - x;
        if (dxl > (0, $3R9TQ.epsilon)) node = node.L;
        else {
            dxr = x - $9bf082222cc5d349$var$rightBreakPoint(node, directrix);
            if (dxr > (0, $3R9TQ.epsilon)) {
                if (!node.R) {
                    lArc = node;
                    break;
                }
                node = node.R;
            } else {
                if (dxl > -(0, $3R9TQ.epsilon)) {
                    lArc = node.P;
                    rArc = node;
                } else if (dxr > -(0, $3R9TQ.epsilon)) {
                    lArc = node;
                    rArc = node.N;
                } else lArc = rArc = node;
                break;
            }
        }
    }
    (0, $8QPfC.createCell)(site);
    var newArc = $9bf082222cc5d349$var$createBeach(site);
    (0, $3R9TQ.beaches).insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
        (0, $72aGh.detachCircle)(lArc);
        rArc = $9bf082222cc5d349$var$createBeach(lArc.site);
        (0, $3R9TQ.beaches).insert(newArc, rArc);
        newArc.edge = rArc.edge = (0, $7XpNS.createEdge)(lArc.site, newArc.site);
        (0, $72aGh.attachCircle)(lArc);
        (0, $72aGh.attachCircle)(rArc);
        return;
    }
    if (!rArc) {
        newArc.edge = (0, $7XpNS.createEdge)(lArc.site, newArc.site);
        return;
    }
    // else lArc !== rArc
    (0, $72aGh.detachCircle)(lArc);
    (0, $72aGh.detachCircle)(rArc);
    var lSite = lArc.site, ax = lSite[0], ay = lSite[1], bx = site[0] - ax, by = site[1] - ay, rSite = rArc.site, cx = rSite[0] - ax, cy = rSite[1] - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = [
        (cy * hb - by * hc) / d + ax,
        (bx * hc - cx * hb) / d + ay
    ];
    (0, $7XpNS.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
    newArc.edge = (0, $7XpNS.createEdge)(lSite, site, null, vertex);
    rArc.edge = (0, $7XpNS.createEdge)(site, rSite, null, vertex);
    (0, $72aGh.attachCircle)(lArc);
    (0, $72aGh.attachCircle)(rArc);
}
function $9bf082222cc5d349$var$leftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site[0], rfocy = site[1], pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site[0], lfocy = site[1], plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
}
function $9bf082222cc5d349$var$rightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return $9bf082222cc5d349$var$leftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site[1] === directrix ? site[0] : Infinity;
}

});
parcelRegister("7X33e", function(module, exports) {

$parcel$export(module.exports, "RedBlackNode", () => $5ca068f93e207dd5$export$5072552a5e64b90a);
$parcel$export(module.exports, "default", () => $5ca068f93e207dd5$export$2e2bcd8739ae039);
function $5ca068f93e207dd5$var$RedBlackTree() {
    this._ = null; // root node
}
function $5ca068f93e207dd5$export$5072552a5e64b90a(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null; // next node
}
$5ca068f93e207dd5$var$RedBlackTree.prototype = {
    constructor: $5ca068f93e207dd5$var$RedBlackTree,
    insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
                after = after.R;
                while(after.L)after = after.L;
                after.L = node;
            } else after.R = node;
            parent = after;
        } else if (this._) {
            after = $5ca068f93e207dd5$var$RedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
        } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while(parent && parent.C){
            grandpa = parent.U;
            if (parent === grandpa.L) {
                uncle = grandpa.R;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.R) {
                        $5ca068f93e207dd5$var$RedBlackRotateLeft(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $5ca068f93e207dd5$var$RedBlackRotateRight(this, grandpa);
                }
            } else {
                uncle = grandpa.L;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.L) {
                        $5ca068f93e207dd5$var$RedBlackRotateRight(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $5ca068f93e207dd5$var$RedBlackRotateLeft(this, grandpa);
                }
            }
            parent = after.U;
        }
        this._.C = false;
    },
    remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right;
        else if (!right) next = left;
        else next = $5ca068f93e207dd5$var$RedBlackFirst(right);
        if (parent) {
            if (parent.L === node) parent.L = next;
            else parent.R = next;
        } else this._ = next;
        if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
                parent = next.U;
                next.U = node.U;
                node = next.R;
                parent.L = node;
                next.R = right;
                right.U = next;
            } else {
                next.U = parent;
                parent = next;
                node = next.R;
            }
        } else {
            red = node.C;
            node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
            node.C = false;
            return;
        }
        do {
            if (node === this._) break;
            if (node === parent.L) {
                sibling = parent.R;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $5ca068f93e207dd5$var$RedBlackRotateLeft(this, parent);
                    sibling = parent.R;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.R || !sibling.R.C) {
                        sibling.L.C = false;
                        sibling.C = true;
                        $5ca068f93e207dd5$var$RedBlackRotateRight(this, sibling);
                        sibling = parent.R;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.R.C = false;
                    $5ca068f93e207dd5$var$RedBlackRotateLeft(this, parent);
                    node = this._;
                    break;
                }
            } else {
                sibling = parent.L;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $5ca068f93e207dd5$var$RedBlackRotateRight(this, parent);
                    sibling = parent.L;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.L || !sibling.L.C) {
                        sibling.R.C = false;
                        sibling.C = true;
                        $5ca068f93e207dd5$var$RedBlackRotateLeft(this, sibling);
                        sibling = parent.L;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.L.C = false;
                    $5ca068f93e207dd5$var$RedBlackRotateRight(this, parent);
                    node = this._;
                    break;
                }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
        }while (!node.C);
        if (node) node.C = false;
    }
};
function $5ca068f93e207dd5$var$RedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
}
function $5ca068f93e207dd5$var$RedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
}
function $5ca068f93e207dd5$var$RedBlackFirst(node) {
    while(node.L)node = node.L;
    return node;
}
var $5ca068f93e207dd5$export$2e2bcd8739ae039 = $5ca068f93e207dd5$var$RedBlackTree;

});

parcelRegister("8QPfC", function(module, exports) {

$parcel$export(module.exports, "createCell", () => $671aef6bdd0b1620$export$3cb21b6b1233300e);
$parcel$export(module.exports, "cellHalfedgeStart", () => $671aef6bdd0b1620$export$67c16aa967774be);
$parcel$export(module.exports, "sortCellHalfedges", () => $671aef6bdd0b1620$export$41888d88cbc31210);
$parcel$export(module.exports, "clipCells", () => $671aef6bdd0b1620$export$cdcebd68073bc3f);

var $7XpNS = parcelRequire("7XpNS");

var $3R9TQ = parcelRequire("3R9TQ");
function $671aef6bdd0b1620$export$3cb21b6b1233300e(site) {
    return (0, $3R9TQ.cells)[site.index] = {
        site: site,
        halfedges: []
    };
}
function $671aef6bdd0b1620$var$cellHalfedgeAngle(cell, edge) {
    var site = cell.site, va = edge.left, vb = edge.right;
    if (site === vb) vb = va, va = site;
    if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
    if (site === va) va = edge[1], vb = edge[0];
    else va = edge[0], vb = edge[1];
    return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}
function $671aef6bdd0b1620$export$67c16aa967774be(cell, edge) {
    return edge[+(edge.left !== cell.site)];
}
function $671aef6bdd0b1620$export$bf8e581ba65a00a5(cell, edge) {
    return edge[+(edge.left === cell.site)];
}
function $671aef6bdd0b1620$export$41888d88cbc31210() {
    for(var i = 0, n = (0, $3R9TQ.cells).length, cell, halfedges, j, m; i < n; ++i)if ((cell = (0, $3R9TQ.cells)[i]) && (m = (halfedges = cell.halfedges).length)) {
        var index = new Array(m), array = new Array(m);
        for(j = 0; j < m; ++j)index[j] = j, array[j] = $671aef6bdd0b1620$var$cellHalfedgeAngle(cell, (0, $3R9TQ.edges)[halfedges[j]]);
        index.sort(function(i, j) {
            return array[j] - array[i];
        });
        for(j = 0; j < m; ++j)array[j] = halfedges[index[j]];
        for(j = 0; j < m; ++j)halfedges[j] = array[j];
    }
}
function $671aef6bdd0b1620$export$cdcebd68073bc3f(x0, y0, x1, y1) {
    var nCells = (0, $3R9TQ.cells).length, iCell, cell, site, iHalfedge, halfedges, nHalfedges, start, startX, startY, end, endX, endY, cover = true;
    for(iCell = 0; iCell < nCells; ++iCell)if (cell = (0, $3R9TQ.cells)[iCell]) {
        site = cell.site;
        halfedges = cell.halfedges;
        iHalfedge = halfedges.length;
        // Remove any dangling clipped edges.
        while(iHalfedge--)if (!(0, $3R9TQ.edges)[halfedges[iHalfedge]]) halfedges.splice(iHalfedge, 1);
        // Insert any border edges as necessary.
        iHalfedge = 0, nHalfedges = halfedges.length;
        while(iHalfedge < nHalfedges){
            end = $671aef6bdd0b1620$export$bf8e581ba65a00a5(cell, (0, $3R9TQ.edges)[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
            start = $671aef6bdd0b1620$export$67c16aa967774be(cell, (0, $3R9TQ.edges)[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
            if (Math.abs(endX - startX) > (0, $3R9TQ.epsilon) || Math.abs(endY - startY) > (0, $3R9TQ.epsilon)) {
                halfedges.splice(iHalfedge, 0, (0, $3R9TQ.edges).push((0, $7XpNS.createBorderEdge)(site, end, Math.abs(endX - x0) < (0, $3R9TQ.epsilon) && y1 - endY > (0, $3R9TQ.epsilon) ? [
                    x0,
                    Math.abs(startX - x0) < (0, $3R9TQ.epsilon) ? startY : y1
                ] : Math.abs(endY - y1) < (0, $3R9TQ.epsilon) && x1 - endX > (0, $3R9TQ.epsilon) ? [
                    Math.abs(startY - y1) < (0, $3R9TQ.epsilon) ? startX : x1,
                    y1
                ] : Math.abs(endX - x1) < (0, $3R9TQ.epsilon) && endY - y0 > (0, $3R9TQ.epsilon) ? [
                    x1,
                    Math.abs(startX - x1) < (0, $3R9TQ.epsilon) ? startY : y0
                ] : Math.abs(endY - y0) < (0, $3R9TQ.epsilon) && endX - x0 > (0, $3R9TQ.epsilon) ? [
                    Math.abs(startY - y0) < (0, $3R9TQ.epsilon) ? startX : x0,
                    y0
                ] : null)) - 1);
                ++nHalfedges;
            }
        }
        if (nHalfedges) cover = false;
    }
    // If there weren’t any edges, have the closest site cover the extent.
    // It doesn’t matter which corner of the extent we measure!
    if (cover) {
        var dx, dy, d2, dc = Infinity;
        for(iCell = 0, cover = null; iCell < nCells; ++iCell)if (cell = (0, $3R9TQ.cells)[iCell]) {
            site = cell.site;
            dx = site[0] - x0;
            dy = site[1] - y0;
            d2 = dx * dx + dy * dy;
            if (d2 < dc) dc = d2, cover = cell;
        }
        if (cover) {
            var v00 = [
                x0,
                y0
            ], v01 = [
                x0,
                y1
            ], v11 = [
                x1,
                y1
            ], v10 = [
                x1,
                y0
            ];
            cover.halfedges.push((0, $3R9TQ.edges).push((0, $7XpNS.createBorderEdge)(site = cover.site, v00, v01)) - 1, (0, $3R9TQ.edges).push((0, $7XpNS.createBorderEdge)(site, v01, v11)) - 1, (0, $3R9TQ.edges).push((0, $7XpNS.createBorderEdge)(site, v11, v10)) - 1, (0, $3R9TQ.edges).push((0, $7XpNS.createBorderEdge)(site, v10, v00)) - 1);
        }
    }
    // Lastly delete any cells with no edges; these were entirely clipped.
    for(iCell = 0; iCell < nCells; ++iCell){
        if (cell = (0, $3R9TQ.cells)[iCell]) {
            if (!cell.halfedges.length) delete (0, $3R9TQ.cells)[iCell];
        }
    }
}

});
parcelRegister("7XpNS", function(module, exports) {

$parcel$export(module.exports, "createEdge", () => $5cb20f18ec3bc7a2$export$bdd941b9b8806569);
$parcel$export(module.exports, "setEdgeEnd", () => $5cb20f18ec3bc7a2$export$9e883caea829cb44);
$parcel$export(module.exports, "createBorderEdge", () => $5cb20f18ec3bc7a2$export$681cc0bbec712be1);
$parcel$export(module.exports, "clipEdges", () => $5cb20f18ec3bc7a2$export$db4502aa9c1617af);

var $3R9TQ = parcelRequire("3R9TQ");
function $5cb20f18ec3bc7a2$export$bdd941b9b8806569(left, right, v0, v1) {
    var edge = [
        null,
        null
    ], index = (0, $3R9TQ.edges).push(edge) - 1;
    edge.left = left;
    edge.right = right;
    if (v0) $5cb20f18ec3bc7a2$export$9e883caea829cb44(edge, left, right, v0);
    if (v1) $5cb20f18ec3bc7a2$export$9e883caea829cb44(edge, right, left, v1);
    (0, $3R9TQ.cells)[left.index].halfedges.push(index);
    (0, $3R9TQ.cells)[right.index].halfedges.push(index);
    return edge;
}
function $5cb20f18ec3bc7a2$export$681cc0bbec712be1(left, v0, v1) {
    var edge = [
        v0,
        v1
    ];
    edge.left = left;
    return edge;
}
function $5cb20f18ec3bc7a2$export$9e883caea829cb44(edge, left, right, vertex) {
    if (!edge[0] && !edge[1]) {
        edge[0] = vertex;
        edge.left = left;
        edge.right = right;
    } else if (edge.left === right) edge[1] = vertex;
    else edge[0] = vertex;
}
// Liang–Barsky line clipping.
function $5cb20f18ec3bc7a2$var$clipEdge(edge, x0, y0, x1, y1) {
    var a = edge[0], b = edge[1], ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
    if (t0 > 0) edge[0] = [
        ax + t0 * dx,
        ay + t0 * dy
    ];
    if (t1 < 1) edge[1] = [
        ax + t1 * dx,
        ay + t1 * dy
    ];
    return true;
}
function $5cb20f18ec3bc7a2$var$connectEdge(edge, x0, y0, x1, y1) {
    var v1 = edge[1];
    if (v1) return true;
    var v0 = edge[0], left = edge.left, right = edge.right, lx = left[0], ly = left[1], rx = right[0], ry = right[1], fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
            if (!v0) v0 = [
                fx,
                y0
            ];
            else if (v0[1] >= y1) return;
            v1 = [
                fx,
                y1
            ];
        } else {
            if (!v0) v0 = [
                fx,
                y1
            ];
            else if (v0[1] < y0) return;
            v1 = [
                fx,
                y0
            ];
        }
    } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
            if (lx > rx) {
                if (!v0) v0 = [
                    (y0 - fb) / fm,
                    y0
                ];
                else if (v0[1] >= y1) return;
                v1 = [
                    (y1 - fb) / fm,
                    y1
                ];
            } else {
                if (!v0) v0 = [
                    (y1 - fb) / fm,
                    y1
                ];
                else if (v0[1] < y0) return;
                v1 = [
                    (y0 - fb) / fm,
                    y0
                ];
            }
        } else if (ly < ry) {
            if (!v0) v0 = [
                x0,
                fm * x0 + fb
            ];
            else if (v0[0] >= x1) return;
            v1 = [
                x1,
                fm * x1 + fb
            ];
        } else {
            if (!v0) v0 = [
                x1,
                fm * x1 + fb
            ];
            else if (v0[0] < x0) return;
            v1 = [
                x0,
                fm * x0 + fb
            ];
        }
    }
    edge[0] = v0;
    edge[1] = v1;
    return true;
}
function $5cb20f18ec3bc7a2$export$db4502aa9c1617af(x0, y0, x1, y1) {
    var i = (0, $3R9TQ.edges).length, edge;
    while(i--)if (!$5cb20f18ec3bc7a2$var$connectEdge(edge = (0, $3R9TQ.edges)[i], x0, y0, x1, y1) || !$5cb20f18ec3bc7a2$var$clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > (0, $3R9TQ.epsilon) || Math.abs(edge[0][1] - edge[1][1]) > (0, $3R9TQ.epsilon))) delete (0, $3R9TQ.edges)[i];
}

});


parcelRegister("72aGh", function(module, exports) {

$parcel$export(module.exports, "firstCircle", () => $51f10157a783d14f$export$2ca650a30b282a37);
$parcel$export(module.exports, "attachCircle", () => $51f10157a783d14f$export$2a19333f6373b7a2);
$parcel$export(module.exports, "detachCircle", () => $51f10157a783d14f$export$f0bd50ff687673c1);

var $7X33e = parcelRequire("7X33e");

var $3R9TQ = parcelRequire("3R9TQ");
var $51f10157a783d14f$var$circlePool = [];
var $51f10157a783d14f$export$2ca650a30b282a37;
function $51f10157a783d14f$var$Circle() {
    (0, $7X33e.RedBlackNode)(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
}
function $51f10157a783d14f$export$2a19333f6373b7a2(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite[0], by = cSite[1], ax = lSite[0] - bx, ay = lSite[1] - by, cx = rSite[0] - bx, cy = rSite[1] - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -(0, $3R9TQ.epsilon2)) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d;
    var circle = $51f10157a783d14f$var$circlePool.pop() || new $51f10157a783d14f$var$Circle;
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
    arc.circle = circle;
    var before = null, node = (0, $3R9TQ.circles)._;
    while(node){
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;
            else {
                before = node.P;
                break;
            }
        } else if (node.R) node = node.R;
        else {
            before = node;
            break;
        }
    }
    (0, $3R9TQ.circles).insert(before, circle);
    if (!before) $51f10157a783d14f$export$2ca650a30b282a37 = circle;
}
function $51f10157a783d14f$export$f0bd50ff687673c1(arc) {
    var circle = arc.circle;
    if (circle) {
        if (!circle.P) $51f10157a783d14f$export$2ca650a30b282a37 = circle.N;
        (0, $3R9TQ.circles).remove(circle);
        $51f10157a783d14f$var$circlePool.push(circle);
        (0, $7X33e.RedBlackNode)(circle);
        arc.circle = null;
    }
}

});





parcelRegister("fMdIC", function(module, exports) {

var $jju98 = parcelRequire("jju98");

var $dkO7y = parcelRequire("dkO7y");

});
parcelRegister("jju98", function(module, exports) {

var $4h5V5 = parcelRequire("4h5V5");

var $kza96 = parcelRequire("kza96");

var $5lXLL = parcelRequire("5lXLL");

var $cdh1A = parcelRequire("cdh1A");
var $gZqlB = parcelRequire("gZqlB");
var $kCHcF = parcelRequire("kCHcF");
var $jSl7R = parcelRequire("jSl7R");
parcelRequire("lshu4");
var $4zBBK = parcelRequire("4zBBK");

var $i1cts = parcelRequire("i1cts");

var $3i9Ix = parcelRequire("3i9Ix");

var $dkO7y = parcelRequire("dkO7y");

var $l0VDS = parcelRequire("l0VDS");
// Ignore right-click, since that should open the context menu.
function $e0f72d17aa7f8ff2$var$defaultFilter() {
    return !(0, $cdh1A.event).button;
}
function $e0f72d17aa7f8ff2$var$defaultExtent() {
    var e = this, w, h;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        w = e.width.baseVal.value;
        h = e.height.baseVal.value;
    } else {
        w = e.clientWidth;
        h = e.clientHeight;
    }
    return [
        [
            0,
            0
        ],
        [
            w,
            h
        ]
    ];
}
function $e0f72d17aa7f8ff2$var$defaultTransform() {
    return this.__zoom || (0, $dkO7y.identity);
}
function $e0f72d17aa7f8ff2$var$defaultWheelDelta() {
    return -(0, $cdh1A.event).deltaY * ((0, $cdh1A.event).deltaMode ? 120 : 1) / 500;
}
function $e0f72d17aa7f8ff2$var$defaultTouchable() {
    return "ontouchstart" in this;
}
function $e0f72d17aa7f8ff2$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $e0f72d17aa7f8ff2$export$2e2bcd8739ae039() {
    var filter = $e0f72d17aa7f8ff2$var$defaultFilter, extent = $e0f72d17aa7f8ff2$var$defaultExtent, constrain = $e0f72d17aa7f8ff2$var$defaultConstrain, wheelDelta = $e0f72d17aa7f8ff2$var$defaultWheelDelta, touchable = $e0f72d17aa7f8ff2$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $5lXLL.default), gestures = [], listeners = (0, $4h5V5.default)("start", "zoom", "end"), touchstarting, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0;
    function zoom(selection) {
        selection.property("__zoom", $e0f72d17aa7f8ff2$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $e0f72d17aa7f8ff2$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform);
        else selection.interrupt().each(function() {
            gesture(this, arguments).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        });
    };
    zoom.scaleTo = function(selection, k) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = centroid(e), p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        });
    };
    zoom.translateBy = function(selection, x, y) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        });
    };
    zoom.translateTo = function(selection, x, y) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p = centroid(e);
            return constrain((0, $dkO7y.identity).translate(p[0], p[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        });
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $dkO7y.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $dkO7y.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, center) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args), e = extent.apply(that, args), p = center || centroid(e), w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $dkO7y.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args) {
        for(var i = 0, n = gestures.length, g; i < n; ++i){
            if ((g = gestures[i]).that === that) return g;
        }
        return new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.index = -1;
        this.active = 0;
        this.extent = extent.apply(that, args);
    }
    Gesture.prototype = {
        start: function() {
            if (++this.active === 1) {
                this.index = gestures.push(this) - 1;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                gestures.splice(this.index, 1);
                this.index = -1;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            (0, $cdh1A.customEvent)(new (0, $3i9Ix.default)(zoom, type, this.that.__zoom), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function wheeled() {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $gZqlB.default)(this);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $4zBBK.default)(this);
            g.start();
        }
        (0, $l0VDS.default)();
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), v = (0, $kCHcF.default)((0, $cdh1A.event).view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $gZqlB.default)(this), x0 = (0, $cdh1A.event).clientX, y0 = (0, $cdh1A.event).clientY;
        (0, $kza96.default)((0, $cdh1A.event).view);
        (0, $l0VDS.nopropagation)();
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $4zBBK.default)(this);
        g.start();
        function mousemoved() {
            (0, $l0VDS.default)();
            if (!g.moved) {
                var dx = (0, $cdh1A.event).clientX - x0, dy = (0, $cdh1A.event).clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $gZqlB.default)(g.that), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped() {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $kza96.yesdrag)((0, $cdh1A.event).view, g.moved);
            (0, $l0VDS.default)();
            g.end();
        }
    }
    function dblclicked() {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $gZqlB.default)(this), p1 = t0.invert(p0), k1 = t0.k * ((0, $cdh1A.event).shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
        (0, $l0VDS.default)();
        if (duration > 0) (0, $kCHcF.default)(this).transition().duration(duration).call(schedule, t1, p0);
        else (0, $kCHcF.default)(this).call(zoom.transform, t1);
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), touches = (0, $cdh1A.event).changedTouches, started, n = touches.length, i, t, p;
        (0, $l0VDS.nopropagation)();
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $jSl7R.default)(this, touches, t.identifier);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true;
            else if (!g.touch1) g.touch1 = p;
        }
        // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
        if (touchstarting) {
            touchstarting = clearTimeout(touchstarting);
            if (!g.touch1) {
                g.end();
                p = (0, $kCHcF.default)(this).on("dblclick.zoom");
                if (p) p.apply(this, arguments);
                return;
            }
        }
        if (started) {
            touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $4zBBK.default)(this);
            g.start();
        }
    }
    function touchmoved() {
        var g = gesture(this, arguments), touches = (0, $cdh1A.event).changedTouches, n = touches.length, i, t, p, l;
        (0, $l0VDS.default)();
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $jSl7R.default)(this, touches, t.identifier);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended() {
        var g = gesture(this, arguments), touches = (0, $cdh1A.event).changedTouches, n = touches.length, i, t;
        (0, $l0VDS.nopropagation)();
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else g.end();
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $i1cts.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $i1cts.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $i1cts.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $i1cts.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    return zoom;
}

});
parcelRegister("kza96", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8ef24c8cfbb662$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $ef8ef24c8cfbb662$export$833237748009e1e1);

var $kCHcF = parcelRequire("kCHcF");

var $6OzG5 = parcelRequire("6OzG5");
function $ef8ef24c8cfbb662$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $kCHcF.default)(view).on("dragstart.drag", (0, $6OzG5.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $6OzG5.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $ef8ef24c8cfbb662$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $kCHcF.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $6OzG5.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("kCHcF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f038de826dcf04e6$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");
function $f038de826dcf04e6$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $71I3e.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $71I3e.Selection)([
        [
            selector
        ]
    ], (0, $71I3e.root));
}

});
parcelRegister("71I3e", function(module, exports) {

$parcel$export(module.exports, "root", () => $51dacc0364d439f6$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $51dacc0364d439f6$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $51dacc0364d439f6$export$2e2bcd8739ae039);

var $az2lm = parcelRequire("az2lm");

var $8qOO0 = parcelRequire("8qOO0");

var $21w6c = parcelRequire("21w6c");

var $jZILB = parcelRequire("jZILB");

var $kQxS5 = parcelRequire("kQxS5");

var $2iDjG = parcelRequire("2iDjG");

var $2bUxG = parcelRequire("2bUxG");

var $vYs98 = parcelRequire("vYs98");

var $7az1U = parcelRequire("7az1U");

var $5NQyZ = parcelRequire("5NQyZ");

var $1jaRO = parcelRequire("1jaRO");

var $9JTOe = parcelRequire("9JTOe");

var $hYrEx = parcelRequire("hYrEx");

var $4y1I6 = parcelRequire("4y1I6");

var $8eEs1 = parcelRequire("8eEs1");

var $hUK07 = parcelRequire("hUK07");

var $5FcLt = parcelRequire("5FcLt");

var $7p4b3 = parcelRequire("7p4b3");

var $5tmfn = parcelRequire("5tmfn");

var $hVxsg = parcelRequire("hVxsg");

var $hc3uF = parcelRequire("hc3uF");

var $hbKVt = parcelRequire("hbKVt");

var $c45BA = parcelRequire("c45BA");

var $bQQzq = parcelRequire("bQQzq");

var $apdts = parcelRequire("apdts");

var $3RvP5 = parcelRequire("3RvP5");

var $5Zksf = parcelRequire("5Zksf");

var $eGyQL = parcelRequire("eGyQL");

var $cVn7l = parcelRequire("cVn7l");

var $cdh1A = parcelRequire("cdh1A");

var $belbG = parcelRequire("belbG");
var $51dacc0364d439f6$export$e8e78c978b129247 = [
    null
];
function $51dacc0364d439f6$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $51dacc0364d439f6$var$selection() {
    return new $51dacc0364d439f6$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $51dacc0364d439f6$export$e8e78c978b129247);
}
$51dacc0364d439f6$export$52baac22726c72bf.prototype = $51dacc0364d439f6$var$selection.prototype = {
    constructor: $51dacc0364d439f6$export$52baac22726c72bf,
    select: (0, $az2lm.default),
    selectAll: (0, $8qOO0.default),
    filter: (0, $21w6c.default),
    data: (0, $jZILB.default),
    enter: (0, $kQxS5.default),
    exit: (0, $2iDjG.default),
    join: (0, $2bUxG.default),
    merge: (0, $vYs98.default),
    order: (0, $7az1U.default),
    sort: (0, $5NQyZ.default),
    call: (0, $1jaRO.default),
    nodes: (0, $9JTOe.default),
    node: (0, $hYrEx.default),
    size: (0, $4y1I6.default),
    empty: (0, $8eEs1.default),
    each: (0, $hUK07.default),
    attr: (0, $5FcLt.default),
    style: (0, $7p4b3.default),
    property: (0, $5tmfn.default),
    classed: (0, $hVxsg.default),
    text: (0, $hc3uF.default),
    html: (0, $hbKVt.default),
    raise: (0, $c45BA.default),
    lower: (0, $bQQzq.default),
    append: (0, $apdts.default),
    insert: (0, $3RvP5.default),
    remove: (0, $5Zksf.default),
    clone: (0, $eGyQL.default),
    datum: (0, $cVn7l.default),
    on: (0, $cdh1A.default),
    dispatch: (0, $belbG.default)
};
var $51dacc0364d439f6$export$2e2bcd8739ae039 = $51dacc0364d439f6$var$selection;

});
parcelRegister("az2lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b0efda42c300db2$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");

var $lfS1Y = parcelRequire("lfS1Y");
function $7b0efda42c300db2$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $lfS1Y.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $71I3e.Selection)(subgroups, this._parents);
}

});
parcelRegister("lfS1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f794e91189614b3e$export$2e2bcd8739ae039);
function $f794e91189614b3e$var$none() {}
function $f794e91189614b3e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $f794e91189614b3e$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("8qOO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $623829604b735567$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");

var $eLBth = parcelRequire("eLBth");
function $623829604b735567$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $eLBth.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $71I3e.Selection)(subgroups, parents);
}

});
parcelRegister("eLBth", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac028579b5493d0d$export$2e2bcd8739ae039);
function $ac028579b5493d0d$var$empty() {
    return [];
}
function $ac028579b5493d0d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $ac028579b5493d0d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("21w6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $179492fa5a972faa$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");

var $fVVXs = parcelRequire("fVVXs");
function $179492fa5a972faa$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $fVVXs.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $71I3e.Selection)(subgroups, this._parents);
}

});
parcelRegister("fVVXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9992320fa5b2c5c$export$2e2bcd8739ae039);
function $b9992320fa5b2c5c$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}

});


parcelRegister("jZILB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8e670973c8cb7de$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");

var $kQxS5 = parcelRequire("kQxS5");

var $4A2gJ = parcelRequire("4A2gJ");
var $e8e670973c8cb7de$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $e8e670973c8cb7de$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $kQxS5.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $e8e670973c8cb7de$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $e8e670973c8cb7de$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $e8e670973c8cb7de$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $kQxS5.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $e8e670973c8cb7de$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $e8e670973c8cb7de$var$bindKey : $e8e670973c8cb7de$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $4A2gJ.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $71I3e.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("kQxS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d2f02459f34c10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $f2d2f02459f34c10$export$67b01759a14cf6a4);

var $bjuDp = parcelRequire("bjuDp");

var $71I3e = parcelRequire("71I3e");
function $f2d2f02459f34c10$export$2e2bcd8739ae039() {
    return new (0, $71I3e.Selection)(this._enter || this._groups.map((0, $bjuDp.default)), this._parents);
}
function $f2d2f02459f34c10$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$f2d2f02459f34c10$export$67b01759a14cf6a4.prototype = {
    constructor: $f2d2f02459f34c10$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("bjuDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c93b6f14b7948e$export$2e2bcd8739ae039);
function $83c93b6f14b7948e$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("4A2gJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $355c48c360a4beab$export$2e2bcd8739ae039);
function $355c48c360a4beab$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("2iDjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acbc29f08408aa6$export$2e2bcd8739ae039);

var $bjuDp = parcelRequire("bjuDp");

var $71I3e = parcelRequire("71I3e");
function $1acbc29f08408aa6$export$2e2bcd8739ae039() {
    return new (0, $71I3e.Selection)(this._exit || this._groups.map((0, $bjuDp.default)), this._parents);
}

});

parcelRegister("2bUxG", function(module, exports) {

$parcel$export(module.exports, "default", () => $198877fe7f84216c$export$2e2bcd8739ae039);
function $198877fe7f84216c$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("vYs98", function(module, exports) {

$parcel$export(module.exports, "default", () => $0601ca10fed17547$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");
function $0601ca10fed17547$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $71I3e.Selection)(merges, this._parents);
}

});

parcelRegister("7az1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $5384a3bd66c4904d$export$2e2bcd8739ae039);
function $5384a3bd66c4904d$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("5NQyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $439a4d5d946e661c$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");
function $439a4d5d946e661c$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $439a4d5d946e661c$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $71I3e.Selection)(sortgroups, this._parents).order();
}
function $439a4d5d946e661c$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1jaRO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3ffebfaed4ec12$export$2e2bcd8739ae039);
function $0f3ffebfaed4ec12$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("9JTOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $71739b8b88a251a1$export$2e2bcd8739ae039);
function $71739b8b88a251a1$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}

});

parcelRegister("hYrEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15d7d87bb3a9007$export$2e2bcd8739ae039);
function $d15d7d87bb3a9007$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("4y1I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $34fbaa063e6a8700$export$2e2bcd8739ae039);
function $34fbaa063e6a8700$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}

});

parcelRegister("8eEs1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fef0242b28b43ea$export$2e2bcd8739ae039);
function $5fef0242b28b43ea$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("hUK07", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ab5975949642bc$export$2e2bcd8739ae039);
function $d0ab5975949642bc$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("5FcLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $01106e2d08cea534$export$2e2bcd8739ae039);

var $7UbnV = parcelRequire("7UbnV");
function $01106e2d08cea534$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $01106e2d08cea534$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $01106e2d08cea534$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $01106e2d08cea534$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $01106e2d08cea534$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $01106e2d08cea534$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $01106e2d08cea534$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $7UbnV.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $01106e2d08cea534$var$attrRemoveNS : $01106e2d08cea534$var$attrRemove : typeof value === "function" ? fullname.local ? $01106e2d08cea534$var$attrFunctionNS : $01106e2d08cea534$var$attrFunction : fullname.local ? $01106e2d08cea534$var$attrConstantNS : $01106e2d08cea534$var$attrConstant)(fullname, value));
}

});
parcelRegister("7UbnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c169828ee12e8de$export$2e2bcd8739ae039);

var $6pLcb = parcelRequire("6pLcb");
function $5c169828ee12e8de$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $6pLcb.default).hasOwnProperty(prefix) ? {
        space: (0, $6pLcb.default)[prefix],
        local: name
    } : name;
}

});
parcelRegister("6pLcb", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $4ab9afed4165bb3f$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $4ab9afed4165bb3f$export$2e2bcd8739ae039);
var $4ab9afed4165bb3f$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $4ab9afed4165bb3f$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $4ab9afed4165bb3f$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("7p4b3", function(module, exports) {

$parcel$export(module.exports, "default", () => $563e1bc004cc19fb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $563e1bc004cc19fb$export$5e3cec964f0b5efd);

var $5qPs0 = parcelRequire("5qPs0");
function $563e1bc004cc19fb$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $563e1bc004cc19fb$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $563e1bc004cc19fb$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $563e1bc004cc19fb$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $563e1bc004cc19fb$var$styleRemove : typeof value === "function" ? $563e1bc004cc19fb$var$styleFunction : $563e1bc004cc19fb$var$styleConstant)(name, value, priority == null ? "" : priority)) : $563e1bc004cc19fb$export$5e3cec964f0b5efd(this.node(), name);
}
function $563e1bc004cc19fb$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $5qPs0.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("5qPs0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f474a78f86b8639$export$2e2bcd8739ae039);
function $3f474a78f86b8639$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("5tmfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc0eafa0aab896f$export$2e2bcd8739ae039);
function $3fc0eafa0aab896f$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $3fc0eafa0aab896f$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $3fc0eafa0aab896f$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $3fc0eafa0aab896f$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $3fc0eafa0aab896f$var$propertyRemove : typeof value === "function" ? $3fc0eafa0aab896f$var$propertyFunction : $3fc0eafa0aab896f$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("hVxsg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0d1b5fc16f58f08$export$2e2bcd8739ae039);
function $d0d1b5fc16f58f08$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $d0d1b5fc16f58f08$var$classList(node) {
    return node.classList || new $d0d1b5fc16f58f08$var$ClassList(node);
}
function $d0d1b5fc16f58f08$var$ClassList(node) {
    this._node = node;
    this._names = $d0d1b5fc16f58f08$var$classArray(node.getAttribute("class") || "");
}
$d0d1b5fc16f58f08$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $d0d1b5fc16f58f08$var$classedAdd(node, names) {
    var list = $d0d1b5fc16f58f08$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $d0d1b5fc16f58f08$var$classedRemove(node, names) {
    var list = $d0d1b5fc16f58f08$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $d0d1b5fc16f58f08$var$classedTrue(names) {
    return function() {
        $d0d1b5fc16f58f08$var$classedAdd(this, names);
    };
}
function $d0d1b5fc16f58f08$var$classedFalse(names) {
    return function() {
        $d0d1b5fc16f58f08$var$classedRemove(this, names);
    };
}
function $d0d1b5fc16f58f08$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $d0d1b5fc16f58f08$var$classedAdd : $d0d1b5fc16f58f08$var$classedRemove)(this, names);
    };
}
function $d0d1b5fc16f58f08$export$2e2bcd8739ae039(name, value) {
    var names = $d0d1b5fc16f58f08$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $d0d1b5fc16f58f08$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $d0d1b5fc16f58f08$var$classedFunction : value ? $d0d1b5fc16f58f08$var$classedTrue : $d0d1b5fc16f58f08$var$classedFalse)(names, value));
}

});

parcelRegister("hc3uF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c84644666e021619$export$2e2bcd8739ae039);
function $c84644666e021619$var$textRemove() {
    this.textContent = "";
}
function $c84644666e021619$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $c84644666e021619$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $c84644666e021619$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c84644666e021619$var$textRemove : (typeof value === "function" ? $c84644666e021619$var$textFunction : $c84644666e021619$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("hbKVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c837dd484b133241$export$2e2bcd8739ae039);
function $c837dd484b133241$var$htmlRemove() {
    this.innerHTML = "";
}
function $c837dd484b133241$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $c837dd484b133241$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $c837dd484b133241$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c837dd484b133241$var$htmlRemove : (typeof value === "function" ? $c837dd484b133241$var$htmlFunction : $c837dd484b133241$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("c45BA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c8a34d6fd885bc5$export$2e2bcd8739ae039);
function $8c8a34d6fd885bc5$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $8c8a34d6fd885bc5$export$2e2bcd8739ae039() {
    return this.each($8c8a34d6fd885bc5$var$raise);
}

});

parcelRegister("bQQzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a0d546df42bfead$export$2e2bcd8739ae039);
function $8a0d546df42bfead$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $8a0d546df42bfead$export$2e2bcd8739ae039() {
    return this.each($8a0d546df42bfead$var$lower);
}

});

parcelRegister("apdts", function(module, exports) {

$parcel$export(module.exports, "default", () => $7936b0d69331db14$export$2e2bcd8739ae039);

var $bjcho = parcelRequire("bjcho");
function $7936b0d69331db14$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $bjcho.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("bjcho", function(module, exports) {

$parcel$export(module.exports, "default", () => $83bafe80a2f64bec$export$2e2bcd8739ae039);

var $7UbnV = parcelRequire("7UbnV");

var $6pLcb = parcelRequire("6pLcb");
function $83bafe80a2f64bec$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $6pLcb.xhtml) && document.documentElement.namespaceURI === (0, $6pLcb.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $83bafe80a2f64bec$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $83bafe80a2f64bec$export$2e2bcd8739ae039(name) {
    var fullname = (0, $7UbnV.default)(name);
    return (fullname.local ? $83bafe80a2f64bec$var$creatorFixed : $83bafe80a2f64bec$var$creatorInherit)(fullname);
}

});


parcelRegister("3RvP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cff01b2d138f246$export$2e2bcd8739ae039);

var $bjcho = parcelRequire("bjcho");

var $lfS1Y = parcelRequire("lfS1Y");
function $2cff01b2d138f246$var$constantNull() {
    return null;
}
function $2cff01b2d138f246$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $bjcho.default)(name), select = before == null ? $2cff01b2d138f246$var$constantNull : typeof before === "function" ? before : (0, $lfS1Y.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("5Zksf", function(module, exports) {

$parcel$export(module.exports, "default", () => $45c28421f4deb594$export$2e2bcd8739ae039);
function $45c28421f4deb594$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $45c28421f4deb594$export$2e2bcd8739ae039() {
    return this.each($45c28421f4deb594$var$remove);
}

});

parcelRegister("eGyQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab100572b50eeab0$export$2e2bcd8739ae039);
function $ab100572b50eeab0$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $ab100572b50eeab0$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $ab100572b50eeab0$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $ab100572b50eeab0$var$selection_cloneDeep : $ab100572b50eeab0$var$selection_cloneShallow);
}

});

parcelRegister("cVn7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $968cbd923db60e9e$export$2e2bcd8739ae039);
function $968cbd923db60e9e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("cdh1A", function(module, exports) {

$parcel$export(module.exports, "event", () => $8e43e7a9663fe880$export$6cd530ed55e06764);
$parcel$export(module.exports, "default", () => $8e43e7a9663fe880$export$2e2bcd8739ae039);
$parcel$export(module.exports, "customEvent", () => $8e43e7a9663fe880$export$4c724631b4750aef);
var $8e43e7a9663fe880$var$filterEvents = {};
var $8e43e7a9663fe880$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $8e43e7a9663fe880$var$element = document.documentElement;
    if (!("onmouseenter" in $8e43e7a9663fe880$var$element)) $8e43e7a9663fe880$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $8e43e7a9663fe880$var$filterContextListener(listener, index, group) {
    listener = $8e43e7a9663fe880$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $8e43e7a9663fe880$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $8e43e7a9663fe880$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $8e43e7a9663fe880$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $8e43e7a9663fe880$export$6cd530ed55e06764 = event0;
        }
    };
}
function $8e43e7a9663fe880$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $8e43e7a9663fe880$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $8e43e7a9663fe880$var$onAdd(typename, value, capture) {
    var wrap = $8e43e7a9663fe880$var$filterEvents.hasOwnProperty(typename.type) ? $8e43e7a9663fe880$var$filterContextListener : $8e43e7a9663fe880$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $8e43e7a9663fe880$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $8e43e7a9663fe880$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $8e43e7a9663fe880$var$onAdd : $8e43e7a9663fe880$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $8e43e7a9663fe880$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $8e43e7a9663fe880$export$6cd530ed55e06764;
    event1.sourceEvent = $8e43e7a9663fe880$export$6cd530ed55e06764;
    $8e43e7a9663fe880$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $8e43e7a9663fe880$export$6cd530ed55e06764 = event0;
    }
}

});

parcelRegister("belbG", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d16fe7b06b44f7$export$2e2bcd8739ae039);

var $5qPs0 = parcelRequire("5qPs0");
function $82d16fe7b06b44f7$var$dispatchEvent(node, type, params) {
    var window = (0, $5qPs0.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $82d16fe7b06b44f7$var$dispatchConstant(type, params) {
    return function() {
        return $82d16fe7b06b44f7$var$dispatchEvent(this, type, params);
    };
}
function $82d16fe7b06b44f7$var$dispatchFunction(type, params) {
    return function() {
        return $82d16fe7b06b44f7$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $82d16fe7b06b44f7$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $82d16fe7b06b44f7$var$dispatchFunction : $82d16fe7b06b44f7$var$dispatchConstant)(type, params));
}

});



parcelRegister("6OzG5", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $4f63167173775644$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $4f63167173775644$export$2e2bcd8739ae039);

var $cdh1A = parcelRequire("cdh1A");
function $4f63167173775644$export$2e2561858db9bf47() {
    (0, $cdh1A.event).stopImmediatePropagation();
}
function $4f63167173775644$export$2e2bcd8739ae039() {
    (0, $cdh1A.event).preventDefault();
    (0, $cdh1A.event).stopImmediatePropagation();
}

});


parcelRegister("5lXLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e5d46e41644f294$export$2e2bcd8739ae039);
var $3e5d46e41644f294$var$rho = Math.SQRT2, $3e5d46e41644f294$var$rho2 = 2, $3e5d46e41644f294$var$rho4 = 4, $3e5d46e41644f294$var$epsilon2 = 1e-12;
function $3e5d46e41644f294$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $3e5d46e41644f294$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $3e5d46e41644f294$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
function $3e5d46e41644f294$export$2e2bcd8739ae039(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    // Special case for u0 ≅ u1.
    if (d2 < $3e5d46e41644f294$var$epsilon2) {
        S = Math.log(w1 / w0) / $3e5d46e41644f294$var$rho;
        i = function(t) {
            return [
                ux0 + t * dx,
                uy0 + t * dy,
                w0 * Math.exp($3e5d46e41644f294$var$rho * t * S)
            ];
        };
    } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + $3e5d46e41644f294$var$rho4 * d2) / (2 * w0 * $3e5d46e41644f294$var$rho2 * d1), b1 = (w1 * w1 - w0 * w0 - $3e5d46e41644f294$var$rho4 * d2) / (2 * w1 * $3e5d46e41644f294$var$rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / $3e5d46e41644f294$var$rho;
        i = function(t) {
            var s = t * S, coshr0 = $3e5d46e41644f294$var$cosh(r0), u = w0 / ($3e5d46e41644f294$var$rho2 * d1) * (coshr0 * $3e5d46e41644f294$var$tanh($3e5d46e41644f294$var$rho * s + r0) - $3e5d46e41644f294$var$sinh(r0));
            return [
                ux0 + u * dx,
                uy0 + u * dy,
                w0 * coshr0 / $3e5d46e41644f294$var$cosh($3e5d46e41644f294$var$rho * s + r0)
            ];
        };
    }
    i.duration = S * 1000;
    return i;
}

});

parcelRegister("gZqlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e6c7e4e9ef7868$export$2e2bcd8739ae039);

var $gzaJc = parcelRequire("gzaJc");

var $faQ2F = parcelRequire("faQ2F");
function $c5e6c7e4e9ef7868$export$2e2bcd8739ae039(node) {
    var event = (0, $gzaJc.default)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $faQ2F.default)(node, event);
}

});
parcelRegister("gzaJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f83c96a52a7d72$export$2e2bcd8739ae039);

var $cdh1A = parcelRequire("cdh1A");
function $c0f83c96a52a7d72$export$2e2bcd8739ae039() {
    var current = (0, $cdh1A.event), source;
    while(source = current.sourceEvent)current = source;
    return current;
}

});

parcelRegister("faQ2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0c028aa3041b87a$export$2e2bcd8739ae039);
function $b0c028aa3041b87a$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}

});


parcelRegister("jSl7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7837298f6cb26ca$export$2e2bcd8739ae039);

var $gzaJc = parcelRequire("gzaJc");

var $faQ2F = parcelRequire("faQ2F");
function $e7837298f6cb26ca$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $gzaJc.default)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $faQ2F.default)(node, touch);
    }
    return null;
}

});

parcelRegister("lshu4", function(module, exports) {

$parcel$export(module.exports, "transition", () => (parcelRequire("8lOOg")).default);
$parcel$export(module.exports, "active", () => (parcelRequire("k7Z5Z")).default);
$parcel$export(module.exports, "interrupt", () => (parcelRequire("4zBBK")).default);
parcelRequire("5h6ag");

var $8lOOg = parcelRequire("8lOOg");

var $k7Z5Z = parcelRequire("k7Z5Z");

var $4zBBK = parcelRequire("4zBBK");

});
parcelRegister("5h6ag", function(module, exports) {

var $71I3e = parcelRequire("71I3e");

var $hi6Vp = parcelRequire("hi6Vp");

var $h6AQL = parcelRequire("h6AQL");
(0, $71I3e.default).prototype.interrupt = (0, $hi6Vp.default);
(0, $71I3e.default).prototype.transition = (0, $h6AQL.default);

});
parcelRegister("hi6Vp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9697d4458116367$export$2e2bcd8739ae039);

var $4zBBK = parcelRequire("4zBBK");
function $c9697d4458116367$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $4zBBK.default)(this, name);
    });
}

});
parcelRegister("4zBBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $35479a768f4e5ab2$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $35479a768f4e5ab2$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $gx72e.STARTING) && schedule.state < (0, $gx72e.ENDING);
        schedule.state = (0, $gx72e.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("gx72e", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", () => $c0952f67df27d0c6$export$584530fe98d14a84);
$parcel$export(module.exports, "STARTING", () => $c0952f67df27d0c6$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $c0952f67df27d0c6$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $c0952f67df27d0c6$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $c0952f67df27d0c6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $c0952f67df27d0c6$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $c0952f67df27d0c6$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $c0952f67df27d0c6$export$adaa4cf7ef1b65be);

var $4h5V5 = parcelRequire("4h5V5");

var $fF74h = parcelRequire("fF74h");
var $5hwOF = parcelRequire("5hwOF");
var $c0952f67df27d0c6$var$emptyOn = (0, $4h5V5.default)("start", "end", "cancel", "interrupt");
var $c0952f67df27d0c6$var$emptyTween = [];
var $c0952f67df27d0c6$export$ff39ebd4bb12b718 = 0;
var $c0952f67df27d0c6$export$584530fe98d14a84 = 1;
var $c0952f67df27d0c6$export$a5d151aee16efd42 = 2;
var $c0952f67df27d0c6$export$fb935ab5849a0db9 = 3;
var $c0952f67df27d0c6$export$1573e22b087389af = 4;
var $c0952f67df27d0c6$export$a2e792214ded83b2 = 5;
var $c0952f67df27d0c6$export$9d38167254403955 = 6;
function $c0952f67df27d0c6$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $c0952f67df27d0c6$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $c0952f67df27d0c6$var$emptyOn,
        tween: $c0952f67df27d0c6$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $c0952f67df27d0c6$export$ff39ebd4bb12b718
    });
}
function $c0952f67df27d0c6$export$2cd8252107eb640b(node, id) {
    var schedule = $c0952f67df27d0c6$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $c0952f67df27d0c6$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $c0952f67df27d0c6$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $c0952f67df27d0c6$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $c0952f67df27d0c6$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $c0952f67df27d0c6$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $c0952f67df27d0c6$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $5hwOF.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $c0952f67df27d0c6$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $c0952f67df27d0c6$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $c0952f67df27d0c6$export$fb935ab5849a0db9) return (0, $fF74h.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $c0952f67df27d0c6$export$1573e22b087389af) {
                o.state = $c0952f67df27d0c6$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $c0952f67df27d0c6$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $fF74h.default)(function() {
            if (self.state === $c0952f67df27d0c6$export$fb935ab5849a0db9) {
                self.state = $c0952f67df27d0c6$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $c0952f67df27d0c6$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $c0952f67df27d0c6$export$a5d151aee16efd42) return; // interrupted
        self.state = $c0952f67df27d0c6$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $c0952f67df27d0c6$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $c0952f67df27d0c6$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $c0952f67df27d0c6$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("fF74h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6702aebe54e863c$export$2e2bcd8739ae039);

var $5hwOF = parcelRequire("5hwOF");
function $b6702aebe54e863c$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $5hwOF.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});




parcelRegister("h6AQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c73f94db51dbe3f4$export$2e2bcd8739ae039);

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");

var $22Bya = parcelRequire("22Bya");

var $5hwOF = parcelRequire("5hwOF");
var $c73f94db51dbe3f4$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $22Bya.cubicInOut)
};
function $c73f94db51dbe3f4$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $c73f94db51dbe3f4$var$defaultTiming.time = (0, $5hwOF.now)(), $c73f94db51dbe3f4$var$defaultTiming;
    }
    return timing;
}
function $c73f94db51dbe3f4$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $8lOOg.Transition)) id = name._id, name = name._name;
    else id = (0, $8lOOg.newId)(), (timing = $c73f94db51dbe3f4$var$defaultTiming).time = (0, $5hwOF.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $gx72e.default)(node, name, id, i, group, timing || $c73f94db51dbe3f4$var$inherit(node, id));
    }
    return new (0, $8lOOg.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("8lOOg", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $6147b2aa1cec151b$export$be58926105124dd4);
$parcel$export(module.exports, "default", () => $6147b2aa1cec151b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "newId", () => $6147b2aa1cec151b$export$9ffd10a3fbdc175b);

var $71I3e = parcelRequire("71I3e");

var $86bWk = parcelRequire("86bWk");

var $j0Usx = parcelRequire("j0Usx");

var $fqGOf = parcelRequire("fqGOf");

var $aB3mk = parcelRequire("aB3mk");

var $dDvSs = parcelRequire("dDvSs");

var $6KZCG = parcelRequire("6KZCG");

var $j10GM = parcelRequire("j10GM");

var $7ag9F = parcelRequire("7ag9F");

var $kVVA3 = parcelRequire("kVVA3");

var $dvPTX = parcelRequire("dvPTX");

var $8iK2g = parcelRequire("8iK2g");

var $1nELt = parcelRequire("1nELt");

var $14car = parcelRequire("14car");

var $64LGr = parcelRequire("64LGr");

var $dqcLv = parcelRequire("dqcLv");

var $bnHxX = parcelRequire("bnHxX");

var $8l6LB = parcelRequire("8l6LB");

var $fsQmP = parcelRequire("fsQmP");

var $allsl = parcelRequire("allsl");
var $6147b2aa1cec151b$var$id = 0;
function $6147b2aa1cec151b$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $6147b2aa1cec151b$export$2e2bcd8739ae039(name) {
    return (0, $71I3e.default)().transition(name);
}
function $6147b2aa1cec151b$export$9ffd10a3fbdc175b() {
    return ++$6147b2aa1cec151b$var$id;
}
var $6147b2aa1cec151b$var$selection_prototype = (0, $71I3e.default).prototype;
$6147b2aa1cec151b$export$be58926105124dd4.prototype = $6147b2aa1cec151b$export$2e2bcd8739ae039.prototype = {
    constructor: $6147b2aa1cec151b$export$be58926105124dd4,
    select: (0, $dvPTX.default),
    selectAll: (0, $8iK2g.default),
    filter: (0, $6KZCG.default),
    merge: (0, $j10GM.default),
    selection: (0, $1nELt.default),
    transition: (0, $8l6LB.default),
    call: $6147b2aa1cec151b$var$selection_prototype.call,
    nodes: $6147b2aa1cec151b$var$selection_prototype.nodes,
    node: $6147b2aa1cec151b$var$selection_prototype.node,
    size: $6147b2aa1cec151b$var$selection_prototype.size,
    empty: $6147b2aa1cec151b$var$selection_prototype.empty,
    each: $6147b2aa1cec151b$var$selection_prototype.each,
    on: (0, $7ag9F.default),
    attr: (0, $86bWk.default),
    attrTween: (0, $j0Usx.default),
    style: (0, $14car.default),
    styleTween: (0, $64LGr.default),
    text: (0, $dqcLv.default),
    textTween: (0, $bnHxX.default),
    remove: (0, $kVVA3.default),
    tween: (0, $fsQmP.default),
    delay: (0, $fqGOf.default),
    duration: (0, $aB3mk.default),
    ease: (0, $dDvSs.default),
    end: (0, $allsl.default)
};

});
parcelRegister("86bWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e58253cc65629d3$export$2e2bcd8739ae039);

var $i3tg2 = parcelRequire("i3tg2");

var $7UbnV = parcelRequire("7UbnV");

var $fsQmP = parcelRequire("fsQmP");

var $3JL3T = parcelRequire("3JL3T");
function $5e58253cc65629d3$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $5e58253cc65629d3$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $5e58253cc65629d3$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $5e58253cc65629d3$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $5e58253cc65629d3$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $5e58253cc65629d3$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $5e58253cc65629d3$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $7UbnV.default)(name), i = fullname === "transform" ? (0, $i3tg2.interpolateTransformSvg) : (0, $3JL3T.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $5e58253cc65629d3$var$attrFunctionNS : $5e58253cc65629d3$var$attrFunction)(fullname, i, (0, $fsQmP.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $5e58253cc65629d3$var$attrRemoveNS : $5e58253cc65629d3$var$attrRemove)(fullname) : (fullname.local ? $5e58253cc65629d3$var$attrConstantNS : $5e58253cc65629d3$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("i3tg2", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $d24f33c6f6939f6a$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $d24f33c6f6939f6a$export$da8cba906d64c082);

var $34azb = parcelRequire("34azb");

var $afoVi = parcelRequire("afoVi");
function $d24f33c6f6939f6a$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $34azb.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $34azb.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $34azb.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $34azb.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $34azb.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $34azb.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $d24f33c6f6939f6a$export$56bec7123bb3589a = $d24f33c6f6939f6a$var$interpolateTransform((0, $afoVi.parseCss), "px, ", "px)", "deg)");
var $d24f33c6f6939f6a$export$da8cba906d64c082 = $d24f33c6f6939f6a$var$interpolateTransform((0, $afoVi.parseSvg), ", ", ")", ")");

});
parcelRegister("34azb", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b9f119ed71a3ce$export$2e2bcd8739ae039);
function $23b9f119ed71a3ce$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("afoVi", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $775ea34d03daa12d$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $775ea34d03daa12d$export$f9ef43f9a1d89a18);

var $7wwlt = parcelRequire("7wwlt");
var $775ea34d03daa12d$var$cssNode, $775ea34d03daa12d$var$cssRoot, $775ea34d03daa12d$var$cssView, $775ea34d03daa12d$var$svgNode;
function $775ea34d03daa12d$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $7wwlt.identity;
    if (!$775ea34d03daa12d$var$cssNode) $775ea34d03daa12d$var$cssNode = document.createElement("DIV"), $775ea34d03daa12d$var$cssRoot = document.documentElement, $775ea34d03daa12d$var$cssView = document.defaultView;
    $775ea34d03daa12d$var$cssNode.style.transform = value;
    value = $775ea34d03daa12d$var$cssView.getComputedStyle($775ea34d03daa12d$var$cssRoot.appendChild($775ea34d03daa12d$var$cssNode), null).getPropertyValue("transform");
    $775ea34d03daa12d$var$cssRoot.removeChild($775ea34d03daa12d$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $7wwlt.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $775ea34d03daa12d$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $7wwlt.identity;
    if (!$775ea34d03daa12d$var$svgNode) $775ea34d03daa12d$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $775ea34d03daa12d$var$svgNode.setAttribute("transform", value);
    if (!(value = $775ea34d03daa12d$var$svgNode.transform.baseVal.consolidate())) return 0, $7wwlt.identity;
    value = value.matrix;
    return (0, $7wwlt.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("7wwlt", function(module, exports) {

$parcel$export(module.exports, "identity", () => $57a49cb08f968769$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $57a49cb08f968769$export$2e2bcd8739ae039);
var $57a49cb08f968769$var$degrees = 180 / Math.PI;
var $57a49cb08f968769$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $57a49cb08f968769$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $57a49cb08f968769$var$degrees,
        skewX: Math.atan(skewX) * $57a49cb08f968769$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("fsQmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42217906e34a7a5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $b42217906e34a7a5$export$f78ce6ab10405d82);

var $gx72e = parcelRequire("gx72e");
function $b42217906e34a7a5$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $gx72e.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $b42217906e34a7a5$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $gx72e.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $b42217906e34a7a5$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $gx72e.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $b42217906e34a7a5$var$tweenRemove : $b42217906e34a7a5$var$tweenFunction)(id, name, value));
}
function $b42217906e34a7a5$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $gx72e.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $gx72e.get)(node, id).value[name];
    };
}

});

parcelRegister("3JL3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8a1488a1229fb5$export$2e2bcd8739ae039);

var $7TBR2 = parcelRequire("7TBR2");

var $34azb = parcelRequire("34azb");
var $lap8T = parcelRequire("lap8T");
var $8rKaq = parcelRequire("8rKaq");
function $2b8a1488a1229fb5$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $34azb.default) : b instanceof (0, $7TBR2.default) ? (0, $lap8T.default) : (c = (0, $7TBR2.default)(b)) ? (b = c, $lap8T.default) : (0, $8rKaq.default))(a, b);
}

});
parcelRegister("7TBR2", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $llFwZ = parcelRequire("llFwZ");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $llFwZ.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $llFwZ.default)(Rgb, rgb, (0, $llFwZ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $llFwZ.default)(Hsl, hsl, (0, $llFwZ.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("llFwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8abc65f18ba9491$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $f8abc65f18ba9491$export$8b58be045bf06082);
function $f8abc65f18ba9491$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $f8abc65f18ba9491$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("lap8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68e08ec6d7168ce$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rgbBasis", () => $f68e08ec6d7168ce$export$2c0e28f2e2852d3f);
$parcel$export(module.exports, "rgbBasisClosed", () => $f68e08ec6d7168ce$export$53d5214f625ccd4c);

var $7TBR2 = parcelRequire("7TBR2");

var $86tqN = parcelRequire("86tqN");

var $l5LKG = parcelRequire("l5LKG");

var $6isdb = parcelRequire("6isdb");
var $f68e08ec6d7168ce$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $6isdb.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $7TBR2.rgb)(start)).r, (end = (0, $7TBR2.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $6isdb.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $f68e08ec6d7168ce$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $7TBR2.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $f68e08ec6d7168ce$export$2c0e28f2e2852d3f = $f68e08ec6d7168ce$var$rgbSpline((0, $86tqN.default));
var $f68e08ec6d7168ce$export$53d5214f625ccd4c = $f68e08ec6d7168ce$var$rgbSpline((0, $l5LKG.default));

});
parcelRegister("86tqN", function(module, exports) {

$parcel$export(module.exports, "basis", () => $5e65b6b294505426$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $5e65b6b294505426$export$2e2bcd8739ae039);
function $5e65b6b294505426$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $5e65b6b294505426$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $5e65b6b294505426$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("l5LKG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5af1b22bfa963ff$export$2e2bcd8739ae039);

var $86tqN = parcelRequire("86tqN");
function $f5af1b22bfa963ff$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $86tqN.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("6isdb", function(module, exports) {

$parcel$export(module.exports, "hue", () => $495a4ec92a76a6a5$export$97d7b0c7ddb78dcf);
$parcel$export(module.exports, "gamma", () => $495a4ec92a76a6a5$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $495a4ec92a76a6a5$export$2e2bcd8739ae039);

var $liQuG = parcelRequire("liQuG");
function $495a4ec92a76a6a5$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $495a4ec92a76a6a5$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $495a4ec92a76a6a5$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $495a4ec92a76a6a5$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $liQuG.default)(isNaN(a) ? b : a);
}
function $495a4ec92a76a6a5$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $495a4ec92a76a6a5$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $495a4ec92a76a6a5$var$exponential(a, b, y) : (0, $liQuG.default)(isNaN(a) ? b : a);
    };
}
function $495a4ec92a76a6a5$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $495a4ec92a76a6a5$var$linear(a, d) : (0, $liQuG.default)(isNaN(a) ? b : a);
}

});
parcelRegister("liQuG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f823ff9c35fdc982$export$2e2bcd8739ae039);
function $f823ff9c35fdc982$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});



parcelRegister("8rKaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6264a832e9b7e426$export$2e2bcd8739ae039);

var $34azb = parcelRequire("34azb");
var $6264a832e9b7e426$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $6264a832e9b7e426$var$reB = new RegExp($6264a832e9b7e426$var$reA.source, "g");
function $6264a832e9b7e426$var$zero(b) {
    return function() {
        return b;
    };
}
function $6264a832e9b7e426$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $6264a832e9b7e426$export$2e2bcd8739ae039(a, b) {
    var bi = $6264a832e9b7e426$var$reA.lastIndex = $6264a832e9b7e426$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $6264a832e9b7e426$var$reA.exec(a)) && (bm = $6264a832e9b7e426$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $34azb.default)(am, bm)
            });
        }
        bi = $6264a832e9b7e426$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $6264a832e9b7e426$var$one(q[0].x) : $6264a832e9b7e426$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});



parcelRegister("j0Usx", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd79d010a4c8efb5$export$2e2bcd8739ae039);

var $7UbnV = parcelRequire("7UbnV");
function $dd79d010a4c8efb5$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $dd79d010a4c8efb5$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $dd79d010a4c8efb5$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $dd79d010a4c8efb5$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $dd79d010a4c8efb5$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $dd79d010a4c8efb5$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $dd79d010a4c8efb5$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $7UbnV.default)(name);
    return this.tween(key, (fullname.local ? $dd79d010a4c8efb5$var$attrTweenNS : $dd79d010a4c8efb5$var$attrTween)(fullname, value));
}

});

parcelRegister("fqGOf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ba7dce83d64446$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $b3ba7dce83d64446$var$delayFunction(id, value) {
    return function() {
        (0, $gx72e.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $b3ba7dce83d64446$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $gx72e.init)(this, id).delay = value;
    };
}
function $b3ba7dce83d64446$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $b3ba7dce83d64446$var$delayFunction : $b3ba7dce83d64446$var$delayConstant)(id, value)) : (0, $gx72e.get)(this.node(), id).delay;
}

});

parcelRegister("aB3mk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b6ff7278dc27637$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $7b6ff7278dc27637$var$durationFunction(id, value) {
    return function() {
        (0, $gx72e.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $7b6ff7278dc27637$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $gx72e.set)(this, id).duration = value;
    };
}
function $7b6ff7278dc27637$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $7b6ff7278dc27637$var$durationFunction : $7b6ff7278dc27637$var$durationConstant)(id, value)) : (0, $gx72e.get)(this.node(), id).duration;
}

});

parcelRegister("dDvSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ed7a50b52f9ec5f$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $9ed7a50b52f9ec5f$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $gx72e.set)(this, id).ease = value;
    };
}
function $9ed7a50b52f9ec5f$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($9ed7a50b52f9ec5f$var$easeConstant(id, value)) : (0, $gx72e.get)(this.node(), id).ease;
}

});

parcelRegister("6KZCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb6d700db7c69fc$export$2e2bcd8739ae039);

var $fVVXs = parcelRequire("fVVXs");

var $8lOOg = parcelRequire("8lOOg");
function $4eb6d700db7c69fc$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $fVVXs.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $8lOOg.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("j10GM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd7ea529e16d1e50$export$2e2bcd8739ae039);

var $8lOOg = parcelRequire("8lOOg");
function $dd7ea529e16d1e50$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $8lOOg.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("7ag9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5375ff9982ff8775$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $5375ff9982ff8775$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $5375ff9982ff8775$var$onFunction(id, name, listener) {
    var on0, on1, sit = $5375ff9982ff8775$var$start(name) ? (0, $gx72e.init) : (0, $gx72e.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $5375ff9982ff8775$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $gx72e.get)(this.node(), id).on.on(name) : this.each($5375ff9982ff8775$var$onFunction(id, name, listener));
}

});

parcelRegister("kVVA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3d5cbd04340ac15$export$2e2bcd8739ae039);
function $f3d5cbd04340ac15$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $f3d5cbd04340ac15$export$2e2bcd8739ae039() {
    return this.on("end.remove", $f3d5cbd04340ac15$var$removeFunction(this._id));
}

});

parcelRegister("dvPTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d666e2bac3e636b$export$2e2bcd8739ae039);

var $lfS1Y = parcelRequire("lfS1Y");

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");
function $9d666e2bac3e636b$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $lfS1Y.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $gx72e.default)(subgroup[i], name, id, i, subgroup, (0, $gx72e.get)(node, id));
        }
    }
    return new (0, $8lOOg.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("8iK2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $60b3b6dd402a5a11$export$2e2bcd8739ae039);

var $eLBth = parcelRequire("eLBth");

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");
function $60b3b6dd402a5a11$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $eLBth.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $gx72e.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $gx72e.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $8lOOg.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("1nELt", function(module, exports) {

$parcel$export(module.exports, "default", () => $10178f78754a35a3$export$2e2bcd8739ae039);

var $71I3e = parcelRequire("71I3e");
var $10178f78754a35a3$var$Selection = (0, $71I3e.default).prototype.constructor;
function $10178f78754a35a3$export$2e2bcd8739ae039() {
    return new $10178f78754a35a3$var$Selection(this._groups, this._parents);
}

});

parcelRegister("14car", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c6f9a5802cc5750$export$2e2bcd8739ae039);

var $i3tg2 = parcelRequire("i3tg2");

var $7p4b3 = parcelRequire("7p4b3");

var $gx72e = parcelRequire("gx72e");

var $fsQmP = parcelRequire("fsQmP");

var $3JL3T = parcelRequire("3JL3T");
function $0c6f9a5802cc5750$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $7p4b3.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $7p4b3.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $0c6f9a5802cc5750$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $0c6f9a5802cc5750$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $7p4b3.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $0c6f9a5802cc5750$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $7p4b3.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $7p4b3.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $0c6f9a5802cc5750$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $gx72e.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $0c6f9a5802cc5750$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $0c6f9a5802cc5750$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $i3tg2.interpolateTransformCss) : (0, $3JL3T.default);
    return value == null ? this.styleTween(name, $0c6f9a5802cc5750$var$styleNull(name, i)).on("end.style." + name, $0c6f9a5802cc5750$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $0c6f9a5802cc5750$var$styleFunction(name, i, (0, $fsQmP.tweenValue)(this, "style." + name, value))).each($0c6f9a5802cc5750$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $0c6f9a5802cc5750$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("64LGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $46c81abc7eeee1f9$export$2e2bcd8739ae039);
function $46c81abc7eeee1f9$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $46c81abc7eeee1f9$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $46c81abc7eeee1f9$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $46c81abc7eeee1f9$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $46c81abc7eeee1f9$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("dqcLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $02858ac2033469a6$export$2e2bcd8739ae039);

var $fsQmP = parcelRequire("fsQmP");
function $02858ac2033469a6$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $02858ac2033469a6$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $02858ac2033469a6$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $02858ac2033469a6$var$textFunction((0, $fsQmP.tweenValue)(this, "text", value)) : $02858ac2033469a6$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("bnHxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $84939f2669c0b99f$export$2e2bcd8739ae039);
function $84939f2669c0b99f$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $84939f2669c0b99f$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $84939f2669c0b99f$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $84939f2669c0b99f$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $84939f2669c0b99f$var$textTween(value));
}

});

parcelRegister("8l6LB", function(module, exports) {

$parcel$export(module.exports, "default", () => $612588a8d9c566b4$export$2e2bcd8739ae039);

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");
function $612588a8d9c566b4$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $8lOOg.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $gx72e.get)(node, id0);
            (0, $gx72e.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $8lOOg.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("allsl", function(module, exports) {

$parcel$export(module.exports, "default", () => $787c824bbab868af$export$2e2bcd8739ae039);

var $gx72e = parcelRequire("gx72e");
function $787c824bbab868af$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $gx72e.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
    });
}

});


parcelRegister("22Bya", function(module, exports) {

$parcel$export(module.exports, "cubicIn", () => $17c8e550f30a6519$export$b1a09cb1b71f86aa);
$parcel$export(module.exports, "cubicOut", () => $17c8e550f30a6519$export$68d528839c701b6);
$parcel$export(module.exports, "cubicInOut", () => $17c8e550f30a6519$export$89238d3bc79d3ada);
function $17c8e550f30a6519$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $17c8e550f30a6519$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $17c8e550f30a6519$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("k7Z5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea73da68e524b250$export$2e2bcd8739ae039);

var $8lOOg = parcelRequire("8lOOg");

var $gx72e = parcelRequire("gx72e");
var $ea73da68e524b250$var$root = [
    null
];
function $ea73da68e524b250$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $gx72e.SCHEDULED) && schedule.name === name) return new (0, $8lOOg.Transition)([
                [
                    node
                ]
            ], $ea73da68e524b250$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("i1cts", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e1ff1432479d3a$export$2e2bcd8739ae039);
function $d1e1ff1432479d3a$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("3i9Ix", function(module, exports) {

$parcel$export(module.exports, "default", () => $265a97322c7aa3b0$export$2e2bcd8739ae039);
function $265a97322c7aa3b0$export$2e2bcd8739ae039(target, type, transform) {
    this.target = target;
    this.type = type;
    this.transform = transform;
}

});

parcelRegister("dkO7y", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $9b54058ed62abff1$export$563a914cafbdc389);
$parcel$export(module.exports, "identity", () => $9b54058ed62abff1$export$f0954fd7d5368655);
function $9b54058ed62abff1$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$9b54058ed62abff1$export$563a914cafbdc389.prototype = {
    constructor: $9b54058ed62abff1$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $9b54058ed62abff1$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $9b54058ed62abff1$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $9b54058ed62abff1$export$f0954fd7d5368655 = new $9b54058ed62abff1$export$563a914cafbdc389(1, 0, 0);
$9b54058ed62abff1$export$2e2bcd8739ae039.prototype = $9b54058ed62abff1$export$563a914cafbdc389.prototype;
function $9b54058ed62abff1$export$2e2bcd8739ae039(node) {
    return node.__zoom || $9b54058ed62abff1$export$f0954fd7d5368655;
}

});

parcelRegister("l0VDS", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $f4c64f9adbbf81c5$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $f4c64f9adbbf81c5$export$2e2bcd8739ae039);

var $cdh1A = parcelRequire("cdh1A");
function $f4c64f9adbbf81c5$export$2e2561858db9bf47() {
    (0, $cdh1A.event).stopImmediatePropagation();
}
function $f4c64f9adbbf81c5$export$2e2bcd8739ae039() {
    (0, $cdh1A.event).preventDefault();
    (0, $cdh1A.event).stopImmediatePropagation();
}

});





parcelRegister("5eFx0", function(module, exports) {
// @ts-check
// grand unified formatting function
/**
 *
 * @param {number} val
 * @param {number} digits
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$toFixed(val, digits) {
    const string = Number(val).toFixed(digits);
    // Ditch -0.0
    return 1 / Number(string) === -Infinity ? 0..toFixed(digits) : string;
}
// Realistically, we have too many changes of spellings and things to not do this, sadly
/**
 *
 * @param {string} type
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$getStandardizedType(type) {
    // { alt: standard }
    const altSpellings = {
        abs: 'ab',
        avg_swing_length: 'swing_length_qualified',
        avg_swing_speed: 'swing_speed_qualified',
        barrels: 'barrel',
        barrels_per_bbe_percent: 'barrel_batted_rate',
        barrels_per_pa_percent: 'barrels_per_pa',
        batting_avg: 'ba',
        bb: 'walk',
        dbls: 'double',
        ev: 'launch_speed',
        hardhit_percent: 'hard_hit_percent',
        hits: 'hit',
        hrs: 'home_run',
        isolated_power: 'iso',
        on_base_percent: 'obp',
        on_base_plus_slg: 'ops',
        pitch_speed: 'pitch_velocity',
        singles: 'single',
        slg_percent: 'slg',
        so: 'strikeout',
        triples: 'triple',
        attack_angle: 'bat_path_angle',
        attack_angle_asc: 'bat_path_angle',
        attack_direction: 'bat_path_angle',
        attack_direction_pullopp: 'bat_path_angle',
        swing_path_tilt: 'bat_path_angle',
        avg_plane_vertical_angle: 'bat_path_angle',
        avg_plane_vertical_angle_asc: 'bat_path_angle',
        vertical_swing_path: 'bat_path_angle',
        bat_minus_plate_pos_y_inches: 'dist_in_inches',
        intercept_ball_minus_plate_pos_y_inches: 'dist_in_inches',
        intercept_ball_minus_batter_pos_y_inches: 'dist_in_inches',
        bat_minus_plate_pos_x_inches: 'dist_in_inches',
        intercept_ball_minus_plate_pos_x_inches: 'dist_in_inches',
        intercept_ball_minus_batter_pos_x_inches: 'dist_in_inches',
        pull_percent_airballs: 'airballs_percent',
        // bit of a hack
        spin_rate: '_avg_spin'
    };
    return altSpellings[type] || type;
}
/**
 *
 * @param {number|string} val
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$threeDigitFormat(val) {
    const num = Number(val);
    if (num >= 0 && num < 1) return num.toFixed(3).slice(-4);
    if (num < 0 && num > -1) return `-${Math.abs(num).toFixed(3).slice(-4)}`;
    return num.toFixed(3);
}
const $3cfe79d709e6baf3$var$threeDigitTypes = [
    'ba',
    'xba',
    'est_ba',
    'obp',
    'xobp',
    'est_obp',
    'slg',
    'xslg',
    'est_slg',
    'iso',
    'xiso',
    'est_iso',
    'ops',
    'babip',
    'est_babip',
    'woba',
    'xwoba',
    'est_woba',
    'wobacon',
    'xwobacon',
    'est_wobacon',
    'bacon',
    'xbacon',
    'est_bacon'
];
const $3cfe79d709e6baf3$var$thousandthTypes = [
    'delta_pitcher_run_exp',
    'delta_run_exp',
    'unadj_delta_pitcher_run_exp',
    'unadj_delta_run_exp',
    'delev_delta_pitcher_run_exp',
    'delev_delta_run_exp'
];
const $3cfe79d709e6baf3$var$hundredthTypes = [
    'catcher_exchange',
    'catcher_poptime',
    'pop_2b_sba',
    'home_to_first',
    'running_splits',
    'era',
    'xera',
    'exchange_time',
    'pop_time',
    'rate_cs_aa',
    'runner_stealing_runs_drawer',
    'avg_hr_trot',
    'home_runs_per_nine'
];
const $3cfe79d709e6baf3$var$tenthTypes = [
    'hard_hit_percent',
    'launch_speed',
    'exit_velocity_avg',
    'avg_best_speed',
    'hyper_speed',
    'avg_hyper_speed',
    'pitch_tempo_empty',
    'sweet_spot_percent',
    'barrel_batted_rate',
    'barrels_per_pa',
    'launch_angle_avg',
    // Pitch metrics
    'fastball_velo',
    'breaking_velo',
    'offspeed_velo',
    'ff_avg_speed',
    'fastball_extension',
    'pitch_type_percent',
    'pitch_velocity',
    'api_break_z_with_gravity',
    'api_break_z_induced',
    'api_break_x_arm',
    'api_break_x_batter_in',
    'active_spin_percent',
    // Bat tracking
    'sweetspot_speed_mph',
    'swing_speed',
    'swing_speed_qualified',
    'swing_length',
    'swing_length_qualified',
    'bat_speed_avg',
    'metric-percent',
    'ideal_angle_rate',
    'miss_distance',
    'swing_timing_dist',
    // bat tracking from sortable stats
    'squared_up_contact',
    'squared_up_swing',
    'blasts_swing',
    'blasts_contact',
    'fast_swing_rate',
    'accel_time_ms',
    // Batted Ball
    'popups_percent',
    'flyballs_percent',
    'linedrives_percent',
    'groundballs_percent',
    'airballs_percent',
    'pull_percent',
    'straightaway_percent',
    'opposite_percent',
    'poorlyweak_percent',
    'poorlytopped_percent',
    'poorlyunder_percent',
    'flareburner_percent',
    'solidcontact_percent',
    'hr_flyballs_percent',
    'dist_in_inches',
    // Plate disc
    'in_zone_percent',
    'out_zone_percent',
    'edge_percent',
    'z_swing_percent',
    'oz_swing_percent',
    'iz_contact_percent',
    'oz_contact_percent',
    'whiff_percent',
    'f_strike_percent',
    'f_swing_percent',
    'swing_percent',
    'meatball_swing_percent',
    'meatball_percent',
    'z_swing_miss_percent',
    'oz_swing_miss_percent',
    'swing_miss_percent',
    // Basics
    'k_percent',
    'bb_percent',
    'putaway_percent',
    // catcher arm
    'catcher_arm',
    // Fielding
    'arm_strength_inf',
    'arm_strength_of',
    'arm_overall',
    'outfield_jump',
    'jump_out_percent',
    // Basestealing
    'r_sec_minus_prim_lead',
    'r_sec_minus_prim_lead_sbx',
    // Baserunning
    'sprint_speed',
    'jump',
    'runs_stolen_on_running_act_drawer',
    // Pitcher Stealing
    'r_primary_lead',
    'r_secondary_lead',
    'r_sec_minus_prim_lead',
    'r_primary_lead_sbx',
    'r_secondary_lead_sbx',
    'r_sec_minus_prim_lead_sbx',
    // Catcher framing
    'strike_rate',
    // Catcher throwing
    'arm_strength',
    'distance_to_target',
    'seasonal_sprint_speed',
    // Other
    'game_score',
    'batter_run_value_per_100',
    'pitcher_run_value_per_100',
    'arm_angle',
    'strike_zone_distance',
    'run_value_zone',
    'exp_abs_chals',
    'batter_run_exp_contact',
    'batter_run_exp_take',
    'batter_run_exp_swing',
    'batter_run_exp',
    'pitcher_run_exp_contact',
    'pitcher_run_exp_take',
    'pitcher_run_exp_swing',
    'pitcher_run_exp',
    'edge_dist'
];
// Should these be noops? Eh.
const $3cfe79d709e6baf3$var$wholeTypes = [
    'barrel',
    'popups',
    'flyballs',
    'linedrives',
    'groundballs',
    'launch_angle',
    'bbdist',
    // Plate disc.
    'in_zone',
    'out_zone',
    'edge',
    'in_zone_swing',
    'out_zone_swing',
    'in_zone_swing_miss',
    'out_zone_swing_miss',
    // Basic
    'pitch_count',
    'pa',
    'ab',
    'bip',
    'hit',
    'single',
    'double',
    'triple',
    'home_run',
    'walk',
    'strikeout',
    'hbp',
    'batted_ball',
    'pitch_count_fastball',
    'pitch_count_offspeed',
    'pitch_count_breaking',
    'whiffs',
    'swings',
    // Total baserunning
    'runner_runs_sb',
    'runner_runs_xb',
    // Baserunning
    'baserunning',
    'fielder_runs',
    'runner_runs',
    'runner_runs_swipe',
    'runner_runs_snipe',
    'runner_runs_freeze',
    'fielder_runs_swipe',
    'fielder_runs_snipe',
    'fielder_runs_freeze',
    'bolts',
    // Basestealing
    'runs_stolen_on_running_act',
    'simple_stolen_on_running_act',
    'net_act_plus',
    'net_act_minus',
    'n_init',
    'n_plus',
    'n_minus',
    // Baserunning Top Performers
    'baserunning_runs',
    'basestealing',
    'extra_bases_taken',
    // Pitcher Stealing
    'runs_prevented_on_running_attr',
    'simple_prevented_on_running_attr',
    'net_attr_plus',
    'net_attr_minus',
    // Runner Stealing
    'runs_stolen_on_running_act',
    'simple_stolen_on_running_act',
    'net_act_plus',
    'net_act_minus',
    // Fielding Runs
    'runs_prevented',
    // Run Value
    'run_value',
    'swing_take_run_value',
    'run_exp',
    'pitcher_run_exp',
    'unadj_run_exp',
    'unadj_pitcher_run_exp',
    'delev_run_exp',
    'delev_pitcher_run_exp',
    'runner_run_value',
    'fielding_run_value',
    'fielding_run_value_arm',
    'pitch_run_value_fastball',
    'pitch_run_value_breaking',
    'pitch_run_value_offspeed',
    'pitcher_stealing_runs',
    'runner_stealing_runs',
    //
    'oaa',
    'outs_above_average',
    'cs_above_average',
    'blocks_above_average',
    'catcher_blocking',
    'catcher_throwing',
    'fielding_run_value',
    'fielding_run_value_framing',
    'framing',
    'player_age',
    'arm_angle_viz',
    // Bat tracking
    'swords',
    'num_swings',
    'peak_accel_ms',
    // Catcher throwing
    'n_xcs_with_untracked_over_xcs',
    'n_xcs_with_onfly_other_over_xcs',
    'n_xcs_with_ground_other_over_xcs',
    'n_xcs_with_accuracy_over_xcs',
    'n_xcs_with_exchange_over_xcs',
    'n_xcs_with_flight_over_xcs',
    'n_xcs',
    'n_cs_aa',
    'cs_raa',
    'venue_fence_distance',
    'venue_square_footage',
    'venue_fence_height',
    'pitch_spin_search',
    'abs_challenges'
];
const $3cfe79d709e6baf3$var$percentWhole = [
    // Baserunning
    'rate_att_xb',
    'est_rate_att_generic_runner',
    'est_rate_att_generic_fielder',
    'rate_att_xb_diff_runner',
    'rate_att_xb_diff_fielder',
    'base_running_rate_safe',
    'base_running_rate_safe_per_attempt',
    'rate_xcs',
    'rate_cs',
    'knee_percent',
    'cs_percent',
    // bat tracking
    'swing_timing_percent',
    // player page pitch percent
    'handed_pitch_percent',
    // ABS
    'abs_chal_percent',
    // gamefeed pitch percent
    'gamefeed_pitch_percent'
];
const $3cfe79d709e6baf3$var$percentTenth = [
    // Pitcher Steal
    'rate_sbx',
    // bat tracking
    'swings_qualified_percent',
    'avg_is_sweetspot_speed_high_qualified',
    'squared_up_per_bat_contact',
    'squared_up_per_swing',
    'squared_up_with_speed_per_swing',
    'squared_up_with_speed_per_bat_contact',
    // Batted ball
    'batted_ball_rate',
    'rate_ideal_attack_angle',
    // Basestealing
    'rate_sbx',
    // Pitching
    'pitch_percent',
    'whiff_rate_percent',
    // Other
    'called_strike_prob',
    'venue_square_footage_diff',
    'abs_chal_rate_percent',
    'home_run_percent',
    // ABS
    'abs_chal_rate_percent'
];
const $3cfe79d709e6baf3$var$angleWhole = [
    'bat_path_angle',
    'launch_angle_search'
];
const $3cfe79d709e6baf3$var$defaultOpts = {
    placeholder: '--',
    isMissingFn: (val)=>[
            null,
            undefined,
            ''
        ].includes(val),
    isDiff: false,
    ignoreExtremaHandling: false
};
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isMovementType(type) {
    return type.includes('movement_vertical_') || type.includes('movement_horizontal_');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isAvgSpeed(type) {
    return type.includes('_avg_speed');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isAvgSpin(type) {
    return type.includes('_avg_spin');
}
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isActiveSpin(type) {
    return type.includes('formatted_active_spin_');
}
// grand unified formatting function
/**
 *
 * @param {string|number|null|undefined} val
 * @param {string} rawType
 * @param {{ placeholder?: any, isMissingFn?: function, isDiff?: boolean, removePercent?: boolean }} [opts]
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$guff(val, rawType, opts = $3cfe79d709e6baf3$var$defaultOpts) {
    const mergedOpts = {
        ...$3cfe79d709e6baf3$var$defaultOpts,
        ...opts
    };
    const type = $3cfe79d709e6baf3$var$getStandardizedType(rawType);
    try {
        // Add some extra checks to pacify typescript
        if (mergedOpts.isMissingFn(val) || val === undefined || val === null) // How is TS okay with turning any here?
        return mergedOpts.placeholder;
        const numberVal = Number(val);
        if (Number.isNaN(numberVal)) return mergedOpts.placeholder;
        // Three Digit Formats (with diffs)
        if ($3cfe79d709e6baf3$var$threeDigitTypes.includes(type) && mergedOpts.isDiff) {
            if (numberVal > -1 && numberVal < 1) {
                const formattedVal = $3cfe79d709e6baf3$var$threeDigitFormat(numberVal);
                if (Number(formattedVal) > 0) return `+${formattedVal}`;
                return formattedVal;
            }
            const formattedVal = $3cfe79d709e6baf3$var$toFixed(numberVal, 3);
            if (Number(formattedVal) > 0) return `+${formattedVal}`;
            if (Number(formattedVal) < 0) return formattedVal;
            return formattedVal;
        }
        if ($3cfe79d709e6baf3$var$threeDigitTypes.includes(type)) return $3cfe79d709e6baf3$var$threeDigitFormat(numberVal);
        if ($3cfe79d709e6baf3$var$thousandthTypes.includes(type)) {
            const formattedValue = $3cfe79d709e6baf3$var$toFixed(numberVal, 3);
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}` : formattedValue;
        }
        if ($3cfe79d709e6baf3$var$hundredthTypes.includes(type)) {
            const formattedValue = $3cfe79d709e6baf3$var$toFixed(numberVal, 2);
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}` : formattedValue;
        }
        if ($3cfe79d709e6baf3$var$tenthTypes.includes(type) || $3cfe79d709e6baf3$var$isMovementType(type) || $3cfe79d709e6baf3$var$isActiveSpin(type) || $3cfe79d709e6baf3$var$isAvgSpeed(type)) {
            const formattedValue = $3cfe79d709e6baf3$var$toFixed(numberVal, 1);
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}` : formattedValue;
        }
        if ($3cfe79d709e6baf3$var$wholeTypes.includes(type) || $3cfe79d709e6baf3$var$isAvgSpin(type)) {
            const formattedValue = Math.round(numberVal) || 0;
            // FWIW - This avoids the -0 problem because String(-0) => '0' and -0 || 0 => 0
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue.toLocaleString()}` : formattedValue.toLocaleString() // for consistently returning a string
            ;
        }
        if ($3cfe79d709e6baf3$var$percentWhole.includes(type)) {
            const roundedNumber = Math.round(numberVal * 100);
            let formattedValue = String(roundedNumber);
            if (roundedNumber === 100 && numberVal < 1) formattedValue = '>99';
            else if (roundedNumber === 0 && numberVal > 0) formattedValue = '<1';
            const suffix = mergedOpts.removePercent ? '' : '%';
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return roundedNumber > 0 && mergedOpts.isDiff ? `+${formattedValue}${suffix}` : formattedValue + suffix;
        }
        if ($3cfe79d709e6baf3$var$percentTenth.includes(type)) {
            let formattedValue = (numberVal * 100).toFixed(1);
            const suffix = mergedOpts.removePercent ? '' : '%';
            if (!mergedOpts.ignoreExtremaHandling) {
                if (formattedValue === '100.0' && numberVal < 1) formattedValue = '>99.9';
                else if (formattedValue === '0.0' && numberVal > 0) formattedValue = '<0.1';
            }
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}${suffix}` : formattedValue + suffix;
        }
        if ($3cfe79d709e6baf3$var$angleWhole.includes(type)) {
            const formattedValue = Math.round(numberVal);
            // FWIW - This avoids the -0 problem because String(-0) => '0'
            return Number(formattedValue) > 0 && mergedOpts.isDiff ? `+${formattedValue}\xb0` : `${formattedValue}\xb0`;
        }
        throw new Error(`type: ${type} not found`);
    } catch (e) {
        console.error('GUFF ERROR', e, val, type);
        return String(val);
    }
}
const $3cfe79d709e6baf3$var$validTypes = [
    ...$3cfe79d709e6baf3$var$threeDigitTypes,
    ...$3cfe79d709e6baf3$var$thousandthTypes,
    ...$3cfe79d709e6baf3$var$hundredthTypes,
    ...$3cfe79d709e6baf3$var$tenthTypes,
    ...$3cfe79d709e6baf3$var$wholeTypes,
    ...$3cfe79d709e6baf3$var$percentWhole,
    ...$3cfe79d709e6baf3$var$percentTenth,
    ...$3cfe79d709e6baf3$var$angleWhole
];
const $3cfe79d709e6baf3$var$validTypeMap = $3cfe79d709e6baf3$var$validTypes.reduce((acc, curr)=>{
    acc[curr] = true;
    return acc;
}, {});
/**
 *
 * @param {string} type
 * @returns {boolean}
 */ function $3cfe79d709e6baf3$var$isGuffable(type) {
    const standardType = $3cfe79d709e6baf3$var$getStandardizedType(type);
    return Boolean($3cfe79d709e6baf3$var$validTypeMap[standardType]) || $3cfe79d709e6baf3$var$isAvgSpeed(standardType) || $3cfe79d709e6baf3$var$isMovementType(standardType) || $3cfe79d709e6baf3$var$isActiveSpin(standardType) || $3cfe79d709e6baf3$var$isAvgSpin(standardType);
}
// table
/**
 *
 * @param {string|number|null|undefined} val
 * @param {any} _
 * @param {{ field: string}} column
 * @returns {string}
 */ function $3cfe79d709e6baf3$var$displayFn(val, _, { field: field }) {
    return $3cfe79d709e6baf3$var$guff(val, field);
}
// table
/**
 *
 */ /**
 *
 * @param {string} type
 * @returns {(val: string|number|null|undefined) => string}
 */ function $3cfe79d709e6baf3$var$displayFnFactory(type) {
    return function displayFunc(val) {
        return $3cfe79d709e6baf3$var$guff(val, type);
    };
}
module.exports = {
    displayFn: $3cfe79d709e6baf3$var$displayFn,
    displayFnFactory: $3cfe79d709e6baf3$var$displayFnFactory,
    guff: $3cfe79d709e6baf3$var$guff,
    isGuffable: $3cfe79d709e6baf3$var$isGuffable
};

});

/* globals data, serverParams */ 
var $gkYm4 = parcelRequire("gkYm4");

var $5eFx0 = parcelRequire("5eFx0");
const { is_team_type: $0b191d797ec05d0d$var$is_team_type } = serverParams;
const $0b191d797ec05d0d$var$tableDivId = 'base_running_table';
let $0b191d797ec05d0d$var$currentData = data.slice();
const $0b191d797ec05d0d$var$isFielderView = [
    'Fld',
    'Pit',
    'Pitching Team'
].includes(serverParams.entity_code);
function $0b191d797ec05d0d$var$loadTable(data1) {
    const width = document.getElementById($0b191d797ec05d0d$var$tableDivId).offsetWidth;
    let repeatHeader = false;
    if (width <= 768) repeatHeader = 15;
    const defaultSort = document.getElementById('sort').value;
    const defaultSortDirection = document.getElementById('sortDir').value;
    // const keys = Object.keys(data[0]).slice(19, 40)
    // const allHeaders = keys.map((key) => ({
    //     name: key,
    //     field: key,
    //     headerClass: 'th-component-header align-center th-vertical-bottom',
    //     fieldClass: 'tr-data',
    //     type: 'number',
    //     displayFn: (val) => {
    //         if (key.includes('rate')) {
    //             return `${(val * 100).toFixed(1)}`
    //         }
    //         if (key.includes('diff')) {
    //             return `${val.toFixed(2)}`
    //         }
    //         if (key.includes('runs')) {
    //             return `${val.toFixed(1)}`
    //         }
    //         return val
    //     },
    // }))
    const runnerRuns = {
        name: 'Runner <br/>Runs',
        field: 'runner_runs',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data border-left border-right`,
        type: 'number',
        displayFn: (val)=>(0, $5eFx0.guff)(val, 'runner_runs'),
        highlightDynamic: true
    };
    const fielderRuns = {
        name: 'Fielder <br/>Runs',
        field: 'fielder_runs',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data border-left border-right`,
        type: 'number',
        displayFn: (val)=>(0, $5eFx0.guff)(val, 'fielder_runs'),
        highlightDynamic: true
    };
    const prefix = $0b191d797ec05d0d$var$isFielderView ? 'fielder' : 'runner';
    const supplementalHeaders = [
        $0b191d797ec05d0d$var$isFielderView ? fielderRuns : runnerRuns,
        {
            name: 'Advances',
            field: `${prefix}_runs_swipe`,
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val)=>(0, $5eFx0.guff)(val, `${prefix}_runs_swipe`)
        },
        {
            name: 'Thrown Out',
            field: `${prefix}_runs_snipe`,
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val)=>(0, $5eFx0.guff)(val, `${prefix}_runs_snipe`)
        },
        {
            name: 'Holds',
            field: `${prefix}_runs_freeze`,
            headerClass: 'th-component-header align-center th-vertical-bottom border-right',
            fieldClass: 'tr-data border-right',
            type: 'number',
            displayFn: (val)=>(0, $5eFx0.guff)(val, `${prefix}_runs_freeze`)
        },
        {
            name: 'Advance <br/> Opportunities',
            field: 'n_opp_xb',
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val)=>{
                if (val) return Number(val).toLocaleString();
                return val;
            }
        },
        // {
        //     name: 'XB Attempts',
        //     field: 'N_att_xb',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        //     displayFn: (val) => {
        //         if (val) {
        //             return Number(val).toLocaleString()
        //         }
        //         return val
        //     },
        // },
        {
            name: 'Advance <br/> Attempt %',
            field: 'rate_att_xb',
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val)=>(0, $5eFx0.guff)(val, 'rate_att_xb')
        },
        {
            name: 'Est. Attempt %',
            field: `est_rate_att_generic_${prefix}`,
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val)=>(0, $5eFx0.guff)(val, `est_rate_att_generic_${prefix}`),
            toolTip: `Estimated Attempt Rate <br/>for a generic ${prefix} <br/>in the same situations.`
        },
        {
            name: 'Attempt % <br/> Above Average',
            field: `rate_att_xb_diff_${prefix}`,
            headerClass: 'th-component-header align-center th-vertical-bottom border-right',
            fieldClass: 'tr-data border-right',
            type: 'number',
            displayFn: (val)=>(0, $5eFx0.guff)(val, `rate_att_xb_diff_${prefix}`),
            toolTip: `Difference between actual attempt rate and estimated attempt rate for a generic ${prefix} in the same situations.`
        },
        // {
        //     name: 'Outs on XB<br/>Attempts',
        //     field: 'N_out',
        //     headerClass: 'th-component-header align-center th-vertical-bottom',
        //     fieldClass: 'tr-data',
        //     type: 'number',
        //     displayFn: (val) => {
        //         if (val) {
        //             return Number(val).toLocaleString()
        //         }
        //         return val
        //     },
        // },
        {
            name: 'Safe on <br/>Advances',
            field: 'n_safe',
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val)=>{
                if (val) return Number(val).toLocaleString();
                return val;
            }
        },
        {
            name: 'Safe / Opportunity',
            field: 'rate_safe',
            headerClass: 'th-component-header align-center th-vertical-bottom',
            fieldClass: 'tr-data',
            type: 'number',
            displayFn: (val)=>`${(val * 100).toFixed(0)}%`
        },
        {
            name: 'Safe / Attempt',
            field: 'rate_safe_per_attempt',
            headerClass: 'th-component-header align-center th-vertical-bottom border-right',
            fieldClass: 'tr-data border-right',
            type: 'number',
            displayFn: (val)=>`${(val * 100).toFixed(0)}%`
        }
    ];
    const headers = [
        {
            name: $0b191d797ec05d0d$var$is_team_type ? 'Team' : 'Player',
            field: 'entity_name',
            customSortField: 'entity_name',
            headerClass: `th-component-header align-left th-vertical-bottom table-static-column`,
            fieldClass: `tr-data align-left table-static-column`,
            photo: $0b191d797ec05d0d$var$is_team_type ? undefined : '<img class="player-mug" onerror="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
            photoId: 'entity_id',
            defaultSortDir: 'asc',
            displayFn: (entity_name, d)=>$0b191d797ec05d0d$var$is_team_type ? entity_name : `<a href="/savant-player/${d.entity_id}">${entity_name}</a>`
        },
        {
            name: $0b191d797ec05d0d$var$is_team_type ? '' : 'Team',
            field: $0b191d797ec05d0d$var$is_team_type ? 'entity_name' : 'team_name',
            headerClass: `th-component-header`,
            fieldClass: `tr-data`,
            photo: '<img class="table-team-logo" src="{1}" onerror="this.onerror=\'\';this.src=\'/site-core/images/savant-mlb.svg\'" />',
            photoId: 'team_image_url',
            defaultSortDir: 'asc',
            photoOnly: true
        },
        {
            name: 'Year',
            field: 'start_year',
            headerClass: `th-component-header align-center th-vertical-bottom ${serverParams.splitYears ? '' : ' hide'}`,
            fieldClass: `tr-data ${serverParams.splitYears ? '' : ' hide'}`
        },
        ...supplementalHeaders,
        {
            name: '',
            field: '',
            headerClass: 'th-component-header align-center th-vertical-bottom cursor-initial',
            fieldClass: 'tr-data',
            sortable: false,
            displayFn: ()=>`
            <span data-video-icon style="inline-block; padding: 2px; border-radius: 50%; border: 2px solid #c2c2c2;">
                <img src="/site-core/images/video.png" style="width: 18px; cursor: pointer;">
            </span>
            `
        }
    ];
    const colspan = serverParams.splitYears ? 5 : 4;
    const secondaryHeaders = [
        {
            name: '',
            colspan: colspan,
            headerClass: 'th-name-header'
        },
        {
            name: 'Runs Breakdown',
            colspan: 3,
            headerClass: 'th-title-header'
        },
        {
            name: 'How often does the runner attempt to advance',
            colspan: 4,
            headerClass: 'th-title-header'
        },
        {
            name: 'How often was the runner successful in advancing',
            colspan: 3,
            headerClass: 'th-title-header'
        }
    ];
    // eslint-disable-next-line no-new
    new (0, $gkYm4.default)({
        id: $0b191d797ec05d0d$var$tableDivId,
        repeatHeader: repeatHeader,
        secondaryHeaders: secondaryHeaders,
        headers: headers,
        highlightFalsy: false,
        data: data1,
        uniqueId: 'catcher_id',
        defaultSort: defaultSort,
        defaultSortDirection: defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback (column, _, { state: state }) {
            const url = new URL(window.location);
            url.searchParams.set('sortColumn', column);
            url.searchParams.set('sortDirection', state);
            window.history.replaceState('', '', url.toString());
        },
        subDataId: 'row_id'
    });
}
const $0b191d797ec05d0d$var$$input = document.querySelector('.table-search');
if (data && data.length) {
    $0b191d797ec05d0d$var$loadTable($0b191d797ec05d0d$var$currentData);
    if ($0b191d797ec05d0d$var$$input) $0b191d797ec05d0d$var$$input.addEventListener('input', (e)=>{
        $0b191d797ec05d0d$var$currentData = $0b191d797ec05d0d$var$getFilteredData(e.target.value);
        $0b191d797ec05d0d$var$loadTable($0b191d797ec05d0d$var$currentData);
    });
}
function $0b191d797ec05d0d$var$showWithTeam(value) {
    if ($0b191d797ec05d0d$var$is_team_type) return;
    const display = [
        '',
        'split'
    ].includes(value) ? 'none' : 'inline-flex';
    document.getElementById('with-team-only-wrapper').style.display = display;
}
document.querySelectorAll('.form-control').forEach((el)=>{
    el.addEventListener('change', (e)=>{
        const id = el.getAttribute('id');
        const type = id.slice(3);
        const { selectedIndex: selectedIndex } = e.target;
        document.querySelector(`.label-change-${type}`).innerText = e.target.value === 'split' ? 'All - Split by Team' : e.target[selectedIndex].text;
        if (type === 'Team') $0b191d797ec05d0d$var$showWithTeam(e.target.value);
    });
});
$0b191d797ec05d0d$var$showWithTeam(serverParams.team || '');
function $0b191d797ec05d0d$var$populateUrl() {
    const parameters = {
        game_type: document.getElementById('ddlGameType').value,
        n: document.getElementById('ddlMinOpps').value,
        key_base_out: document.getElementById('ddlKeyBaseOut').value,
        season_end: document.getElementById('ddlSeasonEnd').value,
        season_start: document.getElementById('ddlSeasonStart').value,
        split: document.getElementById('ddlSplitYears').value,
        team: document.getElementById('ddlTeam').value,
        type: document.getElementById('ddlGroup').value,
        with_team_only: document.getElementById('with-team-only').checked ? 1 : 0
    };
    const urlParams = new URLSearchParams(parameters);
    return `${window.location.pathname}?${urlParams.toString()}`;
}
document.getElementById('btn-update').addEventListener('click', ()=>{
    window.location = $0b191d797ec05d0d$var$populateUrl();
});
// let expanded = false
// document.getElementById('btn-columns').addEventListener('click', () => {
//     expanded = !expanded
//     document.getElementById('btn-columns').innerText = expanded
//         ? 'Show Less Columns'
//         : 'Show More Columns'
//     loadTable(currentData, expanded)
// })
// HT: https://codepen.io/ivanwebstudio/pen/OJVzPBL?editors=0110
/* eslint-disable no-param-reassign */ function $0b191d797ec05d0d$var$slideUp(target, duration = 500) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = `${duration}ms`;
    target.style.boxSizing = 'border-box';
    target.style.height = `${target.offsetHeight}px`;
    // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(()=>{
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}
function $0b191d797ec05d0d$var$slideDown(target, duration = 500) {
    target.style.removeProperty('display');
    let { display: display } = window.getComputedStyle(target);
    if (display === 'none') display = 'block';
    target.style.display = display;
    const height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = `${duration}ms`;
    target.style.height = `${height}px`;
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(()=>{
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}
document.getElementById($0b191d797ec05d0d$var$tableDivId).addEventListener('click', async (e)=>{
    const $a = e.target.closest('a');
    if ($a) return;
    const $el = e.target.closest('tr.default-table-row');
    const $drawer = e.target.closest('.table-drawer');
    if (!$el || $drawer) return;
    const id = `data_${$el.dataset.id}`;
    const $innerDiv = document.getElementById(id);
    const $sub = $el.nextSibling;
    const isOpen = $sub.dataset.open === 'true';
    // Close drawer
    if ($innerDiv && isOpen) {
        $0b191d797ec05d0d$var$slideUp($innerDiv, 400);
        $sub.dataset.open = 'false';
        $el.querySelector('[data-video-icon]').style.backgroundColor = 'white';
        return;
    }
    // Open drawer color
    $el.querySelector('[data-video-icon]').style.backgroundColor = '#797979';
    // Open Drawer
    if ($innerDiv && !isOpen) {
        $0b191d797ec05d0d$var$slideDown($innerDiv, 400);
        $sub.dataset.open = 'true';
        return;
    }
    const $td = $sub.querySelector('td');
    const params = new URLSearchParams(window.location.search);
    // Eww.
    const [entity_id, year, team_id] = $el.dataset.id.split('_');
    params.set('season_start', serverParams.splitYears ? year : params.get('season_start') || '');
    params.set('season_end', serverParams.splitYears ? year : params.get('season_end') || '');
    params.set('team', serverParams.team === 'split' ? team_id : params.get('team') || '');
    const $wrapperDiv = document.createElement('div');
    $wrapperDiv.classList.add('table-drawer');
    $wrapperDiv.textContent = 'Loading...';
    // NO DASHES ALLOWED!
    $wrapperDiv.id = id;
    $sub.style.display = 'table-row';
    $sub.dataset.open = 'true';
    $td.appendChild($wrapperDiv);
    const url = `/leaderboard/services/baserunning/${entity_id}?${params.toString()}`;
    const { data: data1 } = await fetch(url).then((res)=>res.json());
    // Create DIV
    $wrapperDiv.style.display = 'none';
    $wrapperDiv.textContent = '';
    const $tableDiv = document.createElement('div');
    $tableDiv.id = `sub_table_${id}`;
    $wrapperDiv.appendChild($tableDiv);
    const headerClass = 'th-component-header align-center th-vertical-middle plus-sign component-col';
    const fieldClass = 'tr-data';
    const runnerRuns = {
        name: 'Runner Runs',
        field: 'runner_runs',
        headerClass: headerClass,
        fieldClass: fieldClass,
        type: 'number',
        displayFn: (val)=>{
            const str = Number(val).toFixed(2);
            return 1 / Number(str) === -Infinity ? '0.00' : str;
        }
    };
    const fielderRuns = {
        name: 'Fielder Runs',
        field: 'fielder_runs',
        headerClass: headerClass,
        fieldClass: fieldClass,
        type: 'number',
        displayFn: (val)=>{
            const str = Number(val).toFixed(2);
            return 1 / Number(str) === -Infinity ? '0.00' : str;
        }
    };
    // eslint-disable-next-line no-new
    new (0, $gkYm4.default)({
        id: $tableDiv.id,
        data: data1,
        sortClass: 'column-sort',
        headers: [
            {
                name: 'Date',
                field: 'game_date',
                headerClass: headerClass,
                fieldClass: fieldClass
            },
            {
                name: 'Situation',
                field: 'base_out_text',
                headerClass: headerClass,
                fieldClass: fieldClass
            },
            {
                name: 'Attempt XB?',
                field: 'is_att_xb',
                headerClass: headerClass,
                displayFn: (val)=>val === 1 ? 'Yes' : 'No',
                fieldClass: fieldClass
            },
            {
                name: 'Result',
                field: 'result',
                headerClass: headerClass,
                fieldClass: fieldClass
            },
            $0b191d797ec05d0d$var$isFielderView ? fielderRuns : runnerRuns,
            {
                name: '',
                field: 'entity_id',
                headerClass: 'th-component-header align-center th-vertical-bottom video-col cursor-initial',
                fieldClass: 'tr-data video-col',
                type: 'number',
                sortable: false,
                displayFn: (value, { play_id: play_id })=>`
                            <a href="/sporty-videos?playId=${play_id}" target="_BLANK">
                                <img src="/site-core/images/video.png" style="margin-right: 4px; width: 25px; height: 13px; cursor: pointer;">
                            </a>
                           `
            }
        ],
        defaultSort: 'game_date'
    });
    // $wrapperDiv.innerHTML = `
    // <div class="drawer-tabs">
    //     <button data-tab="all" class="tab-all drawer-nav active" >
    //         All Attempts
    //     </button>
    //     <button data-tab="catcher_id" class="tab-catcher drawer-nav" style="display: ${
    //         serverParams.entity_code !== 'Cat' ? 'block' : 'none'
    //     }">
    //         Catchers
    //     </button>
    //     <button data-tab="fielder_id" class="tab-fielder drawer-nav" >
    //         Fielders
    //     </button>
    //     <button data-tab="pitcher_id" class="tab-pitcher drawer-nav" >
    //         Pitchers
    //     </button>
    //     <button data-tab="runner_id" class="tab-runner drawer-nav" >
    //         Runners
    //     </button>
    //     <button data-tab="throw_type" class="tab-runner drawer-nav" >
    //         Throw Types
    //     </button>
    // </div>
    // `
    $0b191d797ec05d0d$var$slideDown($wrapperDiv, 400);
});
function $0b191d797ec05d0d$var$getFilteredData(search) {
    const normalized_search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    return data.filter((d)=>{
        const name = d.entity_name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        return name.includes(normalized_search);
    });
}
document.getElementById('btn-csv').addEventListener('click', ()=>{
    window.location.href = window.location.search ? `${window.location.href}&csv=true` : `${window.location.href}?csv=true`;
});

})();
//# sourceMappingURL=baserunning.js.map
